/*! shopify_app_compiler 2026-04-01 */
var requirejs, require, define;

!function(global, setTimeout) {
    var req, s, head, baseElement, dataMain, src, interactiveScript, currentlyAddingScript, mainScript, subPath, version = "2.3.6", commentRegExp = /\/\*[\s\S]*?\*\/|([^:"'=]|^)\/\/.*$/gm, cjsRequireRegExp = /[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g, jsSuffixRegExp = /\.js$/, currDirRegExp = /^\.\//, op = Object.prototype, ostring = op.toString, hasOwn = op.hasOwnProperty, isBrowser = !("undefined" == typeof window || "undefined" == typeof navigator || !window.document), isWebWorker = !isBrowser && "undefined" != typeof importScripts, readyRegExp = isBrowser && "PLAYSTATION 3" === navigator.platform ? /^complete$/ : /^(complete|loaded)$/, defContextName = "_", isOpera = "undefined" != typeof opera && "[object Opera]" === opera.toString(), contexts = {}, cfg = {}, globalDefQueue = [], useInteractive = !1;
    function commentReplace(e, t) {
        return t || "";
    }
    function isFunction(e) {
        return "[object Function]" === ostring.call(e);
    }
    function isArray(e) {
        return "[object Array]" === ostring.call(e);
    }
    function each(e, t) {
        var i;
        if (e) for (i = 0; i < e.length && (!e[i] || !t(e[i], i, e)); i += 1);
    }
    function eachReverse(e, t) {
        var i;
        if (e) for (i = e.length - 1; -1 < i && (!e[i] || !t(e[i], i, e)); i -= 1);
    }
    function hasProp(e, t) {
        return hasOwn.call(e, t);
    }
    function getOwn(e, t) {
        return hasProp(e, t) && e[t];
    }
    function eachProp(e, t) {
        var i;
        for (i in e) if (hasProp(e, i) && t(e[i], i)) break;
    }
    function mixin(i, e, r, n) {
        return e && eachProp(e, function(e, t) {
            !r && hasProp(i, t) || (!n || "object" != typeof e || !e || isArray(e) || isFunction(e) || e instanceof RegExp ? i[t] = e : (i[t] || (i[t] = {}), 
            mixin(i[t], e, r, n)));
        }), i;
    }
    function bind(e, t) {
        return function() {
            return t.apply(e, arguments);
        };
    }
    function scripts() {
        return document.getElementsByTagName("script");
    }
    function defaultOnError(e) {
        throw e;
    }
    function getGlobal(e) {
        if (!e) return e;
        var t = global;
        return each(e.split("."), function(e) {
            t = t[e];
        }), t;
    }
    function makeError(e, t, i, r) {
        var n = new Error(t + "\nhttps://requirejs.org/docs/errors.html#" + e);
        return n.requireType = e, n.requireModules = r, i && (n.originalError = i), 
        n;
    }
    if (void 0 === define) {
        if (void 0 !== requirejs) {
            if (isFunction(requirejs)) return;
            cfg = requirejs, requirejs = void 0;
        }
        void 0 === require || isFunction(require) || (cfg = require, require = void 0), 
        req = requirejs = function(e, t, i, r) {
            var n, o, a = defContextName;
            return isArray(e) || "string" == typeof e || (o = e, isArray(t) ? (e = t, 
            t = i, i = r) : e = []), o && o.context && (a = o.context), (n = getOwn(contexts, a)) || (n = contexts[a] = req.s.newContext(a)), 
            o && n.configure(o), n.require(e, t, i);
        }, req.config = function(e) {
            return req(e);
        }, req.nextTick = void 0 !== setTimeout ? function(e) {
            setTimeout(e, 4);
        } : function(e) {
            e();
        }, require || (require = req), req.version = version, req.jsExtRegExp = /^\/|:|\?|\.js$/, 
        req.isBrowser = isBrowser, s = req.s = {
            contexts: contexts,
            newContext: newContext
        }, req({}), each([ "toUrl", "undef", "defined", "specified" ], function(t) {
            req[t] = function() {
                var e = contexts[defContextName];
                return e.require[t].apply(e, arguments);
            };
        }), isBrowser && (head = s.head = document.getElementsByTagName("head")[0], 
        baseElement = document.getElementsByTagName("base")[0], baseElement && (head = s.head = baseElement.parentNode)), 
        req.onError = defaultOnError, req.createNode = function(e, t, i) {
            var r = e.xhtml ? document.createElementNS("http://www.w3.org/1999/xhtml", "html:script") : document.createElement("script");
            return r.type = e.scriptType || "text/javascript", r.charset = "utf-8", 
            r.async = !0, r;
        }, req.load = function(t, i, r) {
            var e, n = t && t.config || {};
            if (isBrowser) return (e = req.createNode(n, i, r)).setAttribute("data-requirecontext", t.contextName), 
            e.setAttribute("data-requiremodule", i), !e.attachEvent || e.attachEvent.toString && e.attachEvent.toString().indexOf("[native code") < 0 || isOpera ? (e.addEventListener("load", t.onScriptLoad, !1), 
            e.addEventListener("error", t.onScriptError, !1)) : (useInteractive = !0, 
            e.attachEvent("onreadystatechange", t.onScriptLoad)), e.src = r, n.onNodeCreated && n.onNodeCreated(e, n, i, r), 
            currentlyAddingScript = e, baseElement ? head.insertBefore(e, baseElement) : head.appendChild(e), 
            currentlyAddingScript = null, e;
            if (isWebWorker) try {
                setTimeout(function() {}, 0), importScripts(r), t.completeLoad(i);
            } catch (e) {
                t.onError(makeError("importscripts", "importScripts failed for " + i + " at " + r, e, [ i ]));
            }
        }, isBrowser && !cfg.skipDataMain && eachReverse(scripts(), function(e) {
            if (head || (head = e.parentNode), dataMain = e.getAttribute("data-main")) return mainScript = dataMain, 
            cfg.baseUrl || -1 !== mainScript.indexOf("!") || (mainScript = (src = mainScript.split("/")).pop(), 
            subPath = src.length ? src.join("/") + "/" : "./", cfg.baseUrl = subPath), 
            mainScript = mainScript.replace(jsSuffixRegExp, ""), req.jsExtRegExp.test(mainScript) && (mainScript = dataMain), 
            cfg.deps = cfg.deps ? cfg.deps.concat(mainScript) : [ mainScript ], 
            !0;
        }), define = function(e, i, t) {
            var r, n;
            "string" != typeof e && (t = i, i = e, e = null), isArray(i) || (t = i, 
            i = null), !i && isFunction(t) && (i = [], t.length && (t.toString().replace(commentRegExp, commentReplace).replace(cjsRequireRegExp, function(e, t) {
                i.push(t);
            }), i = (1 === t.length ? [ "require" ] : [ "require", "exports", "module" ]).concat(i))), 
            useInteractive && (r = currentlyAddingScript || getInteractiveScript()) && (e || (e = r.getAttribute("data-requiremodule")), 
            n = contexts[r.getAttribute("data-requirecontext")]), n ? (n.defQueue.push([ e, i, t ]), 
            n.defQueueMap[e] = !0) : globalDefQueue.push([ e, i, t ]);
        }, define.amd = {
            jQuery: !0
        }, req.exec = function(text) {
            return eval(text);
        }, req(cfg);
    }
    function newContext(u) {
        var i, e, l, c, d, g = {
            waitSeconds: 7,
            baseUrl: "./",
            paths: {},
            bundles: {},
            pkgs: {},
            shim: {},
            config: {}
        }, p = {}, f = {}, r = {}, h = [], m = {}, n = {}, v = {}, x = 1, b = 1;
        function q(e, t, i) {
            var r, n, o, a, s, u, c, d, p, f, l = t && t.split("/"), h = g.map, m = h && h["*"];
            if (e && (u = (e = e.split("/")).length - 1, g.nodeIdCompat && jsSuffixRegExp.test(e[u]) && (e[u] = e[u].replace(jsSuffixRegExp, "")), 
            "." === e[0].charAt(0) && l && (e = l.slice(0, l.length - 1).concat(e)), 
            function(e) {
                var t, i;
                for (t = 0; t < e.length; t++) if ("." === (i = e[t])) e.splice(t, 1), 
                t -= 1; else if (".." === i) {
                    if (0 === t || 1 === t && ".." === e[2] || ".." === e[t - 1]) continue;
                    0 < t && (e.splice(t - 1, 2), t -= 2);
                }
            }(e), e = e.join("/")), i && h && (l || m)) {
                e: for (o = (n = e.split("/")).length; 0 < o; o -= 1) {
                    if (s = n.slice(0, o).join("/"), l) for (a = l.length; 0 < a; a -= 1) if ((r = getOwn(h, l.slice(0, a).join("/"))) && (r = getOwn(r, s))) {
                        c = r, d = o;
                        break e;
                    }
                    !p && m && getOwn(m, s) && (p = getOwn(m, s), f = o);
                }
                !c && p && (c = p, d = f), c && (n.splice(0, d, c), e = n.join("/"));
            }
            return getOwn(g.pkgs, e) || e;
        }
        function E(t) {
            isBrowser && each(scripts(), function(e) {
                if (e.getAttribute("data-requiremodule") === t && e.getAttribute("data-requirecontext") === l.contextName) return e.parentNode.removeChild(e), 
                !0;
            });
        }
        function w(e) {
            var t = getOwn(g.paths, e);
            if (t && isArray(t) && 1 < t.length) return t.shift(), l.require.undef(e), 
            l.makeRequire(null, {
                skipMap: !0
            })([ e ]), !0;
        }
        function y(e) {
            var t, i = e ? e.indexOf("!") : -1;
            return -1 < i && (t = e.substring(0, i), e = e.substring(i + 1, e.length)), 
            [ t, e ];
        }
        function S(e, t, i, r) {
            var n, o, a, s, u = null, c = t ? t.name : null, d = e, p = !0, f = "";
            return e || (p = !1, e = "_@r" + (x += 1)), u = (s = y(e))[0], e = s[1], 
            u && (u = q(u, c, r), o = getOwn(m, u)), e && (u ? f = i ? e : o && o.normalize ? o.normalize(e, function(e) {
                return q(e, c, r);
            }) : -1 === e.indexOf("!") ? q(e, c, r) : e : (u = (s = y(f = q(e, c, r)))[0], 
            f = s[1], i = !0, n = l.nameToUrl(f))), {
                prefix: u,
                name: f,
                parentMap: t,
                unnormalized: !!(a = !u || o || i ? "" : "_unnormalized" + (b += 1)),
                url: n,
                originalName: d,
                isDefine: p,
                id: (u ? u + "!" + f : f) + a
            };
        }
        function k(e) {
            var t = e.id, i = getOwn(p, t);
            return i || (i = p[t] = new l.Module(e)), i;
        }
        function M(e, t, i) {
            var r = e.id, n = getOwn(p, r);
            !hasProp(m, r) || n && !n.defineEmitComplete ? (n = k(e)).error && "error" === t ? i(n.error) : n.on(t, i) : "defined" === t && i(m[r]);
        }
        function O(i, e) {
            var t = i.requireModules, r = !1;
            e ? e(i) : (each(t, function(e) {
                var t = getOwn(p, e);
                t && (t.error = i, t.events.error && (r = !0, t.emit("error", i)));
            }), r || req.onError(i));
        }
        function j() {
            globalDefQueue.length && (each(globalDefQueue, function(e) {
                var t = e[0];
                "string" == typeof t && (l.defQueueMap[t] = !0), h.push(e);
            }), globalDefQueue = []);
        }
        function P(e) {
            delete p[e], delete f[e];
        }
        function R() {
            var e, r, t = 1e3 * g.waitSeconds, n = t && l.startTime + t < new Date().getTime(), o = [], a = [], s = !1, u = !0;
            if (!i) {
                if (i = !0, eachProp(f, function(e) {
                    var t = e.map, i = t.id;
                    if (e.enabled && (t.isDefine || a.push(e), !e.error)) if (!e.inited && n) w(i) ? s = r = !0 : (o.push(i), 
                    E(i)); else if (!e.inited && e.fetched && t.isDefine && (s = !0, 
                    !t.prefix)) return u = !1;
                }), n && o.length) return (e = makeError("timeout", "Load timeout for modules: " + o, null, o)).contextName = l.contextName, 
                O(e);
                u && each(a, function(e) {
                    !function n(o, a, s) {
                        var e = o.map.id;
                        o.error ? o.emit("error", o.error) : (a[e] = !0, each(o.depMaps, function(e, t) {
                            var i = e.id, r = getOwn(p, i);
                            !r || o.depMatched[t] || s[i] || (getOwn(a, i) ? (o.defineDep(t, m[i]), 
                            o.check()) : n(r, a, s));
                        }), s[e] = !0);
                    }(e, {}, {});
                }), n && !r || !s || !isBrowser && !isWebWorker || d || (d = setTimeout(function() {
                    d = 0, R();
                }, 50)), i = !1;
            }
        }
        function a(e) {
            hasProp(m, e[0]) || k(S(e[0], null, !0)).init(e[1], e[2]);
        }
        function o(e, t, i, r) {
            e.detachEvent && !isOpera ? r && e.detachEvent(r, t) : e.removeEventListener(i, t, !1);
        }
        function s(e) {
            var t = e.currentTarget || e.srcElement;
            return o(t, l.onScriptLoad, "load", "onreadystatechange"), o(t, l.onScriptError, "error"), 
            {
                node: t,
                id: t && t.getAttribute("data-requiremodule")
            };
        }
        function T() {
            var e;
            for (j(); h.length; ) {
                if (null === (e = h.shift())[0]) return O(makeError("mismatch", "Mismatched anonymous define() module: " + e[e.length - 1]));
                a(e);
            }
            l.defQueueMap = {};
        }
        return c = {
            require: function(e) {
                return e.require ? e.require : e.require = l.makeRequire(e.map);
            },
            exports: function(e) {
                if (e.usingExports = !0, e.map.isDefine) return e.exports ? m[e.map.id] = e.exports : e.exports = m[e.map.id] = {};
            },
            module: function(e) {
                return e.module ? e.module : e.module = {
                    id: e.map.id,
                    uri: e.map.url,
                    config: function() {
                        return getOwn(g.config, e.map.id) || {};
                    },
                    exports: e.exports || (e.exports = {})
                };
            }
        }, (e = function(e) {
            this.events = getOwn(r, e.id) || {}, this.map = e, this.shim = getOwn(g.shim, e.id), 
            this.depExports = [], this.depMaps = [], this.depMatched = [], this.pluginMaps = {}, 
            this.depCount = 0;
        }).prototype = {
            init: function(e, t, i, r) {
                r = r || {}, this.inited || (this.factory = t, i ? this.on("error", i) : this.events.error && (i = bind(this, function(e) {
                    this.emit("error", e);
                })), this.depMaps = e && e.slice(0), this.errback = i, this.inited = !0, 
                this.ignore = r.ignore, r.enabled || this.enabled ? this.enable() : this.check());
            },
            defineDep: function(e, t) {
                this.depMatched[e] || (this.depMatched[e] = !0, this.depCount -= 1, 
                this.depExports[e] = t);
            },
            fetch: function() {
                if (!this.fetched) {
                    this.fetched = !0, l.startTime = new Date().getTime();
                    var e = this.map;
                    if (!this.shim) return e.prefix ? this.callPlugin() : this.load();
                    l.makeRequire(this.map, {
                        enableBuildCallback: !0
                    })(this.shim.deps || [], bind(this, function() {
                        return e.prefix ? this.callPlugin() : this.load();
                    }));
                }
            },
            load: function() {
                var e = this.map.url;
                n[e] || (n[e] = !0, l.load(this.map.id, e));
            },
            check: function() {
                if (this.enabled && !this.enabling) {
                    var t, e, i = this.map.id, r = this.depExports, n = this.exports, o = this.factory;
                    if (this.inited) {
                        if (this.error) this.emit("error", this.error); else if (!this.defining) {
                            if (this.defining = !0, this.depCount < 1 && !this.defined) {
                                if (isFunction(o)) {
                                    if (this.events.error && this.map.isDefine || req.onError !== defaultOnError) try {
                                        n = l.execCb(i, o, r, n);
                                    } catch (e) {
                                        t = e;
                                    } else n = l.execCb(i, o, r, n);
                                    if (this.map.isDefine && void 0 === n && ((e = this.module) ? n = e.exports : this.usingExports && (n = this.exports)), 
                                    t) return t.requireMap = this.map, t.requireModules = this.map.isDefine ? [ this.map.id ] : null, 
                                    t.requireType = this.map.isDefine ? "define" : "require", 
                                    O(this.error = t);
                                } else n = o;
                                if (this.exports = n, this.map.isDefine && !this.ignore && (m[i] = n, 
                                req.onResourceLoad)) {
                                    var a = [];
                                    each(this.depMaps, function(e) {
                                        a.push(e.normalizedMap || e);
                                    }), req.onResourceLoad(l, this.map, a);
                                }
                                P(i), this.defined = !0;
                            }
                            this.defining = !1, this.defined && !this.defineEmitted && (this.defineEmitted = !0, 
                            this.emit("defined", this.exports), this.defineEmitComplete = !0);
                        }
                    } else hasProp(l.defQueueMap, i) || this.fetch();
                }
            },
            callPlugin: function() {
                var u = this.map, c = u.id, e = S(u.prefix);
                this.depMaps.push(e), M(e, "defined", bind(this, function(e) {
                    var o, t, i, r = getOwn(v, this.map.id), n = this.map.name, a = this.map.parentMap ? this.map.parentMap.name : null, s = l.makeRequire(u.parentMap, {
                        enableBuildCallback: !0
                    });
                    return this.map.unnormalized ? (e.normalize && (n = e.normalize(n, function(e) {
                        return q(e, a, !0);
                    }) || ""), M(t = S(u.prefix + "!" + n, this.map.parentMap, !0), "defined", bind(this, function(e) {
                        this.map.normalizedMap = t, this.init([], function() {
                            return e;
                        }, null, {
                            enabled: !0,
                            ignore: !0
                        });
                    })), void ((i = getOwn(p, t.id)) && (this.depMaps.push(t), this.events.error && i.on("error", bind(this, function(e) {
                        this.emit("error", e);
                    })), i.enable()))) : r ? (this.map.url = l.nameToUrl(r), void this.load()) : ((o = bind(this, function(e) {
                        this.init([], function() {
                            return e;
                        }, null, {
                            enabled: !0
                        });
                    })).error = bind(this, function(e) {
                        this.inited = !0, (this.error = e).requireModules = [ c ], 
                        eachProp(p, function(e) {
                            0 === e.map.id.indexOf(c + "_unnormalized") && P(e.map.id);
                        }), O(e);
                    }), o.fromText = bind(this, function(e, t) {
                        var i = u.name, r = S(i), n = useInteractive;
                        t && (e = t), n && (useInteractive = !1), k(r), hasProp(g.config, c) && (g.config[i] = g.config[c]);
                        try {
                            req.exec(e);
                        } catch (e) {
                            return O(makeError("fromtexteval", "fromText eval for " + c + " failed: " + e, e, [ c ]));
                        }
                        n && (useInteractive = !0), this.depMaps.push(r), l.completeLoad(i), 
                        s([ i ], o);
                    }), void e.load(u.name, s, o, g));
                })), l.enable(e, this), this.pluginMaps[e.id] = e;
            },
            enable: function() {
                (f[this.map.id] = this).enabled = !0, this.enabling = !0, each(this.depMaps, bind(this, function(e, t) {
                    var i, r, n;
                    if ("string" == typeof e) {
                        if (e = S(e, this.map.isDefine ? this.map : this.map.parentMap, !1, !this.skipMap), 
                        this.depMaps[t] = e, n = getOwn(c, e.id)) return void (this.depExports[t] = n(this));
                        this.depCount += 1, M(e, "defined", bind(this, function(e) {
                            this.undefed || (this.defineDep(t, e), this.check());
                        })), this.errback ? M(e, "error", bind(this, this.errback)) : this.events.error && M(e, "error", bind(this, function(e) {
                            this.emit("error", e);
                        }));
                    }
                    i = e.id, r = p[i], hasProp(c, i) || !r || r.enabled || l.enable(e, this);
                })), eachProp(this.pluginMaps, bind(this, function(e) {
                    var t = getOwn(p, e.id);
                    t && !t.enabled && l.enable(e, this);
                })), this.enabling = !1, this.check();
            },
            on: function(e, t) {
                var i = this.events[e];
                i || (i = this.events[e] = []), i.push(t);
            },
            emit: function(e, t) {
                each(this.events[e], function(e) {
                    e(t);
                }), "error" === e && delete this.events[e];
            }
        }, (l = {
            config: g,
            contextName: u,
            registry: p,
            defined: m,
            urlFetched: n,
            defQueue: h,
            defQueueMap: {},
            Module: e,
            makeModuleMap: S,
            nextTick: req.nextTick,
            onError: O,
            configure: function(e) {
                if (e.baseUrl && "/" !== e.baseUrl.charAt(e.baseUrl.length - 1) && (e.baseUrl += "/"), 
                "string" == typeof e.urlArgs) {
                    var i = e.urlArgs;
                    e.urlArgs = function(e, t) {
                        return (-1 === t.indexOf("?") ? "?" : "&") + i;
                    };
                }
                var r = g.shim, n = {
                    paths: !0,
                    bundles: !0,
                    config: !0,
                    map: !0
                };
                eachProp(e, function(e, t) {
                    n[t] ? (g[t] || (g[t] = {}), mixin(g[t], e, !0, !0)) : g[t] = e;
                }), e.bundles && eachProp(e.bundles, function(e, t) {
                    each(e, function(e) {
                        e !== t && (v[e] = t);
                    });
                }), e.shim && (eachProp(e.shim, function(e, t) {
                    isArray(e) && (e = {
                        deps: e
                    }), !e.exports && !e.init || e.exportsFn || (e.exportsFn = l.makeShimExports(e)), 
                    r[t] = e;
                }), g.shim = r), e.packages && each(e.packages, function(e) {
                    var t;
                    t = (e = "string" == typeof e ? {
                        name: e
                    } : e).name, e.location && (g.paths[t] = e.location), g.pkgs[t] = e.name + "/" + (e.main || "main").replace(currDirRegExp, "").replace(jsSuffixRegExp, "");
                }), eachProp(p, function(e, t) {
                    e.inited || e.map.unnormalized || (e.map = S(t, null, !0));
                }), (e.deps || e.callback) && l.require(e.deps || [], e.callback);
            },
            makeShimExports: function(t) {
                return function() {
                    var e;
                    return t.init && (e = t.init.apply(global, arguments)), e || t.exports && getGlobal(t.exports);
                };
            },
            makeRequire: function(o, a) {
                function s(e, t, i) {
                    var r, n;
                    return a.enableBuildCallback && t && isFunction(t) && (t.__requireJsBuild = !0), 
                    "string" == typeof e ? isFunction(t) ? O(makeError("requireargs", "Invalid require call"), i) : o && hasProp(c, e) ? c[e](p[o.id]) : req.get ? req.get(l, e, o, s) : (r = S(e, o, !1, !0).id, 
                    hasProp(m, r) ? m[r] : O(makeError("notloaded", 'Module name "' + r + '" has not been loaded yet for context: ' + u + (o ? "" : ". Use require([])")))) : (T(), 
                    l.nextTick(function() {
                        T(), (n = k(S(null, o))).skipMap = a.skipMap, n.init(e, t, i, {
                            enabled: !0
                        }), R();
                    }), s);
                }
                return a = a || {}, mixin(s, {
                    isBrowser: isBrowser,
                    toUrl: function(e) {
                        var t, i = e.lastIndexOf("."), r = e.split("/")[0];
                        return -1 !== i && (!("." === r || ".." === r) || 1 < i) && (t = e.substring(i, e.length), 
                        e = e.substring(0, i)), l.nameToUrl(q(e, o && o.id, !0), t, !0);
                    },
                    defined: function(e) {
                        return hasProp(m, S(e, o, !1, !0).id);
                    },
                    specified: function(e) {
                        return e = S(e, o, !1, !0).id, hasProp(m, e) || hasProp(p, e);
                    }
                }), o || (s.undef = function(i) {
                    j();
                    var e = S(i, o, !0), t = getOwn(p, i);
                    t.undefed = !0, E(i), delete m[i], delete n[e.url], delete r[i], 
                    eachReverse(h, function(e, t) {
                        e[0] === i && h.splice(t, 1);
                    }), delete l.defQueueMap[i], t && (t.events.defined && (r[i] = t.events), 
                    P(i));
                }), s;
            },
            enable: function(e) {
                getOwn(p, e.id) && k(e).enable();
            },
            completeLoad: function(e) {
                var t, i, r, n = getOwn(g.shim, e) || {}, o = n.exports;
                for (j(); h.length; ) {
                    if (null === (i = h.shift())[0]) {
                        if (i[0] = e, t) break;
                        t = !0;
                    } else i[0] === e && (t = !0);
                    a(i);
                }
                if (l.defQueueMap = {}, r = getOwn(p, e), !t && !hasProp(m, e) && r && !r.inited) {
                    if (!(!g.enforceDefine || o && getGlobal(o))) return w(e) ? void 0 : O(makeError("nodefine", "No define call for " + e, null, [ e ]));
                    a([ e, n.deps || [], n.exportsFn ]);
                }
                R();
            },
            nameToUrl: function(e, t, i) {
                var r, n, o, a, s, u, c = getOwn(g.pkgs, e);
                if (c && (e = c), u = getOwn(v, e)) return l.nameToUrl(u, t, i);
                if (req.jsExtRegExp.test(e)) a = e + (t || ""); else {
                    for (r = g.paths, o = (n = e.split("/")).length; 0 < o; o -= 1) if (s = getOwn(r, n.slice(0, o).join("/"))) {
                        isArray(s) && (s = s[0]), n.splice(0, o, s);
                        break;
                    }
                    a = n.join("/"), a = ("/" === (a += t || (/^data\:|^blob\:|\?/.test(a) || i ? "" : ".js")).charAt(0) || a.match(/^[\w\+\.\-]+:/) ? "" : g.baseUrl) + a;
                }
                return g.urlArgs && !/^blob\:/.test(a) ? a + g.urlArgs(e, a) : a;
            },
            load: function(e, t) {
                req.load(l, e, t);
            },
            execCb: function(e, t, i, r) {
                return t.apply(r, i);
            },
            onScriptLoad: function(e) {
                if ("load" === e.type || readyRegExp.test((e.currentTarget || e.srcElement).readyState)) {
                    interactiveScript = null;
                    var t = s(e);
                    l.completeLoad(t.id);
                }
            },
            onScriptError: function(e) {
                var i = s(e);
                if (!w(i.id)) {
                    var r = [];
                    return eachProp(p, function(e, t) {
                        0 !== t.indexOf("_@r") && each(e.depMaps, function(e) {
                            if (e.id === i.id) return r.push(t), !0;
                        });
                    }), O(makeError("scripterror", 'Script error for "' + i.id + (r.length ? '", needed by: ' + r.join(", ") : '"'), e, [ i.id ]));
                }
            }
        }).require = l.makeRequire(), l;
    }
    function getInteractiveScript() {
        return interactiveScript && "interactive" === interactiveScript.readyState || eachReverse(scripts(), function(e) {
            if ("interactive" === e.readyState) return interactiveScript = e;
        }), interactiveScript;
    }
}(this, "undefined" == typeof setTimeout ? void 0 : setTimeout);

var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || {
            __proto__: []
        } instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, 
        new __());
    };
}();

var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var __generator = this && this.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        throw: verb(1),
        return: verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([ n, v ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 
            0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [ op[0] & 2, t.value ];
            switch (op[0]) {
              case 0:
              case 1:
                t = op;
                break;

              case 4:
                _.label++;
                return {
                    value: op[1],
                    done: false
                };

              case 5:
                _.label++;
                y = op[1];
                op = [ 0 ];
                continue;

              case 7:
                op = _.ops.pop();
                _.trys.pop();
                continue;

              default:
                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                }
                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                }
                if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                }
                if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                }
                if (t[2]) _.ops.pop();
                _.trys.pop();
                continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [ 6, e ];
            y = 0;
        } finally {
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

define("core/shopify-app/st-modules/_general-methods/dom-loaded", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDOMLoaded = void 0;
    var StDOMLoaded = function() {
        function StDOMLoaded() {
            var _this = this;
            this.className = "DOMLoaded";
            this.domLoaded = false;
            this.domLoadedCallbacks = [];
            this.readyStateChange = function() {
                if (document.readyState === "interactive") {
                    _this.domLoaded = true;
                    _this.fireDOMLoadedCallbacks();
                }
            };
            this.fireDOMLoadedCallbacks = function() {
                for (var i = 0; i < _this.domLoadedCallbacks.length; i++) {
                    _this.domLoadedCallbacks[i]();
                }
            };
            this.subscribeDOMLoaded = function(cb) {
                if (_this.domLoaded) {
                    cb();
                } else {
                    _this.domLoadedCallbacks.push(cb);
                }
            };
        }
        StDOMLoaded.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        StDOMLoaded.prototype.initDOMLoaded = function() {
            if (!StDOMLoaded.initStarted) {
                StDOMLoaded.initStarted = true;
                if (document.readyState === "interactive" || document.readyState === "complete") {
                    this.domLoaded = true;
                    this.fireDOMLoadedCallbacks();
                } else {
                    document.addEventListener("readystatechange", this.readyStateChange, false);
                }
            }
        };
        StDOMLoaded.initStarted = false;
        return StDOMLoaded;
    }();
    exports.StDOMLoaded = StDOMLoaded;
});

define("core/connector-app/_shared/routes.config", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.endpointData = void 0;
    exports.endpointData = {
        webalias: {
            repSite: "||-API-ROOT-||/webalias/sca/repSite"
        },
        webhook: {
            removeAll: "||-API-ROOT-||/webhook/gar/removeAll"
        },
        customer: {
            updatePersonalInfo: "||-API-ROOT-||/customer/sca/updatePersonalInfo",
            updateSponsor: "||-API-ROOT-||/customer/sca/updateSponsor",
            getReferralLink: "||-API-ROOT-||/customer/sca/getReferralLink",
            getReferralRewards: "||-API-ROOT-||/customer/sca/getReferralRewards",
            validateReferralRewards: "||-API-ROOT-||/customer/sca/validateReferralRewards",
            getSponsorAlias: "||-API-ROOT-||/customer/sca/getSponsorAlias",
            getDownLine: "||-API-ROOT-||/customer/sca/getDownLine",
            getCustomerSubscriptions: "||-API-ROOT-||/customer/sca/getCustomerSubscriptions",
            contactAffiliate: "||-API-ROOT-||/customer/sca/contactAffiliate",
            getReferralLinkByMail: "||-API-ROOT-||/customer/sca/getReferralLinkByMail",
            getAwtomicCustomerPortalLink: "||-API-ROOT-||/customer/sca/getAwtomicCustomerPortalLink",
            generateSSOForWineCellar: "||-API-ROOT-||/customer/sca/generateSSOForWineCellar",
            affiliateUpdate: "||-API-ROOT-||/customer/sca/affiliateUpdate"
        },
        auth: {
            generateJwt: "||-API-ROOT-||/auth/sca/generateJwt",
            checkJwt: "||-API-ROOT-||/auth/sca/checkJwt"
        },
        order: {
            validateLabelCreation: "||-API-ROOT-||/order/sca/validateLabelCreation"
        },
        enrollment: {
            "validate-data": "||-API-ROOT-||/enrollment/sca/validate-data",
            createAccount: "||-API-ROOT-||/enrollment/sca/createAccount"
        },
        searchSponsor: {
            getSponsorInfo: "||-API-ROOT-||/searchSponsor/sca/getSponsorInfo",
            getSponsorByPersonalInfo: "||-API-ROOT-||/searchSponsor/sca/getSponsorByPersonalInfo"
        },
        cart: {
            generateCartToken: "||-API-ROOT-||/cart/sca/generateCartToken",
            decodeCartToken: "||-API-ROOT-||/cart/sca/decodeCartToken",
            getShareCarts: "||-API-ROOT-||/cart/sca/getShareCarts",
            deleteShareCart: "||-API-ROOT-||/cart/sca/deleteShareCart",
            getShareCartDetails: "||-API-ROOT-||/cart/sca/getShareCartDetails"
        },
        sampler: {
            generateLink: "||-API-ROOT-||/sampler/sca/generateLink",
            getLinks: "||-API-ROOT-||/sampler/sca/getLinks",
            validateLink: "||-API-ROOT-||/sampler/sca/validateLink",
            deleteSampleLink: "||-API-ROOT-||/sampler/sca/deleteSampleLink",
            getSamplerLink: "||-API-ROOT-||/sampler/sca/getSamplerLink",
            validateDate: "||-API-ROOT-||/sampler/sca/validateDate",
            invalidateAffiliateSamplerLink: "||-API-ROOT-||/sampler/sca/invalidateAffiliateSamplerLink",
            hostTastingForm: "||-API-ROOT-||/sampler/sca/hostTastingForm"
        },
        referral: {
            getReferralInfo: "||-API-ROOT-||/referral/sca/getReferralInfo"
        }
    };
});

define("core/shopify-app/st-modules/_static/static", [ "require", "exports", "core/connector-app/_shared/routes.config" ], function(require, exports, routes_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StStatic = void 0;
    var StStatic = function() {
        function StStatic() {
            var _this = this;
            this.className = "Static";
            this.shopConfig = window.stAppConfig;
            this.apiRoot = this.shopConfig.apiRoot;
            this.init = function() {};
            this.setup = function() {};
            this.obtainStaticEndpoints = function() {
                return _this.endpoint;
            };
            this.obtainMainScope = function() {
                return window.stApp;
            };
            this.obtainCart = function() {
                return window.shopifyCartData;
            };
            this.injectRootToEndpoints = function(endpoints) {
                for (var controllerKey in endpoints) {
                    for (var endpoint in endpoints[controllerKey]) {
                        endpoints[controllerKey][endpoint] = endpoints[controllerKey][endpoint].replace(/\|\|-API-ROOT-\|\|/g, _this.apiRoot);
                    }
                }
                return endpoints;
            };
            this.endpoint = this.injectRootToEndpoints(routes_config_1.endpointData);
        }
        StStatic.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        return StStatic;
    }();
    exports.StStatic = StStatic;
});

define("core/shopify-app/st-modules/_general-methods/ajax", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAjax = void 0;
    var StAjax = function() {
        function StAjax() {}
        StAjax.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        StAjax.prototype.setupFormatting = function(objectToQueryStringFn) {
            this.objectToQueryString = objectToQueryStringFn;
        };
        StAjax.prototype.determineContentType = function(contentType) {
            var output = {
                type: "application/x-www-form-urlencoded",
                prepFn: this.objectToQueryString
            };
            switch (contentType) {
              case "form":
                output.type = "application/x-www-form-urlencoded";
                output.prepFn = this.objectToQueryString;
                break;

              case "json":
                output.type = "application/json";
                output.prepFn = JSON.stringify;
                break;
            }
            return output;
        };
        StAjax.prototype.send = function(options) {
            var fnReference = this;
            if (typeof options == "object") {
                var defaultOptions = {
                    endpoint: "",
                    method: "POST",
                    contentType: "json",
                    data: {},
                    callback: function() {},
                    callbackParams: []
                };
                var completeOptions_1 = __assign(__assign({}, defaultOptions), options);
                var contentTypeData = this.determineContentType(completeOptions_1.contentType);
                var requestMethod = completeOptions_1.method.toUpperCase();
                var allowedMethods = [ "POST", "GET", "PUT", "DELETE" ];
                completeOptions_1.method = allowedMethods.indexOf(requestMethod) >= 0 ? requestMethod : "POST";
                var request_1 = new XMLHttpRequest();
                request_1.open(completeOptions_1.method, completeOptions_1.endpoint, true);
                request_1.withCredentials = true;
                request_1.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                request_1.setRequestHeader("Content-Type", contentTypeData.type);
                request_1.setRequestHeader("credentials", "include");
                request_1.onreadystatechange = function() {
                    if (request_1.readyState === 4) {
                        completeOptions_1.callbackParams.unshift(request_1);
                        completeOptions_1.callback.apply(fnReference, completeOptions_1.callbackParams);
                    }
                };
                request_1.send(contentTypeData.prepFn(completeOptions_1.data));
                return request_1;
            }
        };
        return StAjax;
    }();
    exports.StAjax = StAjax;
});

define("core/shopify-app/st-modules/_di-container/st.module.interface", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/_di-container/di.container.public", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, dom_loaded_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.DiContainerPublic = void 0;
    var DiContainerPublic = function() {
        function DiContainerPublic() {
            this.className = "DI";
            this.subscribeDOMLoaded = function(cb) {
                dom_loaded_1.StDOMLoaded.Instance().subscribeDOMLoaded(cb);
            };
            this.init = function() {};
            this.setup = function() {};
        }
        return DiContainerPublic;
    }();
    exports.DiContainerPublic = DiContainerPublic;
});

define("core/shopify-app/st-modules/_di-container/st.module", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/ajax", "core/shopify-app/st-modules/_static/static", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, ajax_1, static_1, dom_loaded_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StModule = void 0;
    var StModule = function() {
        function StModule(args) {
            var _this = this;
            this.dependency = [];
            this.init = function() {};
            this.setup = function() {
                if (!_this.setupFlag) {
                    if (_this.hasOwnProperty("init")) {
                        _this.setupFlag = true;
                        _this.init();
                        _this.dependency.forEach(function(dependency) {
                            dependency.setup();
                        });
                    }
                }
            };
            this.dependency = args && args.length > 0 ? __spreadArray([], args, true) : [];
            this.Static = static_1.StStatic.Instance();
            this.endpoint = this.Static.obtainStaticEndpoints();
            this.cart = this.Static.obtainCart();
            this.ajax = ajax_1.StAjax.Instance();
            this.subscribeDOMLoaded = dom_loaded_2.StDOMLoaded.Instance().subscribeDOMLoaded;
            this.setupFlag = false;
        }
        return StModule;
    }();
    exports.StModule = StModule;
});

define("core/shopify-app/st-modules/_di-container/di.container.setup", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, dom_loaded_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDIContainerSetup = void 0;
    var StDIContainerSetup = function() {
        function StDIContainerSetup(appName, StAppDIConfig) {
            var _this = this;
            this.className = "DI";
            this.getModules = function(appName) {
                return _this.StAppDIConfig.Instance.hierarchy(appName);
            };
            if (!window.stApp) window.stApp = {};
            this.StAppDIConfig = StAppDIConfig;
            this.init(appName);
        }
        StDIContainerSetup.prototype.init = function(appName) {
            document.querySelector("body").classList.add("st_app-".concat(appName));
            this.mainServices = this.getModules(appName);
            this.mainServices.forEach(function(service) {
                if (service.className) {
                    window.stApp[service.className] = service;
                    service.setup();
                } else {
                    console.error("Instance has no className: ", service);
                }
            });
            dom_loaded_3.StDOMLoaded.Instance().initDOMLoaded();
        };
        return StDIContainerSetup;
    }();
    exports.StDIContainerSetup = StDIContainerSetup;
});

define("core/shopify-app/st-modules/_general-methods/cookies/cookies", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCookies = void 0;
    var StCookies = function(_super) {
        __extends(StCookies, _super);
        function StCookies() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Cookies";
            _this_1.init = function() {
                var _this = _this_1;
                _this_1.subscribeDOMLoaded(function() {
                    _this.initCookieApi();
                    _this.onPrivacyBannerAction();
                });
            };
            _this_1.initCookieApi = function() {
                var wShopify = window.Shopify;
                if (!!wShopify) {
                    wShopify.loadFeatures([ {
                        name: "consent-tracking-api",
                        version: "0.1"
                    } ], function(error) {
                        if (error) {
                            throw error;
                        }
                        _this_1.showPrivacyBanner();
                    });
                }
            };
            _this_1.showPrivacyBanner = function() {
                var wShopify = window.Shopify;
                var shouldShowBanner = wShopify.customerPrivacy.shouldShowGDPRBanner();
                var banner = document.querySelector(".st_privacy-bar_JS");
                if (!!banner && shouldShowBanner) {
                    banner.removeAttribute("hidden");
                }
            };
            _this_1.hidePrivacyBanner = function() {
                var banner = document.querySelector(".st_privacy-bar_JS");
                if (!!banner) {
                    banner.setAttribute("hidden", "");
                }
            };
            _this_1.onPrivacyBannerAction = function() {
                var _this = _this_1;
                var privacyBannerBtnList = document.querySelectorAll(".st_privacy-banner-btn_JS");
                if ((privacyBannerBtnList === null || privacyBannerBtnList === void 0 ? void 0 : privacyBannerBtnList.length) > 0) {
                    privacyBannerBtnList.forEach(function(btn) {
                        btn.addEventListener("click", function() {
                            var btnDataAction = btn.getAttribute("data-action");
                            var wShopify = window === null || window === void 0 ? void 0 : window.Shopify;
                            wShopify.customerPrivacy.setTrackingConsent(btnDataAction === "accept", _this.hidePrivacyBanner);
                        });
                    });
                }
            };
            _this_1.getCookie = function(cookieKey) {
                return window.localStorage.getItem(cookieKey);
            };
            _this_1.setCookies = function(cookieKey, cookieValue) {
                window.localStorage.setItem(cookieKey, cookieValue);
            };
            _this_1.clearCookie = function(cookieKey) {
                window.localStorage.removeItem(cookieKey);
            };
            _this_1.clearAllCookie = function() {
                window.localStorage.clear();
            };
            return _this_1;
        }
        return StCookies;
    }(st_module_1.StModule);
    exports.StCookies = StCookies;
});

define("_features.config", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.useCommissionEngineIdInRewardCode = exports.rewardItemCollectionId = exports.rewardDiscountMinimum = exports.rewardCodePrefix = exports.rewardAmount = exports.rewardType = exports.shareRefCodeFunctionality = exports.discountUsageLimit = exports.discountCollectionSpend = exports.discountMinimumRequirement = exports.discountSegmentConditionTag = exports.discountNamePrefix = exports.discountAmount = exports.discountType = exports.enrollmentParams = exports.reasonForRefundWhenReturnMoney = exports.availableRechargeUsage = exports.sponsorGenealogyTimeout = exports.wineCellarRedirectUrl = exports.downgradeRepresentativeByDesignWebhook = exports.cronJobReSyncOrders = exports.repDiscountWithPromoCode = exports.searchSponsorsMinNumOfResult = exports.searchSponsorsFetchAttemptsLimit = exports.representative = exports.commissionEngine = exports.autoshipItems = exports.productVolumesConfig = exports.EProductPriceType = exports.sampleSKUs = exports.ECustomerType = exports.defaultCorporationImage = exports.additionalRepInfo = exports.activeLastSponsorFeature = exports.canGoUnderCorporateSite = exports.lockedRepresentativeSite = exports.samplerAdditionalItemQuantityLimit = exports.samplerLoadingPageRoute = exports.referralRewardDiscountTitle = exports.samplerLinkQueryParam = exports.cartTokenQueryParam = exports.referralQueryParam = exports.corporationName = exports.aliasQueryParam = exports.defaultWebAlias = void 0;
    exports.defaultWebAlias = "wineshopathome";
    exports.aliasQueryParam = "ref";
    exports.corporationName = "WineShop At Home";
    exports.referralQueryParam = "cref";
    exports.cartTokenQueryParam = "cartToken";
    exports.samplerLinkQueryParam = "sampler";
    exports.referralRewardDiscountTitle = "winediscount";
    exports.samplerLoadingPageRoute = "pages/load-sampler";
    exports.samplerAdditionalItemQuantityLimit = "3";
    exports.lockedRepresentativeSite = false;
    exports.canGoUnderCorporateSite = true;
    exports.activeLastSponsorFeature = true;
    exports.additionalRepInfo = false;
    exports.defaultCorporationImage = "https://codemancystudio.com/cdm_template/wp-content/uploads/2018/03/cdm-logo-blacksmall.png";
    var ECustomerType;
    (function(ECustomerType) {
        ECustomerType["retail"] = "retail";
        ECustomerType["representative"] = "affiliate";
        ECustomerType["guest"] = "guest";
        ECustomerType["noType"] = "";
    })(ECustomerType = exports.ECustomerType || (exports.ECustomerType = {}));
    exports.sampleSKUs = [ "41-0050", "41-0040", "41-0070", "41-0060" ];
    var EProductPriceType;
    (function(EProductPriceType) {
        EProductPriceType["retail"] = "retail";
        EProductPriceType["representative"] = "representative";
        EProductPriceType["noSpecificType"] = "";
    })(EProductPriceType = exports.EProductPriceType || (exports.EProductPriceType = {}));
    exports.productVolumesConfig = {
        cv: false,
        qv: false,
        bv: false,
        cvMetafieldKey: "cvolume",
        qvMetafieldKey: "qvolume",
        bvMetafieldKey: "bvolume",
        Volume: "cv",
        Volume2: "qv",
        Volume3: "bv",
        calculatePriceAsVolume: false,
        generalPriceVolumePercentage: 1,
        retailVolumeAndPricePercentage: 1,
        representativeVolumeAndPricePercentage: 1
    };
    exports.autoshipItems = [ "AUTOSHIP-1", "AUTOSHIP-2", "consultant-kit", "enrollment-bundle" ];
    exports.commissionEngine = "ByDesign";
    exports.representative = "representative";
    exports.searchSponsorsFetchAttemptsLimit = 3;
    exports.searchSponsorsMinNumOfResult = 3;
    exports.repDiscountWithPromoCode = false;
    exports.cronJobReSyncOrders = false;
    exports.downgradeRepresentativeByDesignWebhook = false;
    exports.wineCellarRedirectUrl = "https://winecellar.wineshopathome.com/shapetech/catch.php?JWT=";
    exports.sponsorGenealogyTimeout = 6e5;
    exports.availableRechargeUsage = false;
    exports.reasonForRefundWhenReturnMoney = "refundmoney";
    exports.enrollmentParams = [ "SSN", "dateOfBirth", "day", "email", "firstName", "lastName", "month", "optionalKitRecurring", "optionalKits", "phoneNumber", "requiredKitRecurring", "requiredKits", "shopifyId", "sponsorWebAlias", "sponsorsWebAlias", "webAlias", "year" ];
    exports.discountType = "fixed_amount";
    exports.discountAmount = 10;
    exports.discountNamePrefix = "Core_";
    exports.discountSegmentConditionTag = "no_order";
    exports.discountMinimumRequirement = "1.00";
    exports.discountCollectionSpend = 405622423800;
    exports.discountUsageLimit = 10;
    exports.shareRefCodeFunctionality = false;
    exports.rewardType = "fixed_amount";
    exports.rewardAmount = 20;
    exports.rewardCodePrefix = "RewardedFrom-";
    exports.rewardDiscountMinimum = 1;
    exports.rewardItemCollectionId = 405622423800;
    exports.useCommissionEngineIdInRewardCode = true;
});

define("core/shopify-app/st-modules/_general-methods/form/customer-type", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_2, _features_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCustomerType = void 0;
    var StCustomerType = function(_super) {
        __extends(StCustomerType, _super);
        function StCustomerType() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "CustomerType";
            _this.init = function() {};
            _this.get = function() {
                var customerType;
                if (!!window.customerInfoMetafields.customerType) {
                    customerType = window.customerInfoMetafields.customerType;
                } else {
                    customerType = _features_config_1.ECustomerType.guest;
                }
                return customerType;
            };
            return _this;
        }
        return StCustomerType;
    }(st_module_2.StModule);
    exports.StCustomerType = StCustomerType;
});

define("core/shopify-app/st-modules/_general-methods/object-formatting", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StObjectFormatting = void 0;
    var StObjectFormatting = function(_super) {
        __extends(StObjectFormatting, _super);
        function StObjectFormatting() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ObjectFormatting";
            _this.convertObjectToQueryString = function(object) {
                var string = "", i = 0;
                for (var j in object) {
                    var s = encodeURIComponent(j) + "=" + encodeURIComponent(object[j]);
                    string += i > 0 ? "&" + s : s;
                    i++;
                }
                return "?" + string;
            };
            _this.convertQueryStringToObject = function(query) {
                query = typeof query != "string" ? "" : query.substr(query.indexOf("?") + 1);
                var query_string = {};
                if (query !== "") {
                    var vars = query.split("&");
                    for (var i = 0; i < vars.length; i++) {
                        var pair = vars[i].split("=");
                        var key = decodeURIComponent(pair[0]);
                        var value = decodeURIComponent(pair[1]);
                        if (typeof query_string[key] === "undefined") {
                            query_string[key] = decodeURIComponent(value);
                        } else if (typeof query_string[key] === "string") {
                            query_string[key] = [ query_string[key], decodeURIComponent(value) ];
                        } else {
                            query_string[key].push(decodeURIComponent(value));
                        }
                    }
                } else {
                    console.warn("Invalid query string supplied to convertQueryStringToObject.");
                }
                return query_string;
            };
            _this.ajax.setupFormatting(_this.convertObjectToQueryString);
            return _this;
        }
        return StObjectFormatting;
    }(st_module_3.StModule);
    exports.StObjectFormatting = StObjectFormatting;
});

define("core/shopify-app/st-modules/_general-methods/browser-history", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StBrowserHistory = void 0;
    var StBrowserHistory = function(_super) {
        __extends(StBrowserHistory, _super);
        function StBrowserHistory(objectFormatting) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "BrowserHistory";
            _this.pushHistory = function(rootURL, urlParams) {
                var serializedUrlParams = _this.objectFormatting.convertObjectToQueryString(urlParams);
                window.history.replaceState(urlParams, "", rootURL + serializedUrlParams);
            };
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        return StBrowserHistory;
    }(st_module_4.StModule);
    exports.StBrowserHistory = StBrowserHistory;
});

define("core/connector-app/_shared/models/webalias/webalias.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/_general-methods/general-methods", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGeneralMethods = void 0;
    var StGeneralMethods = function(_super) {
        __extends(StGeneralMethods, _super);
        function StGeneralMethods() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "GeneralMethods";
            _this.scrollTo = function(element, duration, offset) {
                if (offset === void 0) {
                    offset = 150;
                }
                var startingY = window.scrollY;
                var elementY = window.scrollY + element.getBoundingClientRect().top - offset;
                var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
                var diff = targetY - startingY;
                var easing = function(t) {
                    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
                };
                var start;
                if (!diff) return;
                window.requestAnimationFrame(function step(timestamp) {
                    if (!start) start = timestamp;
                    var time = timestamp - start;
                    var percent = Math.min(time / duration, 1);
                    percent = easing(percent);
                    window.scrollTo(0, startingY + diff * percent);
                    if (time < duration) {
                        window.requestAnimationFrame(step);
                    }
                });
            };
            return _this;
        }
        StGeneralMethods.prototype.getClosestByClass = function(el, cls) {
            var res = el;
            while ((res = res.parentElement) && !res.classList.contains(cls));
            return res;
        };
        StGeneralMethods.prototype.getClosestByTag = function(el, tagName) {
            var res = el;
            while ((res = res.parentElement) && !res.tagName === tagName);
            return res;
        };
        return StGeneralMethods;
    }(st_module_5.StModule);
    exports.StGeneralMethods = StGeneralMethods;
});

define("core/shopify-app/st-modules/webalias/webalias-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAliasClassConfig = void 0;
    var StWebAliasClassConfig = function(_super) {
        __extends(StWebAliasClassConfig, _super);
        function StWebAliasClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StWebAliasClassConfig";
            _this.classNameRepId = "st_representative-id_JS";
            _this.selectorRepId = "." + _this.classNameRepId;
            _this.classNameRepAlias = "st_representative-alias_JS";
            _this.selectorRepAlias = "." + _this.classNameRepAlias;
            _this.classNameRepFullName = "st_representative-fullname_JS";
            _this.selectorRepFullName = "." + _this.classNameRepFullName;
            _this.classNameRepInitials = "st_representative-initials_JS";
            _this.selectorRepInitials = "." + _this.classNameRepInitials;
            _this.classNameRepSite = "st_representative-site_JS";
            _this.selectorRepSite = "." + _this.classNameRepSite;
            _this.classNameRepBio = "st_representative-site-bio_JS";
            _this.selectorRepBio = "." + _this.classNameRepBio;
            _this.classNameRepAddress = "st_representative-address_JS";
            _this.selectorRepAddress = "." + _this.classNameRepAddress;
            _this.classNameNonSponsor = "st_non-sponsor_JS";
            _this.selectorNonSponsor = "." + _this.classNameNonSponsor;
            _this.classRepresentativeBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeBannerWrapper = "." + _this.classRepresentativeBannerWrapper;
            _this.classNameBusinessContentRepName = "st_account-business--rep-name_JS";
            _this.selectorBusinessContentRepName = "." + _this.classNameBusinessContentRepName;
            _this.classNamePersonalInfoForm = "st_personal-info-form_JS";
            _this.selectorPersonalInfoForm = "." + _this.classNamePersonalInfoForm;
            _this.classNamePersonalInfoRepFullName = "st_representative-info-fullname_JS";
            _this.selectorPersonalInfoRepFullName = "." + _this.classNamePersonalInfoRepFullName;
            return _this;
        }
        return StWebAliasClassConfig;
    }(st_module_6.StModule);
    exports.StWebAliasClassConfig = StWebAliasClassConfig;
});

define("core/shopify-app/st-modules/webalias/inject-representative-info", [ "require", "exports", "_features.config", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, _features_config_2, st_module_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInjectRepresentativeInfo = void 0;
    var StInjectRepresentativeInfo = function(_super) {
        __extends(StInjectRepresentativeInfo, _super);
        function StInjectRepresentativeInfo(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "InjectRepresentativeInfo";
            _this.injectToFields = function(repInfo) {
                var repId = repInfo.repId, webAlias = repInfo.webAlias, firstName = repInfo.firstName, lastName = repInfo.lastName, imageUrl = repInfo.imageUrl;
                if (!!repId) {
                    _this.appendIdToField(repInfo.repId);
                }
                if (!!webAlias) {
                    _this.appendAlsToField(webAlias);
                    _this.appendRepSiteUrlToField(webAlias);
                }
                if (!!firstName || !!lastName) {
                    _this.appendRepFullNameToField(firstName, lastName, webAlias);
                }
                if (!!imageUrl && _features_config_2.additionalRepInfo) {
                    _this.appendRepBioToField(imageUrl);
                }
            };
            _this.injectSponsorInfoToField = function(firstName, lastName) {
                var repNameSelector = document.querySelector(_this.classConfig.selectorBusinessContentRepName);
                if (!!repNameSelector) {
                    if (firstName !== "" || lastName !== "") {
                        repNameSelector.innerHTML = firstName + " " + lastName;
                    } else {
                        repNameSelector.innerHTML = "no name";
                    }
                }
                var personalInformationRep = document.querySelector(_this.classConfig.selectorPersonalInfoRepFullName);
                if (!!personalInformationRep) {
                    if (firstName || lastName) {
                        repNameSelector.innerHTML = firstName + " " + lastName;
                    } else {
                        repNameSelector.innerHTML = "no name";
                    }
                }
            };
            _this.appendIdToField = function(id) {
                var repAliasFields = document.querySelectorAll(_this.classConfig.selectorRepId);
                if (repAliasFields.length > 0) {
                    _this.appendValueToFields(repAliasFields, id);
                }
            };
            _this.appendAlsToField = function(alias) {
                var repAliasFields = document.querySelectorAll(_this.classConfig.selectorRepAlias);
                if (repAliasFields.length > 0) {
                    _this.appendValueToFields(repAliasFields, alias);
                }
            };
            _this.appendRepSiteUrlToField = function(alias) {
                var repSiteFields = document.querySelectorAll(_this.classConfig.selectorRepSite);
                var repSite = window.location.origin + "/?als=" + alias;
                if (repSiteFields.length > 0) {
                    _this.appendValueToFields(repSiteFields, repSite);
                }
            };
            _this.appendRepFullNameToField = function(repFirstName, repLastName, webAlias) {
                var repFullNameFields = document.querySelectorAll(_this.classConfig.selectorRepFullName);
                var fullName = _this.getFullName(repFirstName, repLastName, webAlias);
                if (repFullNameFields.length > 0) {
                    _this.appendValueToFields(repFullNameFields, fullName);
                }
            };
            _this.appendRepBioToField = function(imageUrl) {
                var repImages = document.querySelectorAll(_this.classConfig.selectorRepBio);
                var imageString = 'BIO: <img class="" style="width: 50px; height: auto;" alt="representatve image" src="' + imageUrl + '">';
                if (repImages.length > 0) {
                    repImages.forEach(function(field) {
                        return field.innerHTML = imageString;
                    });
                }
            };
            _this.getFullName = function(repFirstName, repLastName, webAlias) {
                var fullName = "";
                if (!!repFirstName) {
                    fullName = repFirstName;
                    if (!!repLastName) {
                        fullName += " " + repLastName;
                    }
                }
                if (webAlias === _features_config_2.defaultWebAlias) {
                    fullName = _features_config_2.corporationName;
                }
                return fullName;
            };
            _this.appendValueToFields = function(fields, value) {
                fields.forEach(function(field) {
                    if (field.tagName.toLowerCase() === "input") {
                        field.value = value;
                    } else if (field.tagName.toLowerCase() === "a") {
                        field.setAttribute("href", value);
                    } else {
                        field.innerHTML = value;
                    }
                });
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StInjectRepresentativeInfo;
    }(st_module_7.StModule);
    exports.StInjectRepresentativeInfo = StInjectRepresentativeInfo;
});

define("core/shopify-app/st-modules/cart/cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_8) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCart = void 0;
    var StCart = function(_super) {
        __extends(StCart, _super);
        function StCart() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Cart";
            _this_1.reloadSubscriber = [];
            _this_1.cartInterceptorEndpoints = [ "/cart/add", "/cart/update", "/cart/change", "/cart/clear", "/wallets/checkouts/" ];
            _this_1.shopifyCartApiEndpoints = {
                "get-cart": "/cart.js",
                "add-to-cart": "/cart/add.js",
                "clear-cart": "/cart/clear.js",
                "change-cart": "/cart/change.js",
                "update-cart": "/cart/update.js"
            };
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.cartFetchInterceptorInit();
                });
            };
            _this_1.cartFetchInterceptorInit = function() {
                var originalFetch = window.fetch;
                window.fetch = function() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return __awaiter(_this_1, void 0, void 0, function() {
                        var resource, config, response;
                        return __generator(this, function(_a) {
                            switch (_a.label) {
                              case 0:
                                resource = args[0], config = args[1];
                                return [ 4, originalFetch(resource, config) ];

                              case 1:
                                response = _a.sent();
                                if (this.isCartChangeRequest(response.url)) {
                                    this.getCart(this.handleChangeCartInterceptor);
                                }
                                return [ 2, response ];
                            }
                        });
                    });
                };
            };
            _this_1.handleChangeCartInterceptor = function(cartObj) {
                try {
                    _this_1.setShopifyCartData(cartObj);
                    _this_1.addOrEditPropertiesForWebAlias(cartObj.items, cartObj.attributes.sponsorWebAlias);
                    _this_1.fireAllCallbacks(cartObj);
                } catch (err) {
                    console.error("handleChangeCartInterceptor ---\x3e Error:", err);
                }
            };
            _this_1.initCartSetup = function() {
                _this_1.getCart(function(cartObj) {
                    _this_1.setShopifyCartData(cartObj);
                });
            };
            _this_1.fireAllCallbacks = function(cartObject) {
                _this_1.fireChangeCartCallbacks(cartObject);
                setTimeout(function() {
                    _this_1.fireRenderCartCallbacks();
                }, 1e3);
            };
            _this_1.subscribeChangeCart = function(callback) {
                _this_1.subCallbacks.push(callback);
            };
            _this_1.fireChangeCartCallbacks = function(cartObject) {
                if (_this_1.subCallbacks.length > 0) {
                    _this_1.subCallbacks.forEach(function(callback) {
                        callback(cartObject);
                    });
                }
            };
            _this_1.subscribeRenderCart = function(callback) {
                _this_1.subRenderCartCallbacks.push(callback);
            };
            _this_1.fireRenderCartCallbacks = function() {
                if (_this_1.subRenderCartCallbacks.length > 0) {
                    _this_1.subRenderCartCallbacks.forEach(function(callback) {
                        callback();
                    });
                }
            };
            _this_1.matchUrlSnippet = function(url, urlSnippetArr) {
                for (var i = 0; i < urlSnippetArr.length; i++) {
                    if (url.includes(urlSnippetArr[i])) {
                        return true;
                    }
                }
                return false;
            };
            _this_1.isGetCartRequest = function(url) {
                return url.endsWith("/cart.json");
            };
            _this_1.isCartChangeRequest = function(url) {
                return _this_1.matchUrlSnippet(url, _this_1.cartInterceptorEndpoints);
            };
            _this_1.setShopifyCartData = function(cartObj) {
                window.shopifyCartData = cartObj;
                _this_1.setCartInfo(cartObj);
            };
            _this_1.handleChangeCartResponseGeneric = function(res, handleFunc, cartRefresh) {
                if (handleFunc === void 0) {
                    handleFunc = function() {};
                }
                if (cartRefresh === void 0) {
                    cartRefresh = true;
                }
                try {
                    var cartRes_1 = JSON.parse(res.response);
                    _this_1.getCart(function(cartObj) {
                        _this_1.setShopifyCartData(cartObj);
                        if (cartRefresh) {
                            _this_1.requestCartRefresh(cartObj);
                        }
                        _this_1.fireAllCallbacks(cartObj);
                        handleFunc(cartRes_1);
                    });
                } catch (err) {
                    console.log("handleChangeCartResponseGeneric ---\x3e Error: ", err);
                }
            };
            _this_1.getCart = function(responseHandle) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["get-cart"],
                        method: "GET",
                        contentType: "json",
                        callback: function(res) {
                            try {
                                console.log("ALOOOOO BREEEE" + res.response);
                                var cartObj = JSON.parse(res.response);
                                responseHandle(cartObj);
                            } catch (err) {
                                console.log("Cart Api Error: ", err);
                            }
                        }
                    });
                } catch (err) {
                    console.log("Get Cart ---\x3e Error:", err);
                }
            };
            _this_1.clearCart = function(responseHandle, cartRefresh) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["clear-cart"],
                        method: "POST",
                        contentType: "json",
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle, cartRefresh);
                        }
                    });
                } catch (err) {
                    console.log("Clear Cart ---\x3e Error:", err);
                }
            };
            _this_1.changeCart = function(changeData, responseHandle, cartRefresh) {
                if (cartRefresh === void 0) {
                    cartRefresh = true;
                }
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["change-cart"],
                        method: "POST",
                        contentType: "json",
                        data: changeData,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle, cartRefresh);
                        }
                    });
                } catch (err) {
                    console.log("Change Cart ---\x3e Error:", err);
                }
            };
            _this_1.updateCart = function(updateData, responseHandle) {
                try {
                    var data = Array.isArray(updateData) ? {
                        updates: updateData
                    } : updateData;
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["update-cart"],
                        method: "POST",
                        contentType: "json",
                        data: data,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Update Cart ---\x3e Error:", err);
                }
            };
            _this_1.addCart = function(addData, responseHandle, cartRefresh) {
                try {
                    var data = Array.isArray(addData) ? {
                        items: addData
                    } : addData;
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["add-to-cart"],
                        method: "POST",
                        contentType: "json",
                        data: data,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle, cartRefresh);
                        }
                    });
                } catch (err) {
                    console.log("Add To Cart ---\x3e Error:", err);
                }
            };
            _this_1.requestCartRefresh = function(cart) {
                var isCartPage = location.pathname === "/cart";
                if (isCartPage) {
                    var _this_2 = _this_1;
                    var refreshIndex_1 = _this_1.subscribeCartReload();
                    setTimeout(function() {
                        _this_2.triggerCartReload(refreshIndex_1);
                    }, 500);
                }
                if (!isCartPage) {
                    _this_1.ajax.send({
                        endpoint: "".concat(window.Shopify.routes.root, "?section_id=cart-drawer"),
                        method: "GET",
                        callback: function(request) {
                            var cartDrawerTemplate = request.responseText;
                            _this_1.ajax.send({
                                endpoint: "".concat(window.Shopify.routes.root, "?section_id=variant-added"),
                                method: "GET",
                                callback: function(request) {
                                    var variantAddedTemplate = request.responseText;
                                    _this_1.triggerCartRefresh(cart, {
                                        "cart-drawer": cartDrawerTemplate,
                                        "variant-added": variantAddedTemplate
                                    });
                                }
                            });
                        }
                    });
                }
            };
            _this_1.triggerCartRefresh = function(cart, sections) {
                var addEvt = new CustomEvent("variant:add");
                var cartRefreshEvt = new CustomEvent("cart:refresh");
                var totalQuantity = cart.items.reduce(function(acc, item) {
                    return acc + item.quantity;
                }, 0);
                var cartChangeEvt = new CustomEvent("cart:change", {
                    detail: {
                        cart: __assign(__assign({}, cart), {
                            item_count: totalQuantity,
                            sections: sections
                        })
                    }
                });
                document.dispatchEvent(cartChangeEvt);
                document.dispatchEvent(cartRefreshEvt);
                document.dispatchEvent(addEvt);
            };
            _this_1.setCartInfo = function(shopifyCart) {
                _this_1.cart = __assign(__assign({}, _this_1.cart), shopifyCart);
            };
            _this_1.updateCartItemsProperies = function(alias) {
                _this_1.getCart(function(cartResponse) {
                    var attributes = cartResponse.attributes;
                    attributes = __assign(__assign({}, attributes), {
                        sponsorWebAlias: !!alias ? alias : ""
                    });
                    var updateAttributes = {
                        attributes: attributes
                    };
                    _this_1.updateCartAttributesOrNote(updateAttributes, function(cartRes) {});
                });
            };
            _this_1.addOrEditPropertiesForWebAlias = function(cartItems, alias) {
                var _a;
                var updateCartProperties = false;
                var item = {};
                var itemWithProperties = cartItems.find(function(item) {
                    var _a;
                    return ((_a = item.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) !== undefined;
                });
                var duplicateItem = cartItems.find(function(item) {
                    var _a;
                    return item.sku === (itemWithProperties === null || itemWithProperties === void 0 ? void 0 : itemWithProperties.sku) && ((_a = item.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) === undefined;
                });
                if (!itemWithProperties && cartItems.length > 0) {
                    item = cartItems[cartItems.length - 1];
                    updateCartProperties = true;
                } else if (duplicateItem) {
                    item = duplicateItem;
                    updateCartProperties = true;
                } else if (itemWithProperties && ((_a = itemWithProperties.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) !== alias) {
                    item = itemWithProperties;
                    updateCartProperties = true;
                }
                var refreshCart = !!duplicateItem;
                if (updateCartProperties) {
                    _this_1.updateItemProperties(item, alias, refreshCart);
                }
            };
            _this_1.updateItemProperties = function(item, alias, refreshCart) {
                var updateData = {
                    id: "".concat(item.key),
                    quantity: item.quantity,
                    properties: __assign(__assign({}, item.properties), {
                        _sponsorWebAlias: alias
                    })
                };
                _this_1.changeCart(updateData, function(updatedCart) {}, refreshCart);
            };
            _this_1.updateCartAttributesOrNote = function(updateData, responseHandle) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["update-cart"],
                        method: "POST",
                        contentType: "json",
                        data: updateData,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGenericNoRefresh(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Update Cart ---\x3e Error:", err);
                }
            };
            _this_1.handleChangeCartResponseGenericNoRefresh = function(res, handleFunc) {
                try {
                    var cartRes = JSON.parse(res.response);
                    handleFunc(cartRes);
                    _this_1.getCart(function(cartObj) {
                        _this_1.setShopifyCartData(cartObj);
                        _this_1.handleChangeCartInterceptor(cartObj);
                    });
                } catch (err) {
                    console.log("handleChangeCartResponseGenericNoRefresh ---\x3e Error: ", err);
                }
            };
            _this_1.subscribeCartReload = function() {
                _this_1.reloadSubscriber.push(false);
                return _this_1.reloadSubscriber.length - 1;
            };
            _this_1.triggerCartReload = function(index) {
                var shouldRefresh = true;
                _this_1.reloadSubscriber[index] = true;
                for (var i = 0; i < _this_1.reloadSubscriber.length; i++) {
                    if (_this_1.reloadSubscriber[i] === false) {
                        shouldRefresh = false;
                        break;
                    }
                }
                if (shouldRefresh) window.location.reload();
            };
            _this_1.subCallbacks = [];
            _this_1.subRenderCartCallbacks = [];
            return _this_1;
        }
        Object.defineProperty(StCart.prototype, "getShopifyCartData", {
            get: function() {
                return window.shopifyCartData;
            },
            enumerable: false,
            configurable: true
        });
        return StCart;
    }(st_module_8.StModule);
    exports.StCart = StCart;
});

define("core/shopify-app/st-modules/search-sponsor/sponsor-search-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorClassConfig = void 0;
    var StSearchSponsorClassConfig = function(_super) {
        __extends(StSearchSponsorClassConfig, _super);
        function StSearchSponsorClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorClassConfig";
            _this.classNameSponsorId = "st_sponsor-id_JS";
            _this.selectorSponsorId = "." + _this.classNameSponsorId;
            _this.classNameSponsorAlias = "st_sponsor-alias_JS";
            _this.selectorSponsorAlias = "." + _this.classNameSponsorAlias;
            _this.classNameSponsorFullName = "st_sponsor-fullname_JS";
            _this.selectorSponsorFullName = "." + _this.classNameSponsorFullName;
            _this.classNameSponsorInitials = "st_sponsor-initials_JS";
            _this.selectorSponsorInitials = "." + _this.classNameSponsorInitials;
            _this.classNameSponsorAddress = "st_sponsor-address_JS";
            _this.selectorSponsorAddress = "." + _this.classNameSponsorAddress;
            _this.classNameSearchSponsorWrapperPage = "st_search-sponsor--wrapper_JS";
            _this.selectorSearchSponsorWrapperPage = "." + _this.classNameSearchSponsorWrapperPage;
            _this.classNameInputBoxPage = "st_search-sponsor--by-id_JS";
            _this.selectorInputBoxPage = "." + _this.classNameInputBoxPage;
            _this.classNameChangeSponsorWrapperlink = "st_change-sponsor--wrapper_JS";
            _this.selectorChangeSponsorWrapperLink = "." + _this.classNameChangeSponsorWrapperlink;
            _this.classNameChangeSponsorWrapper = "st_change-sponsor_JS";
            _this.selectorChangeSponsorWrapper = "." + _this.classNameChangeSponsorWrapper;
            _this.classNameSearchInput = "st_search-input_JS";
            _this.selectorSearchInput = "." + _this.classNameSearchInput;
            _this.classNameNonSponsor = "st_non-sponsor_JS";
            _this.selectorNonSponsor = "." + _this.classNameNonSponsor;
            _this.classNameChooseSponsor = "st_choose-sponsor_JS";
            _this.selectorChooseSponsor = "." + _this.classNameChooseSponsor;
            _this.classNameSearchResult = "st_search-result_JS";
            _this.selectorSearchResult = "." + _this.classNameSearchResult;
            _this.classNameRepresentativeAlias = "st_representative-alias_JS";
            _this.selectorRepresentativeAlias = "." + _this.classNameRepresentativeAlias;
            _this.classNameRepresentativeFullName = "st_representative-fullname_JS";
            _this.selectorRepresentativeFullName = "." + _this.classNameRepresentativeFullName;
            _this.classNameSponsorData = "st_sponsor-data_JS";
            _this.selectorSponsorData = "." + _this.classNameSponsorData;
            _this.classNameSearchSponsor = "st_search-sponsors_JS";
            _this.selectorSearchSponsor = "." + _this.classNameSearchSponsor;
            _this.classNameFoundSponsor = "st_found-sponsors_JS";
            _this.selectorFoundSponsor = "." + _this.classNameFoundSponsor;
            _this.classNameSearchSponsorBy = "st_search-sponsor-by_JS";
            _this.selectorSearchSponsorBy = "." + _this.classNameSearchSponsorBy;
            _this.classNameRadioText = "st_radio-text";
            _this.selectorRadioText = "." + _this.classNameRadioText;
            _this.classRepresentativeBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeBannerWrapper = "." + _this.classRepresentativeBannerWrapper;
            return _this;
        }
        return StSearchSponsorClassConfig;
    }(st_module_9.StModule);
    exports.StSearchSponsorClassConfig = StSearchSponsorClassConfig;
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor-guard", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_10, _features_config_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorGuard = void 0;
    var StSearchSponsorGuard = function(_super) {
        __extends(StSearchSponsorGuard, _super);
        function StSearchSponsorGuard(classConfig, browserHistory, objectFormatting, generalMethods, cartComponent) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorGuard";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.listenForSponsorChange();
                    _this.cartComponent.subscribeRenderCart(function() {
                        var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                        var currentAlias = urlParams[_features_config_3.aliasQueryParam];
                        _this.toggleCantGoUnderCorporateSite(currentAlias === _features_config_3.defaultWebAlias);
                    });
                });
            };
            _this.toggleElementVisibility = function(element, hideElement) {
                if (hideElement) {
                    _this.hideElement(element);
                } else {
                    _this.showElement(element);
                }
            };
            _this.showElement = function(element) {
                if (_this.isElementHidden(element)) {
                    element.classList.remove("st_hidden");
                }
            };
            _this.hideElement = function(element) {
                if (!_this.isElementHidden(element)) {
                    element.classList.add("st_hidden");
                }
            };
            _this.isElementHidden = function(element) {
                return element.classList.contains("st_hidden");
            };
            _this.toggleShoppingWith = function(hideElement) {
                var banner = document.querySelector(_this.classConfig.selectorRepresentativeBannerWrapper);
                _this.toggleElementVisibility(banner, hideElement);
            };
            _this.disableNonSponsor = function() {
                var nonSponsorBtn = document.querySelector(_this.classConfig.selectorNonSponsor);
                nonSponsorBtn === null || nonSponsorBtn === void 0 ? void 0 : nonSponsorBtn.remove();
            };
            _this.toggleBuying = function(hideBuying) {
                _this.toggleCheckoutButtons(hideBuying);
                _this.togglePaymentButtons(hideBuying);
                _this.toggleSearchSponsor(hideBuying);
            };
            _this.toggleSearchSponsor = function(hideElement) {
                var searchSponsorWrappers = document.querySelectorAll(".st_search-sponsor--wrapper_JS");
                searchSponsorWrappers.forEach(function(searchSponsorWrapper) {
                    _this.toggleSearchSponsorInput(searchSponsorWrapper, !hideElement);
                    _this.toggleSearchSponsorResult(searchSponsorWrapper, hideElement);
                });
            };
            _this.toggleSearchSponsorResult = function(container, hideElement) {
                var searchSponsorResultWrapper = container.querySelector(".st_search-result_JS");
                if (!!searchSponsorResultWrapper) {
                    _this.toggleElementVisibility(searchSponsorResultWrapper, hideElement);
                }
            };
            _this.toggleSearchSponsorInput = function(container, hideElement) {
                var searchSponsorInputWrapper = container.querySelector(".st_search-input_JS");
                if (!!searchSponsorInputWrapper) {
                    _this.toggleElementVisibility(searchSponsorInputWrapper, hideElement);
                }
            };
            _this.toggleCheckoutButtons = function(hideElement) {
                var checkoutButtons = document.querySelectorAll('button[name="checkout"]');
                if (checkoutButtons.length > 0) {
                    checkoutButtons.forEach(function(btn) {
                        _this.toggleElementVisibility(btn, hideElement);
                    });
                }
            };
            _this.togglePaymentButtons = function(hideElement) {
                var paymentButtonsWrapper = document.querySelectorAll(".st_product-buy-now-wrapper_JS");
                if (paymentButtonsWrapper.length > 0) {
                    paymentButtonsWrapper.forEach(function(wrp) {
                        _this.toggleElementVisibility(wrp, hideElement);
                    });
                }
            };
            _this.toggleCantGoUnderCorporateSite = function(hideElements) {
                if (!_features_config_3.canGoUnderCorporateSite) {
                    _this.disableNonSponsor();
                    _this.toggleShoppingWith(hideElements);
                    _this.toggleBuying(hideElements);
                }
            };
            _this.listenForSponsorChange = function() {
                window.addEventListener("sponsorChange", function() {
                    var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                    var currentAlias = urlParams[_features_config_3.aliasQueryParam];
                    _this.toggleCantGoUnderCorporateSite(currentAlias === _features_config_3.defaultWebAlias);
                });
            };
            _this.classConfig = classConfig;
            _this.browserHistory = browserHistory;
            _this.objectFormatting = objectFormatting;
            _this.generalMethods = generalMethods;
            _this.cartComponent = cartComponent;
            return _this;
        }
        return StSearchSponsorGuard;
    }(st_module_10.StModule);
    exports.StSearchSponsorGuard = StSearchSponsorGuard;
});

define("core/connector-app/_shared/models/customer/sponsor/customer.update.sponsor.request", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/webalias/webalias.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/account/_general/account-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_11) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountClassConfig = void 0;
    var StAccountClassConfig = function(_super) {
        __extends(StAccountClassConfig, _super);
        function StAccountClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "AccountClassConfig";
            _this.classNameProvinceSelector = "st_province-selector_JS";
            _this.selectorProvinceSelector = "." + _this.classNameProvinceSelector;
            _this.classNameProvinceSource = "st_province-source_JS";
            _this.selectorProvinceSource = "." + _this.classNameProvinceSource;
            _this.classNameAccountPage = "st_account_JS";
            _this.selectorAccountPage = "." + _this.classNameAccountPage;
            _this.classNameAccountSection = "st_account-page--section_JS";
            _this.selectorAccountSection = "." + _this.classNameAccountSection;
            _this.classNameAccountContent = "st_account-page_JS";
            _this.selectorAccountContent = "." + _this.classNameAccountContent;
            _this.classNameAccountNavWrapper = "st_account-nav--wrapper_JS";
            _this.selectorAccountNavWrapper = "." + _this.classNameAccountNavWrapper;
            _this.classNameAccountNavHolder = "st_account-nav--holder_JS";
            _this.selectorAccountNavHolder = "." + _this.classNameAccountNavHolder;
            _this.classNameAccountNavHolderSingle = "st_account-nav--holder-single_JS";
            _this.selectorAccountNavHolderSingle = "." + _this.classNameAccountNavHolderSingle;
            _this.classNameAccountNavButton = "st_account-button_JS";
            _this.selectorAccountNavButton = "." + _this.classNameAccountNavButton;
            _this.classNameAccountIcon = "st_account--nav-icon_JS";
            _this.selectorAccountIcon = "." + _this.classNameAccountIcon;
            _this.classNameAccountCopyText = "st_copy-repsite_JS";
            _this.selectorAccountIconCopyText = "." + _this.classNameAccountCopyText;
            _this.classNameAccountCopyTextWrapper = "st_copy-repsite--wrapper_JS";
            _this.selectorAccountIconCopyTextWrapper = "." + _this.classNameAccountCopyTextWrapper;
            _this.classNameAccountLogout = "st_account-logout_JS";
            _this.selectorAccountLogout = "." + _this.classNameAccountLogout;
            _this.classNameAccountWebAlias = "st_input-wrapper_JS input";
            _this.selectorAccountWebAlias = "." + _this.classNameAccountWebAlias;
            _this.classNameAccountAddressesDropdown = "st_addresses-dots--button_JS";
            _this.selectorAccountAddressesDropdown = "." + _this.classNameAccountAddressesDropdown;
            _this.classNameAccountAddressesDropdownWrapper = "st_dropdown-address--wrapper";
            _this.selectorAccountAddressesDropdownWrapper = "." + _this.classNameAccountAddressesDropdownWrapper;
            _this.classNameAccountTabButton = "st_button-wrapper_JS";
            _this.selectorAccountTabButton = "." + _this.classNameAccountTabButton;
            _this.classNameAccountBackButton = "st_arrow-back--button_JS";
            _this.selectorAccountBackButton = "." + _this.classNameAccountBackButton;
            _this.classNameSingleOrder = "st_single-order_JS";
            _this.selectorSingleOrder = "." + _this.classNameSingleOrder;
            _this.classNameOpenOrderCSSClass = "st_open-single-order";
            _this.selectorOpenOrderCSSClass = "." + _this.classNameOpenOrderCSSClass;
            _this.classNameOpenSingleOrderButton = "st_open-single-order_JS";
            _this.selectorOpenSingleOrderButton = "." + _this.classNameOpenSingleOrderButton;
            _this.classNameOrderHistory = "st_order-history_JS";
            _this.selectorOrderHistory = "." + _this.classNameOrderHistory;
            _this.classNameBackToHistoryOrders = "st_back-to-history-orders_JS";
            _this.selectorBackToHistoryOrders = "." + _this.classNameBackToHistoryOrders;
            _this.classNameBackOfficeLink = "st_backoffice-link_JS";
            _this.selectorBackOfficeLink = "." + _this.classNameBackOfficeLink;
            _this.classNameWebAliasFormatting = "st_formatting-web-alias_JS";
            _this.selectorWebAliasFormatting = "." + _this.classNameWebAliasFormatting;
            _this.classNameWebAliasWrapper = "st_web-alias-wrapper_JS";
            _this.selectorWebAliasWrapper = "." + _this.classNameWebAliasWrapper;
            _this.classNameWebAliasValue = "st_web-alias-readonly-input_JS";
            _this.selectorWebAliasValue = "." + _this.classNameWebAliasValue;
            _this.classNameAddressesWrapper = "st_addresses--wrapper_JS";
            _this.selectorAddressesWrapper = "." + _this.classNameAddressesWrapper;
            _this.classNameEditWebAliasForm = "st_edit-webalias-form_JS";
            _this.selectorEditWebAliasForm = "." + _this.classNameEditWebAliasForm;
            _this.classNameSubmitButton = "st_submit--btn_JS";
            _this.selectorSubmitButton = "." + _this.classNameSubmitButton;
            _this.classNameProvinceWrapper = "st_province-wrapper_JS";
            _this.selectorProvinceWrapper = "." + _this.classNameProvinceWrapper;
            _this.classNamePersonalInfoForm = "st_personal-info-form_JS";
            _this.selectorPersonalInfoForm = "." + _this.classNamePersonalInfoForm;
            _this.classNameBusinessContent = "st_account-business--content_JS";
            _this.selectorBusinessContent = "." + _this.classNameBusinessContent;
            _this.classNameBusinessContentName = "st_account-business--name_JS";
            _this.selectorBusinessContentName = "." + _this.classNameBusinessContentName;
            _this.classNameBusinessContentRepName = "st_account-business--rep-name_JS";
            _this.selectorBusinessContentRepName = "." + _this.classNameBusinessContentRepName;
            _this.classNameBusinessContentEmail = "st_account-business--email_JS";
            _this.selectorBusinessContentEmail = "." + _this.classNameBusinessContentEmail;
            return _this;
        }
        return StAccountClassConfig;
    }(st_module_11.StModule);
    exports.StAccountClassConfig = StAccountClassConfig;
});

define("core/shopify-app/st-modules/account/blocks/personal-site/personal-site", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_12, _features_config_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountPersonalSite = void 0;
    var StAccountPersonalSite = function(_super) {
        __extends(StAccountPersonalSite, _super);
        function StAccountPersonalSite(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountPersonalSite";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.copyRefToClipboard(_this_1.classConfig.selectorAccountIconCopyText, ".st_representative-site-link_JS");
                    _this_1.getRefCode();
                });
            };
            _this_1.getRefCode = function() {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_retail-personal-promo-code-link_JS");
                if (_features_config_4.shareRefCodeFunctionality) {
                    _this_1.copyRefToClipboard(".st_referral-link-copy-clipboard_JS", ".st_retail-personal-promo-code-link_JS");
                    _this_1.createLinkWithRef;
                    _this_1.showIncludePromoCode();
                    _this_1.showPersonalSiteRetailBlock();
                    if (!customersRef) {
                        _this_1.createLinkWithoutRef;
                    }
                } else {
                    _this_1.hideIncludePromoCode();
                    _this_1.hidePersonalSiteRetailBlock();
                    _this_1.createLinkWithoutRef;
                }
            };
            _this_1.createLinkWithRef = function(alias) {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_retail-personal-promo-code-link_JS");
                retailInput.forEach(function(input) {
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_4.aliasQueryParam + "=" + alias + "&" + "ref=" + customersRef;
                });
            };
            _this_1.createLinkWithoutRef = function(als) {
                var inputEl = document.querySelectorAll(".st_representative-site-link_JS");
                if (inputEl) {
                    inputEl.forEach(function(input) {
                        var als = localStorage.getItem("webAlias");
                        input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_4.aliasQueryParam + "=" + als;
                    });
                }
            };
            _this_1.hidePersonalSiteRetailBlock = function() {
                var personalSiteRetailBlockWrapper = document.querySelector(".st_personal-site-retail--wrapper_JS");
                if (!!personalSiteRetailBlockWrapper) {
                    personalSiteRetailBlockWrapper.classList.add("st_hidden");
                }
            };
            _this_1.showPersonalSiteRetailBlock = function() {
                var personalSiteRetailBlockWrapper = document.querySelector(".st_personal-site-retail--wrapper_JS");
                if (!!personalSiteRetailBlockWrapper) {
                    personalSiteRetailBlockWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.createLinkWithRefRep = function(alias) {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_representative-site-link_JS");
                retailInput.forEach(function(input) {
                    var hisAlias = localStorage.getItem("webAlias");
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + "als=" + hisAlias + "&" + "ref=" + customersRef;
                });
            };
            _this_1.createLinkWithoutRefRep = function(als) {
                var inputEl = document.querySelectorAll(".st_representative-site-link_JS");
                if (inputEl) {
                    inputEl.forEach(function(input) {
                        var hisAlias = localStorage.getItem("webAlias");
                        input.value = window.location.protocol + "//" + window.location.host + "/?" + "als=" + hisAlias;
                    });
                }
            };
            _this_1.includePromoCode = function(als) {
                var _this = _this_1;
                var includeInput = document.querySelector(".st_include-promo-code-input_JS");
                if (!!includeInput) {
                    var inputEl_1 = document.querySelectorAll(".st_representative-site-link_JS");
                    if (includeInput.checked) {
                        _this.createLinkWithRefRep(als);
                    } else {
                        _this.createLinkWithoutRefRep(als);
                    }
                    includeInput.addEventListener("change", function(event) {
                        if (!!inputEl_1) {
                            if (includeInput.checked) {
                                _this.createLinkWithRefRep(als);
                            } else {
                                _this.createLinkWithoutRefRep(als);
                            }
                        }
                    });
                }
            };
            _this_1.hideIncludePromoCode = function() {
                var includePromoCodeWrapper = document.querySelector(".st_include-promo-code-wrapper_JS");
                if (!!includePromoCodeWrapper) {
                    includePromoCodeWrapper.classList.add("st_hidden");
                }
            };
            _this_1.showIncludePromoCode = function() {
                var includePromoCodeWrapper = document.querySelector(".st_include-promo-code-wrapper_JS");
                if (!!includePromoCodeWrapper) {
                    includePromoCodeWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.copyRefToClipboard = function(button, input) {
                var copyRepSiteButtonAll = document.querySelectorAll(button);
                if (!!copyRepSiteButtonAll) {
                    copyRepSiteButtonAll.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            var copyText = document.querySelectorAll(input);
                            if (!!copyText) {
                                copyText.forEach(function(input) {
                                    if (!!input) {
                                        input.select();
                                        input.setSelectionRange(0, 99999);
                                        navigator.clipboard.writeText(input.value);
                                        input.style.backgroundColor = "rgb(217, 218, 220)";
                                        input.style.transition = "0.2s";
                                        setTimeout(function() {
                                            input.style.backgroundColor = "rgb(249, 249, 249)";
                                        }, 1e3);
                                    }
                                });
                            }
                        });
                    });
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountPersonalSite;
    }(st_module_12.StModule);
    exports.StAccountPersonalSite = StAccountPersonalSite;
});

define("core/shopify-app/st-modules/webalias/webalias", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_13, _features_config_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAlias = void 0;
    var StWebAlias = function(_super) {
        __extends(StWebAlias, _super);
        function StWebAlias(classConfig, browserHistory, objectFormatting, cookies, customerType, generalMethods, injectRepresentativeInfo, cartComponent, searchSponsorGuard, accountPersonalSite) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "WebAlias";
            _this.cookieNameWebAlias = "webAlias";
            _this.cookieNameRepId = "repId";
            _this.cookieNameFirstName = "firstName";
            _this.cookieNameLastName = "lastName";
            _this.cookieNameImageUrl = "imageUrl";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.initWebAliasFlow();
                    _this.initSponsorCheck();
                    console.log("lockedRepresentativeSite: ", _features_config_5.lockedRepresentativeSite);
                    console.log("canGoUnderCorporateSite: ", _features_config_5.canGoUnderCorporateSite);
                    _this.getSponsorInformation();
                });
            };
            _this.initWebAliasFlow = function() {
                if (_this.isCustomerRepresentative) {
                    _this.representativeAliasFlow();
                    return;
                }
                if (_this.isCustomerRetail) {
                    _this.retailAliasFlow();
                    return;
                }
                if (_this.isCustomerGuest) {
                    _this.guestAliasFlow();
                }
            };
            _this.representativeAliasFlow = function() {
                _this.getRepresentativesOwnInfo(_this.customerIdFromMetafields);
            };
            _this.guestAliasFlow = function() {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_5.aliasQueryParam];
                var urlAliasExists = !!currentAlias;
                var cookieAliasExists = !!_this.cookies.getCookie("webAlias");
                if (urlAliasExists) {
                    _this.getRepresentativesOwnInfo(currentAlias);
                    return;
                }
                if (cookieAliasExists) {
                    _this.injectRepInfoFromCookie();
                    return;
                }
                _this.injectDefaultRepInfo();
            };
            _this.retailAliasFlow = function() {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_5.aliasQueryParam];
                var urlAliasExists = !!currentAlias;
                var cookieAliasExists = !!_this.cookies.getCookie("webAlias");
                var isLocked = _features_config_5.lockedRepresentativeSite;
                if (isLocked) {
                    var customerIdOrAls = _this.customerIdFromMetafields;
                    _this.getCustomersRepresentativeInfo(customerIdOrAls);
                    return;
                }
                if (!isLocked) {
                    if (urlAliasExists) {
                        _this.getRepresentativesOwnInfo(currentAlias);
                        return;
                    } else {
                        if (cookieAliasExists) {
                            _this.injectRepInfoFromCookie();
                            return;
                        } else {
                            _this.injectDefaultRepInfo();
                            return;
                        }
                    }
                }
            };
            _this.handleRepresentativeInfoResponse = function(response) {
                var data = response.data, status = response.status;
                var webAlias = data.webAlias, repId = data.repId;
                if (status !== 200) {
                    _this.nonExistentRepresentativeFlow();
                    return;
                }
                if (!webAlias && webAlias === "") {
                    data = __assign(__assign({}, data), {
                        webAlias: repId
                    });
                }
                _this.updateCurrentRepInfo(data);
            };
            _this.getRepresentativesOwnInfo = function(customerIdOrAlias) {
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: true
                }, _this.handleRepresentativeInfoResponse);
            };
            _this.getCustomersRepresentativeInfo = function(customerIdOrAlias) {
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: false
                }, _this.handleRepresentativeInfoResponse);
            };
            _this.getRepresentativeInfo = function(webAliasRequest, handleResponse) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["webalias"]["repSite"],
                        method: "post",
                        contentType: "json",
                        data: webAliasRequest,
                        callback: function(response) {
                            try {
                                var representativeInfoRes = JSON.parse(response.response);
                                handleResponse(representativeInfoRes);
                            } catch (error) {
                                _this.nonExistentRepresentativeFlow();
                                console.log("Response Error ------\x3e" + error);
                            }
                        }
                    });
                } catch (error) {
                    console.log("Request Error ------\x3e" + error);
                }
            };
            _this.getSponsorInformation = function() {
                var repIdMetafield = window.customerInfoMetafields.representativeId;
                var webAliasRequestedData = {
                    customerIdOrAlias: repIdMetafield,
                    isOwnInfo: true
                };
                _this.getRepresentativeInfo(webAliasRequestedData, _this.handleSponsorInfoResponse);
            };
            _this.handleSponsorInfoResponse = function(response) {
                if (response.status === 200) {
                    var sponsorInfo = response.data;
                    _this.injectRepresentativeInfo.injectSponsorInfoToField(sponsorInfo.firstName, sponsorInfo.lastName);
                    _this.accountPersonalSite.createLinkWithRef(sponsorInfo.webAlias);
                    _this.accountPersonalSite.includePromoCode(sponsorInfo.webAlias);
                } else {
                    _this.injectRepresentativeInfo.injectSponsorInfoToField("", "");
                }
            };
            _this.updateCurrentRepInfo = function(repInfo) {
                var webAlias = repInfo.webAlias;
                if (!_this.isAliasEqualToStored(webAlias)) {
                    _this.setRepresentativeCookies(repInfo);
                }
                if (!_this.isAliasEqualToUrlAlias(webAlias)) {
                    _this.setNewAliasInUrl(webAlias);
                }
                _this.cartComponent.updateCartItemsProperies(webAlias);
                _this.searchSponsorGuard.toggleCantGoUnderCorporateSite(webAlias === _features_config_5.defaultWebAlias);
                _this.injectRepresentativeInfo.injectToFields(repInfo);
            };
            _this.nonExistentRepresentativeFlow = function() {
                if (!_this.isCustomerRetail) {
                    _this.injectDefaultRepInfo();
                    return;
                }
                _this.injectRepInfoFromCookie();
            };
            _this.injectRepInfoFromCookie = function() {
                var repInfo = {
                    firstName: _this.cookies.getCookie(_this.cookieNameFirstName),
                    lastName: _this.cookies.getCookie(_this.cookieNameLastName),
                    webAlias: _this.cookies.getCookie(_this.cookieNameWebAlias),
                    repId: _this.cookies.getCookie(_this.cookieNameRepId)
                };
                var imageUrl = _this.cookies.getCookie(_this.cookieNameImageUrl);
                if (!!imageUrl && _features_config_5.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: imageUrl
                    });
                }
                _this.updateCurrentRepInfo(repInfo);
            };
            _this.injectDefaultRepInfo = function() {
                var repInfo = {
                    webAlias: _features_config_5.defaultWebAlias,
                    firstName: _features_config_5.corporationName,
                    lastName: ""
                };
                if (_features_config_5.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: _features_config_5.defaultCorporationImage
                    });
                }
                _this.updateCurrentRepInfo(repInfo);
            };
            _this.isAliasEqualToStored = function(alias) {
                return alias === _this.cookies.getCookie("webAlias");
            };
            _this.isAliasEqualToUrlAlias = function(alias) {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_5.aliasQueryParam];
                return currentAlias === alias;
            };
            _this.setNewAliasInUrl = function(alias) {
                var _a;
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var newUrlParams = __assign(__assign({}, urlParams), (_a = {}, _a[_features_config_5.aliasQueryParam] = alias, 
                _a));
                var newURL = window.location.href.replace(window.location.search, "");
                _this.browserHistory.pushHistory(newURL, newUrlParams);
            };
            _this.setRepresentativeCookies = function(repInfo) {
                _this.cookies.setCookies(_this.cookieNameWebAlias, repInfo.webAlias);
                _this.cookies.setCookies(_this.cookieNameRepId, repInfo.repId);
                _this.cookies.setCookies(_this.cookieNameFirstName, repInfo.firstName);
                _this.cookies.setCookies(_this.cookieNameLastName, repInfo.lastName);
                if (_features_config_5.additionalRepInfo) {
                    _this.cookies.setCookies(_this.cookieNameImageUrl, repInfo.imageUrl);
                }
            };
            _this.initSponsorCheck = function() {
                var shopifyCustomerId = _this.shopifyCustomerId;
                if (_this.isTimeForSponsorCheck() && shopifyCustomerId && shopifyCustomerId !== 0) {
                    _this.updateCustomerSponsor(shopifyCustomerId);
                }
            };
            _this.updateCustomerSponsor = function(shopifyCustomerId) {
                var updateSponsorData = {
                    shopifyCustomerId: shopifyCustomerId
                };
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["customer"]["updateSponsor"],
                        method: "post",
                        contentType: "json",
                        data: updateSponsorData
                    });
                } catch (error) {
                    console.log("Request Error ------\x3e " + error);
                }
            };
            _this.isTimeForSponsorCheck = function() {
                var timestamp = Date.now();
                var lastCheck = _this.customerSponsorLastCheck;
                var timeThreshold = _features_config_5.sponsorGenealogyTimeout ? _features_config_5.sponsorGenealogyTimeout : 9e5;
                return timestamp - lastCheck > timeThreshold;
            };
            _this.classConfig = classConfig;
            _this.browserHistory = browserHistory;
            _this.objectFormatting = objectFormatting;
            _this.cookies = cookies;
            _this.customerType = customerType;
            _this.generalMethods = generalMethods;
            _this.injectRepresentativeInfo = injectRepresentativeInfo;
            _this.cartComponent = cartComponent;
            _this.searchSponsorGuard = searchSponsorGuard;
            _this.accountPersonalSite = accountPersonalSite;
            return _this;
        }
        Object.defineProperty(StWebAlias.prototype, "isCustomerGuest", {
            get: function() {
                return this.customerType.get() === _features_config_5.ECustomerType.guest;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "isCustomerRetail", {
            get: function() {
                return this.customerType.get() === _features_config_5.ECustomerType.retail;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "isCustomerRepresentative", {
            get: function() {
                return this.customerType.get() === _features_config_5.ECustomerType.representative;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "customerIdFromMetafields", {
            get: function() {
                return window.customerInfoMetafields.customerId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "shopifyCustomerId", {
            get: function() {
                return window.customerShopifyId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "customerSponsorLastCheck", {
            get: function() {
                return window.customerSponsorLastCheck;
            },
            enumerable: false,
            configurable: true
        });
        return StWebAlias;
    }(st_module_13.StModule);
    exports.StWebAlias = StWebAlias;
});

define("core/shopify-app/st-modules/_general-methods/form/form-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_14) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFormClassConfig = void 0;
    var StFormClassConfig = function(_super) {
        __extends(StFormClassConfig, _super);
        function StFormClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "FormClassConfig";
            _this.classNameDateWrp = "st_date_JS";
            _this.selectorDateWrp = "." + _this.classNameDateWrp;
            _this.classNameDateYearInput = "st_date--year_JS";
            _this.selectorDateYearInput = "." + _this.classNameDateYearInput;
            _this.classNameDateMonthInput = "st_date--month_JS";
            _this.selectorDateMonthInput = "." + _this.classNameDateMonthInput;
            _this.classNameDateDayInput = "st_date--day_JS";
            _this.selectorDateDayInput = "." + _this.classNameDateDayInput;
            _this.classNameDateCompleteInput = "st_date--complete_JS";
            _this.selectorDateCompleteInput = "." + _this.classNameDateCompleteInput;
            _this.months = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
            return _this;
        }
        return StFormClassConfig;
    }(st_module_14.StModule);
    exports.StFormClassConfig = StFormClassConfig;
});

define("core/shopify-app/st-modules/_general-methods/form/fields/date-input", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_15) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDateInput = void 0;
    var StDateInput = function(_super) {
        __extends(StDateInput, _super);
        function StDateInput(classConfig) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "DateInput";
            _this_1.setupDateFields = function() {
                var dateWraps = document.querySelectorAll(_this_1.classConfig.selectorDateWrp);
                dateWraps.forEach(function(dateWrp) {
                    _this_1.setupDateField(dateWrp);
                });
            };
            _this_1.setupDateField = function(dateWrap) {
                var _a;
                var dateYearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var dateMonthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dateDayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var now = new Date();
                var yearNow = now.getUTCFullYear();
                _this_1.generateYears(dateYearInput, 1900, yearNow);
                dateYearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var defaultYear = dateYearInput.getAttribute("data-default");
                var defaultYearIndex = !!defaultYear ? parseInt(dateYearInput.querySelector('[value="'.concat(defaultYear, '"]')).getAttribute("data-index")) : 0;
                _this_1.setSelectValue(dateYearInput, defaultYearIndex);
                _this_1.generateMonths(dateMonthInput);
                dateMonthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var defaultMonth = dateMonthInput.getAttribute("data-default");
                var defaultMonthIndex = !!defaultMonth ? parseInt(dateMonthInput.querySelector('[value="'.concat(defaultMonth, '"]')).getAttribute("data-index")) : 0;
                _this_1.setSelectValue(dateMonthInput, defaultMonthIndex);
                _this_1.generateDays(dateDayInput, (_a = parseInt(dateYearInput.value)) !== null && _a !== void 0 ? _a : yearNow, defaultMonthIndex);
                var defaultDay = dateDayInput.getAttribute("data-default");
                var defaultDayIndex = !!defaultDay ? parseInt(dateDayInput.querySelector('[value="'.concat(defaultDay, '"]')).getAttribute("data-index")) : 0;
                dateDayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                _this_1.setSelectValue(dateDayInput, defaultDayIndex);
                _this_1.setupEvents(dateWrap, dateYearInput, dateMonthInput, dateDayInput);
            };
            _this_1.getDays = function(year, month) {
                return new Date(year, month + 1, 0).getDate();
            };
            _this_1.generateDays = function(holder, year, month) {
                var days = _this_1.getDays(year, month);
                holder.replaceChildren();
                for (var i = 1; i <= days; i++) {
                    var option = _this_1.generateOption(i, undefined, undefined, i - 1);
                    holder.appendChild(option);
                }
                return days;
            };
            _this_1.generateMonths = function(holder) {
                for (var i = 0; i < _this_1.classConfig.months.length; i++) {
                    var option = _this_1.generateOption(i, _this_1.classConfig.months[i], undefined, i);
                    holder.appendChild(option);
                }
            };
            _this_1.generateYears = function(holder, startingYear, endYear) {
                for (var i = 0; i < endYear - startingYear; i++) {
                    var option = _this_1.generateOption(endYear - i, undefined, undefined, i);
                    holder.appendChild(option);
                }
            };
            _this_1.generateOption = function(value, displayValue, selected, elementIndex) {
                if (displayValue === void 0) {
                    displayValue = value;
                }
                if (selected === void 0) {
                    selected = false;
                }
                var option = document.createElement("option");
                option.value = "".concat(value);
                option.setAttribute("value", "".concat(value));
                option.innerHTML = "".concat(displayValue);
                if (selected) {
                    option.setAttribute("selected", "selected");
                }
                if (typeof elementIndex !== "undefined") {
                    option.setAttribute("data-index", "".concat(elementIndex));
                }
                return option;
            };
            _this_1.setSelectValue = function(holder, optionIndex) {
                var options = holder.querySelectorAll("option");
                var selected = options[holder.selectedIndex];
                if (!!selected) {
                    selected.removeAttribute("selected");
                    selected.selected = false;
                }
                optionIndex = optionIndex > options.length - 1 ? options.length - 1 : optionIndex;
                holder.selectedIndex = optionIndex;
                options[optionIndex].selected = true;
                options[optionIndex].setAttribute("selected", "selected");
            };
            _this_1.setInputValue = function(input, value) {
                input.value = value;
                input.setAttribute("value", value);
                input.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
            };
            _this_1.setupEvents = function(dateWrap, yearInput, monthInput, dayInput) {
                var _this = _this_1;
                monthInput.addEventListener("change", function(e) {
                    _this.adaptDaysOnChange(dateWrap);
                    _this.completeDate(dateWrap);
                });
                yearInput.addEventListener("change", function(e) {
                    _this.adaptDaysOnChange(dateWrap);
                    _this.completeDate(dateWrap);
                });
                dayInput.addEventListener("change", function(e) {
                    _this.completeDate(dateWrap);
                });
            };
            _this_1.completeDate = function(dateWrap) {
                var yearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var monthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var completeInput = dateWrap.querySelector(_this_1.classConfig.selectorDateCompleteInput);
                var year = parseInt(yearInput.querySelectorAll("option")[yearInput.selectedIndex].value);
                var month = parseInt(monthInput.querySelectorAll("option")[monthInput.selectedIndex].value);
                var day = parseInt(dayInput.querySelectorAll("option")[dayInput.selectedIndex].value);
                var completeDate = "".concat(year, "-").concat(month + 1, "-").concat(day);
                _this_1.setInputValue(completeInput, completeDate);
            };
            _this_1.adaptDaysOnChange = function(dateWrap) {
                var yearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var monthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var year = parseInt(yearInput.querySelectorAll("option")[yearInput.selectedIndex].value);
                var month = parseInt(monthInput.querySelectorAll("option")[monthInput.selectedIndex].value);
                var day = parseInt(dayInput.querySelectorAll("option")[dayInput.selectedIndex].value);
                var maxDays = _this_1.generateDays(dayInput, year, month);
                var selectedIndex = day > maxDays ? maxDays : day;
                _this_1.setSelectValue(dayInput, selectedIndex - 1);
            };
            _this_1.classConfig = classConfig;
            return _this_1;
        }
        return StDateInput;
    }(st_module_15.StModule);
    exports.StDateInput = StDateInput;
});

define("core/shopify-app/st-modules/_general-methods/form/form", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_16) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StForm = void 0;
    var StForm = function(_super) {
        __extends(StForm, _super);
        function StForm(classConfig, dateInput) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Form";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.dateInput.setupDateFields();
                });
            };
            _this_1.liveTrim = function(inputs) {
                inputs = inputs ? inputs : document.querySelectorAll(".st_input");
                var trimOperation = function(trigger) {
                    trigger.value = trigger.value.replace(/  +/g, " ");
                    trigger.value = trigger.value.trimStart();
                };
                inputs.forEach(function(input) {
                    input.addEventListener("keyup", function() {
                        trimOperation(this);
                    });
                    input.addEventListener("change", function() {
                        trimOperation(this);
                    });
                });
            };
            _this_1.collectFormData = function(form) {
                if (form === undefined || form === null) {
                    return false;
                }
                var data = {};
                for (var i = 0; i < form.elements.length; i++) {
                    var field = form.elements[i];
                    data = __assign(__assign({}, data), _this_1.collectField(field));
                }
                return data;
            };
            _this_1.collectField = function(field) {
                var data = {};
                if (!field.name || field.type === "file" || field.type === "reset" || field.type === "submit" || field.type === "button") return data;
                if (field.disabled && field.tagName !== "SELECT") return data;
                if (field.type === "select-multiple") {
                    data[field.name] = [];
                    for (var n = 0; n < field.options.length; n++) {
                        if (!field.options[n].selected) continue;
                        data[field.name].push(field.options[n].value);
                    }
                } else if (field.type !== "checkbox" && field.type !== "radio") {
                    data[field.name] = field.value;
                    if (field.value.toLowerCase() === "true") {
                        data[field.name] = true;
                    } else if (field.value.toLowerCase() === "false") {
                        data[field.name] = false;
                    }
                } else if (field.type === "checkbox") {
                    data[field.name] = !!field.checked;
                }
                if (field.getAttribute("data-parse") === "true") {
                    if (field.getAttribute("data-decode") !== "false") {
                        data[field.name] = decodeURIComponent(data[field.name]);
                    }
                    data[field.name] = JSON.parse(data[field.name]);
                }
                return data;
            };
            _this_1.markValidation = function(page, inputName, isValid, invalidMessage) {
                if (invalidMessage === void 0) {
                    invalidMessage = "";
                }
                page.querySelectorAll('[data-validation-visual="'.concat(inputName, '"]')).forEach(function(validationVisual) {
                    var errorMessage = validationVisual.parentElement.querySelector(".st_message-error_JS");
                    if (isValid) {
                        validationVisual.classList.remove("st_input_invalid");
                        if (!!errorMessage) {
                            errorMessage.remove();
                        }
                    } else {
                        validationVisual.classList.add("st_input_invalid");
                        if (!errorMessage) {
                            var errorMessageBlock = document.createElement("span");
                            errorMessageBlock.className = "st_message-error st_message-error_JS";
                            validationVisual.parentElement.append(errorMessageBlock);
                            errorMessage = validationVisual.parentElement.querySelector(".st_message-error_JS");
                        }
                        errorMessage.innerHTML = invalidMessage;
                    }
                });
            };
            _this_1.markValidationResults = function(page, validationResponse) {
                if (Object.keys(validationResponse).length > 0) {
                    Object.keys(validationResponse).forEach(function(paramName) {
                        _this_1.markValidation(page, paramName, validationResponse[paramName].isValid, validationResponse[paramName].message);
                    });
                }
            };
            _this_1.numbersOnly = function() {
                var numberInputs = document.querySelectorAll(".nuv_only-number_JS");
                if (numberInputs && numberInputs.length > 0) {
                    for (var i = 0; i < numberInputs.length; i++) {
                        var inputSelector = numberInputs[i];
                        inputSelector.addEventListener("keyup", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                        inputSelector.addEventListener("input", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                        inputSelector.addEventListener("change", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                    }
                }
            };
            _this_1.formValidation = function() {
                var _this = _this_1;
                var taxId = document.querySelector('[name="enrollment[tax_id]"]');
                if (taxId && typeof taxId != "undefined") {
                    taxId.addEventListener("input", function(e) {
                        _this.applyFormatting(this);
                    });
                }
                var email = document.querySelector('[name="enrollment[email]"]');
                if (email && typeof email != "undefined") {
                    email.addEventListener("input", function(e) {
                        _this.validateEmail(this);
                    });
                }
                var upgradeEmail = document.querySelector('[name="address[email]"]');
                if (upgradeEmail && typeof upgradeEmail != "undefined") {
                    upgradeEmail.addEventListener("input", function(e) {
                        _this.validateEmail(this);
                    });
                }
            };
            _this_1.validateDateOfBirth = function() {
                var currentYear = new Date().getFullYear();
                var dateOfBirtd = document.querySelector('[name="enrollment[date_of_birtd]"]');
                if (dateOfBirtd && typeof dateOfBirtd != "undefined") {
                    var date = new Date(dateOfBirtd.value);
                    var year = date.getFullYear();
                    return year < currentYear && year > 1900;
                } else {
                    return false;
                }
            };
            _this_1.validateEmail = function(field) {
                var valid = false;
                var val = field.value;
                var at = val.indexOf("@");
                if (at >= 2) {
                    val = val.substr(at);
                    var dot = val.indexOf(".");
                    if (dot >= 2) {
                        val = val.substr(dot);
                        if (val.length >= 2) {
                            valid = true;
                            if (field.classList.contains("st-bds_invalid_input")) {
                                field.classList.remove("st-bds_invalid_input");
                            }
                        }
                    } else {
                        if (!field.classList.contains("st-bds_invalid_input")) {
                            field.classList.add("st-bds_invalid_input");
                        }
                    }
                } else {
                    if (!field.classList.contains("st-bds_invalid_input")) {
                        field.classList.add("st-bds_invalid_input");
                    }
                }
                return valid;
            };
            _this_1.applyFormatting = function(field) {
                var val = field.value;
                var format = "";
                var formatData = {
                    separator: "-",
                    format: "XXX-XX-XXXX",
                    type: "numeric"
                };
                if (formatData.type === "numeric") {
                    val = val.replace(/[^0-9]/g, "");
                }
                if (typeof formatData.format === "object") {
                    format = formatData.format[field.name];
                } else {
                    format = formatData.format;
                    var segments = formatData.separator ? formatData.format.split(formatData.separator) : [ formatData.format ];
                    var disp = [];
                    for (var i = 0; i < segments.length; i++) {
                        var it_1 = val.substr(0, segments[i].length);
                        if (it_1 !== "") {
                            disp.push(it_1);
                        }
                        val = val.replace(it_1, "");
                    }
                    val = disp.join(formatData.separator);
                }
                if (format.length > val.length) {
                    field.classList.add("st-bds_invalid_input");
                } else if (format.length === val.length) {
                    field.classList.remove("st-bds_invalid_input");
                } else {
                    val = val.substr(0, format.length);
                }
                field.value = val;
            };
            _this_1.clearFormatting = function(page, inputNames) {
                var _this = _this_1;
                inputNames.forEach(function(inputName) {
                    _this.markValidation(page, inputName, true, "");
                });
            };
            _this_1.dateInput = dateInput;
            _this_1.classConfig = classConfig;
            return _this_1;
        }
        return StForm;
    }(st_module_16.StModule);
    exports.StForm = StForm;
});

define("core/shopify-app/st-modules/account/account", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_17) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccount = void 0;
    var StAccount = function(_super) {
        __extends(StAccount, _super);
        function StAccount(form) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Account";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.form.liveTrim();
                });
            };
            _this.form = form;
            return _this;
        }
        return StAccount;
    }(st_module_17.StModule);
    exports.StAccount = StAccount;
});

define("core/shopify-app/st-modules/enrollment/_general/enrollment-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_18) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentClassConfig = void 0;
    var StEnrollmentClassConfig = function(_super) {
        __extends(StEnrollmentClassConfig, _super);
        function StEnrollmentClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentClassConfig";
            _this.classNameEnrollmentWrapper = "st_enrollment_JS";
            _this.selectorEnrollmentWrapper = "." + _this.classNameEnrollmentWrapper;
            _this.classNameEnrollmentPage = "st_enrollment--page_JS";
            _this.selectorEnrollmentPage = "." + _this.classNameEnrollmentPage;
            _this.classNameEnrollmentPageShow = "st_show";
            _this.selectorEnrollmentPageShow = "." + _this.classNameEnrollmentPageShow;
            _this.classNameEnrollmentForm = "st_enrollment-section--form_JS";
            _this.selectorEnrollmentForm = "." + _this.classNameEnrollmentForm;
            _this.classNameEnrollmentPrev = "st_enrollment--prev_JS";
            _this.selectorEnrollmentPrev = "." + _this.classNameEnrollmentPrev;
            _this.classNameEnrollmentNext = "st_enrollment--next_JS";
            _this.selectorEnrollmentNext = "." + _this.classNameEnrollmentNext;
            _this.classNameEnrollmentNavWrapper = "st_enrollment-nav--wrapper_JS";
            _this.selectorEnrollmentNavWrapper = "." + _this.classNameEnrollmentNavWrapper;
            _this.classNameEnrollmentNavHolder = "st_enrollment-nav--holder_JS";
            _this.selectorEnrollmentNavHolder = "." + _this.classNameEnrollmentNavHolder;
            _this.classNameEnrollmentNavHolderSingle = "st_enrollment-nav--holder-single_JS";
            _this.selectorEnrollmentNavHolderSingle = "." + _this.classNameEnrollmentNavHolderSingle;
            _this.classNameEnrollmentNavButton = "st_enrollment-button_JS";
            _this.selectorEnrollmentNavButton = "." + _this.classNameEnrollmentNavButton;
            _this.classNameInputInvalid = "st_input_invalid";
            _this.selectorInputInvalid = "." + _this.classNameInputInvalid;
            _this.classNameElementShow = "st_show";
            _this.selectorElementShow = "." + _this.classNameElementShow;
            _this.classNameElementHide = "st_hidden";
            _this.selectorElementHide = "." + _this.classNameElementHide;
            _this.textSubmit = "Submit";
            _this.textNext = "Next";
            _this.classNameEnrollmentPrivacyForm = "st_enrollment-section--privacy-form_JS";
            _this.selectorEnrollmentPrivacyForm = "." + _this.classNameEnrollmentPrivacyForm;
            _this.classNameEnrollmentTnCField = "st_enrollment--tnc-field_JS";
            _this.selectorEnrollmentTnCField = "." + _this.classNameEnrollmentTnCField;
            _this.classNameEnrollmentAccountDetailsForm = "st_enrollment-section--account-details-form_JS";
            _this.selectorEnrollmentAccountDetailsForm = "." + _this.classNameEnrollmentAccountDetailsForm;
            _this.classNameEnrollmentAccountDetailsPhone = "st_enrollment-section--account-details-phone_JS";
            _this.selectorEnrollmentAccountDetailsPhone = "." + _this.classNameEnrollmentAccountDetailsPhone;
            _this.classNameEnrollmentBusinessDetailsWebAlias = "st_enrollment-section--business-details-web-alias_JS";
            _this.selectorEnrollmentBusinessDetailsWebAlias = "." + _this.classNameEnrollmentBusinessDetailsWebAlias;
            _this.classNameEnrollmentBusinessDetailsWebAliasPresenter = "st_enrollment-web-alias-preview_JS";
            _this.selectorEnrollmentBusinessDetailsWebAliasPresenter = "." + _this.classNameEnrollmentBusinessDetailsWebAliasPresenter;
            _this.classNameEnrollmentBusinessDetailsSSN = "st_enrollment-section--business-details-ssn_JS";
            _this.selectorEnrollmentBusinessDetailsSSN = "." + _this.classNameEnrollmentBusinessDetailsSSN;
            _this.classEnrollmentRequiredKitVariantSelect = "st_enrollment-required-kits-select_JS";
            _this.selectorEnrollmentRequiredKitVariantSelect = "." + _this.classEnrollmentRequiredKitVariantSelect;
            _this.classEnrollmentRequiredKitVariantHeading = "st_enrollment-required-kit-variant-title_JS";
            _this.selectorEnrollmentRequiredKitVariantHeading = "." + _this.classEnrollmentRequiredKitVariantHeading;
            _this.classEnrollmentRequiredKitVariantPrice = "st_enrollment-required-kit-price_JS";
            _this.selectorEnrollmentRequiredKitVariantPrice = "." + _this.classEnrollmentRequiredKitVariantPrice;
            _this.classEnrollmentRequiredKitSelectedVariantTitle = "st_enrollment-required-kits-selected-variant-title_JS";
            _this.selectorEnrollmentRequiredKitSelectedVariantTitle = "." + _this.classEnrollmentRequiredKitSelectedVariantTitle;
            _this.classEnrollmentHiddenRequiredKitInput = "st_hidden-requiredKitInput_JS";
            _this.selectorEnrollmentHiddenRequiredKitInput = "." + _this.classEnrollmentHiddenRequiredKitInput;
            _this.classEnrollmentRequiredKitWrapper = "st_consultant-kit-order--wrapper";
            _this.selectorEnrollmentRequiredKitWrapper = "." + _this.classEnrollmentRequiredKitWrapper;
            _this.classEnrollmentRequiredKitsOptionsWrapper = "st_enrollment-required-kits-options-wrapper_JS";
            _this.selectorEnrollmentRequiredKitsOptionsWrapper = "." + _this.classEnrollmentRequiredKitsOptionsWrapper;
            _this.classEnrollmentRequiredKitsText = "st_consultant-kit-text_JS";
            _this.selectorEnrollmentRequiredKitsText = "." + _this.classEnrollmentRequiredKitsText;
            _this.classEnrollmentRequiredKitsImg = "st_enrollment-required-kit-img_JS";
            _this.selectorEnrollmentRequiredKitsImg = "." + _this.classEnrollmentRequiredKitsImg;
            _this.classNameEnrollmentOptionalKitsInput = "st_optional-kits--input_JS";
            _this.selectorEnrollmentOptionalKitsInput = "." + _this.classNameEnrollmentOptionalKitsInput;
            _this.classNameEnrollmentOptionalKitsTrigger = "st_enrollment--optional-bundle-trigger_JS";
            _this.selectorEnrollmentOptionalKitsTrigger = "." + _this.classNameEnrollmentOptionalKitsTrigger;
            _this.reviewEditText = "Edit";
            _this.classNameEnrollmentReviewWrapper = "st_enrollment--review-wrapper_JS";
            _this.selectorEnrollmentReviewWrapper = "." + _this.classNameEnrollmentReviewWrapper;
            _this.classNameEnrollmentReviewParamHolder = "st_enrollment--review-param-holder_JS";
            _this.selectorEnrollmentReviewParamHolder = "." + _this.classNameEnrollmentReviewParamHolder;
            _this.classNameEnrollmentReviewCartWrapper = "st_enrollment--review-cart-wrapper_JS";
            _this.selectorEnrollmentReviewCartWrapper = "." + _this.classNameEnrollmentReviewCartWrapper;
            _this.classNameEnrollmentReviewCartContentWrapper = "st_enrollment--review-cart-content-wrapper_JS";
            _this.selectorEnrollmentReviewCartContentWrapper = "." + _this.classNameEnrollmentReviewCartContentWrapper;
            _this.classNameEnrollmentReviewCartTotalWrapper = "st_enrollment--review-cart-total-wrapper_JS";
            _this.selectorEnrollmentReviewCartTotalWrapper = "." + _this.classNameEnrollmentReviewCartTotalWrapper;
            _this.classNameEnrollmentReviewCartTotal = "st_enrollment--review-cart-total_JS";
            _this.selectorEnrollmentReviewCartTotal = "." + _this.classNameEnrollmentReviewCartTotal;
            return _this;
        }
        return StEnrollmentClassConfig;
    }(st_module_18.StModule);
    exports.StEnrollmentClassConfig = StEnrollmentClassConfig;
});

define("core/shopify-app/st-modules/enrollment/enrollment", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_19) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollment = void 0;
    var StEnrollment = function(_super) {
        __extends(StEnrollment, _super);
        function StEnrollment(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Enrollment";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.preventFormSubmit();
                });
            };
            _this.classConfig = classConfig;
            return _this;
        }
        StEnrollment.prototype.preventFormSubmit = function(forms) {
            forms = forms ? forms : document.querySelectorAll(this.classConfig.selectorEnrollmentForm);
            if (forms.length > 0) {
                forms.forEach(function(form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                    });
                });
            }
        };
        return StEnrollment;
    }(st_module_19.StModule);
    exports.StEnrollment = StEnrollment;
});

define("core/shopify-app/st-modules/_general-methods/form/cart-manipulation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_20) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCartManipulation = void 0;
    var StCartManipulation = function(_super) {
        __extends(StCartManipulation, _super);
        function StCartManipulation() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "CartManipulation";
            return _this;
        }
        return StCartManipulation;
    }(st_module_20.StModule);
    exports.StCartManipulation = StCartManipulation;
});

define("core/shopify-app/st-modules/_general-methods/form/loader", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_21) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StLoader = void 0;
    var StLoader = function(_super) {
        __extends(StLoader, _super);
        function StLoader() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Loader";
            _this.init = function() {};
            _this.on = function(triggerBtn) {
                if (!!triggerBtn && !triggerBtn.classList.contains("st_loader-active")) {
                    triggerBtn.classList.add("st_loader-active");
                }
            };
            _this.off = function(triggerBtn) {
                if (!!triggerBtn && triggerBtn.classList.contains("st_loader-active")) {
                    triggerBtn.classList.remove("st_loader-active");
                }
            };
            return _this;
        }
        return StLoader;
    }(st_module_21.StModule);
    exports.StLoader = StLoader;
});

define("core/shopify-app/st-modules/_general-methods/button/button-actions", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_22) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StButtonActions = exports.EButtonAction = void 0;
    var EButtonAction;
    (function(EButtonAction) {
        EButtonAction["enable"] = "enable";
        EButtonAction["disable"] = "disable";
        EButtonAction["toggleState"] = "toggleState";
        EButtonAction["prevent"] = "prevent";
        EButtonAction["allow"] = "allow";
        EButtonAction["addLoader"] = "addLoader";
        EButtonAction["removeLoader"] = "removeLoader";
        EButtonAction["toggleLoader"] = "toggleLoader";
    })(EButtonAction = exports.EButtonAction || (exports.EButtonAction = {}));
    var StButtonActions = function(_super) {
        __extends(StButtonActions, _super);
        function StButtonActions() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ButtonActions";
            _this.applyToMultiple = function(buttons, action) {
                buttons.forEach(function(button) {
                    _this[action](button);
                });
            };
            _this.enable = function(button) {
                if (!!button) {
                    button.removeAttribute("disabled");
                    button.classList.remove("st-disabled");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.disable = function(button) {
                if (!!button) {
                    button.setAttribute("disabled", "");
                    button.classList.add("st-disabled");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.addLoader = function(button) {
                if (!!button) {
                    button.classList.add("st-loading");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.removeLoader = function(button) {
                if (!!button) {
                    button.classList.remove("st-loading");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.toggleState = function(button) {
                if (!!button) {
                    if (button.classList.contains("st-disabled")) {
                        _this.enable(button);
                    } else {
                        _this.disable(button);
                    }
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.toggleLoader = function(button) {
                if (!!button) {
                    if (button.classList.contains("st-loading")) {
                        _this.removeLoader(button);
                    } else {
                        _this.addLoader(button);
                    }
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.prevent = function(button) {
                if (!!button) {
                    _this.disable(button);
                    _this.addLoader(button);
                    button.classList.add("st-blocked");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.allow = function(button) {
                if (!!button) {
                    _this.enable(button);
                    _this.removeLoader(button);
                    button.classList.remove("st-blocked");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.isBlocked = function(button) {
                return button.classList.contains("st-blocked");
            };
            _this.isLoading = function(button) {
                return button.classList.contains("st-loading");
            };
            _this.isDisabled = function(button) {
                return button.classList.contains("st-disabled") || button.classList.contains("st-disabled");
            };
            return _this;
        }
        return StButtonActions;
    }(st_module_22.StModule);
    exports.StButtonActions = StButtonActions;
});

define("core/shopify-app/st-modules/_general-methods/notification", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_23) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StNotification = exports.ENotificationType = void 0;
    var ENotificationType;
    (function(ENotificationType) {
        ENotificationType["success"] = "success";
        ENotificationType["error"] = "error";
        ENotificationType["info"] = "info";
    })(ENotificationType = exports.ENotificationType || (exports.ENotificationType = {}));
    var StNotification = function(_super) {
        __extends(StNotification, _super);
        function StNotification() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Notification";
            _this.createNotification = function() {
                var element = document.createElement("div");
                element.setAttribute("class", "st_notification-wrapper");
                element.setAttribute("id", "st_notification");
                var trigger = document.createElement("button");
                trigger.setAttribute("type", "button");
                trigger.dataset.close = "notification";
                trigger.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 40 40"><path d="M23.868 20.015L39.117 4.78c1.11-1.108 1.11-2.77 0-3.877-1.109-1.108-2.773-1.108-3.882 0L19.986 16.137 4.737.904C3.628-.204 1.965-.204.856.904c-1.11 1.108-1.11 2.77 0 3.877l15.249 15.234L.855 35.248c-1.108 1.108-1.108 2.77 0 3.877.555.554 1.248.831 1.942.831s1.386-.277 1.94-.83l15.25-15.234 15.248 15.233c.555.554 1.248.831 1.941.831s1.387-.277 1.941-.83c1.11-1.109 1.11-2.77 0-3.878L23.868 20.015z" /></svg>';
                element.appendChild(trigger);
                var title = document.createElement("div");
                title.setAttribute("class", "st_notification-title");
                element.appendChild(title);
                var desc = document.createElement("div");
                desc.setAttribute("class", "st_notification-description");
                element.appendChild(desc);
                return element;
            };
            _this.assembleNotification = function(type, title, description) {
                if (title === void 0) {
                    title = "";
                }
                if (description === void 0) {
                    description = "";
                }
                var typeClass = "";
                var notification = _this.createNotification();
                if (typeof description === "string") {
                    description = [ description ];
                }
                switch (type) {
                  case "success":
                    typeClass = "st_success";
                    break;

                  case "error":
                    typeClass = "st_error";
                    break;

                  case "info":
                    typeClass = "st_info";
                    break;
                }
                notification.classList.add(typeClass);
                var t = notification.querySelector(".st_notification-title");
                t.innerHTML = title;
                var d = notification.querySelector(".st_notification-description");
                var message = "";
                for (var i = 0; i < description.length; i++) {
                    if (i !== 0) {
                        message += "<hr>";
                    }
                    message += description[i];
                }
                d.innerHTML = message;
                return notification;
            };
            _this.showNotification = function(type, title, description, duration, preventDisappear) {
                if (type === void 0) {
                    type = ENotificationType.error;
                }
                if (title === void 0) {
                    title = "";
                }
                if (description === void 0) {
                    description = "";
                }
                if (duration === void 0) {
                    duration = 5e3;
                }
                if (preventDisappear === void 0) {
                    preventDisappear = false;
                }
                var notif = document.getElementById("st_notification");
                if (notif !== null) {
                    notif.remove();
                }
                var notification = _this.assembleNotification(type, title, description);
                var button = notification.querySelectorAll('button[data-close="notification"]')[0];
                button.addEventListener("click", function(e) {
                    var el = this.closest(".st_notification-wrapper");
                    body.removeChild(el);
                });
                var body = document.getElementsByTagName("body")[0];
                body.appendChild(notification);
                if (!preventDisappear) {
                    clearTimeout(_this.globalShowTimeout);
                    _this.globalShowTimeout = setTimeout(function() {
                        if (notification && notification.parentNode) {
                            notification.parentNode.removeChild(notification);
                        }
                    }, duration);
                }
            };
            return _this;
        }
        return StNotification;
    }(st_module_23.StModule);
    exports.StNotification = StNotification;
});

define("core/connector-app/_shared/models/enrollment/enrollment-submit/enrollment.submit.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/enrollment/page/enrollment-submit", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_24, notification_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentActions = void 0;
    var StEnrollmentActions = function(_super) {
        __extends(StEnrollmentActions, _super);
        function StEnrollmentActions(classConfig, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentActions";
            _this_1.submit = function(dataToSubmit) {
                var _this = _this_1;
                console.log(dataToSubmit);
                _this_1.ajax.send({
                    endpoint: _this.endpoint["enrollment"]["submit"],
                    method: "post",
                    contentType: "json",
                    data: dataToSubmit,
                    callback: function(response) {
                        try {
                            var submitResponse = JSON.parse(response.response);
                            if (response.status === 200) {
                                if (submitResponse.data.checkoutUrl && submitResponse.data.checkoutUrl !== "") {
                                    console.log(submitResponse.data.checkoutUrl);
                                    window.location.href = submitResponse.data.checkoutUrl;
                                } else {
                                    window.location.href = window.typagehandle;
                                }
                            } else {
                                _this.notification.showNotification(notification_1.ENotificationType.error, "An Error Occurred", submitResponse.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_1.ENotificationType.error, "An Error Occurred", error);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            return _this_1;
        }
        return StEnrollmentActions;
    }(st_module_24.StModule);
    exports.StEnrollmentActions = StEnrollmentActions;
});

define("core/connector-app/_shared/models/enrollment/enrollment-validation/enrollment.validation.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/enrollment/enrollment-validation/enrollment.validation.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/enrollment/_general/enrollment-models", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/enrollment/page/enrollment-page", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_25) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentPage = void 0;
    var StEnrollmentPage = function(_super) {
        __extends(StEnrollmentPage, _super);
        function StEnrollmentPage(classConfig, generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentPage";
            _this.maxPage = 0;
            _this.currentIndex = 0;
            _this.setMaxPage = function(maxPage) {
                _this.maxPage = maxPage;
            };
            _this.getMaxPage = function() {
                return _this.maxPage;
            };
            _this.setCurrentIndex = function(index) {
                _this.currentIndex = index;
            };
            _this.getCurrentIndex = function() {
                return _this.currentIndex;
            };
            _this.getCurrentPage = function() {
                return _this.getPageByIndex(_this.currentIndex);
            };
            _this.setupPageIndex = function(pages) {
                pages.forEach(function(page, ind) {
                    page.setAttribute("data-page-index", "" + ind);
                });
            };
            _this.getPageByIndex = function(pageIndex) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var pages = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentPage);
                return pages[pageIndex];
            };
            _this.openPage = function(pageIndex) {
                if (pageIndex === void 0) {
                    pageIndex = 0;
                }
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var alreadyOpen = wrp.querySelector(_this.classConfig.selectorEnrollmentPage + _this.classConfig.selectorEnrollmentPageShow);
                var enrollmentPages = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentPage);
                var navHolder = wrp.querySelector(_this.classConfig.selectorEnrollmentNavHolder);
                var enrollmentNavElements = navHolder.querySelectorAll(_this.classConfig.selectorEnrollmentNavHolderSingle);
                var prevButtons = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentPrev);
                if (!!alreadyOpen) {
                    alreadyOpen.classList.remove(_this.classConfig.classNameElementShow);
                }
                if (enrollmentPages.length > 0) {
                    enrollmentPages[pageIndex].classList.add(_this.classConfig.classNameElementShow);
                } else {
                    console.error("Invalid page index supplied to enrollment openPage method!");
                }
                enrollmentNavElements.forEach(function(navElement, index) {
                    navElement.classList.remove("active");
                    navElement.classList.remove("current");
                    if (index < pageIndex) {
                        navElement.classList.add("active");
                    } else if (index === pageIndex) {
                        navElement.classList.add("current");
                    }
                });
                _this.setCurrentIndex(pageIndex);
                _this.changeButtonText();
                _this.prevButtonVisibility(prevButtons, pageIndex);
                _this.generalMethods.scrollTo(_this.getCurrentPage(), 500);
            };
            _this.changeButtonText = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var selectorEnrollmentNext = wrp.querySelector(_this.classConfig.selectorEnrollmentNext);
                selectorEnrollmentNext.querySelector("span").innerHTML = _this.currentIndex === _this.maxPage - 1 ? _this.classConfig.textSubmit : _this.classConfig.textNext;
            };
            _this.prevButtonVisibility = function(prevButtons, pageIndex) {
                if (pageIndex === 0) {
                    prevButtons.forEach(function(button) {
                        button.classList.add("st_hidden");
                    });
                } else {
                    prevButtons.forEach(function(button) {
                        button.classList.remove("st_hidden");
                    });
                }
            };
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StEnrollmentPage;
    }(st_module_25.StModule);
    exports.StEnrollmentPage = StEnrollmentPage;
});

define("core/shopify-app/st-modules/enrollment/_validation/enrollment-validation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_26, notification_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentValidation = void 0;
    var StEnrollmentValidation = function(_super) {
        __extends(StEnrollmentValidation, _super);
        function StEnrollmentValidation(classConfig, notification, enrollmentPage) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentValidate";
            _this_1.validationMethods = {};
            _this_1.setupValidation = function(validationClasses) {
                validationClasses.forEach(function(validationClass) {
                    var methods = validationClass.setupValidationMethods();
                    if (!!methods) {
                        _this_1.validationMethods = __assign(__assign({}, _this_1.validationMethods), methods);
                    }
                });
            };
            _this_1.getValidation = function() {
                return __assign({}, _this_1.validationMethods);
            };
            _this_1.markInvalid = function(page, inputName) {
                page.querySelectorAll('[data-validation-visual="'.concat(inputName, '"]')).forEach(function(validationVisual) {
                    validationVisual.classList.add(_this_1.classConfig.classNameInputInvalid);
                });
            };
            _this_1.clearInvalid = function(page, specificElement) {
                if (!!specificElement) {
                    specificElement.classList.remove(_this_1.classConfig.classNameInputInvalid);
                } else {
                    page.querySelectorAll(_this_1.classConfig.selectorInputInvalid).forEach(function(element) {
                        element.classList.remove(_this_1.classConfig.classNameInputInvalid);
                    });
                }
            };
            _this_1.serverValidate = function(dataToValidate, validCB, invalidCB) {
                if (validCB === void 0) {
                    validCB = function() {};
                }
                if (invalidCB === void 0) {
                    invalidCB = function() {};
                }
                var _this = _this_1;
                _this_1.ajax.send({
                    endpoint: _this.endpoint["enrollment"]["validate-data"],
                    method: "post",
                    contentType: "json",
                    data: dataToValidate,
                    callback: function(request) {
                        try {
                            var data = JSON.parse(request.response);
                            if (request.status === 200) {
                                validCB(request, data);
                            } else {
                                invalidCB({
                                    status: request.status,
                                    message: data.message
                                });
                                _this.notification.showNotification(notification_2.ENotificationType.error, "Validation Error", data.message);
                            }
                        } catch (error) {
                            invalidCB({
                                status: 500,
                                message: error.message
                            });
                            console.error(error);
                            _this.notification.showNotification(notification_2.ENotificationType.error, "Validation Error", error);
                        }
                    }
                });
            };
            _this_1.basicValidate = function(pageIndex) {
                var page, forms;
                if (typeof pageIndex !== "undefined" && pageIndex !== -1) {
                    page = _this_1.enrollmentPage.getPageByIndex(pageIndex);
                    forms = page.querySelectorAll(_this_1.classConfig.selectorEnrollmentForm);
                } else {
                    var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                    forms = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentForm);
                }
                for (var i = 0; i < forms.length; i++) {
                    var form = forms[i];
                    var sectionName = form.getAttribute("data-name");
                    var validation = _this_1.getValidation();
                    if (validation[sectionName]) {
                        var basicValidationParams = validation[sectionName].basic();
                        for (var j = 0; j < basicValidationParams.length; j++) {
                            var validationParam = basicValidationParams[j];
                            var input = form.querySelector('[name="'.concat(validationParam, '"]'));
                            if (!!input) {
                                if (typeof input.value === "undefined" || input.value === "") {
                                    return false;
                                }
                            } else {
                                console.warn('Input with name: "'.concat(validationParam, "\" was added to basic validation but doesn't exist in DOM. Skipping this field for validation."));
                            }
                        }
                    }
                }
                return true;
            };
            _this_1.basicValidationDelay = 200;
            _this_1.setupBasicValidationEvents = function(inputSelector, afterValidation) {
                var _this = _this_1;
                afterValidation(_this.runBasicValidation());
                var eventListenerFn = function() {
                    clearTimeout(_this.basicValidationTimeout);
                    _this.basicValidationTimeout = setTimeout(function() {
                        afterValidation(_this.runBasicValidation());
                    }, _this.basicValidationDelay);
                };
                inputSelector.addEventListener("input", eventListenerFn);
                inputSelector.addEventListener("change", eventListenerFn);
                inputSelector.addEventListener("paste", eventListenerFn);
            };
            _this_1.runBasicValidation = function() {
                var pageIndex = _this_1.enrollmentPage.getCurrentIndex();
                return _this_1.basicValidate(pageIndex);
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            _this_1.enrollmentPage = enrollmentPage;
            return _this_1;
        }
        return StEnrollmentValidation;
    }(st_module_26.StModule);
    exports.StEnrollmentValidation = StEnrollmentValidation;
});

define("core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_27) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionBase = void 0;
    var StEnrollmentSectionBase = function(_super) {
        __extends(StEnrollmentSectionBase, _super);
        function StEnrollmentSectionBase(args) {
            var _this = _super.call(this, args) || this;
            _this.setupValidationMethods = function() {
                var methods = {};
                methods[_this.validationName] = {
                    site: _this.validateOnSite,
                    server: _this.validateOnServer,
                    basic: _this.addToBasicValidation
                };
                return methods;
            };
            _this.addToBasicValidation = function() {
                return [];
            };
            _this.validateOnServer = function() {
                return [];
            };
            _this.validateOnSite = function() {
                return [];
            };
            return _this;
        }
        StEnrollmentSectionBase.prototype.initFields = function() {};
        StEnrollmentSectionBase.prototype.selectFields = function() {
            return [];
        };
        return StEnrollmentSectionBase;
    }(st_module_27.StModule);
    exports.StEnrollmentSectionBase = StEnrollmentSectionBase;
});

define("core/shopify-app/st-modules/enrollment/blocks/review-privacy/enrollment-section-review-privacy", [ "require", "exports", "core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base" ], function(require, exports, enrollment_section_validation_base_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionPrivacy = void 0;
    var StEnrollmentSectionPrivacy = function(_super) {
        __extends(StEnrollmentSectionPrivacy, _super);
        function StEnrollmentSectionPrivacy(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentSectionPrivacy";
            _this.validationName = "privacy";
            _this.validateOnSite = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var output = [];
                if (!!wrp) {
                    var inputs = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentTnCField);
                    inputs.forEach(function(input) {
                        var fieldName = input.getAttribute("name");
                        var isChecked = input.checked === true;
                        var isRequired = !!input.getAttribute("required");
                        var isValid = isChecked && isRequired || !isRequired;
                        output[fieldName] = {
                            isValid: isValid,
                            message: !isValid ? "You must accept terms and conditions to continue!" : ""
                        };
                    });
                }
                return output;
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentSectionPrivacy;
    }(enrollment_section_validation_base_1.StEnrollmentSectionBase);
    exports.StEnrollmentSectionPrivacy = StEnrollmentSectionPrivacy;
});

define("core/shopify-app/st-modules/enrollment/blocks/account-details/enrollment-section-account-details", [ "require", "exports", "core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base" ], function(require, exports, enrollment_section_validation_base_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionAccountDetails = void 0;
    var StEnrollmentSectionAccountDetails = function(_super) {
        __extends(StEnrollmentSectionAccountDetails, _super);
        function StEnrollmentSectionAccountDetails() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountDetails";
            _this.validationName = "account-details";
            _this.addToBasicValidation = function() {
                return [ "firstName", "lastName", "phoneNumber", "dateOfBirth" ];
            };
            _this.validateOnServer = function() {
                return [ "firstName", "lastName", "phoneNumber", "dateOfBirth" ];
            };
            return _this;
        }
        return StEnrollmentSectionAccountDetails;
    }(enrollment_section_validation_base_2.StEnrollmentSectionBase);
    exports.StEnrollmentSectionAccountDetails = StEnrollmentSectionAccountDetails;
});

define("core/shopify-app/st-modules/enrollment/blocks/business-info/enrollment-section-business-details", [ "require", "exports", "core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base" ], function(require, exports, enrollment_section_validation_base_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionBusinessDetails = void 0;
    var StEnrollmentSectionBusinessDetails = function(_super) {
        __extends(StEnrollmentSectionBusinessDetails, _super);
        function StEnrollmentSectionBusinessDetails() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentBusinessDetails";
            _this.validationName = "business-details";
            _this.addToBasicValidation = function() {
                return [ "SSN", "webAlias" ];
            };
            _this.validateOnServer = function() {
                return [ "SSN", "webAlias" ];
            };
            return _this;
        }
        return StEnrollmentSectionBusinessDetails;
    }(enrollment_section_validation_base_3.StEnrollmentSectionBase);
    exports.StEnrollmentSectionBusinessDetails = StEnrollmentSectionBusinessDetails;
});

define("core/shopify-app/st-modules/enrollment/_validation/enrollment-validation-setup", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_28) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentValidationSetup = void 0;
    var StEnrollmentValidationSetup = function(_super) {
        __extends(StEnrollmentValidationSetup, _super);
        function StEnrollmentValidationSetup(enrollmentValidation, sectionPrivacy, sectionAccountDetails, sectionBusinessDetails) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentValidationSetup";
            _this.setupValidation = function() {
                _this.enrollmentValidation.setupValidation([ _this.sectionPrivacy, _this.sectionAccountDetails, _this.sectionBusinessDetails ]);
            };
            _this.enrollmentValidation = enrollmentValidation;
            _this.sectionPrivacy = sectionPrivacy;
            _this.sectionAccountDetails = sectionAccountDetails;
            _this.sectionBusinessDetails = sectionBusinessDetails;
            return _this;
        }
        return StEnrollmentValidationSetup;
    }(st_module_28.StModule);
    exports.StEnrollmentValidationSetup = StEnrollmentValidationSetup;
});

define("core/shopify-app/st-modules/enrollment/_general/enrollment-store", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_29) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentStore = void 0;
    var StEnrollmentStore = function(_super) {
        __extends(StEnrollmentStore, _super);
        function StEnrollmentStore(classConfig, cartHandler) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentStore";
            _this.dataStore = {
                shopifyId: undefined
            };
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                    var shopifyIdHolder = wrp.querySelector('[name="shopifyId"]');
                    var shopifyId = parseInt(shopifyIdHolder.value);
                    _this.saveData({
                        shopifyId: shopifyId
                    });
                });
            };
            _this.saveData = function(dataToSave) {
                _this.dataStore = __assign(__assign({}, _this.dataStore), dataToSave);
                _this.updateCart({
                    attributes: __assign({}, _this.dataStore)
                }, function(cart) {
                    console.log(cart);
                });
            };
            _this.loadData = function() {
                return __assign({}, _this.dataStore);
            };
            _this.updateCart = function(params, callback) {
                _this.ajax.send({
                    endpoint: _this.cartHandler.shopifyCartApiEndpoints["update-cart"],
                    method: "POST",
                    contentType: "json",
                    data: params,
                    callback: function(request) {
                        callback(JSON.parse(request.response));
                    }
                });
            };
            _this.classConfig = classConfig;
            _this.cartHandler = cartHandler;
            return _this;
        }
        return StEnrollmentStore;
    }(st_module_29.StModule);
    exports.StEnrollmentStore = StEnrollmentStore;
});

define("core/shopify-app/st-modules/_general-methods/currency", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_30) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCurrency = exports.EAmountType = exports.ECurrencyFormatType = void 0;
    var ECurrencyFormatType;
    (function(ECurrencyFormatType) {
        ECurrencyFormatType["withCurrency"] = "withCurrency";
        ECurrencyFormatType["withoutCurrency"] = "withoutCurrency";
    })(ECurrencyFormatType = exports.ECurrencyFormatType || (exports.ECurrencyFormatType = {}));
    var EAmountType;
    (function(EAmountType) {
        EAmountType["amount"] = "amount";
        EAmountType["amount_no_decimals"] = "amount_no_decimals";
        EAmountType["unknown"] = "unknown";
    })(EAmountType = exports.EAmountType || (exports.EAmountType = {}));
    var StCurrency = function(_super) {
        __extends(StCurrency, _super);
        function StCurrency() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Currency";
            _this.currencyFormat = window.stCurrencyFormat;
            _this.applyFormat = function(amount, formatType) {
                if (formatType === void 0) {
                    formatType = ECurrencyFormatType.withCurrency;
                }
                var format = _this.currencyFormat[formatType];
                var amountType = _this.determineAmountType(format);
                if (amountType !== EAmountType.unknown) {
                    return format.replace("{{" + amountType + "}}", "" + amount.toFixed(2));
                } else {
                    console.error("Unrecognized price format. Returning price without currency formatting.");
                    return "" + amount;
                }
            };
            _this.determineAmountType = function(format) {
                if (format.indexOf("{{amount}}") > -1) {
                    return EAmountType.amount;
                } else if (format.indexOf("{{amount_no_decimals}}") > -1) {
                    return EAmountType.amount_no_decimals;
                } else {
                    return EAmountType.unknown;
                }
            };
            return _this;
        }
        StCurrency.prototype.commaFormattedPrice = function(amount, decimalDelimiter, thousandsDelimiter) {
            if (decimalDelimiter === void 0) {
                decimalDelimiter = ".";
            }
            if (thousandsDelimiter === void 0) {
                thousandsDelimiter = ",";
            }
            var amountComponents = String(amount).split(".", 2);
            var wholeNumber = parseInt(amountComponents[0]);
            if (isNaN(wholeNumber)) {
                return "";
            }
            var decimal = amountComponents[1];
            var minus = wholeNumber < 0 ? "-" : "";
            wholeNumber = Math.abs(wholeNumber);
            var wholeString = String(wholeNumber);
            var amountSegmented = [];
            while (wholeString.length > 3) {
                amountSegmented.unshift(wholeString.substr(wholeString.length - 3));
                wholeString = wholeString.substr(0, wholeString.length - 3);
            }
            if (wholeString.length > 0) {
                amountSegmented.unshift(wholeString);
            }
            wholeString = amountSegmented.join(thousandsDelimiter);
            decimal = decimal.length < 1 ? "" : decimalDelimiter + decimal;
            return minus + wholeString + decimal;
        };
        return StCurrency;
    }(st_module_30.StModule);
    exports.StCurrency = StCurrency;
});

define("core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review-cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency" ], function(require, exports, st_module_31, currency_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentReviewCart = void 0;
    var StEnrollmentReviewCart = function(_super) {
        __extends(StEnrollmentReviewCart, _super);
        function StEnrollmentReviewCart(classConfig, store, currency) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentReviewCart";
            _this.injectCart = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var cartContent = wrp.querySelector(_this.classConfig.selectorEnrollmentReviewCartContentWrapper);
                var cartWrapper = wrp.querySelector(_this.classConfig.selectorEnrollmentReviewCartWrapper);
                var storeData = _this.store.loadData();
                var reqKits = storeData.requiredKits ? storeData.requiredKits : [];
                var optKits = storeData.optionalKits ? storeData.optionalKits : [];
                var selectedProducts = __spreadArray(__spreadArray([], reqKits, true), optKits, true);
                if (selectedProducts.length > 0) {
                    !!cartWrapper && cartWrapper.classList.remove("st_hidden");
                    !!cartContent && cartContent.classList.remove("st_hidden");
                    !!cartContent && cartContent.replaceChildren();
                    var productPrices_1 = [];
                    selectedProducts.forEach(function(selectedProduct) {
                        var imageEl = wrp.querySelector('[data-image-holder="'.concat(selectedProduct.variantId, '"]'));
                        var titleEl = wrp.querySelector('[data-title-holder="'.concat(selectedProduct.variantId, '"]'));
                        var descriptionEl = wrp.querySelector('[data-description-holder="'.concat(selectedProduct.variantId, '"]'));
                        var priceEl = wrp.querySelector('[data-price-holder="'.concat(selectedProduct.variantId, '"]'));
                        var recurringEl = wrp.querySelector('[data-recurring-holder="'.concat(selectedProduct.variantId, '"]'));
                        var sellingPlanEl = wrp.querySelector('[data-selling-plan-holder="'.concat(selectedProduct.variantId, '"]'));
                        var imageURL = !!imageEl ? imageEl.src : "";
                        var title = !!titleEl ? titleEl.innerHTML : "";
                        var description = !!descriptionEl ? descriptionEl.innerHTML : "";
                        var price = !!priceEl ? priceEl.innerHTML : "";
                        var priceRaw = !!priceEl ? parseInt(priceEl.getAttribute("data-price-raw")) : 0;
                        var recurring = !!recurringEl ? recurringEl.value === "true" : false;
                        var sellingPlan = !!sellingPlanEl ? sellingPlanEl.value : "One Time Payment";
                        var printableReviewProduct = {
                            variantId: selectedProduct.variantId,
                            image: imageURL,
                            title: title,
                            description: description,
                            price: price,
                            recurring: recurring,
                            sellingPlan: sellingPlan
                        };
                        productPrices_1.push(priceRaw);
                        if (!!cartContent) {
                            var cartMember = _this.generateCartMember(printableReviewProduct);
                            cartContent.appendChild(cartMember);
                        }
                    });
                    var cartTotalEl = wrp.querySelector(_this.classConfig.selectorEnrollmentReviewCartTotal);
                    if (!!cartTotalEl) {
                        var total = productPrices_1.reduce(function(accumulator, value) {
                            return accumulator + parseInt("".concat(value));
                        });
                        cartTotalEl.innerHTML = _this.currency.applyFormat(total / 100, currency_1.ECurrencyFormatType.withCurrency);
                    }
                } else {
                    !!cartWrapper && cartWrapper.classList.add("st_hidden");
                    !!cartContent && cartContent.classList.add("st_hidden");
                }
            };
            _this.generateCartMembers = function(products) {
                var output = [];
                products.forEach(function(productInfo) {
                    var cartMember = _this.generateCartMember(productInfo);
                    output.push(cartMember);
                });
                return output;
            };
            _this.generateCartMember = function(productInfo) {
                var wrap = document.createElement("div");
                wrap.classList.add("st_enrollment-checkout-row");
                wrap.classList.add("st_flex");
                wrap.classList.add("st_align");
                var imageWrap = document.createElement("div");
                imageWrap.classList.add("st_enrollment-image--wrapper");
                var image = document.createElement("img");
                image.src = productInfo.image;
                image.alt = productInfo.title;
                var listWrapper = document.createElement("div");
                listWrapper.classList.add("st_enrollment-list--wrapper");
                var title = document.createElement("div");
                title.classList.add("st_title");
                title.innerHTML = productInfo.title;
                var description = document.createElement("div");
                description.innerHTML = productInfo.description;
                var priceWrapper = document.createElement("div");
                priceWrapper.classList.add("st_enrollment-price--wrapper");
                var recurring = document.createElement("div");
                recurring.classList.add("st_subscription");
                recurring.classList.add("st_subscription-review");
                recurring.innerText = productInfo.sellingPlan;
                var price = document.createElement("div");
                price.classList.add("st_price");
                price.innerHTML = productInfo.price;
                imageWrap.appendChild(image);
                listWrapper.appendChild(title);
                listWrapper.appendChild(description);
                priceWrapper.appendChild(recurring);
                priceWrapper.appendChild(price);
                wrap.appendChild(imageWrap);
                wrap.appendChild(listWrapper);
                wrap.appendChild(priceWrapper);
                return wrap;
            };
            _this.classConfig = classConfig;
            _this.store = store;
            _this.currency = currency;
            return _this;
        }
        return StEnrollmentReviewCart;
    }(st_module_31.StModule);
    exports.StEnrollmentReviewCart = StEnrollmentReviewCart;
});

define("core/shopify-app/st-modules/enrollment/blocks/optional-kits/enrollment-section-optional-kits", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_32) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentOptionalKits = void 0;
    var StEnrollmentOptionalKits = function(_super) {
        __extends(StEnrollmentOptionalKits, _super);
        function StEnrollmentOptionalKits(classConfig, store, reviewCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentOptionalBundle";
            _this_1.setupButtons = function(buttons) {
                var _this = _this_1;
                buttons.forEach(function(button) {
                    button.addEventListener("click", function(e) {
                        e.preventDefault();
                        var variantId = this.getAttribute("data-variant-id");
                        var quantity = parseInt(this.getAttribute("data-quantity"));
                        var sellingPlan = this.getAttribute("data-selling-plan");
                        var selected = this.getAttribute("data-selected") === "true";
                        selected = !selected;
                        var bundleObject = {
                            variantId: "" + variantId,
                            quantity: quantity
                        };
                        if (sellingPlan && sellingPlan !== "") {
                            bundleObject.selling_plan = sellingPlan;
                        }
                        var span = this.querySelector(".st_text");
                        var icon = this.querySelector(".st_check-icon");
                        if (selected) {
                            icon.classList.remove("st_hidden");
                            span.classList.add("st_hidden");
                        } else {
                            icon.classList.add("st_hidden");
                            span.classList.remove("st_hidden");
                        }
                        _this.toggleBundleSelect(selected, bundleObject);
                        this.setAttribute("data-selected", selected);
                    });
                });
            };
            _this_1.toggleBundleSelect = function(makeSelected, bundleObject) {
                try {
                    var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                    var optionalBundlesInput = wrp.querySelector(_this_1.classConfig.selectorEnrollmentOptionalKitsInput);
                    var selectedBundles = JSON.parse(optionalBundlesInput.value);
                    if (makeSelected) {
                        var itemAlreadySelected = false;
                        for (var i = 0; i < selectedBundles.length; i++) {
                            if ("" + selectedBundles[i].variantId === "" + bundleObject.variantId) {
                                itemAlreadySelected = true;
                                break;
                            }
                        }
                        if (!itemAlreadySelected) {
                            selectedBundles.push(bundleObject);
                        }
                    } else {
                        var formattedBundles = [];
                        for (var i = 0; i < selectedBundles.length; i++) {
                            if ("" + selectedBundles[i].variantId !== "" + bundleObject.variantId) {
                                formattedBundles.push(selectedBundles[i]);
                            }
                        }
                        selectedBundles = formattedBundles;
                    }
                    optionalBundlesInput.value = JSON.stringify(selectedBundles);
                    optionalBundlesInput.setAttribute("value", optionalBundlesInput.value);
                    _this_1.store.saveData({
                        optionalKits: selectedBundles
                    });
                    _this_1.reviewCart.injectCart();
                } catch (e) {
                    console.error("An error occurred while processing toggleBundleSelect. Error message: " + e.message);
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.reviewCart = reviewCart;
            return _this_1;
        }
        return StEnrollmentOptionalKits;
    }(st_module_32.StModule);
    exports.StEnrollmentOptionalKits = StEnrollmentOptionalKits;
});

define("core/shopify-app/st-modules/enrollment/blocks/required-kits/enrollment-section-required-kits", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_33) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentRequiredKits = void 0;
    var StEnrollmentRequiredKits = function(_super) {
        __extends(StEnrollmentRequiredKits, _super);
        function StEnrollmentRequiredKits(classConfig, store, reviewCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentRequiredBundle";
            _this_1.init = function() {
                var _this = _this_1;
                _this_1.subscribeDOMLoaded(function() {
                    _this.store.saveData({
                        requiredKits: _this.getRequiredKits()
                    });
                    _this_1.reviewCart.injectCart();
                    _this_1.onRequiredKitVariantSelect();
                });
            };
            _this_1.getRequiredKits = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var requiredKitsHolder = wrp.querySelector('[name="requiredKits"]');
                return requiredKitsHolder ? JSON.parse(decodeURIComponent(requiredKitsHolder.value)) : [];
            };
            _this_1.format = function(sourceData) {
                var formattedData = [];
                sourceData.forEach(function(item) {
                    if (typeof item.variantId !== "undefined") {
                        var formattedItem = {
                            variantId: item.variantId.toString(),
                            quantity: item.quantity
                        };
                        if (item.selling_plan && item.selling_plan !== "") {
                            formattedItem.selling_plan = item.selling_plan + "";
                        }
                        formattedData.push(formattedItem);
                    }
                });
                return formattedData;
            };
            _this_1.onRequiredKitVariantSelect = function() {
                var _this = _this_1;
                var requiredKitWrapperList = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentRequiredKitWrapper);
                if (!!requiredKitWrapperList) {
                    requiredKitWrapperList.forEach(function(requiredKitWrapper) {
                        var variantSelect = requiredKitWrapper.querySelector(_this_1.classConfig.selectorEnrollmentRequiredKitVariantSelect);
                        if (!!variantSelect) {
                            variantSelect.onchange = function() {
                                var variantValue = JSON.parse(decodeURI(variantSelect.value));
                                var optionValue = [];
                                optionValue.push(variantValue);
                                var variantHiddenWrapper = document.querySelector(_this.classConfig.selectorEnrollmentRequiredKitsOptionsWrapper);
                                var requiredKitDescription = document.querySelector(_this.classConfig.selectorEnrollmentRequiredKitsText);
                                var requiredKitImg = requiredKitWrapper.querySelector(_this.classConfig.selectorEnrollmentRequiredKitsImg);
                                var variantTitleHeading = document.querySelector(_this.classConfig.selectorEnrollmentRequiredKitVariantHeading);
                                var variantTitle = requiredKitWrapper.querySelector(_this.classConfig.selectorEnrollmentRequiredKitSelectedVariantTitle);
                                var variantTitleHidden = variantHiddenWrapper.querySelector('input[data-title-holder="'.concat(variantValue.variantId, '"]'));
                                var variantPrice = requiredKitWrapper.querySelector(_this.classConfig.selectorEnrollmentRequiredKitVariantPrice);
                                var variantPriceHidden = variantHiddenWrapper.querySelector('input[data-price-holder="'.concat(variantValue.variantId, '"]'));
                                var variantPriceRawHidden = variantHiddenWrapper.querySelector('input[data-price-raw-holder="'.concat(variantValue.variantId, '"]'));
                                var hiddenVariantInput = document.querySelector(_this.classConfig.selectorEnrollmentHiddenRequiredKitInput);
                                if (!!requiredKitDescription) {
                                    requiredKitDescription.setAttribute("data-description-holder", variantValue.variantId);
                                }
                                if (!!requiredKitImg) {
                                    requiredKitImg.setAttribute("data-image-holder", variantValue.variantId);
                                }
                                if (!!variantTitleHeading) {
                                    variantTitleHeading.innerHTML = variantTitleHidden.value;
                                    variantTitleHeading.setAttribute("data-title-holder", variantValue.variantId);
                                }
                                if (!!variantTitle) {
                                    variantTitle.innerHTML = variantTitleHidden.value;
                                }
                                if (!!variantPrice) {
                                    variantPrice.innerHTML = variantPriceHidden.value;
                                    variantPrice.setAttribute("data-price-holder", variantValue.variantId);
                                    variantPrice.setAttribute("data-price-raw", variantPriceRawHidden.value);
                                }
                                if (!!hiddenVariantInput) {
                                    delete optionValue[optionValue.length - 1].price;
                                    hiddenVariantInput.value = encodeURI(JSON.stringify(optionValue));
                                    hiddenVariantInput.setAttribute("value", JSON.stringify(optionValue));
                                    _this.store.saveData({
                                        requiredKits: optionValue
                                    });
                                    _this_1.reviewCart.injectCart();
                                }
                            };
                        }
                    });
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.reviewCart = reviewCart;
            return _this_1;
        }
        return StEnrollmentRequiredKits;
    }(st_module_33.StModule);
    exports.StEnrollmentRequiredKits = StEnrollmentRequiredKits;
});

define("core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_34) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentReview = void 0;
    var EFormatType;
    (function(EFormatType) {
        EFormatType["date"] = "date";
    })(EFormatType || (EFormatType = {}));
    var StEnrollmentReview = function(_super) {
        __extends(StEnrollmentReview, _super);
        function StEnrollmentReview(classConfig, store, generalMethods, enrollmentPage, currency, form, reviewCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentReview";
            _this_1.setupReview = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                if (_this_1.reviewBlockExists(wrp)) {
                    var holder = wrp.querySelector(_this_1.classConfig.selectorEnrollmentReviewParamHolder);
                    if (!!holder) {
                        _this_1.generateReviewParams(holder, _this_1.getParamInfo());
                    }
                    var paramSources = wrp.querySelectorAll("[data-review-param]");
                    _this_1.setupParamChangeEvents(paramSources);
                }
            };
            _this_1.reviewBlockExists = function(wrp) {
                var reviewSection = wrp.querySelector(_this_1.classConfig.selectorEnrollmentReviewWrapper);
                return !!reviewSection;
            };
            _this_1.getParamInfo = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var paramHolders = wrp.querySelectorAll("[data-review-param]");
                var params = [];
                var storedData = _this_1.store.loadData();
                paramHolders.forEach(function(paramHolder) {
                    var pageWrapper = _this_1.generalMethods.getClosestByClass(paramHolder, _this_1.classConfig.classNameEnrollmentPage);
                    var pageIndex = parseInt(pageWrapper.getAttribute("data-page-index"));
                    var inputName = paramHolder.getAttribute("name");
                    var formatName = paramHolder.getAttribute("data-format");
                    var param = {
                        name: paramHolder.getAttribute("data-review-param"),
                        inputName: inputName,
                        value: storedData[inputName] ? storedData[inputName] : "",
                        allowEdit: paramHolder.getAttribute("data-review-edit") !== "false",
                        pageIndex: pageIndex,
                        format: _this_1.getFormatByName(EFormatType[formatName])
                    };
                    params.push(param);
                });
                return params;
            };
            _this_1.getFormatByName = function(name) {
                if (name === EFormatType.date) {
                    return function(value) {
                        if (value && value !== "-") {
                            var dateComponents = value.split("-");
                            var days = dateComponents[2];
                            days = days.length === 1 ? "0".concat(days) : "".concat(days);
                            var months = dateComponents[1];
                            months = months.length === 1 ? "0".concat(months) : "".concat(months);
                            var years = dateComponents[0];
                            return "".concat(months, "/").concat(days, "/").concat(years);
                        } else {
                            return "";
                        }
                    };
                } else {
                    return function(value) {
                        return value;
                    };
                }
            };
            _this_1.generateReviewParams = function(holder, params) {
                var _this = _this_1;
                params.forEach(function(param, ind) {
                    var row = document.createElement("div");
                    row.classList.add("st_enrollment-business-info-row");
                    var col = document.createElement("div");
                    col.classList.add("st_info-column");
                    var colL = document.createElement("div");
                    colL.classList.add("st_col-left");
                    var colName = document.createElement("div");
                    colName.classList.add("st_name");
                    colName.innerText = param.name;
                    colL.appendChild(colName);
                    var value = typeof param.value !== "undefined" && param.value !== "" ? "" + param.value : "-";
                    var colValue = document.createElement("div");
                    colValue.classList.add("st_print-name");
                    if (param.inputName == "email") colValue.classList.add("st_email");
                    colValue.setAttribute("data-field-for", param.inputName);
                    colValue.innerText = param.format(value);
                    colL.appendChild(colValue);
                    col.appendChild(colL);
                    var colR = document.createElement("div");
                    colR.classList.add("st_col-right");
                    if (param.allowEdit) {
                        var editButton = document.createElement("button");
                        editButton.setAttribute("type", "button");
                        editButton.classList.add("st_enrollment-edit");
                        editButton.setAttribute("data-page-index", "" + param.pageIndex);
                        editButton.setAttribute("data-edit-for", param.inputName);
                        editButton.innerText = _this_1.classConfig.reviewEditText;
                        colR.appendChild(editButton);
                        editButton.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.edit(this.getAttribute("data-edit-for"), parseInt(this.getAttribute("data-page-index")));
                        });
                    }
                    col.appendChild(colR);
                    row.appendChild(col);
                    holder.appendChild(row);
                });
            };
            _this_1.setupParamChangeEvents = function(paramSources) {
                var _this = _this_1;
                paramSources.forEach(function(paramHolder) {
                    var fieldObj = _this.form.collectField(paramHolder);
                    var inputName = paramHolder.getAttribute("name");
                    var name = paramHolder.getAttribute("data-review-param");
                    var value = fieldObj[inputName];
                    _this.applyParamChange(name, inputName, value.toString());
                    paramHolder.addEventListener("keyup", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var name = this.getAttribute("data-review-param");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(name, inputName, value.toString());
                    });
                    paramHolder.addEventListener("input", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var name = this.getAttribute("data-review-param");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(name, inputName, value.toString());
                    });
                    paramHolder.addEventListener("change", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var name = this.getAttribute("data-review-param");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(name, inputName, value.toString());
                    });
                });
            };
            _this_1.applyParamChange = function(name, inputName, value) {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var holder = wrp.querySelector('[data-review-param="'.concat(name, '"]'));
                var param = wrp.querySelector('[data-field-for="'.concat(inputName, '"]'));
                var formatName = holder.getAttribute("data-format");
                var format = _this_1.getFormatByName(EFormatType[formatName]);
                if (param) {
                    param.innerText = format(value.toString());
                } else {
                    console.error("Review template error. Couldn't find element to change parameter with name: ".concat(inputName, "."));
                }
            };
            _this_1.edit = function(holderName, pageIndex) {
                _this_1.enrollmentPage.openPage(pageIndex);
                var currentPage = _this_1.enrollmentPage.getCurrentPage();
                var holdersFirstVisual = currentPage.querySelector('[data-validation-visual="'.concat(holderName, '"]'));
                if (!!holdersFirstVisual) {
                    _this_1.generalMethods.scrollTo(holdersFirstVisual, 500);
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.generalMethods = generalMethods;
            _this_1.enrollmentPage = enrollmentPage;
            _this_1.currency = currency;
            _this_1.form = form;
            _this_1.reviewCart = reviewCart;
            return _this_1;
        }
        return StEnrollmentReview;
    }(st_module_34.StModule);
    exports.StEnrollmentReview = StEnrollmentReview;
});

define("core/shopify-app/st-modules/enrollment/page-header/nav/enrollment-nav", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/_general-methods/button/button-actions" ], function(require, exports, st_module_35, notification_3, button_actions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentNav = void 0;
    var StEnrollmentNav = function(_super) {
        __extends(StEnrollmentNav, _super);
        function StEnrollmentNav(classConfig, actions, optionalKits, requiredKits, store, form, buttonActions, enrollmentValidation, enrollmentValidationSetup, notification, enrollmentReview, enrollmentPage) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentNav";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupNavPages();
                    _this_1.setupButtons();
                    _this_1.setupOptionalBundles();
                    _this_1.setupBasicValidation();
                });
            };
            _this_1.setupButtons = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var pages = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPage);
                if (pages.length > 0) {
                    _this_1.enrollmentPage.setMaxPage(pages.length);
                    _this_1.enrollmentPage.setupPageIndex(pages);
                    _this_1.enrollmentReview.setupReview();
                    _this_1.openPage(_this_1.enrollmentPage.getCurrentIndex());
                    if (!!wrp) {
                        _this_1.bindEvents(wrp);
                    } else {
                        console.error("Enrollment wrapper does not exist! Cannot setup enrollment nav.");
                    }
                } else {
                    console.error("Enrollment doesn't have a page! Can't init enrollment!");
                }
            };
            _this_1.openPage = function(pageIndex) {
                _this_1.enrollmentPage.openPage(pageIndex);
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                if (pageIndex === 0) {
                    prevButtons.forEach(function(button) {
                        button.classList.add("st_hidden");
                    });
                } else {
                    prevButtons.forEach(function(button) {
                        button.classList.remove("st_hidden");
                    });
                }
            };
            _this_1.bindEvents = function(wrp) {
                var _this = _this_1;
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                nextButtons.forEach(function(nextButton) {
                    nextButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        if (!_this.buttonActions.isDisabled(this)) {
                            _this.nextOrSubmit();
                        }
                    });
                });
                prevButtons.forEach(function(prevButton) {
                    prevButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.prev();
                    });
                });
            };
            _this_1.setupOptionalBundles = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var optionalBundleTriggers = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentOptionalKitsTrigger);
                _this_1.optionalKits.setupButtons(optionalBundleTriggers);
            };
            _this_1.nextOrSubmit = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var enrollmentPages = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPage);
                var currentPage = enrollmentPages[_this_1.enrollmentPage.getCurrentIndex()];
                var forms = currentPage.querySelectorAll(_this_1.classConfig.selectorEnrollmentForm);
                var shopifyIdHolder = wrp.querySelector('[name="shopifyId"]');
                var shopifyId = parseInt(shopifyIdHolder.value);
                var serverValidationParams = {
                    shopifyId: shopifyId
                };
                var onSiteValidationFunctions = [];
                var validation = _this_1.enrollmentValidation.getValidation();
                var dataToSave = {};
                _this_1.enrollmentValidation.clearInvalid(currentPage);
                forms.forEach(function(form) {
                    var sectionName = form.getAttribute("data-name");
                    if (!!sectionName && sectionName !== "") {
                        var formData_1 = _this_1.form.collectFormData(form);
                        var paramsToValidate_1 = {};
                        dataToSave = __assign(__assign({}, dataToSave), formData_1);
                        if (validation.hasOwnProperty(sectionName)) {
                            var backendParamNames = validation[sectionName].server();
                            backendParamNames.forEach(function(param) {
                                if (typeof paramsToValidate_1[param] !== "undefined") {
                                    console.error("Duplicate setup of param with name: ".concat(param));
                                }
                                paramsToValidate_1[param] = formData_1[param];
                            });
                            serverValidationParams = __assign(__assign({}, serverValidationParams), paramsToValidate_1);
                            onSiteValidationFunctions.push(validation[sectionName].site);
                        } else {
                            console.log('Enrollment block with name "'.concat(sectionName, '" does not have registered validation class. Skipping validation.'));
                        }
                    }
                });
                var joinedValidationResponse = {};
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.prevent);
                _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.prevent);
                if (Object.keys(serverValidationParams).length > 0) {
                    _this_1.enrollmentValidation.serverValidate(serverValidationParams, function(response, validation) {
                        joinedValidationResponse = _this_1.validateOnSite(__assign({}, validation.data), onSiteValidationFunctions);
                        _this_1.afterValidation(joinedValidationResponse, dataToSave, currentPage);
                    }, function(error) {
                        console.error("An error occurred with status: ".concat(error.status, ". Message: ").concat(error.message));
                        _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.allow);
                        _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.allow);
                    });
                } else {
                    joinedValidationResponse = _this_1.validateOnSite(joinedValidationResponse, onSiteValidationFunctions);
                    _this_1.afterValidation(joinedValidationResponse, dataToSave, currentPage);
                }
            };
            _this_1.validateOnSite = function(joinedValidationResponse, onSiteValidationFunctions) {
                if (onSiteValidationFunctions === void 0) {
                    onSiteValidationFunctions = [];
                }
                var output = joinedValidationResponse;
                onSiteValidationFunctions.forEach(function(paramValidationFunction) {
                    output = __assign(__assign({}, output), paramValidationFunction());
                });
                return output;
            };
            _this_1.afterValidation = function(validationResponse, dataToSave, page) {
                if (Object.keys(validationResponse).length > 0) {
                    var hasInvalid_1 = false;
                    var errorMessage_1 = [];
                    Object.keys(validationResponse).forEach(function(paramName) {
                        if (!validationResponse[paramName].isValid) {
                            _this_1.enrollmentValidation.markInvalid(page, paramName);
                            hasInvalid_1 = true;
                            errorMessage_1.push(validationResponse[paramName].message);
                        }
                    });
                    if (hasInvalid_1) {
                        _this_1.notification.showNotification(notification_3.ENotificationType.error, "Some fields are invalid!", errorMessage_1);
                        var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                        var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                        var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                        _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.allow);
                        _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.allow);
                    } else {
                        _this_1.store.saveData(dataToSave);
                        _this_1.next();
                    }
                } else {
                    _this_1.store.saveData(dataToSave);
                    _this_1.next();
                }
            };
            _this_1.setupBasicValidation = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var paramNames = [];
                var validation = _this_1.enrollmentValidation.getValidation();
                var allFormNames = Object.keys(validation);
                allFormNames.forEach(function(formName) {
                    if (validation[formName]) {
                        paramNames = paramNames.concat(validation[formName].basic());
                    }
                });
                for (var i = 0; i < paramNames.length; i++) {
                    var param = paramNames[i];
                    var input = wrp.querySelector('[name="'.concat(param, '"]'));
                    _this_1.enrollmentValidation.setupBasicValidationEvents(input, _this_1.afterBasicValidation);
                }
            };
            _this_1.afterBasicValidation = function(valid) {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                if (valid) {
                    nextButtons.forEach(function(nextButton) {
                        _this_1.buttonActions.enable(nextButton);
                    });
                } else {
                    nextButtons.forEach(function(nextButton) {
                        _this_1.buttonActions.disable(nextButton);
                    });
                }
            };
            _this_1.next = function() {
                var currentIndex = _this_1.enrollmentPage.getCurrentIndex();
                if (currentIndex + 1 < _this_1.enrollmentPage.getMaxPage()) {
                    _this_1.enrollmentPage.setCurrentIndex(currentIndex + 1);
                    _this_1.openPage(currentIndex + 1);
                    var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                    var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                    var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                    _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.allow);
                    _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.allow);
                } else {
                    var data = _this_1.store.loadData();
                    var items = data.requiredKits ? _this_1.requiredKits.format(data.requiredKits) : [];
                    items = data.optionalKits ? items.concat(data.optionalKits) : items;
                    var submit = {
                        shopifyId: data.shopifyId,
                        firstName: data.firstName,
                        lastName: data.lastName,
                        phoneNumber: data.phoneNumber,
                        webAlias: data.webAlias,
                        sponsorsWebAlias: data.sponsorsWebAlias,
                        dateOfBirth: data.dateOfBirth,
                        SSN: data.SSN,
                        items: items
                    };
                    _this_1.actions.submit(submit);
                }
            };
            _this_1.prev = function() {
                var currentIndex = _this_1.enrollmentPage.getCurrentIndex();
                if (currentIndex - 1 >= 0) {
                    _this_1.enrollmentPage.setCurrentIndex(currentIndex - 1);
                    _this_1.openPage(currentIndex - 1);
                }
            };
            _this_1.setupNavPages = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var pages = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPage);
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorEnrollmentNavHolder);
                if (!!navHolder) {
                    if (pages.length > 1) {
                        pages.forEach(function(page, pageIndex) {
                            var templateName = page.getAttribute("data-name");
                            var isActive = pageIndex === 0;
                            navHolder.appendChild(_this_1.navPageTemplate(pageIndex, templateName, isActive));
                        });
                    } else {
                        var navWrp = wrp.querySelector(_this_1.classConfig.selectorEnrollmentNavWrapper);
                        if (navWrp) {
                            navWrp.classList.add(_this_1.classConfig.classNameElementHide);
                        }
                    }
                } else {
                    console.error("Enrollment Nav holder not present! Navigation won't setup");
                }
            };
            _this_1.navPageTemplate = function(pageIndex, templateName, isActive) {
                if (templateName === void 0) {
                    templateName = "";
                }
                var templateNode;
                templateNode = document.createElement("div");
                templateNode.classList.add("st_header-enrollment-single-column");
                templateNode.classList.add(_this_1.classConfig.classNameEnrollmentNavHolderSingle);
                if (isActive) {
                    templateNode.classList.add("active");
                }
                var innerWrapper = document.createElement("div");
                innerWrapper.classList.add("st_flex");
                innerWrapper.classList.add("st_align");
                var button = document.createElement("button");
                button.classList.add("st_header-navigation-enrollment");
                button.classList.add(_this_1.classConfig.selectorEnrollmentNavButton);
                button.setAttribute("data-index", "".concat(pageIndex));
                var text = document.createElement("span");
                text.classList.add("st_header-text");
                text.innerHTML = templateName;
                var pageNumber = document.createElement("span");
                pageNumber.classList.add("st_number");
                pageNumber.innerHTML = "" + (pageIndex + 1);
                button.appendChild(pageNumber);
                innerWrapper.appendChild(button);
                innerWrapper.appendChild(text);
                templateNode.appendChild(innerWrapper);
                return templateNode;
            };
            _this_1.classConfig = classConfig;
            _this_1.actions = actions;
            _this_1.optionalKits = optionalKits;
            _this_1.requiredKits = requiredKits;
            _this_1.store = store;
            _this_1.form = form;
            _this_1.buttonActions = buttonActions;
            _this_1.enrollmentValidation = enrollmentValidation;
            _this_1.enrollmentValidationSetup = enrollmentValidationSetup;
            _this_1.notification = notification;
            _this_1.enrollmentReview = enrollmentReview;
            _this_1.enrollmentPage = enrollmentPage;
            _this_1.enrollmentValidationSetup.setupValidation();
            return _this_1;
        }
        return StEnrollmentNav;
    }(st_module_35.StModule);
    exports.StEnrollmentNav = StEnrollmentNav;
});

define("core/connector-app/_shared/models/search-sponsor/search.sponsor.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor-service", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_36) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorService = void 0;
    var StSearchSponsorService = function(_super) {
        __extends(StSearchSponsorService, _super);
        function StSearchSponsorService() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorService";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {});
            };
            _this.getSponsorByPersonalInfo = function(inputValue, handleGetSponsorInfo) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["searchSponsor"]["getSponsorByPersonalInfo"],
                        method: "post",
                        contentType: "json",
                        data: {
                            query: inputValue
                        },
                        callback: handleGetSponsorInfo
                    });
                } catch (error) {
                    console.log("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            _this.getSponsorInfo = function(sponsorIdOrAlias, handleGetSponsorInfo) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["searchSponsor"]["getSponsorInfo"],
                        method: "post",
                        contentType: "json",
                        data: {
                            query: sponsorIdOrAlias
                        },
                        callback: handleGetSponsorInfo
                    });
                } catch (error) {
                    console.log("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            return _this;
        }
        return StSearchSponsorService;
    }(st_module_36.StModule);
    exports.StSearchSponsorService = StSearchSponsorService;
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_37, _features_config_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsor = void 0;
    var SponsorRequestType;
    (function(SponsorRequestType) {
        SponsorRequestType[SponsorRequestType["GET_BY_ID_OR_ALIAS"] = 0] = "GET_BY_ID_OR_ALIAS";
        SponsorRequestType[SponsorRequestType["GET_BY_PERSONAL_INFORMATION"] = 1] = "GET_BY_PERSONAL_INFORMATION";
    })(SponsorRequestType || (SponsorRequestType = {}));
    var StSearchSponsor = function(_super) {
        __extends(StSearchSponsor, _super);
        function StSearchSponsor(generalMethods, objectFormatting, browserHistory, classConfig, cookies, cart, sponsorService) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsor";
            _this.endpointString = [ "getSponsorInfo", "getSponsorByPersonalInfo" ];
            _this.MIN_CHAR_SEARCH_REQUIREMENT = 2;
            _this.REQUEST_DELAY = 1e3;
            _this.inputValue = "";
            _this.cookieNameWebAlias = "webAlias";
            _this.cookieNameRepId = "repId";
            _this.cookieNameFirstName = "firstName";
            _this.cookieNameLastName = "lastName";
            _this.retryWebAliasFetch = true;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.initSearchBoxFunctionality();
                    _this.initRadioButtons();
                    _this.windowClick();
                    _this.triggerVisibilityOfSection();
                    _this.cart.subscribeRenderCart(function(callback) {
                        _this.changeCartEvents();
                    });
                });
            };
            _this.loaderOn = function(triggerBtn) {
                var label = _this.generalMethods.getClosestByTag(triggerBtn, "label");
                if (!!label && !label.classList.contains("st_loader-active")) {
                    label.classList.add("st_loader-active");
                }
            };
            _this.loaderOff = function(triggerBtn) {
                var label = _this.generalMethods.getClosestByTag(triggerBtn, "label");
                if (!!label && label.classList.contains("st_loader-active")) {
                    label.classList.remove("st_loader-active");
                }
            };
            _this.changeCartEvents = function() {
                _this.initSearchBoxFunctionality();
                _this.initRadioButtons();
                _this.triggerVisibilityOfSection();
            };
            _this.setRepCookies = function(repInfo) {
                _this.cookies.setCookies(_this.cookieNameWebAlias, repInfo.webAlias);
                _this.cookies.setCookies(_this.cookieNameRepId, repInfo.repId);
                _this.cookies.setCookies(_this.cookieNameFirstName, repInfo.firstName);
                _this.cookies.setCookies(_this.cookieNameLastName, repInfo.lastName);
            };
            _this.triggerVisibilityOfSection = function() {
                var searchSponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                searchSponsorWrappers === null || searchSponsorWrappers === void 0 ? void 0 : searchSponsorWrappers.forEach(function(searchSponsorWrapper) {
                    var customerType = window.customerInfoMetafields.customerType;
                    if (customerType == _features_config_6.ECustomerType.retail && _features_config_6.lockedRepresentativeSite || customerType == _features_config_6.ECustomerType.representative) {
                        var searchSponsorWrapperLink = searchSponsorWrapper.querySelector(_this.classConfig.selectorChangeSponsorWrapperLink);
                        searchSponsorWrapperLink === null || searchSponsorWrapperLink === void 0 ? void 0 : searchSponsorWrapperLink.classList.add("st_hidden");
                    } else {
                        var triggerForOpenSearchInput = searchSponsorWrapper.querySelector(_this.classConfig.selectorChangeSponsorWrapper);
                        triggerForOpenSearchInput === null || triggerForOpenSearchInput === void 0 ? void 0 : triggerForOpenSearchInput.addEventListener("click", function(e) {
                            e.preventDefault();
                            searchSponsorWrappers.forEach(function(wrapper) {
                                _this.defaultVisibility(wrapper);
                            });
                            _this.showSearchInput(searchSponsorWrapper);
                            _this.hideSearchResults(searchSponsorWrapper);
                        });
                        _this.nonSponsors(searchSponsorWrapper);
                    }
                });
            };
            _this.nonSponsors = function(searchSponsorWrapper) {
                var triggerForDefaultSponsorInput = searchSponsorWrapper.querySelector(_this.classConfig.selectorNonSponsor);
                triggerForDefaultSponsorInput === null || triggerForDefaultSponsorInput === void 0 ? void 0 : triggerForDefaultSponsorInput.addEventListener("click", function() {
                    _this.updateUrl(_features_config_6.defaultWebAlias);
                    _this.defaultVisibility(searchSponsorWrapper);
                    _this.getSponsorInfo(_features_config_6.defaultWebAlias);
                    _this.setSponsorWebAliasToForm(_features_config_6.defaultWebAlias);
                    _this.setNewSponsorInfoToHeader(_features_config_6.corporationName, "", _features_config_6.defaultWebAlias);
                });
            };
            _this.updateUrl = function(newAlias) {
                var _a;
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_6.aliasQueryParam];
                if (currentAlias !== newAlias) {
                    urlParams = __assign(__assign({}, urlParams), (_a = {}, _a[_features_config_6.aliasQueryParam] = newAlias, 
                    _a));
                    var newURL = window.location.href.replace(window.location.search, "");
                    _this.cart.updateCartItemsProperies(newAlias);
                    _this.browserHistory.pushHistory(newURL, urlParams);
                }
            };
            _this.windowClick = function() {
                document.addEventListener("click", function(e) {
                    var searchSponsorsResult = document.querySelector(_this.classConfig.selectorChooseSponsor);
                    if (!!searchSponsorsResult) {
                        if (!_this.generalMethods.getClosestByClass(e.target, "st_search-input-and-result")) {
                            var sponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                            sponsorWrappers === null || sponsorWrappers === void 0 ? void 0 : sponsorWrappers.forEach(function(sponsorWrapper) {
                                _this.clearSponsorSuggestions(sponsorWrapper);
                            });
                        }
                    }
                });
            };
            _this.defaultVisibility = function(searchSponsorWrapper) {
                if (!!searchSponsorWrapper) {
                    _this.hideSearchInput(searchSponsorWrapper);
                    _this.showSearchResults(searchSponsorWrapper);
                }
            };
            _this.setSponsorWebAliasToForm = function(alias) {
                if (_features_config_6.canGoUnderCorporateSite || !_features_config_6.canGoUnderCorporateSite && alias !== _features_config_6.defaultWebAlias) {
                    var sponsorWebAliasFields = document.querySelectorAll(_this.classConfig.selectorRepresentativeAlias);
                    sponsorWebAliasFields === null || sponsorWebAliasFields === void 0 ? void 0 : sponsorWebAliasFields.forEach(function(field) {
                        _this.appendValueToField(field, alias);
                    });
                }
            };
            _this.getSponsorInfo = function(sponsorIdOrAlias) {
                if (_this.lastSponsorInfo && (_this.lastSponsorInfo.webAlias === sponsorIdOrAlias || _this.lastSponsorInfo.repId === sponsorIdOrAlias)) {
                    _this.injectSponsorInfo(_this.lastSponsorInfo);
                    return;
                }
                _this.loadersOnForSponsorInfo();
                _this.sponsorService.getSponsorInfo(sponsorIdOrAlias, function(request) {
                    var _a;
                    try {
                        if (request.status === 200) {
                            var sponsorInfoResponse = JSON.parse(request.response);
                            var sponsorsInformation = (_a = sponsorInfoResponse.data) === null || _a === void 0 ? void 0 : _a.sponsors;
                            var sponsorInformation = sponsorsInformation ? sponsorsInformation[0] : null;
                            if (!sponsorInformation.webAlias && sponsorInformation.webAlias === "") {
                                sponsorInformation.webAlias = sponsorInformation.repId;
                            }
                            _this.lastSponsorInfo = sponsorInformation;
                            _this.injectSponsorInfo(sponsorInformation);
                            _this.setRepCookies(sponsorInformation);
                        } else {
                            if (_this.retryWebAliasFetch) {
                                _this.retryWebAliasFetch = false;
                                _this.getSponsorInfo(_features_config_6.defaultWebAlias);
                            }
                        }
                    } catch (error) {
                        console.log(error);
                        _this.getSponsorInfo(_features_config_6.defaultWebAlias);
                    }
                });
            };
            _this.loadersOnForSponsorInfo = function() {
                var sponsorsData = document.querySelectorAll(_this.classConfig.selectorSponsorData);
                var svg = '<svg width="15" height="15" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#222" class="st_loader">\n                        <g fill="none" fill-rule="evenodd">\n                            <g transform="translate(1 1)" stroke-width="2">\n                                <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>\n                                <path d="M36 18c0-9.94-8.06-18-18-18">\n                                    <animateTransform\n                                            attributeName="transform"\n                                            type="rotate"\n                                            from="0 18 18"\n                                            to="360 18 18"\n                                            dur="1s"\n                                            repeatCount="indefinite"/>\n                                </path>\n                            </g>\n                        </g>\n                    </svg>';
                sponsorsData === null || sponsorsData === void 0 ? void 0 : sponsorsData.forEach(function(sponsorData) {
                    sponsorData.innerHTML = svg;
                });
            };
            _this.injectSponsorInfo = function(sponsorInformation) {
                var sponsorIdFields = document.querySelectorAll(_this.classConfig.selectorSponsorId);
                var sponsorAliasFields = document.querySelectorAll(_this.classConfig.selectorSponsorAlias);
                var sponsorFullNameFields = document.querySelectorAll(_this.classConfig.selectorSponsorFullName);
                var sponsorInitialsFields = document.querySelectorAll(_this.classConfig.selectorSponsorInitials);
                var sponsorAddressFields = document.querySelectorAll(_this.classConfig.selectorSponsorAddress);
                _this.injectTextIntoFields(sponsorIdFields, sponsorInformation.repId);
                _this.injectTextIntoFields(sponsorAliasFields, sponsorInformation.webAlias);
                _this.injectTextIntoFields(sponsorFullNameFields, "".concat(sponsorInformation.firstName, " ").concat(sponsorInformation.lastName));
                _this.injectTextIntoFields(sponsorInitialsFields, "".concat(sponsorInformation.firstName.charAt(0)).concat(sponsorInformation.lastName.charAt(0)));
                var address = sponsorInformation.address.state && sponsorInformation.address.state !== "" ? sponsorInformation.address.state + ", " + sponsorInformation.address.city : sponsorInformation.address.city;
                _this.injectTextIntoFields(sponsorAddressFields, address);
            };
            _this.searchSponsors = function(searchWrapper) {
                var input = searchWrapper.querySelector(_this.classConfig.selectorSearchSponsor);
                if (!!input) {
                    input.addEventListener("keyup", function(e) {
                        _this.getSponsors(input);
                    });
                    input.addEventListener("input", function(e) {
                        _this.getSponsors(input);
                    });
                    input.addEventListener("paste", function(e) {
                        _this.getSponsors(input);
                    });
                }
            };
            _this.getSponsors = function(input) {
                var value = input.value;
                if (_this.inputValue === value) return;
                if (value.length < _this.MIN_CHAR_SEARCH_REQUIREMENT) {
                    var searchSponsorInputWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                    _this.clearSponsorSuggestions(searchSponsorInputWrapper);
                    _this.enableRadioButtons(input);
                    return;
                }
                _this.inputValue = value;
                var requestType = _this.getCurrentRoute(input);
                _this.loaderOn(input);
                _this.disableRadioButtons(input);
                if (requestType === SponsorRequestType.GET_BY_ID_OR_ALIAS) {
                    _this.subscribeToTimeout(input, function() {
                        _this.sponsorService.getSponsorInfo(value, function(request) {
                            return _this.handleGetSponsorsResponse(request, input);
                        });
                    });
                }
                if (requestType === SponsorRequestType.GET_BY_PERSONAL_INFORMATION) {
                    _this.subscribeToTimeout(input, function() {
                        _this.sponsorService.getSponsorByPersonalInfo(value, function(request) {
                            return _this.handleGetSponsorsResponse(request, input);
                        });
                    });
                }
            };
            _this.getCurrentRoute = function(input) {
                var route;
                var sponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton, index) {
                    if (radioButton.classList.contains("st_checked")) {
                        route = index;
                    }
                });
                return route;
            };
            _this.enableRadioButtons = function(input) {
                var sponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                    radioButton.removeAttribute("disabled");
                });
            };
            _this.disableRadioButtons = function(input) {
                var sponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                    radioButton.setAttribute("disabled", "disabled");
                });
            };
            _this.initRadioButtons = function() {
                var radioButtonsWrappers = document.querySelectorAll(_this.classConfig.selectorSearchInput);
                radioButtonsWrappers === null || radioButtonsWrappers === void 0 ? void 0 : radioButtonsWrappers.forEach(function(radioButtonsWrapper) {
                    var radioButtons = radioButtonsWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                    radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(input) {
                        input.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.handleRadioButtonStatusChange(radioButtons, radioButtonsWrapper);
                            _this.clearSearchSponsorInputValueAndSuggestions(input);
                        });
                    });
                });
            };
            _this.setChecked = function(element) {
                if (!element.classList.contains("st_checked")) {
                    element.classList.add("st_checked");
                }
                element.setAttribute("checked", "checked");
            };
            _this.removeChecked = function(element) {
                if (element.classList.contains("st_checked")) {
                    element.classList.remove("st_checked");
                }
                element.removeAttribute("checked");
            };
            _this.renderPlaceholderText = function(radioButton, wrapper) {
                var label = _this.generalMethods.getClosestByTag(radioButton, "label");
                var text = label.querySelector(_this.classConfig.selectorRadioText).textContent;
                var placeholder = wrapper.querySelector(".st_search-input .st_placeholder-text");
                placeholder.innerHTML = text;
            };
            _this.clearSearchSponsorInputValueAndSuggestions = function(input) {
                var searchSponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                if (!!searchSponsorWrapper) {
                    _this.clearSearchSponsorInputValue(searchSponsorWrapper);
                    _this.clearSponsorSuggestions(searchSponsorWrapper);
                }
            };
            _this.clearSearchSponsorInputValue = function(searchSponsorWrapper) {
                var searchSponsorInput = searchSponsorWrapper.querySelector(_this.classConfig.selectorSearchSponsor);
                if (!!searchSponsorInput) {
                    searchSponsorInput.value = "";
                    searchSponsorInput.replaceChildren();
                }
            };
            _this.clearSponsorSuggestions = function(searchSponsorWrapper) {
                var searchSponsorResult = searchSponsorWrapper.querySelector(_this.classConfig.selectorFoundSponsor);
                searchSponsorResult === null || searchSponsorResult === void 0 ? void 0 : searchSponsorResult.replaceChildren();
            };
            _this.renderSuggestionsWrapper = function(sponsorsList, input) {
                var sponsorsInputWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                if (!!sponsorsInputWrapper) {
                    var sponsorsWrapper_1 = sponsorsInputWrapper.querySelector(_this.classConfig.selectorFoundSponsor);
                    if (!!sponsorsWrapper_1) {
                        sponsorsWrapper_1.classList.remove("st_hidden");
                        sponsorsWrapper_1.replaceChildren();
                        sponsorsList === null || sponsorsList === void 0 ? void 0 : sponsorsList.forEach(function(sponsor) {
                            var sponsorJson = JSON.stringify(sponsor);
                            var buttonWithSponsorInfo = _this.createDOMElement("button", "st_search-sponsor-button--result st_choose-sponsor_JS", sponsorsWrapper_1);
                            buttonWithSponsorInfo.setAttribute("type", "button");
                            buttonWithSponsorInfo.setAttribute("data-sponsor-info", sponsorJson);
                            var leftPart = _this.createDOMElement("span", "st_result-left-part", buttonWithSponsorInfo);
                            var addressPart = _this.createDOMElement("span", "st_result-address", buttonWithSponsorInfo);
                            var credentialsSection = _this.createDOMElement("span", "st_account-sponsor-credentials-section", leftPart);
                            var sponsorResultName = _this.createDOMElement("span", "st_result-name", leftPart);
                            var addressPartData = _this.createDOMElement("span", "st_sponsor-address_JS", addressPart);
                            var state = sponsor.address.state;
                            var city = sponsor.address.city;
                            var address = state && state !== "" ? state + ", " + city : city;
                            addressPartData.innerHTML = address;
                            var initialsSection = _this.createDOMElement("span", "st_account-sponsor-initials", credentialsSection);
                            var initialsJSSection = _this.createDOMElement("span", "st_sponsor-initials_JS", initialsSection);
                            initialsJSSection.innerHTML = "".concat(sponsor.firstName.charAt(0)).concat(sponsor.lastName.charAt(0));
                            var colWrapper = _this.createDOMElement("span", "st_span-full-width", sponsorResultName);
                            var fullName = _this.createDOMElement("span", "st_sponsor-fullname_JS", colWrapper);
                            fullName.innerHTML = sponsor.firstName + " " + sponsor.lastName;
                            var sponsorIdWrapper = _this.createDOMElement("span", "st_sponsor-id", colWrapper);
                            var sponsorIdNumber = _this.createDOMElement("span", "st_sponsor-id_JS", sponsorIdWrapper);
                            sponsorIdNumber.innerHTML = " (ID: " + sponsor.repId + ")";
                            var aliasWrapper = _this.createDOMElement("span", "st_sponsor-alias", sponsorResultName);
                            var aliasWrapperData = _this.createDOMElement("span", "st_sponsor-alias_JS", aliasWrapper);
                            aliasWrapperData.innerHTML = sponsor.webAlias;
                        });
                    }
                    _this.chooseSponsor(sponsorsInputWrapper);
                }
            };
            _this.createDOMElement = function(element, classNames, parentElement) {
                var newElement = document.createElement(element);
                newElement.className = classNames;
                parentElement.appendChild(newElement);
                return newElement;
            };
            _this.chooseSponsor = function(sponsorsInputWrapper) {
                var sponsorButtons = sponsorsInputWrapper.querySelectorAll(_this.classConfig.selectorChooseSponsor);
                sponsorButtons === null || sponsorButtons === void 0 ? void 0 : sponsorButtons.forEach(function(sponsor) {
                    sponsor.addEventListener("click", function(e) {
                        e.preventDefault();
                        var newSponsorJson = sponsor.getAttribute("data-sponsor-info");
                        var newSponsor = JSON.parse(newSponsorJson);
                        var sponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                        sponsorWrappers === null || sponsorWrappers === void 0 ? void 0 : sponsorWrappers.forEach(function(sponsorWrapper) {
                            _this.defaultVisibility(sponsorWrapper);
                        });
                        _this.updateUrl(newSponsor.webAlias);
                        _this.clearSearchSponsorInputValueAndSuggestions(e.target);
                        _this.injectSponsorInfo(newSponsor);
                        _this.setRepCookies(newSponsor);
                        _this.setSponsorWebAliasToForm(newSponsor.webAlias);
                        _this.setNewSponsorInfoToHeader(newSponsor.firstName, newSponsor.lastName, newSponsor.webAlias);
                        window.dispatchEvent(new Event("sponsorChange"));
                    });
                });
            };
            _this.setNewSponsorInfoToHeader = function(repFirstName, repLastName, webAlias) {
                var repFullNameFields = document.querySelectorAll(_this.classConfig.selectorRepresentativeFullName);
                var fullName = _this.getFullName(repFirstName, repLastName, webAlias);
                repFullNameFields === null || repFullNameFields === void 0 ? void 0 : repFullNameFields.forEach(function(field) {
                    _this.appendValueToField(field, fullName);
                });
            };
            _this.appendValueToField = function(field, value) {
                if (field.tagName.toLowerCase() === "input") {
                    field.value = value;
                } else {
                    field.innerHTML = value;
                }
            };
            _this.hideSuggestionsWrapper = function(input) {
                var sponsorsInputWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var sponsorsWrapper = sponsorsInputWrapper === null || sponsorsInputWrapper === void 0 ? void 0 : sponsorsInputWrapper.querySelector(_this.classConfig.selectorFoundSponsor);
                sponsorsWrapper === null || sponsorsWrapper === void 0 ? void 0 : sponsorsWrapper.replaceChildren();
                sponsorsWrapper === null || sponsorsWrapper === void 0 ? void 0 : sponsorsWrapper.classList.add("st_hidden");
            };
            _this.generalMethods = generalMethods;
            _this.objectFormatting = objectFormatting;
            _this.browserHistory = browserHistory;
            _this.classConfig = classConfig;
            _this.cookies = cookies;
            _this.cart = cart;
            _this.sponsorService = sponsorService;
            return _this;
        }
        StSearchSponsor.prototype.hideSearchResults = function(searchWrapper) {
            var searchResult = searchWrapper.querySelector(this.classConfig.selectorSearchResult);
            if (!(searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.contains("st_hidden"))) {
                searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.add("st_hidden");
            }
        };
        StSearchSponsor.prototype.showSearchResults = function(searchWrapper) {
            var searchResult = searchWrapper.querySelector(this.classConfig.selectorSearchResult);
            if (searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.contains("st_hidden")) {
                searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.remove("st_hidden");
            }
        };
        StSearchSponsor.prototype.hideSearchInput = function(searchWrapper) {
            var searchInput = searchWrapper.querySelector(this.classConfig.selectorSearchInput);
            if (!(searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.contains("st_hidden"))) {
                searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.add("st_hidden");
            }
        };
        StSearchSponsor.prototype.showSearchInput = function(searchWrapper) {
            var searchInput = searchWrapper.querySelector(this.classConfig.selectorSearchInput);
            if (searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.contains("st_hidden")) {
                searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.remove("st_hidden");
            }
        };
        StSearchSponsor.prototype.initSearchBoxFunctionality = function() {
            var _this = this;
            var searchWrappers = document.querySelectorAll(this.classConfig.selectorSearchSponsorWrapperPage);
            if (searchWrappers.length > 0) {
                var customerID = window.customerInfoMetafields.customerId;
                var sponsorRepID = window.customerInfoMetafields.representativeId;
                var customerType = window.customerInfoMetafields.customerType;
                var repSite = void 0;
                if (!!customerID && _features_config_6.lockedRepresentativeSite && customerType !== _features_config_6.ECustomerType.noType) {
                    repSite = customerType === _features_config_6.ECustomerType.representative ? customerID : sponsorRepID;
                } else {
                    var urlParams = this.objectFormatting.convertQueryStringToObject(window.location.search);
                    var currentAlias = urlParams[_features_config_6.aliasQueryParam];
                    if (currentAlias) {
                        repSite = currentAlias;
                    } else {
                        if (!!this.cookies.getCookie("webAlias")) {
                            repSite = this.cookies.getCookie("webAlias");
                        }
                    }
                }
                this.getSponsorInfo(repSite);
            }
            searchWrappers === null || searchWrappers === void 0 ? void 0 : searchWrappers.forEach(function(wrapper) {
                _this.searchSponsors(wrapper);
            });
        };
        StSearchSponsor.prototype.injectTextIntoFields = function(fields, text) {
            fields === null || fields === void 0 ? void 0 : fields.forEach(function(field) {
                field.innerHTML = text;
            });
        };
        StSearchSponsor.prototype.subscribeToTimeout = function(input, request) {
            var value = input.value;
            if (value.length > 1) {
                clearTimeout(this.requestTimeout);
                this.requestTimeout = setTimeout(request, this.REQUEST_DELAY);
            } else {
                var searchSponsorInputWrapper = this.generalMethods.getClosestByClass(input, this.classConfig.classNameSearchInput);
                this.clearSponsorSuggestions(searchSponsorInputWrapper);
                this.enableRadioButtons(input);
            }
        };
        StSearchSponsor.prototype.handleGetSponsorsResponse = function(request, input) {
            var res = JSON.parse(request.response);
            if (res.status === 200) {
                var sponsorsList = res.data.sponsors;
                if (sponsorsList.length > 0) {
                    this.loaderOff(input);
                    this.enableRadioButtons(input);
                    this.renderSuggestionsWrapper(sponsorsList, input);
                } else {
                    this.loaderOff(input);
                    this.enableRadioButtons(input);
                    this.hideSuggestionsWrapper(input);
                }
            } else {
                this.loaderOff(input);
                this.enableRadioButtons(input);
                this.hideSuggestionsWrapper(input);
            }
        };
        StSearchSponsor.prototype.handleRadioButtonStatusChange = function(radioButtons, radioButtonsWrapper) {
            var _this = this;
            radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                if (!!radioButton.checked) {
                    _this.setChecked(radioButton);
                    _this.renderPlaceholderText(radioButton, radioButtonsWrapper);
                } else {
                    _this.removeChecked(radioButton);
                }
            });
        };
        StSearchSponsor.prototype.getFullName = function(repFirstName, repLastName, webAlias) {
            var fullName = !!repLastName ? repFirstName : "";
            fullName = !!repLastName ? fullName.concat(" ".concat(repLastName)) : fullName;
            if (webAlias === _features_config_6.defaultWebAlias) fullName = _features_config_6.corporationName;
            return fullName;
        };
        return StSearchSponsor;
    }(st_module_37.StModule);
    exports.StSearchSponsor = StSearchSponsor;
});

define("core/shopify-app/st-modules/enrollment-account/enrollment-account-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_38) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentAccountClassConfig = void 0;
    var StEnrollmentAccountClassConfig = function(_super) {
        __extends(StEnrollmentAccountClassConfig, _super);
        function StEnrollmentAccountClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountClassConfig";
            _this.classNameEnrollmentAccountPageWrp = "st_enrollment-account-page_JS";
            _this.selectorEnrollmentAccountPageWrp = "." + _this.classNameEnrollmentAccountPageWrp;
            _this.classNameEnrollmentLoginForm = "st_enrollment-login_JS";
            _this.selectorEnrollmentLoginForm = "." + _this.classNameEnrollmentLoginForm;
            _this.classNameEnrollmentCreateAccountWrp = "st_enrollment-create-account_JS";
            _this.selectorEnrollmentCreateAccountWrp = "." + _this.classNameEnrollmentCreateAccountWrp;
            _this.classNameEnrollmentCreateAccountForm = "st_enrollment-create-account--form_JS";
            _this.selectorEnrollmentCreateAccountForm = "." + _this.classNameEnrollmentCreateAccountForm;
            _this.classNameEnrollmentCreateAccountOpenButton = "st_enrollment-create-account--open_JS";
            _this.selectorEnrollmentCreateAccountOpenButton = "." + _this.classNameEnrollmentCreateAccountOpenButton;
            _this.classNameEnrollmentCreateAccountSubmit = "st_submit--btn_JS";
            _this.selectorEnrollmentCreateAccountSubmit = "." + _this.classNameEnrollmentCreateAccountSubmit;
            _this.classNameEnrollmentAccountPassword = "st_enrollment-account-create-password_JS";
            _this.selectorEnrollmentAccountPassword = "." + _this.classNameEnrollmentAccountPassword;
            _this.classNameEnrollmentAccountRepeatPassword = "st_enrollment-account-create-repeat-password_JS";
            _this.selectorEnrollmentAccountRepeatPassword = "." + _this.classNameEnrollmentAccountRepeatPassword;
            _this.classNamePrimaryInput = "st_primary-input_JS";
            _this.selectorPrimaryInput = "." + _this.classNamePrimaryInput;
            return _this;
        }
        return StEnrollmentAccountClassConfig;
    }(st_module_38.StModule);
    exports.StEnrollmentAccountClassConfig = StEnrollmentAccountClassConfig;
});

define("core/shopify-app/st-modules/enrollment/enrollment-cleanup", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_39, _features_config_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentCleanup = void 0;
    var StEnrollmentCleanup = function(_super) {
        __extends(StEnrollmentCleanup, _super);
        function StEnrollmentCleanup(cart) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StEnrollmentCleanup";
            _this.init = function() {};
            _this.clearCartAttributes = function(callback) {
                if (callback === void 0) {
                    callback = function() {};
                }
                _this.cart.getCart(function(cartData) {
                    var paramsToClear = _features_config_7.enrollmentParams !== null && _features_config_7.enrollmentParams !== void 0 ? _features_config_7.enrollmentParams : [];
                    if (cartData.attributes) {
                        var attributesFormatted_1 = __assign({}, cartData.attributes);
                        Object.keys(attributesFormatted_1).forEach(function(param) {
                            if (paramsToClear.indexOf(param) > -1) {
                                attributesFormatted_1[param] = "";
                            }
                        });
                        _this.cart.updateCart({
                            attributes: attributesFormatted_1
                        }, callback);
                    }
                });
            };
            _this.cart = cart;
            return _this;
        }
        return StEnrollmentCleanup;
    }(st_module_39.StModule);
    exports.StEnrollmentCleanup = StEnrollmentCleanup;
});

define("core/shopify-app/st-modules/enrollment-account/enrollment-account", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_40, notification_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentAccount = void 0;
    var StEnrollmentAccount = function(_super) {
        __extends(StEnrollmentAccount, _super);
        function StEnrollmentAccount(classConfig, buttonActions, notification, form, generalMethod, enrollmentCleanup, cart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentAccount";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.enrollmentLoginPreventDefault();
                    _this_1.toggleCreateAccount();
                    _this_1.enrollmentCreateAccountForm();
                });
            };
            _this_1.enrollmentLoginPreventDefault = function() {
                var _this = _this_1;
                var enrollmentForms = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentLoginForm);
                enrollmentForms.forEach(function(form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.enrollmentLogin(form, _this.prepareForLogin(form));
                    });
                });
            };
            _this_1.prepareForLogin = function(form) {
                var formData = _this_1.form.collectFormData(form);
                return {
                    email: formData["customer[email]"],
                    password: formData["customer[password]"]
                };
            };
            _this_1.enrollmentLogin = function(form, formData) {
                var _this = _this_1;
                var redirectUrl = form.getAttribute("data-url");
                var submitBtn = form.querySelector(".st_submit--btn_JS");
                _this.buttonActions.prevent(submitBtn);
                var loginRequest = {};
                loginRequest.form_type = "customer_login";
                loginRequest["customer[email]"] = formData.email;
                loginRequest["customer[password]"] = formData.password;
                _this.ajax.send({
                    endpoint: window.location.protocol + "//" + window.location.hostname + "/account/login",
                    method: "post",
                    contentType: "form",
                    data: loginRequest,
                    callback: function(request) {
                        try {
                            if (request.status == 200) {
                                var redirectUrlResponse = request.responseURL.toString();
                                if (redirectUrlResponse.includes("/account/login")) {
                                    window.location.reload();
                                    _this.buttonActions.allow(submitBtn);
                                    _this.notification.showNotification(notification_4.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                                } else {
                                    var cartData = _this.stCart.getShopifyCartData;
                                    if (cartData.attributes.email !== formData.email) {
                                        _this.enrollmentCleanup.clearCartAttributes(function() {
                                            window.location.assign(window.location.protocol + "//" + window.location.hostname + redirectUrl);
                                        });
                                    } else {
                                        window.location.assign(window.location.protocol + "//" + window.location.hostname + redirectUrl);
                                    }
                                }
                            } else {
                                window.location.reload();
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_4.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.buttonActions.allow(submitBtn);
                            _this.notification.showNotification(notification_4.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.toggleCreateAccount = function() {
                var _this = _this_1;
                var createAccountBtns = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentCreateAccountOpenButton);
                createAccountBtns.forEach(function(btn) {
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.showEnrollmentCreateAccount(this);
                    });
                });
            };
            _this_1.showEnrollmentCreateAccount = function(triggerBtn) {
                var enrollmentCreateAccount = document.querySelector(_this_1.classConfig.selectorEnrollmentCreateAccountWrp);
                if (!!enrollmentCreateAccount) {
                    enrollmentCreateAccount.classList.remove("st_visibility-hidden");
                    document.body.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                    var enrollmentAccountPage = _this_1.generalMethod.getClosestByClass(triggerBtn, _this_1.classConfig.classNameEnrollmentAccountPageWrp);
                    if (!!enrollmentAccountPage) {
                        enrollmentAccountPage.classList.add("st_visibility-hidden");
                    }
                }
            };
            _this_1.enrollmentCreateAccountForm = function() {
                var _this = _this_1;
                var enrollmentCreateAccountForms = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentCreateAccountForm);
                enrollmentCreateAccountForms.forEach(function(form) {
                    _this.onRepeatPassword(form);
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.enrollmentCreateAccountFormSubmit(form);
                    });
                });
            };
            _this_1.enrollmentCreateAccountFormSubmit = function(form) {
                var _this = _this_1;
                var formData = _this.form.collectFormData(form);
                var submitBtn = form.querySelector(_this_1.classConfig.selectorEnrollmentCreateAccountSubmit);
                _this.form.clearFormatting(form, [ "repeatPassword" ]);
                _this.buttonActions.prevent(submitBtn);
                var passwordInputElement = document.querySelector('input[name="password"]');
                var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                if (passwordInputElement.value.length > 40) {
                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", "Password cannot contain more than 40 characters!");
                    _this.buttonActions.allow(submitBtn);
                } else if (passwordInputElement.value === (repeatPasswordInputElement === null || repeatPasswordInputElement === void 0 ? void 0 : repeatPasswordInputElement.value) || !repeatPasswordInputElement) {
                    _this.ajax.send({
                        endpoint: _this.endpoint["enrollment"]["createAccount"],
                        method: "post",
                        contentType: "json",
                        data: formData,
                        callback: function(response) {
                            try {
                                var createAccountResponse = JSON.parse(response.response);
                                if (createAccountResponse.status === 200) {
                                    _this.buttonActions.allow(submitBtn);
                                    var formDataLogin = {
                                        email: formData.email,
                                        password: formData.password
                                    };
                                    _this.enrollmentLogin(form, formDataLogin);
                                } else if (createAccountResponse.status === 400) {
                                    var validationErrors = _this.prepareErrorArray(createAccountResponse.data);
                                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", validationErrors);
                                    _this.buttonActions.allow(submitBtn);
                                    var errors = [];
                                    for (var validationParam in createAccountResponse.data) {
                                        var validationResult = createAccountResponse.data[validationParam];
                                        if (!validationResult.isValid) {
                                            errors.push(validationResult.message);
                                        }
                                    }
                                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", errors);
                                    _this.buttonActions.allow(submitBtn);
                                } else {
                                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", createAccountResponse.message);
                                    _this.buttonActions.allow(submitBtn);
                                }
                            } catch (error) {
                                console.error(error);
                                _this.notification.showNotification(notification_4.ENotificationType.error, "Server Error", error);
                                _this.buttonActions.allow(submitBtn);
                            }
                        }
                    });
                } else {
                    _this.form.markValidationResults(form, _this.checkPasswordMatch({}));
                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", "Passwords not matching!");
                    _this.buttonActions.allow(submitBtn);
                }
            };
            _this_1.onRepeatPassword = function(form) {
                var _this = _this_1;
                var passwordInputElement = document.querySelector('input[name="password"]');
                var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                passwordInputElement.oninput = function(e) {
                    var validationProperties = _this.checkPasswordMatch({});
                    if (Object.keys(validationProperties).length === 0) {
                        _this.form.clearFormatting(form, [ "repeatPassword" ]);
                    } else {
                        _this.form.markValidationResults(form, validationProperties);
                    }
                };
                if (repeatPasswordInputElement) {
                    repeatPasswordInputElement.oninput = function() {
                        var validationProperties = _this.checkPasswordMatch({});
                        if (Object.keys(validationProperties).length === 0) {
                            _this.form.clearFormatting(form, [ "repeatPassword" ]);
                        } else {
                            _this.form.markValidationResults(form, validationProperties);
                        }
                    };
                }
            };
            _this_1.checkPasswordMatch = function(validationProperties) {
                var passwordInputElement = document.querySelector(_this_1.classConfig.selectorEnrollmentAccountPassword);
                var repeatPasswordInputElement = document.querySelector(_this_1.classConfig.selectorEnrollmentAccountRepeatPassword);
                if (repeatPasswordInputElement) {
                    if (passwordInputElement.value !== repeatPasswordInputElement.value) {
                        return __assign(__assign({}, validationProperties), {
                            repeatPassword: {
                                isValid: false,
                                message: "Passwords not matching!"
                            }
                        });
                    }
                }
                return validationProperties;
            };
            _this_1.prepareErrorArray = function(validationData) {
                var validationDataKeys = Object.keys(validationData);
                var errorArray = [];
                validationDataKeys.forEach(function(key) {
                    if (!validationData[key].isValid) {
                        errorArray.push(validationData[key].message);
                    }
                });
                return errorArray;
            };
            _this_1.classConfig = classConfig;
            _this_1.buttonActions = buttonActions;
            _this_1.notification = notification;
            _this_1.form = form;
            _this_1.generalMethod = generalMethod;
            _this_1.enrollmentCleanup = enrollmentCleanup;
            _this_1.stCart = cart;
            return _this_1;
        }
        return StEnrollmentAccount;
    }(st_module_40.StModule);
    exports.StEnrollmentAccount = StEnrollmentAccount;
});

define("core/shopify-app/st-modules/_general-methods/form/formatting", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_41) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFormFormatting = void 0;
    var StFormFormatting = function(_super) {
        __extends(StFormFormatting, _super);
        function StFormFormatting() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Formatting";
            _this.setupFormatting = function(collectionToIterate, formattingFn, callbackFn) {
                if (callbackFn === void 0) {
                    callbackFn = function(value) {};
                }
                collectionToIterate.forEach(function(input) {
                    var formattedVal = formattingFn(input.value);
                    input.value = formattedVal;
                    input.setAttribute("value", formattedVal);
                    callbackFn(formattedVal);
                    input.addEventListener("input", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                    input.addEventListener("keyup", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                    input.addEventListener("paste", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                });
            };
            _this.formatPhoneNumber = function(phone) {
                var phoneString = ("" + phone).replace(/\D/g, "");
                var segment1 = phoneString.slice(0, 3);
                var segment2 = phoneString.slice(3, 6);
                var segment3 = phoneString.slice(6, 10);
                return segment1 + (segment2.length > 0 ? "-" + segment2 : "") + (segment3.length > 0 ? "-" + segment3 : "");
            };
            _this.formatWebAlias = function(webAlias) {
                return webAlias.replace(/[^A-Za-z0-9\-_]/g, "");
            };
            _this.formatSSN = function(ssn) {
                var phoneString = ("" + ssn).replace(/\D/g, "");
                var segment1 = phoneString.slice(0, 3);
                var segment2 = phoneString.slice(3, 5);
                var segment3 = phoneString.slice(5, 9);
                return segment1 + (segment2.length > 0 ? "-" + segment2 : "") + (segment3.length > 0 ? "-" + segment3 : "");
            };
            return _this;
        }
        return StFormFormatting;
    }(st_module_41.StModule);
    exports.StFormFormatting = StFormFormatting;
});

define("core/shopify-app/st-modules/enrollment/blocks/account-details/account-details-helpers", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_42) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentAccountDetailsHelpers = void 0;
    var StEnrollmentAccountDetailsHelpers = function(_super) {
        __extends(StEnrollmentAccountDetailsHelpers, _super);
        function StEnrollmentAccountDetailsHelpers(formFormatting, classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountDetailsHelpers";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.setupPhoneFormatting();
                });
            };
            _this.setupPhoneFormatting = function(inputs) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var collectionToIterate = !!inputs ? inputs : wrp.querySelectorAll(_this.classConfig.selectorEnrollmentAccountDetailsPhone);
                _this.formFormatting.setupFormatting(collectionToIterate, _this.formFormatting.formatPhoneNumber);
            };
            _this.formFormatting = formFormatting;
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentAccountDetailsHelpers;
    }(st_module_42.StModule);
    exports.StEnrollmentAccountDetailsHelpers = StEnrollmentAccountDetailsHelpers;
});

define("core/shopify-app/st-modules/enrollment/blocks/business-info/business-details-helpers", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_43) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentBusinessDetailsHelpers = void 0;
    var StEnrollmentBusinessDetailsHelpers = function(_super) {
        __extends(StEnrollmentBusinessDetailsHelpers, _super);
        function StEnrollmentBusinessDetailsHelpers(formatting, classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "BusinessDetailsHelpers";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.setupWebAliasFormatting();
                    _this.setupSSNFormatting();
                });
            };
            _this.setupWebAliasFormatting = function(inputs) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var collectionToIterate = !!inputs ? inputs : wrp.querySelectorAll(_this.classConfig.selectorEnrollmentBusinessDetailsWebAlias);
                _this.formFormatting.setupFormatting(collectionToIterate, _this.formFormatting.formatWebAlias, function(value) {
                    var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                    var webAliasPresenter = wrp.querySelector(_this.classConfig.selectorEnrollmentBusinessDetailsWebAliasPresenter);
                    if (!!webAliasPresenter) {
                        webAliasPresenter.innerText = value;
                    }
                });
            };
            _this.setupSSNFormatting = function(inputs) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var collectionToIterate = !!inputs ? inputs : wrp.querySelectorAll(_this.classConfig.selectorEnrollmentBusinessDetailsSSN);
                _this.formFormatting.setupFormatting(collectionToIterate, _this.formFormatting.formatSSN);
            };
            _this.formFormatting = formatting;
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentBusinessDetailsHelpers;
    }(st_module_43.StModule);
    exports.StEnrollmentBusinessDetailsHelpers = StEnrollmentBusinessDetailsHelpers;
});

define("core/shopify-app/st-modules/account/header/nav/account-nav", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_44) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountNav = void 0;
    var StAccountNav = function(_super) {
        __extends(StAccountNav, _super);
        function StAccountNav(classConfig, objectFormatting, browserHistory, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountNav";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupAccountNavPages();
                    _this_1.openPage();
                    _this_1.bindNavEvents();
                    _this_1.logout();
                });
            };
            _this_1.setupAccountNavPages = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var pageWrappers = wrp.querySelectorAll(_this_1.classConfig.selectorAccountContent);
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorAccountNavHolder);
                var navWrp = wrp.querySelector(_this_1.classConfig.selectorAccountNavWrapper);
                if (!!navHolder) {
                    if (pageWrappers.length > 1) {
                        pageWrappers.forEach(function(pageWrapper, pageIndex) {
                            var templateName = pageWrapper.getAttribute("data-name");
                            var svgIcon = pageWrapper.querySelector(_this_1.classConfig.selectorAccountIcon).innerHTML;
                            var page = _this_1.navPageTemplate(pageIndex, templateName, svgIcon);
                            navHolder.appendChild(page);
                        });
                        if (navWrp) {
                            navWrp.classList.remove("st_hidden");
                        }
                    } else {
                        if (navWrp) {
                            navWrp.classList.add("st_hidden");
                        }
                    }
                } else {
                    console.error("Account Nav holder not present! Navigation won't setup");
                }
            };
            _this_1.navPageTemplate = function(pageIndex, templateName, svgIcon) {
                if (templateName === void 0) {
                    templateName = "";
                }
                if (svgIcon === void 0) {
                    svgIcon = "";
                }
                var templateNode;
                templateNode = document.createElement("div");
                templateNode.classList.add("st_header-account-nav-link");
                templateNode.classList.add(_this_1.classConfig.classNameAccountNavHolderSingle);
                var button = document.createElement("button");
                button.classList.add("st_header-navigation-account", "st_account--button");
                button.classList.add(_this_1.classConfig.classNameAccountNavButton);
                button.setAttribute("data-index", "".concat(pageIndex));
                button.innerHTML = svgIcon;
                var text = document.createElement("span");
                text.classList.add("st_header-text");
                text.innerHTML = templateName.charAt(0).toUpperCase() + templateName.slice(1);
                button.appendChild(text);
                templateNode.appendChild(button);
                return templateNode;
            };
            _this_1.bindNavEvents = function() {
                var _this = _this_1;
                var navLinks = document.querySelectorAll(_this.classConfig.selectorAccountNavButton);
                navLinks.forEach(function(navLink) {
                    navLink.addEventListener("click", function(e) {
                        e.preventDefault();
                        var pageIndex = parseInt(this.getAttribute("data-index"));
                        _this.openPage(pageIndex);
                        _this.closeAddressEdit();
                        _this.closeSingleOrder();
                    });
                });
            };
            _this_1.closeAddressEdit = function() {
                var editAddressButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountBackButton);
                if (!!editAddressButtons) {
                    editAddressButtons.forEach(function(editAddressButton) {
                        var addressWrapper = _this_1.generalMethods.getClosestByClass(editAddressButton, _this_1.classConfig.classNameAddressesWrapper);
                        if (!!addressWrapper) {
                            var buttonDropdown = addressWrapper.querySelector(_this_1.classConfig.selectorAccountAddressesDropdown);
                            var buttonDropdownContent = addressWrapper.querySelector(_this_1.classConfig.selectorAccountAddressesDropdownWrapper);
                            addressWrapper.classList.remove("st_hide");
                            if (!!buttonDropdown && !!buttonDropdownContent) {
                                buttonDropdown.classList.remove("active");
                                buttonDropdownContent.classList.remove("active");
                            }
                        }
                    });
                }
            };
            _this_1.closeSingleOrder = function() {
                var _this = _this_1;
                var orderHistory = document.querySelectorAll(_this.classConfig.selectorBackToHistoryOrders);
                orderHistory.forEach(function(order) {
                    var singleOrderWrapper = document.querySelector(".st_single-order_JS");
                    if (!!singleOrderWrapper) {
                        singleOrderWrapper.style.display = "none";
                    }
                    var orderWrapper = document.querySelector(".st_order-history_JS");
                    if (!!orderWrapper) {
                        orderWrapper.classList.remove(_this.classConfig.classNameOpenOrderCSSClass);
                    }
                });
            };
            _this_1.openPage = function(pageIndex) {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var alreadyOpen = wrp.querySelector(_this_1.classConfig.selectorAccountSection + ".st_show");
                var accountSections = wrp.querySelectorAll(_this_1.classConfig.selectorAccountSection);
                if (typeof pageIndex === "undefined") {
                    var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                    var maxTab = accountSections.length - 1;
                    var tabIndex = urlParams.tab ? parseInt(urlParams.tab) : 0;
                    pageIndex = isNaN(tabIndex) ? 0 : tabIndex;
                    pageIndex = tabIndex > maxTab ? maxTab : tabIndex;
                }
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorAccountNavHolder);
                var AccountNavElements = navHolder.querySelectorAll(_this_1.classConfig.selectorAccountNavHolderSingle);
                if (!!alreadyOpen) {
                    alreadyOpen.classList.remove("st_show");
                }
                if (accountSections.length > pageIndex) {
                    accountSections[pageIndex].classList.add("st_show");
                } else {
                    console.error("Invalid page index supplied to Account nav openPage method!");
                }
                AccountNavElements.forEach(function(navElement, index) {
                    navElement.classList.remove("current");
                    if (index === pageIndex) {
                        _this_1.updateTabToUrl("" + pageIndex);
                        navElement.classList.add("current");
                    }
                });
            };
            _this_1.updateTabToUrl = function(activeTab) {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                urlParams.tab = "" + activeTab;
                var newURL = window.location.href.replace(window.location.search, "");
                _this_1.browserHistory.pushHistory(newURL, urlParams);
            };
            _this_1.logout = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var logoutBtns = wrp.querySelectorAll(_this_1.classConfig.selectorAccountLogout);
                if (!!logoutBtns) {
                    logoutBtns.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            window.location.assign(window.location.protocol + "//" + window.location.hostname + "/account/logout");
                        });
                    });
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.objectFormatting = objectFormatting;
            _this_1.browserHistory = browserHistory;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountNav;
    }(st_module_44.StModule);
    exports.StAccountNav = StAccountNav;
});

define("extension/shopify-app/st-modules/_general-methods/form/customer-type-extended", [ "require", "exports", "_features.config", "core/shopify-app/st-modules/_general-methods/form/customer-type" ], function(require, exports, _features_config_8, customer_type_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCustomerTypeExtended = void 0;
    var StCustomerTypeExtended = function(_super) {
        __extends(StCustomerTypeExtended, _super);
        function StCustomerTypeExtended() {
            var _this = _super.call(this) || this;
            _this.className = "CustomerType";
            _this.init = function() {};
            _this.get = function() {
                var win = window;
                if (win.customerType && Object.values(_features_config_8.ECustomerType).includes(win.customerType)) {
                    return win.customerType;
                } else {
                    return _features_config_8.ECustomerType.guest;
                }
            };
            return _this;
        }
        return StCustomerTypeExtended;
    }(customer_type_1.StCustomerType);
    exports.StCustomerTypeExtended = StCustomerTypeExtended;
});

define("extension/shopify-app/st-modules/account/header/nav/account-nav-extended", [ "require", "exports", "core/shopify-app/st-modules/account/header/nav/account-nav", "_features.config" ], function(require, exports, account_nav_1, _features_config_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountNavExtended = void 0;
    var StAccountNavExtended = function(_super) {
        __extends(StAccountNavExtended, _super);
        function StAccountNavExtended(classConfig, objectFormatting, browserHistory, generalMethods, cart, customerType) {
            var _this_1 = _super.call(this, classConfig, objectFormatting, browserHistory, generalMethods) || this;
            _this_1.className = "AccountNav";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupAccountNavPages();
                    _this_1.openPage();
                    _this_1.bindNavEvents();
                    _this_1.logout();
                });
            };
            _this_1.setupAccountNavPages = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var pageWrappers = wrp.querySelectorAll(_this_1.classConfig.selectorAccountContent);
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorAccountNavHolder);
                var navWrp = wrp.querySelector(_this_1.classConfig.selectorAccountNavWrapper);
                if (!!navHolder) {
                    if (pageWrappers.length > 1) {
                        pageWrappers.forEach(function(pageWrapper, pageIndex) {
                            var templateName = pageWrapper.getAttribute("data-name");
                            var svgIcon = pageWrapper.querySelector(_this_1.classConfig.selectorAccountIcon).innerHTML;
                            if (_this_1.shouldPrintNavItem(templateName)) {
                                var page = _this_1.navPageTemplate(pageIndex, templateName, svgIcon);
                                navHolder.appendChild(page);
                            }
                        });
                        if (navWrp) {
                            navWrp.classList.remove("st_hidden");
                        }
                    } else {
                        if (navWrp) {
                            navWrp.classList.add("st_hidden");
                        }
                    }
                } else {
                    console.error("Account Nav holder not present! Navigation won't setup");
                }
            };
            _this_1.shouldPrintNavItem = function(templateName) {
                var isRep = _this_1.customerType.get() === _features_config_9.ECustomerType.representative;
                var isRetail = _this_1.customerType.get() === _features_config_9.ECustomerType.retail;
                return !(templateName.toLowerCase() === "upgrade to wine consultant" && isRep) && !(templateName.toLowerCase() === "wine cellar" && isRetail);
            };
            _this_1.openPage = function(pageIndex) {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var alreadyOpen = wrp.querySelector(_this_1.classConfig.selectorAccountSection + ".st_show");
                var accountSections = wrp.querySelectorAll(_this_1.classConfig.selectorAccountSection);
                if (typeof pageIndex === "undefined") {
                    var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                    var maxTab = accountSections.length - 1;
                    var tabIndex = urlParams.tab ? parseInt(urlParams.tab) : 0;
                    pageIndex = isNaN(tabIndex) ? 0 : tabIndex;
                    pageIndex = tabIndex > maxTab ? maxTab : tabIndex;
                }
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorAccountNavHolder);
                var AccountNavElements = navHolder.querySelectorAll(_this_1.classConfig.selectorAccountNavHolderSingle);
                if (!!alreadyOpen) {
                    alreadyOpen.classList.remove("st_show");
                }
                if (accountSections.length > pageIndex) {
                    accountSections[pageIndex].classList.add("st_show");
                } else {
                    console.error("Invalid page index supplied to Account nav openPage method!");
                }
                AccountNavElements.forEach(function(navElement) {
                    navElement.classList.remove("current");
                    var index = -1;
                    var navButton = navElement.querySelector(_this_1.classConfig.selectorAccountNavButton);
                    if (!!navButton) {
                        index = parseInt(navButton.getAttribute("data-index"));
                    }
                    if (index === pageIndex) {
                        _this_1.updateTabToUrl("" + pageIndex);
                        navElement.classList.add("current");
                    }
                });
            };
            _this_1.updateTabToUrl = function(activeTab) {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                urlParams.tab = "" + activeTab;
                var newURL = window.location.href.replace(window.location.search, "");
                _this_1.browserHistory.pushHistory(newURL, urlParams);
            };
            _this_1.logout = function() {
                var _this = _this_1;
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var logoutBtns = wrp.querySelectorAll(_this_1.classConfig.selectorAccountLogout);
                if (!!logoutBtns) {
                    logoutBtns.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.cart.clearCart(function() {
                                window.location.assign(window.location.protocol + "//" + window.location.hostname + "/account/logout");
                                _this.cart.updateCartAttributesOrNote({
                                    attributes: {
                                        sampler: "",
                                        billingDate: "",
                                        samplerDate: ""
                                    }
                                }, function() {});
                            });
                        });
                    });
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.objectFormatting = objectFormatting;
            _this_1.browserHistory = browserHistory;
            _this_1.generalMethods = generalMethods;
            _this_1.cart = cart;
            _this_1.customerType = customerType;
            return _this_1;
        }
        return StAccountNavExtended;
    }(account_nav_1.StAccountNav);
    exports.StAccountNavExtended = StAccountNavExtended;
});

define("core/connector-app/_shared/models/auth/sso.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/auth/sso.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/account/header/backoffice-sso/backoffice-sso", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_45, notification_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StBackofficeSSO = void 0;
    var StBackofficeSSO = function(_super) {
        __extends(StBackofficeSSO, _super);
        function StBackofficeSSO(classConfig, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "BackofficeSSO";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.getSSOLinkEvent();
                });
            };
            _this_1.getSSOLinkEvent = function() {
                var _this = _this_1;
                var ssoLinks = document.querySelectorAll(_this_1.classConfig.selectorBackOfficeLink);
                for (var i = 0; i < ssoLinks.length; i++) {
                    var ssoLink = ssoLinks[i];
                    ssoLink.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.getSSOLink();
                    });
                }
            };
            _this_1.getSSOLink = function() {
                var _this = _this_1;
                var customerInfoMetafields = window.customerInfoMetafields;
                var ssoLinkRequest = {
                    customerId: customerInfoMetafields.customerId,
                    sponsorId: customerInfoMetafields.representativeId,
                    isAutoship: false,
                    customerType: customerInfoMetafields.customerType
                };
                _this_1.ajax.send({
                    endpoint: _this.endpoint["auth"]["sso"],
                    method: "post",
                    contentType: "json",
                    data: ssoLinkRequest,
                    callback: function(response) {
                        try {
                            var ssoLinkResponse = JSON.parse(response.response);
                            if (ssoLinkResponse.status === 200) {
                                var ssoLinkData = ssoLinkResponse.data;
                                if (!!ssoLinkData.ssoLink && ssoLinkData.ssoLink !== "") {
                                    window.location.href = ssoLinkData.ssoLink;
                                }
                            } else {
                                _this.notification.showNotification(notification_5.ENotificationType.error, "An Error Occurred!", ssoLinkResponse.message);
                            }
                        } catch (error) {
                            _this.notification.showNotification(notification_5.ENotificationType.error, "An Error Occurred!", error);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            return _this_1;
        }
        return StBackofficeSSO;
    }(st_module_45.StModule);
    exports.StBackofficeSSO = StBackofficeSSO;
});

define("core/shopify-app/st-modules/account/blocks/web-alias-edit/web-alias-edit", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_46, notification_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountWebAliasEdit = void 0;
    var StAccountWebAliasEdit = function(_super) {
        __extends(StAccountWebAliasEdit, _super);
        function StAccountWebAliasEdit(classConfig, generalMethods, notification, buttonActions, form, formFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountWebAliasEdit";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupWebAliasInputEvents();
                    _this_1.editWebAlias();
                });
            };
            _this_1.setupWebAliasInputEvents = function() {
                var _this = _this_1;
                var webAliasInputsFields = document.querySelectorAll(_this_1.classConfig.selectorAccountWebAlias);
                webAliasInputsFields.forEach(function(webAliasInput) {
                    _this.injectWebAlias(webAliasInput);
                    webAliasInput.addEventListener("keyup", function() {
                        this.value = _this.formFormatting.formatWebAlias(this.value);
                        _this.injectWebAlias(this);
                    });
                    webAliasInput.addEventListener("input", function() {
                        this.value = _this.formFormatting.formatWebAlias(this.value);
                        _this.injectWebAlias(this);
                    });
                    webAliasInput.addEventListener("paste", function() {
                        this.value = _this.formFormatting.formatWebAlias(this.value);
                        _this.injectWebAlias(this);
                    });
                });
            };
            _this_1.injectWebAlias = function(webAliasInput) {
                var inputValue = webAliasInput.value;
                var webAliasWrapper = _this_1.generalMethods.getClosestByClass(webAliasInput, _this_1.classConfig.classNameWebAliasWrapper);
                var readOnlyInput = webAliasWrapper.querySelector(_this_1.classConfig.selectorWebAliasValue);
                readOnlyInput.value = inputValue;
            };
            _this_1.editWebAlias = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorEditWebAliasForm);
                if (!!form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.submitWebAlias(this);
                    });
                }
            };
            _this_1.submitWebAlias = function(form) {
                var _this = _this_1;
                var formData = _this.form.collectFormData(form);
                var submitBtn = form.querySelector(_this_1.classConfig.selectorSubmitButton);
                _this.buttonActions.prevent(submitBtn);
                _this.ajax.send({
                    endpoint: _this.endpoint["customer"]["updateWebAlias"],
                    method: "post",
                    contentType: "json",
                    data: formData,
                    callback: function(response) {
                        try {
                            var editWebAliasResponse = JSON.parse(response.response);
                            if (editWebAliasResponse.status === 200) {
                                _this.buttonActions.allow(submitBtn);
                                window.location.reload();
                            } else if (editWebAliasResponse.status === 400) {
                                var validationProperties = editWebAliasResponse.data;
                                _this.form.markValidationResults(form, validationProperties);
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_6.ENotificationType.error, "An Error Occurred", "Some fields are invalid.");
                            } else {
                                _this.notification.showNotification(notification_6.ENotificationType.error, "An Error Occurred", editWebAliasResponse.message);
                                _this.buttonActions.allow(submitBtn);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_6.ENotificationType.error, "Server Error", error);
                            _this.buttonActions.allow(submitBtn);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.form = form;
            _this_1.formFormatting = formFormatting;
            return _this_1;
        }
        return StAccountWebAliasEdit;
    }(st_module_46.StModule);
    exports.StAccountWebAliasEdit = StAccountWebAliasEdit;
});

define("core/shopify-app/st-modules/account/blocks/addresses/addresses", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_47) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountAddresses = void 0;
    var StAccountAddresses = function(_super) {
        __extends(StAccountAddresses, _super);
        function StAccountAddresses(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountAddress";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.openAddressDropDown();
                    _this_1.setupAddressEdit();
                    _this_1.setupAddressProvinceField();
                });
            };
            _this_1.openAddressDropDown = function() {
                var _this = _this_1;
                var dropDownButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountAddressesDropdown);
                dropDownButtons.forEach(function(dropDownButton) {
                    dropDownButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.openAddressActiveState(dropDownButton);
                    });
                });
            };
            _this_1.openAddressActiveState = function(dropDownButton) {
                dropDownButton.classList.toggle("active");
            };
            _this_1.setupAddressEdit = function() {
                var _this = _this_1;
                var addressTabButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountTabButton);
                addressTabButtons.forEach(function(addressTabButton) {
                    addressTabButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.showAddressEdit(addressTabButton);
                    });
                });
                var editAddressButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountBackButton);
                editAddressButtons.forEach(function(editAddressButton) {
                    editAddressButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.hideAddressEdit(editAddressButton);
                    });
                });
            };
            _this_1.showAddressEdit = function(addressTabButton) {
                var addressWrapper = _this_1.generalMethods.getClosestByClass(addressTabButton, _this_1.classConfig.classNameAddressesWrapper);
                if (!!addressWrapper) {
                    addressWrapper.classList.add("st_hide");
                }
            };
            _this_1.hideAddressEdit = function(editAddressButton) {
                var addressWrapper = _this_1.generalMethods.getClosestByClass(editAddressButton, _this_1.classConfig.classNameAddressesWrapper);
                if (!!addressWrapper) {
                    var buttonDropdown = addressWrapper.querySelector(".st_addresses-dots--button_JS");
                    var buttonDropdownContent = addressWrapper.querySelector(".st_dropdown-address--wrapper");
                    addressWrapper.classList.remove("st_hide");
                    buttonDropdown.classList.remove("active");
                    buttonDropdownContent.classList.remove("active");
                }
            };
            _this_1.setupAddressProvinceField = function() {
                var _this = _this_1;
                var provinceSelector = document.querySelector(_this_1.classConfig.selectorProvinceSelector);
                var provinceSource = document.querySelector(_this_1.classConfig.selectorProvinceSource);
                if (!!provinceSelector && !!provinceSource) {
                    _this_1.addProvinceOptions(provinceSelector, provinceSource);
                    provinceSource.addEventListener("change", function(e) {
                        _this.addProvinceOptions(provinceSelector, provinceSource);
                    });
                }
            };
            _this_1.addProvinceOptions = function(provinceSelector, provinceSource) {
                var selectedCountry = provinceSource.value ? provinceSource.value : provinceSource.getAttribute("data-default");
                var provinceSelectedOption = provinceSource.querySelector('option[value="'.concat(selectedCountry, '"]'));
                var provinceWrapper = _this_1.generalMethods.getClosestByClass(provinceSelector, _this_1.classConfig.classNameProvinceWrapper);
                if (!!provinceWrapper) {
                    provinceWrapper.classList.remove("st_hidden");
                }
                try {
                    var provinces = JSON.parse(provinceSelectedOption.getAttribute("data-provinces"));
                    provinceSelector.replaceChildren();
                    for (var i = 0; i < provinces.length; i++) {
                        var opt = document.createElement("option");
                        opt.value = provinces[i][0];
                        opt.innerHTML = provinces[i][1];
                        opt.setAttribute("data-ind", "" + i);
                        provinceSelector.appendChild(opt);
                    }
                    var defaultProvince = provinceSelector.getAttribute("data-default");
                    var defaultProvinceEl = provinceSelector.querySelector('option[value="'.concat(defaultProvince, '"]'));
                    var provinceOptions = provinceSelector.querySelectorAll("option");
                    var selectedOption = defaultProvince ? defaultProvinceEl : provinceOptions[0];
                    if (!!selectedOption) {
                        provinceSelector.value = selectedOption.value;
                        provinceSelector.selectedIndex = parseInt(selectedOption.getAttribute("data-ind"));
                        provinceOptions.forEach(function(provinceOption) {
                            provinceOption.removeAttribute("selected");
                        });
                        selectedOption.selected = true;
                        selectedOption.setAttribute("selected", "selected");
                    }
                } catch (e) {
                    console.error(e);
                    var provinceWrapper_1 = _this_1.generalMethods.getClosestByClass(provinceSelector, _this_1.classConfig.classNameProvinceWrapper);
                    if (!!provinceWrapper_1) {
                        provinceWrapper_1.classList.add("st_hidden");
                    }
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountAddresses;
    }(st_module_47.StModule);
    exports.StAccountAddresses = StAccountAddresses;
});

define("core/connector-app/_shared/models/customer/account/customer.account.request", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/account/blocks/personal-info/personal-info", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_48, notification_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountPersonalInfo = void 0;
    var StAccountPersonalInfo = function(_super) {
        __extends(StAccountPersonalInfo, _super);
        function StAccountPersonalInfo(classConfig, form, formFormatting, buttonActions, notification, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountPersonalInfo";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.editPersonalInfo();
                    _this_1.setupFormatPhoneNumber();
                });
            };
            _this_1.editPersonalInfo = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorPersonalInfoForm);
                if (!!form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.submitPersonalInfo(this);
                    });
                }
            };
            _this_1.submitPersonalInfo = function(form) {
                var _this = _this_1;
                var data = _this.form.collectFormData(form);
                var formData = {
                    firstName: data.firstName,
                    lastName: data.lastName,
                    phoneNumber: data.phoneNumber,
                    shopifyId: data.shopifyId,
                    email: data.email
                };
                var submitBtn = form.querySelector(_this_1.classConfig.selectorSubmitButton);
                _this.buttonActions.prevent(submitBtn);
                _this.ajax.send({
                    endpoint: _this.endpoint["customer"]["updatePersonalInfo"],
                    method: "post",
                    contentType: "json",
                    data: formData,
                    callback: function(response) {
                        try {
                            var editPersonalInfoResponse = JSON.parse(response.response);
                            var validationProperties = editPersonalInfoResponse.data;
                            if (editPersonalInfoResponse.status === 200) {
                                _this.buttonActions.allow(submitBtn);
                                _this.form.markValidationResults(form, validationProperties);
                                _this.notification.showNotification(notification_7.ENotificationType.success, "Success", "You have successfully modified your information.");
                                _this.updatePersonalInfoWrapperIfExist(form, formData);
                            } else if (editPersonalInfoResponse.status === 400) {
                                _this.form.markValidationResults(form, validationProperties);
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_7.ENotificationType.error, "An Error Occurred", "Some fields are invalid.");
                            } else {
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_7.ENotificationType.error, "An Error Occurred", editPersonalInfoResponse.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_7.ENotificationType.error, "Server Error", error);
                            _this.buttonActions.allow(submitBtn);
                        }
                    }
                });
            };
            _this_1.updatePersonalInfoWrapperIfExist = function(formSelector, formData) {
                var accountPage = _this_1.generalMethods.getClosestByClass(formSelector, _this_1.classConfig.classNameAccountPage);
                if (!!accountPage) {
                    var selectorBusinessContent = accountPage.querySelector(_this_1.classConfig.selectorBusinessContent);
                    if (!!selectorBusinessContent) {
                        var nameSelector = selectorBusinessContent.querySelector(_this_1.classConfig.selectorBusinessContentName);
                        var emailSelector = selectorBusinessContent.querySelector(_this_1.classConfig.selectorBusinessContentEmail);
                        if (!!emailSelector) {
                            emailSelector.innerHTML = formData.email;
                        }
                        if (!!nameSelector) {
                            nameSelector.innerHTML = formData.firstName + " " + formData.lastName;
                        }
                    }
                }
            };
            _this_1.setupFormatPhoneNumber = function() {
                var phoneNumberInputs = document.querySelectorAll('input[name="phoneNumber"]');
                _this_1.formFormatting.setupFormatting(phoneNumberInputs, _this_1.formFormatting.formatPhoneNumber);
            };
            _this_1.classConfig = classConfig;
            _this_1.form = form;
            _this_1.formFormatting = formFormatting;
            _this_1.buttonActions = buttonActions;
            _this_1.notification = notification;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountPersonalInfo;
    }(st_module_48.StModule);
    exports.StAccountPersonalInfo = StAccountPersonalInfo;
});

define("core/shopify-app/st-modules/account/blocks/order-history/order-history", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_49) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountOrderHistory = void 0;
    var StAccountOrderHistory = function(_super) {
        __extends(StAccountOrderHistory, _super);
        function StAccountOrderHistory(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountOrderHistory";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.openSingleOrder();
                    _this_1.backToHistoryOrders();
                });
            };
            _this_1.openSingleOrder = function() {
                var _this = _this_1;
                var singleOrderTriggers = document.querySelectorAll(_this.classConfig.selectorOpenSingleOrderButton);
                singleOrderTriggers.forEach(function(order) {
                    order.addEventListener("click", function(e) {
                        e.preventDefault();
                        var orderId = order.getAttribute("data-order-id");
                        var orderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameOrderHistory);
                        orderWrapper.classList.add(_this.classConfig.classNameOpenOrderCSSClass);
                        var singleOrderWrapper = orderWrapper.querySelector(_this.classConfig.selectorSingleOrder + '[data-order-id="' + orderId + '"]');
                        singleOrderWrapper.style.display = "block";
                    });
                });
            };
            _this_1.backToHistoryOrders = function() {
                var _this = _this_1;
                var orderHistory = document.querySelectorAll(_this.classConfig.selectorBackToHistoryOrders);
                orderHistory.forEach(function(order) {
                    order.addEventListener("click", function(e) {
                        e.preventDefault();
                        var singleOrderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameSingleOrder);
                        singleOrderWrapper.style.display = "none";
                        var orderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameOrderHistory);
                        orderWrapper.classList.remove(_this.classConfig.classNameOpenOrderCSSClass);
                    });
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountOrderHistory;
    }(st_module_49.StModule);
    exports.StAccountOrderHistory = StAccountOrderHistory;
});

define("core/shopify-app/st-modules/enrollment-account/enrollment-account-repeat-password-validation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_50) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentRepeatPasswordValidation = void 0;
    var StEnrollmentRepeatPasswordValidation = function(_super) {
        __extends(StEnrollmentRepeatPasswordValidation, _super);
        function StEnrollmentRepeatPasswordValidation(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentRepeatPassword";
            _this.validateOnSite = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentAccountPageWrp);
                var output = [];
                if (!!wrp) {
                    var inputs = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentAccountRepeatPassword);
                    inputs.forEach(function(input) {
                        var fieldName = input.getAttribute("name");
                        var isValid = input.value === input.value;
                        output[fieldName] = {
                            isValid: isValid,
                            message: !isValid ? "Your passwords are not matching!" : ""
                        };
                    });
                }
                return output;
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentRepeatPasswordValidation;
    }(st_module_50.StModule);
    exports.StEnrollmentRepeatPasswordValidation = StEnrollmentRepeatPasswordValidation;
});

define("core/shopify-app/st-modules/account-register/account-register-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_51) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountRegisterClassConfig = void 0;
    var StAccountRegisterClassConfig = function(_super) {
        __extends(StAccountRegisterClassConfig, _super);
        function StAccountRegisterClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountClassConfig";
            _this.classAccountRegisterForm = "st_account-register-form_JS";
            _this.selectorAccountRegisterForm = "." + _this.classAccountRegisterForm;
            _this.classAccountRegisterFormPreventDefault = "st_prevent-form-default_JS";
            _this.selectorAccountRegisterFormPreventDefault = "." + _this.classAccountRegisterFormPreventDefault;
            _this.classRepresentativeAlias = "st_representative-alias_JS";
            _this.selectorRepresentativeAlias = "." + _this.classRepresentativeAlias;
            _this.classRegisterPasswordInput = "st_register-password-input_JS";
            _this.selectorRegisterPasswordInput = "." + _this.classRegisterPasswordInput;
            return _this;
        }
        return StAccountRegisterClassConfig;
    }(st_module_51.StModule);
    exports.StAccountRegisterClassConfig = StAccountRegisterClassConfig;
});

define("core/shopify-app/st-modules/account-register/account-register", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, st_module_52, notification_8, _features_config_10) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountRegister = void 0;
    var StAccountRegister = function(_super) {
        __extends(StAccountRegister, _super);
        function StAccountRegister(form, notification, buttonActions, classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountRegister";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.onSubmit();
                });
            };
            _this_1.onSubmit = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorAccountRegisterForm);
                if (!!form) {
                    form.addEventListener("submit", function(e) {
                        _this.validateAccountCreation(this, e);
                    });
                }
            };
            _this_1.prepareErrorArray = function(validationData) {
                var validationDataKeys = Object.keys(validationData);
                var errorArray = [];
                validationDataKeys.forEach(function(key) {
                    if (!validationData[key].isValid) {
                        errorArray.push(validationData[key].message);
                    }
                });
                return errorArray;
            };
            _this_1.loginCustomer = function(formData) {
                var _this = _this_1;
                var loginPayload = {};
                loginPayload.form_type = "customer_login";
                loginPayload["customer[email]"] = formData.email;
                loginPayload["customer[password]"] = formData.password;
                _this.ajax.send({
                    endpoint: window.location.protocol + "//" + window.location.hostname + "/account/login",
                    method: "post",
                    contentType: "form",
                    data: loginPayload,
                    callback: function(response) {
                        try {
                            if (response.status == 200) {
                                var redirectUrlResponse = response.responseURL.toString();
                                if (redirectUrlResponse.includes("/account/login")) {
                                    window.location.reload();
                                    _this.revertSubmitButtonToDefault();
                                    _this.notification.showNotification(notification_8.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                                } else {
                                    window.location.assign(redirectUrlResponse);
                                }
                            } else {
                                window.location.reload();
                                _this.revertSubmitButtonToDefault();
                                _this.notification.showNotification(notification_8.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.revertSubmitButtonToDefault();
                            _this.notification.showNotification(notification_8.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.registerCustomer = function(customerPayload) {
                var _this = _this_1;
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["enrollment"]["createAccount"],
                    method: "post",
                    contentType: "json",
                    data: customerPayload,
                    callback: function(response) {
                        try {
                            _this.loginCustomer(customerPayload);
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_8.ENotificationType.error, "Server Error", error);
                            _this.revertSubmitButtonToDefault();
                        }
                    }
                });
            };
            _this_1.validateAccountCreation = function(form, submitEvent) {
                var _this = _this_1;
                if (form.classList.contains(_this_1.classConfig.classAccountRegisterFormPreventDefault)) {
                    submitEvent.preventDefault();
                    var formData = _this.form.collectFormData(form);
                    var hiddenAlsInput = form.querySelector(_this_1.classConfig.selectorRepresentativeAlias);
                    if (!(hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) || !_features_config_10.canGoUnderCorporateSite && (hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) === _features_config_10.defaultWebAlias) {
                        _this.notification.showNotification(notification_8.ENotificationType.error, "Validation Error", "Web alias not entered or invalid");
                        _this.revertSubmitButtonToDefault();
                    } else {
                        var payload_1 = {
                            email: formData["customer[email]"],
                            firstName: formData["customer[first_name]"],
                            lastName: formData["customer[last_name]"],
                            password: formData["customer[password]"],
                            sponsorsWebAlias: formData["customer[note][sponsorWebAlias]"]
                        };
                        var passwordInputElement = document.querySelector('input[name="customer[password]"]');
                        var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                        if (passwordInputElement.value.length > 40) {
                            _this.notification.showNotification(notification_8.ENotificationType.error, "Validation Error", "Password cannot contain more than 40 characters!");
                            _this.revertSubmitButtonToDefault();
                        } else if (passwordInputElement.value === (repeatPasswordInputElement === null || repeatPasswordInputElement === void 0 ? void 0 : repeatPasswordInputElement.value) || !repeatPasswordInputElement) {
                            _this.ajax.send({
                                endpoint: _this.endpoint["enrollment"]["validate-data"],
                                method: "post",
                                contentType: "json",
                                data: payload_1,
                                callback: function(response) {
                                    try {
                                        var validationResponse = JSON.parse(response.response);
                                        var validationErrors = _this.prepareErrorArray(validationResponse.data);
                                        if (validationErrors.length !== 0) {
                                            _this.notification.showNotification(notification_8.ENotificationType.error, "Validation Error", validationErrors);
                                            _this.revertSubmitButtonToDefault();
                                        } else {
                                            _this.registerCustomer(payload_1);
                                        }
                                    } catch (error) {
                                        console.error(error);
                                        _this.notification.showNotification(notification_8.ENotificationType.error, "Server Error", error);
                                        _this.revertSubmitButtonToDefault();
                                    }
                                }
                            });
                        } else {
                            _this.notification.showNotification(notification_8.ENotificationType.error, "Validation Error", "Passwords not matching!");
                            _this.revertSubmitButtonToDefault();
                        }
                    }
                } else {
                    form.classList.add(_this.classConfig.classAccountRegisterFormPreventDefault);
                }
            };
            _this_1.revertSubmitButtonToDefault = function() {
                var submitBtn = document.querySelector('[type="submit"]');
                if (!!submitBtn) {
                    submitBtn.removeAttribute("aria-busy");
                }
            };
            _this_1.form = form;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountRegister;
    }(st_module_52.StModule);
    exports.StAccountRegister = StAccountRegister;
});

define("core/shopify-app/st-modules/main/auto-apply-promo", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config", "_features.config" ], function(require, exports, st_module_53, _features_config_11, _features_config_12) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAutoApplyPromo = void 0;
    var StAutoApplyPromo = function(_super) {
        __extends(StAutoApplyPromo, _super);
        function StAutoApplyPromo() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AutoApplyPromo";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var _a, _b;
                    var promoCode = (_b = (_a = window.stAppConfig) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.repPromoCode;
                    if (promoCode) {
                        _this_1.setupRepDiscount(promoCode);
                        _this_1.removeCodeOnLogout(promoCode);
                        if (_features_config_12.shareRefCodeFunctionality) {
                            _this_1.applyRefPromoCode();
                        }
                    }
                });
            };
            _this_1.setupRepDiscount = function(promoCode) {
                var _a, _b;
                document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                var repType = (_b = (_a = window.stAppConfig.options) === null || _a === void 0 ? void 0 : _a.customerType) === null || _b === void 0 ? void 0 : _b.representative;
                var currentCustomerType = window.customerInfoMetafields.customerType;
                if (currentCustomerType === repType && _features_config_11.repDiscountWithPromoCode) {
                    _this_1.applyPromoCodeIfNeeded(promoCode);
                }
            };
            _this_1.applyRefPromoCode = function() {
                document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                var refCode = localStorage.getItem("ref");
                if (!!refCode || refCode !== "null") {
                    _this_1.applyPromoCodeIfNeeded(refCode);
                }
            };
            _this_1.applyPromoCodeIfNeeded = function(promoCode) {
                if (!_this_1.isRepPromoApplied(promoCode)) {
                    var body = document.querySelector("body");
                    var iframeHolder = document.createElement("div");
                    iframeHolder.classList.add("st-autoapply-promocode");
                    var iframe = document.createElement("iframe");
                    iframe.classList.add("st_hidden");
                    iframe.src = "".concat(window.location.origin, "/discount/").concat(promoCode);
                    iframeHolder.appendChild(iframe);
                    body.insertBefore(iframeHolder, body.firstChild);
                }
            };
            _this_1.isRepPromoApplied = function(promoCode) {
                var alreadyApplied = false;
                var x = document.cookie.split("; ");
                for (var i = 0; i < x.length; i++) {
                    var c = x[i].split("=");
                    if (c[0] === "discount_code" || c[0] === "discount_code" && c[1] === promoCode) {
                        alreadyApplied = true;
                        break;
                    }
                }
                return alreadyApplied;
            };
            _this_1.removeCodeOnLogout = function(promoCode) {
                var _this = _this_1;
                var logoutLinks = document.querySelectorAll('[href*="account/logout"]');
                logoutLinks.forEach(function(logoutLink) {
                    logoutLink.addEventListener("click", function(e) {
                        if (_this.isRepPromoApplied(promoCode)) {
                            document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                        }
                    });
                });
            };
            return _this_1;
        }
        return StAutoApplyPromo;
    }(st_module_53.StModule);
    exports.StAutoApplyPromo = StAutoApplyPromo;
});

define("core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_54) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StRepresentativeRedirectClassConfig = void 0;
    var StRepresentativeRedirectClassConfig = function(_super) {
        __extends(StRepresentativeRedirectClassConfig, _super);
        function StRepresentativeRedirectClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "representativeRedirectClassConfig";
            _this.classNameRepRedirectCopyText = "st_copy-repsite_JS";
            _this.selectorRepRedirectIconCopyText = "." + _this.classNameRepRedirectCopyText;
            _this.classNameRepRedirectCopyTextWrapper = "st_copy-repsite--wrapper_JS";
            _this.selectorRepRedirectCopyTextWrapper = "." + _this.classNameRepRedirectCopyTextWrapper;
            _this.classNameRepRedirectLabel = "st_representative-site_JS";
            _this.selectorRepRedirectLabel = "." + _this.classNameRepRedirectLabel;
            return _this;
        }
        return StRepresentativeRedirectClassConfig;
    }(st_module_54.StModule);
    exports.StRepresentativeRedirectClassConfig = StRepresentativeRedirectClassConfig;
});

define("core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_55) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StRepresentativeRedirectPage = void 0;
    var StRepresentativeRedirectPage = function(_super) {
        __extends(StRepresentativeRedirectPage, _super);
        function StRepresentativeRedirectPage(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "RepresentativeRedirectPage";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.copyToClipboard();
                });
            };
            _this_1.copyToClipboard = function() {
                var _this = _this_1;
                var copyRepSiteButtonAll = document.querySelectorAll(_this_1.classConfig.selectorRepRedirectIconCopyText);
                if (copyRepSiteButtonAll && copyRepSiteButtonAll.length > 0) {
                    for (var i = 0; i < copyRepSiteButtonAll.length; i++) {
                        var copyRepSiteButton = copyRepSiteButtonAll[i];
                        copyRepSiteButton.addEventListener("click", function(e) {
                            e.preventDefault();
                            var copyText = document.querySelector(_this.classConfig.selectorRepRedirectLabel);
                            if (!!copyText) {
                                var copyText_1 = document.querySelector(_this.classConfig.selectorRepRedirectLabel);
                                copyText_1.select();
                                copyText_1.setSelectionRange(0, 99999);
                                navigator.clipboard.writeText(copyText_1.value);
                                copyText_1.style.backgroundColor = "rgb(217, 218, 220)";
                                copyText_1.style.transition = "0.5s";
                                setTimeout(function() {
                                    copyText_1.style.backgroundColor = "rgb(249, 249, 249)";
                                    copyText_1.style.transition = "0.5s";
                                }, 1e3);
                            }
                        });
                    }
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StRepresentativeRedirectPage;
    }(st_module_55.StModule);
    exports.StRepresentativeRedirectPage = StRepresentativeRedirectPage;
});

define("core/shopify-app/st-modules/reset-password/reset-password-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_56) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StResetPasswordClassConfig = void 0;
    var StResetPasswordClassConfig = function(_super) {
        __extends(StResetPasswordClassConfig, _super);
        function StResetPasswordClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ResetPasswordClassConfig";
            _this.classLoginPasswordInput = "st_reset-password-input_JS";
            _this.selectorLoginPasswordInput = "." + _this.classLoginPasswordInput;
            return _this;
        }
        return StResetPasswordClassConfig;
    }(st_module_56.StModule);
    exports.StResetPasswordClassConfig = StResetPasswordClassConfig;
});

define("core/shopify-app/st-modules/reset-password/reset-password", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_57) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StResetPassword = void 0;
    var StResetPassword = function(_super) {
        __extends(StResetPassword, _super);
        function StResetPassword(form, notification, buttonActions, classConfig, generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ResetPassword";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.form.liveTrim();
                });
            };
            _this.form = form;
            _this.notification = notification;
            _this.buttonActions = buttonActions;
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StResetPassword;
    }(st_module_57.StModule);
    exports.StResetPassword = StResetPassword;
});

define("core/shopify-app/st-modules/referral/referral", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, st_module_58, notification_9, _features_config_13) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StReferral = void 0;
    var StReferral = function(_super) {
        __extends(StReferral, _super);
        function StReferral(generalMethods, objectFormatting, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Referral";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.checkTags();
                    _this_1.handlerRefBanner();
                });
            };
            _this_1.checkTags = function() {
                if (_features_config_13.shareRefCodeFunctionality) {
                    var customerTagsWrapper = document.querySelector(".st_customer-tags");
                    if (!!customerTagsWrapper) {
                        var tags = customerTagsWrapper.getAttribute("data-tags");
                        var isLogged = customerTagsWrapper.getAttribute("data-customer-id");
                        var splitStr = tags.split(",");
                        var retail = splitStr.find(function(ret) {
                            return ret.includes("retail");
                        });
                        var noOrder = splitStr.find(function(el) {
                            return el.includes("no_order");
                        });
                        if (isLogged) {
                            if (retail && noOrder) {
                                _this_1.getRefFromLink();
                                _this_1.setRefInLink();
                            } else {
                                _this_1.deleteRefCode();
                            }
                        } else {
                            _this_1.getRefFromLink();
                            _this_1.setRefInLink();
                        }
                    }
                } else {
                    _this_1.deleteRefCode();
                    _this_1.hideRef();
                }
            };
            _this_1.getRefFromLink = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var ref = urlParams.ref;
                if (!!ref) {
                    localStorage.setItem("ref", ref);
                }
            };
            _this_1.getCode = function() {
                var tagFromNav = document.querySelector(".st_referral-code-div_JS");
                if (!!tagFromNav) {
                    return tagFromNav.getAttribute("data-customer-tags");
                }
            };
            _this_1.setRefInLink = function() {
                var refCode = localStorage.getItem("ref");
                var refCodeFromTag = _this_1.getCode();
                if (!refCode || refCode === "null" || refCode === " " || refCode === "undefined" || refCode === "") {
                    _this_1.deleteRefCode();
                } else {
                    if (refCode === refCodeFromTag) {
                        _this_1.deleteRefCode();
                    } else {
                        var params = new URLSearchParams(window.location.search);
                        if (!params.get("ref")) {
                            params.append("ref", refCode);
                        }
                        var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + params;
                        window.history.replaceState({
                            path: newUrl
                        }, "", newUrl);
                    }
                }
            };
            _this_1.deleteRefCode = function() {
                var params = new URLSearchParams(window.location.search);
                params.delete("ref");
                var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                if (!!params.toString()) {
                    newUrl += "?" + params;
                }
                window.history.replaceState({
                    path: newUrl
                }, "", newUrl);
                localStorage.removeItem("ref");
            };
            _this_1.handlerRefBanner = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var ref = urlParams.ref;
                if (_features_config_13.shareRefCodeFunctionality) {
                    if (!!ref) {
                        _this_1.getReferralsData();
                    } else {
                        _this_1.hideRef();
                    }
                } else {
                    _this_1.hideRef();
                }
            };
            _this_1.showRef = function() {
                var refWrapper = document.querySelector(".st_referred-by-banner_JS");
                if (!!refWrapper) {
                    if (refWrapper.classList.contains("st_hidden")) {
                        refWrapper.classList.remove("st_hidden");
                    }
                }
            };
            _this_1.hideRef = function() {
                var refWrapper = document.querySelector(".st_referred-by-banner_JS");
                if (!!refWrapper) {
                    if (!refWrapper.classList.contains("st_hidden")) {
                        refWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this_1.getReferralsData = function() {
                var _this = _this_1;
                var referralCode = localStorage.getItem("ref");
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_13.aliasQueryParam];
                var refCode = {
                    promoCode: referralCode,
                    webAlias: currentAlias
                };
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["customer"]["getReferralInfo"],
                    method: "post",
                    contentType: "json",
                    data: refCode,
                    callback: function(response) {
                        try {
                            var getReferralInfo = JSON.parse(response.response);
                            if (getReferralInfo.status === 200) {
                                var refType = getReferralInfo.data.customerType;
                                if (refType === "retail") {
                                    _this.showRef();
                                    var fullname = getReferralInfo.data.firstName + " " + getReferralInfo.data.lastName;
                                    _this.writeRefName(fullname);
                                    if (getReferralInfo.data.customerSponsorMatch === false) {
                                        _this.deleteRefCode();
                                        _this.hideRef();
                                    }
                                }
                                if (refType === "representative") {
                                    if (getReferralInfo.data.customerSponsorMatch === false) {
                                        _this.deleteRefCode();
                                        _this.hideRef();
                                    }
                                }
                                if (refType === "") {
                                    _this.deleteRefCode();
                                    _this.hideRef();
                                }
                            } else {
                                _this.notification.showNotification(notification_9.ENotificationType.error, "An Error Occurred", getReferralInfo.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_9.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.writeRefName = function(fullname) {
                var refNameSpan = document.querySelector(".st_referral-fullname_JS");
                if (!!refNameSpan) {
                    refNameSpan.innerHTML = fullname;
                }
            };
            _this_1.generalMethods = generalMethods;
            _this_1.objectFormatting = objectFormatting;
            _this_1.notification = notification;
            return _this_1;
        }
        return StReferral;
    }(st_module_58.StModule);
    exports.StReferral = StReferral;
});

define("extension/shopify-app/st-modules/referral/referral", [ "require", "exports", "core/shopify-app/st-modules/referral/referral" ], function(require, exports, referral_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StReferralExtension = void 0;
    var StReferralExtension = function(_super) {
        __extends(StReferralExtension, _super);
        function StReferralExtension(generalMethods, objectFormatting, notification) {
            var _this = _super.call(this, generalMethods, objectFormatting, notification) || this;
            _this.className = "Referral";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {});
            };
            _this.generalMethods = generalMethods;
            _this.objectFormatting = objectFormatting;
            _this.notification = notification;
            return _this;
        }
        return StReferralExtension;
    }(referral_1.StReferral);
    exports.StReferralExtension = StReferralExtension;
});

define("core/shopify-app/st-modules/account/blocks/coupon-codes/coupon-codes", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_59, _features_config_14) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCouponCodes = void 0;
    var StCouponCodes = function(_super) {
        __extends(StCouponCodes, _super);
        function StCouponCodes() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "CouponCodes";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.blockHandle();
                });
            };
            _this_1.blockHandle = function() {
                var mainWrapper = document.querySelector(".st_account-coupon-codes_wrapper_JS");
                if (!!mainWrapper) {
                    if (_features_config_14.shareRefCodeFunctionality) {
                        mainWrapper.classList.remove("st_hidden");
                        _this_1.toggleInputs();
                        _this_1.copyCode();
                        _this_1.earnedCouponCodes();
                        _this_1.redeemedCouponCodes();
                        var showInactive = false;
                        _this_1.filterStatus(showInactive);
                    } else {
                        mainWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this_1.toggleInputs = function() {
                var _this = _this_1;
                var showCodeBtnField = document.querySelectorAll(".st_coupon-codes-table-codes_JS");
                if (!!showCodeBtnField) {
                    showCodeBtnField.forEach(function(el) {
                        var showCodeBtn = el.querySelector(".st_table-show-coupon_JS");
                        showCodeBtn.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.showCode(el);
                        });
                    });
                }
            };
            _this_1.showCode = function(el) {
                var showCodeBtnWrapper = el.querySelector(".st_table-coupon-code-show-wrapper_JS");
                var codeWrapper = el.querySelector(".st_table-coupon-code-input-wrapper_JS");
                if (!!showCodeBtnWrapper && !!codeWrapper) {
                    showCodeBtnWrapper.classList.add("st_hidden");
                    codeWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.copyCode = function() {
                var showCodeBtnField = document.querySelectorAll(".st_coupon-codes-table-codes_JS");
                if (!!showCodeBtnField) {
                    showCodeBtnField.forEach(function(el) {
                        var copyCodeBtn = el.querySelector(".st_table-copy-coupon_JS");
                        if (!!copyCodeBtn) {
                            copyCodeBtn.addEventListener("click", function() {
                                var input = el.querySelector(".st_table-coupon-code_JS");
                                if (!!input) {
                                    input.select();
                                    input.setSelectionRange(0, 99999);
                                    navigator.clipboard.writeText(input.value);
                                    input.style.backgroundColor = "rgb(217, 218, 220)";
                                    input.style.transition = "0.2s";
                                    setTimeout(function() {
                                        input.style.backgroundColor = "rgb(249, 249, 249)";
                                    }, 1e3);
                                }
                            });
                        }
                    });
                }
            };
            _this_1.earnedCouponCodes = function() {
                var _this = _this_1;
                var earnedBtn = document.querySelector(".st_earned-coupon-codes_JS");
                if (!!earnedBtn) {
                    earnedBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var flag = false;
                        _this.filterStatus(flag);
                    });
                }
            };
            _this_1.redeemedCouponCodes = function() {
                var _this = _this_1;
                var redeemedBtn = document.querySelector(".st_redeemed-coupon-codes_JS");
                if (!!redeemedBtn) {
                    redeemedBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var flag = true;
                        _this.filterStatus(flag);
                    });
                }
            };
            _this_1.filterStatus = function(flag) {
                var _this = _this_1;
                var tableRows = document.querySelectorAll(".st_coupon-codes-table-row_JS");
                if (!!tableRows) {
                    tableRows.forEach(function(el) {
                        var couponStatusEl = el.querySelector(".st_coupon-codes-table-status_JS");
                        var status = couponStatusEl.getAttribute("data-status");
                        if (flag) {
                            if (status === "Active") {
                                el.classList.add("st_hidden");
                            } else {
                                el.classList.remove("st_hidden");
                            }
                        } else {
                            if (status === "Active") {
                                el.classList.remove("st_hidden");
                            } else {
                                el.classList.add("st_hidden");
                            }
                        }
                        _this.adjustTableHeader(flag);
                        _this.adjustTableForInactive(status, el);
                    });
                }
            };
            _this_1.adjustTableForInactive = function(status, el) {
                var copyBtn = el.querySelector(".st_table-copy-coupon_JS");
                var columnNameEl = document.querySelector(".st_table-head-actions_JS");
                if (!!columnNameEl) {
                    if (status === "Active") {
                        copyBtn.classList.remove("st_hidden");
                    } else {
                        copyBtn.classList.add("st_hidden");
                        _this_1.showCode(el);
                    }
                }
            };
            _this_1.adjustTableHeader = function(flag) {
                var columnNameEl = document.querySelector(".st_table-head-actions_JS");
                if (!!columnNameEl) {
                    if (flag) {
                        columnNameEl.innerHTML = "Used Promo Code";
                    } else {
                        columnNameEl.innerHTML = "Actions";
                    }
                }
            };
            return _this_1;
        }
        return StCouponCodes;
    }(st_module_59.StModule);
    exports.StCouponCodes = StCouponCodes;
});

define("extension/connector-app/_shared/models/share-cart/generate.cart.token.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/connector-app/_shared/models/share-cart/decode.cart.token.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/connector-app/_shared/models/share-cart/decode.cart.token.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/shopify-app/st-modules/cart/theme-cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_60) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StThemeCart = void 0;
    var StThemeCart = function(_super) {
        __extends(StThemeCart, _super);
        function StThemeCart() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ThemeCart";
            _this.bindDrawerEvent = function(refreshCallback, callbackParams) {
                if (refreshCallback === void 0) {
                    refreshCallback = function() {};
                }
                if (callbackParams === void 0) {
                    callbackParams = [];
                }
                _this.triedTooManyTimes = 0;
                var drawerArray = document.querySelectorAll("drawer-context");
                var cartContext = document.querySelector("cart-context");
                drawerArray.forEach(function(drawer) {
                    document.addEventListener("addToCart", function() {
                        refreshCallback.apply(void 0, callbackParams);
                    });
                    document.addEventListener("removeFromCart", function() {
                        refreshCallback.apply(void 0, callbackParams);
                    });
                    if (!!drawer && !!cartContext) {
                        drawer.addEventListener("drawer:open", function() {
                            refreshCallback.apply(void 0, callbackParams);
                        });
                    } else {
                        if (_this.triedTooManyTimes < 20) {
                            _this.triedTooManyTimes++;
                            setTimeout(function() {
                                _this.bindDrawerEvent(refreshCallback, callbackParams);
                            }, 200);
                        } else {
                            console.error("Couldn't bind drawer events!");
                        }
                    }
                });
            };
            _this.bindOpenCartDrawer = function(refreshCallback, callbackParams) {
                if (refreshCallback === void 0) {
                    refreshCallback = function() {};
                }
                if (callbackParams === void 0) {
                    callbackParams = [];
                }
                document.addEventListener("drawer:open", function() {
                    refreshCallback.apply(void 0, callbackParams);
                });
            };
            _this.bindDrawerRemoveItem = function(refreshCallback, callbackParams) {
                if (refreshCallback === void 0) {
                    refreshCallback = function() {};
                }
                if (callbackParams === void 0) {
                    callbackParams = [];
                }
                document.addEventListener("removeLabelMakerFromCart", function() {
                    refreshCallback.apply(void 0, callbackParams);
                });
            };
            return _this;
        }
        return StThemeCart;
    }(st_module_60.StModule);
    exports.StThemeCart = StThemeCart;
});

define("extension/shopify-app/st-modules/share-cart/share-cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_61, notification_10) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShareCart = void 0;
    var StShareCart = function(_super) {
        __extends(StShareCart, _super);
        function StShareCart(cartComponent, generalMethods, buttonActions, notifications, themeCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "ShareCart";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.isShareCartTokenExist();
                    _this_1.shareCartEvent();
                    _this_1.showHideShareCart();
                    _this_1.themeCart.bindDrawerEvent(_this_1.showHideShareCart);
                });
            };
            _this_1.shareCartEvent = function() {
                var _this = _this_1;
                var body = document.querySelector("body");
                if (!body.classList.contains("wine_share_cart_setup")) {
                    body.classList.add("wine_share_cart_setup");
                    document.addEventListener("click", function(e) {
                        if (_this.isShareCartButtonClicked(e)) {
                            _this.generateCartToken();
                            _this.copyShareCartLink();
                            _this.showHideShareCart();
                        }
                    });
                }
            };
            _this_1.selectShareCartButton = function(current) {
                if (current) {
                    if (current.classList.contains("wl_share-cart--generate-url-button_JS")) {
                        return current;
                    } else {
                        return _this_1.generalMethods.getClosestByClass(current, "wl_share-cart--generate-url-button_JS");
                    }
                } else {
                    return document.querySelector(".wl_share-cart--generate-url-button_JS");
                }
            };
            _this_1.isShareCartButtonClicked = function(e) {
                return !!_this_1.selectShareCartButton(e.target);
            };
            _this_1.showHideShareCart = function() {
                var shareCartWrapper = document.querySelector(".wl_share-cart--wrapper_JS");
                if (!!shareCartWrapper) {
                    _this_1.cartComponent.getCart(function(response) {
                        window.shopifyCartData = response;
                        if (window.shopifyCartData.items.length > 0) {
                            shareCartWrapper.classList.remove("st_hidden");
                        } else {
                            shareCartWrapper.classList.add("st_hidden");
                        }
                    });
                }
            };
            _this_1.isShareCartTokenExist = function() {
                var shopifyId = window.customerShopifyId;
                var customerShopifyId = !!shopifyId && shopifyId !== 0 ? shopifyId : undefined;
                var urlParams = new URLSearchParams(window.location.search);
                var token = urlParams.get("cartToken");
                var attributes = window.shopifyCartData.attributes;
                var tokenShareCartToken = attributes.shareCartToken;
                var decodeCartTokenRequest = {
                    shopifyId: customerShopifyId,
                    cartToken: token
                };
                if (!!token) {
                    _this_1.clearCart(_this_1.decodeCartToken, [ token, decodeCartTokenRequest, _this_1.updateAttributes, [ token ] ]);
                }
            };
            _this_1.clearCart = function(cb, params) {
                if (cb === void 0) {
                    cb = function() {};
                }
                if (params === void 0) {
                    params = [];
                }
                _this_1.cartComponent.clearCart(function(response) {
                    cb.apply(void 0, params);
                }, false);
            };
            _this_1.updateAttributes = function(attributes, cb, params) {
                if (cb === void 0) {
                    cb = function() {};
                }
                if (params === void 0) {
                    params = [];
                }
                _this_1.cart.updateCartAttributesOrNote(attributes, function(response) {
                    cb.apply(void 0, params);
                });
            };
            _this_1.decodeCartToken = function(token, decodeCartTokenRequest, cb, params) {
                if (params === void 0) {
                    params = [];
                }
                var _this = _this_1;
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["cart"]["decodeCartToken"],
                    method: "post",
                    contentType: "json",
                    data: decodeCartTokenRequest,
                    callback: function(responseData) {
                        try {
                            var decodeCartTokenResponse = JSON.parse(responseData.response);
                            var cartInfo = decodeCartTokenResponse.data;
                            var addToCartItems_1 = _this.transformResponseToCartItems(cartInfo.items, true);
                            var promoCode = cartInfo.promoCode;
                            if (promoCode) {
                                _this.updateCartAndToken(addToCartItems_1, token, promoCode);
                            } else {
                                if (addToCartItems_1.length > 0) {
                                    var attributes = window.shopifyCartData.attributes.attributes;
                                    attributes = __assign(__assign({}, attributes), {
                                        shareCartToken: token
                                    });
                                    var updateAttributes = {
                                        attributes: attributes
                                    };
                                    _this_1.cartComponent.updateCartAttributesOrNote(updateAttributes, function() {
                                        _this.cartComponent.addCart(addToCartItems_1, function(updatedCart) {
                                            _this.deleteShareCartTokenFromURL();
                                        }, true);
                                    });
                                }
                            }
                        } catch (error) {
                            console.log("Response Error ------\x3e" + error);
                        }
                    }
                });
            };
            _this_1.updateCartAndToken = function(addToCartItems, token, promoCode) {
                fetch("https://".concat(window.location.hostname, "/discount/").concat(promoCode)).then(function() {
                    _this_1.cartComponent.addCart(addToCartItems, function(updatedCart) {
                        _this_1.addTokenToCartAttribute(token);
                    });
                }).catch(function(error) {
                    console.error("error:", error);
                });
            };
            _this_1.transformResponseToCartItems = function(responseCartItems, onlyAvailable) {
                if (onlyAvailable === void 0) {
                    onlyAvailable = false;
                }
                var cartItems = [];
                responseCartItems.forEach(function(item) {
                    if (!onlyAvailable || item.available) {
                        var newItem = {
                            id: item.variantId,
                            quantity: item.quantity,
                            selling_plan: item.selling_plan,
                            properties: {
                                _personalizeLabelToken: item.labelToken,
                                _personalizeLabelImg: item.labelImage
                            }
                        };
                        cartItems.push(newItem);
                    }
                });
                return cartItems;
            };
            _this_1.addTokenToCartAttribute = function(cartToken) {
                var _this = _this_1;
                var attributes = window.shopifyCartData.attributes.attributes;
                attributes = __assign(__assign({}, attributes), {
                    shareCartToken: cartToken
                });
                var updateAttributes = {
                    attributes: attributes
                };
                _this_1.cartComponent.updateCartAttributesOrNote(updateAttributes, function() {
                    _this.deleteShareCartTokenFromURL();
                });
            };
            _this_1.deleteShareCartTokenFromURL = function() {
                var params = new URLSearchParams(window.location.search);
                params.delete("cartToken");
                var newURL = window.location.href.replace(window.location.search, "");
                history.replaceState(null, null, "?" + params);
                window.location.href = "/cart";
            };
            _this_1.generateCartToken = function() {
                var generateUrlButton = document.querySelector(".wl_share-cart--generate-url-button_JS");
                if (!generateUrlButton) {
                    console.error("Generate URL button not found");
                    return;
                }
                var shareCartWrapper = _this_1.generalMethods.getClosestByClass(generateUrlButton, "wl_share-cart--wrapper_JS");
                var urlContainer = shareCartWrapper.querySelector(".wl_share-cart--url-container_JS");
                var urlInput = urlContainer.querySelector(".wl_share-cart-url_JS");
                var promoCodeInput = shareCartWrapper.querySelector(".wl_share-cart--promo-code-input_JS");
                var shopifyId = window.customerShopifyId;
                var currentWebAlias = window.shopifyCartData.attributes.sponsorWebAlias;
                var customerShopifyId = shopifyId && shopifyId !== 0 ? shopifyId : undefined;
                _this_1.cartComponent.getCart(function(cart) {
                    var generateCartItem = _this_1.getGenerateCartItem(cart);
                    var generateCartTokenRequest = _this_1.createCartTokenRequest(customerShopifyId, currentWebAlias, promoCodeInput === null || promoCodeInput === void 0 ? void 0 : promoCodeInput.value, generateCartItem, generateCartItem.labelToken, generateCartItem.labelItemImage);
                    _this_1.sendCartTokenRequest(generateCartTokenRequest, urlContainer, urlInput, promoCodeInput);
                });
            };
            _this_1.getGenerateCartItem = function(cart) {
                return cart.items.map(function(item) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                    return {
                        variantId: item.variant_id.toString(),
                        quantity: item.quantity,
                        selling_plan: (_d = (_c = (_b = (_a = item.selling_plan_allocation) === null || _a === void 0 ? void 0 : _a.selling_plan) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : undefined,
                        labelToken: (_g = (_f = (_e = item.properties) === null || _e === void 0 ? void 0 : _e._personalizeLabelToken) === null || _f === void 0 ? void 0 : _f.toString()) !== null && _g !== void 0 ? _g : undefined,
                        labelItemImage: (_k = (_j = (_h = item.properties) === null || _h === void 0 ? void 0 : _h._personalizeLabelImg) === null || _j === void 0 ? void 0 : _j.toString()) !== null && _k !== void 0 ? _k : undefined
                    };
                });
            };
            _this_1.createCartTokenRequest = function(customerShopifyId, currentWebAlias, promoCode, generateCartItem, labelToken, labelImgToken) {
                return {
                    shopifyId: customerShopifyId,
                    webAlias: currentWebAlias,
                    promoCode: promoCode,
                    items: generateCartItem,
                    labelToken: labelToken,
                    labelItemImage: labelImgToken
                };
            };
            _this_1.removePreviousUrl = function() {
                var inputs = document.querySelectorAll(".wl_share-cart-url-click-copy_JS");
                if (inputs) {
                    inputs.forEach(function(input) {
                        input.value = "";
                    });
                }
            };
            _this_1.sendCartTokenRequest = function(generateCartTokenRequest, urlContainer, urlInput, promoCodeInput) {
                var _this = _this_1;
                var buttons = document.querySelectorAll(".wl_share-cart--generate-url-button_JS");
                buttons.forEach(function(btn) {
                    _this_1.buttonActions.disable(btn);
                    _this_1.buttonActions.addLoader(btn);
                });
                if (generateCartTokenRequest.items.length > 0) {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["cart"]["generateCartToken"],
                        method: "post",
                        contentType: "json",
                        data: generateCartTokenRequest,
                        callback: function(responseData) {
                            try {
                                var cartTokenRes = JSON.parse(responseData.response);
                                buttons.forEach(function(btn) {
                                    _this.buttonActions.enable(btn);
                                    _this.buttonActions.removeLoader(btn);
                                });
                                if (cartTokenRes.status === 200) {
                                    var cartTokenInfo = cartTokenRes.data;
                                    if (cartTokenInfo) {
                                        urlContainer.classList.remove("st_hidden");
                                        _this_1.removePreviousUrl();
                                        urlInput.value = "https://".concat(window.location.hostname, "/pages/share-cart-loading").concat(cartTokenInfo.url);
                                        _this_1.copyShareCartLink();
                                        promoCodeInput.value = "";
                                    }
                                } else {
                                    console.error("Error message: ", cartTokenRes.message, " Status: ", cartTokenRes.status);
                                }
                            } catch (error) {
                                console.error("Error processing response", error);
                            }
                        }
                    });
                } else {
                    _this.notifications.showNotification(notification_10.ENotificationType.error, "Error", "Cart is empty. You can not share empty cart.");
                    var buttons_1 = document.querySelectorAll(".wl_share-cart--generate-url-button_JS");
                    buttons_1.forEach(function(btn) {
                        _this_1.buttonActions.enable(btn);
                    });
                    var inputs = document.querySelectorAll(".wl_share-cart--url-container_JS");
                    if (!!inputs) {
                        inputs.forEach(function(input) {
                            input.classList.add("st_hidden");
                        });
                    }
                }
            };
            _this_1.copyShareCartLink = function() {
                var _this = _this_1;
                var linkClass = ".wl_share-cart-url-click-copy_JS";
                var copyRepSiteButtonAll = document.querySelectorAll(linkClass);
                if (!!copyRepSiteButtonAll) {
                    copyRepSiteButtonAll.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.notifications.showNotification(notification_10.ENotificationType.success, "Share Cart", "Link is copied to clipboard.");
                            var copyText = document.querySelectorAll(linkClass);
                            this.select();
                            navigator.clipboard.writeText(this.value);
                            this.style.backgroundColor = "rgb(217, 218, 220)";
                            this.style.transition = "0.2s";
                            setTimeout(function() {
                                btn.style.backgroundColor = "rgb(249, 249, 249)";
                            }, 1e3);
                        });
                    });
                }
            };
            _this_1.cartComponent = cartComponent;
            _this_1.generalMethods = generalMethods;
            _this_1.buttonActions = buttonActions;
            _this_1.notifications = notifications;
            _this_1.themeCart = themeCart;
            return _this_1;
        }
        return StShareCart;
    }(st_module_61.StModule);
    exports.StShareCart = StShareCart;
});

define("extension/shopify-app/st-modules/webalias/webalias-class-config-extended", [ "require", "exports", "core/shopify-app/st-modules/webalias/webalias-class-config" ], function(require, exports, webalias_class_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAliasClassConfigExtended = void 0;
    var StWebAliasClassConfigExtended = function(_super) {
        __extends(StWebAliasClassConfigExtended, _super);
        function StWebAliasClassConfigExtended() {
            var _this = _super.call(this) || this;
            _this.className = "StWebAliasClassConfig";
            _this.classNameRepId = "st_representative-id_JS";
            _this.selectorRepId = "." + _this.classNameRepId;
            _this.classNameRepAlias = "st_representative-alias_JS";
            _this.selectorRepAlias = "." + _this.classNameRepAlias;
            _this.classNameRepFullName = "st_representative-fullname_JS";
            _this.selectorRepFullName = "." + _this.classNameRepFullName;
            _this.classNameRepInitials = "st_representative-initials_JS";
            _this.selectorRepInitials = "." + _this.classNameRepInitials;
            _this.classNameRepSite = "st_representative-site_JS";
            _this.selectorRepSite = "." + _this.classNameRepSite;
            _this.classNameRepBio = "st_representative-site-bio_JS";
            _this.selectorRepBio = "." + _this.classNameRepBio;
            _this.classNameRepAddress = "st_representative-address_JS";
            _this.selectorRepAddress = "." + _this.classNameRepAddress;
            _this.classNameNonSponsor = "st_non-sponsor_JS";
            _this.selectorNonSponsor = "." + _this.classNameNonSponsor;
            _this.classRepresentativeBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeBannerWrapper = "." + _this.classRepresentativeBannerWrapper;
            _this.classNameBusinessContentRepName = "st_account-business--rep-name_JS";
            _this.selectorBusinessContentRepName = "." + _this.classNameBusinessContentRepName;
            _this.classNamePersonalInfoForm = "st_personal-info-form_JS";
            _this.selectorPersonalInfoForm = "." + _this.classNamePersonalInfoForm;
            _this.classNamePersonalInfoRepFullName = "st_representative-info-fullname_JS";
            _this.selectorPersonalInfoRepFullName = "." + _this.classNamePersonalInfoRepFullName;
            _this.classNameTastingWithWrp = "st_tasting-with-wrp_JS";
            _this.selectorTastingWithWrp = "." + _this.classNameTastingWithWrp;
            _this.classNameTastingWithFullName = "st_tasting-with-fullname_JS";
            _this.selectorTastingWithFullName = "." + _this.classNameTastingWithFullName;
            _this.classErrorMessage = "st_representative-banner-message-error_JS";
            _this.selectorErrorMessage = "." + _this.classErrorMessage;
            return _this;
        }
        return StWebAliasClassConfigExtended;
    }(webalias_class_config_1.StWebAliasClassConfig);
    exports.StWebAliasClassConfigExtended = StWebAliasClassConfigExtended;
});

define("extension/shopify-app/st-modules/tasting/tasting-ref", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_62, notification_11) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCustomerReferral = void 0;
    var StCustomerReferral = function(_super) {
        __extends(StCustomerReferral, _super);
        function StCustomerReferral(notification, cart, cookies) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StCustomerReferral";
            _this_1.init = function() {
                var _this = _this_1;
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.checkCref();
                });
            };
            _this_1.checkCref = function() {
                var urlParams = new URLSearchParams(window.location.search);
                var cref = urlParams.get("cref");
                if (!cref) {
                    cref = window.shopifyCartData.attributes.cref;
                    if (cref) {
                        var sp = new URLSearchParams(location.search);
                        _this_1.cookies.clearCookie("cref");
                        sp.append("cref", cref);
                        window.history.replaceState(null, null, "?".concat(sp.toString()));
                    } else {
                        cref = _this_1.cookies.getCookie("cref");
                        if (cref) {
                            var sp = new URLSearchParams(location.search);
                            sp.append("cref", cref);
                            window.history.replaceState(null, null, "?".concat(sp.toString()));
                        }
                    }
                } else {
                    _this_1.cookies.setCookies("cref", cref);
                }
                if (cref) {
                    _this_1.getCrefInfo(cref);
                }
            };
            _this_1.getCrefInfo = function(cref) {
                var _this = _this_1;
                var customerID = window.customerShopifyId;
                var requestData = {
                    referralCode: cref,
                    shopifyCustomerId: Number(customerID)
                };
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["referral"]["getReferralInfo"],
                    method: "post",
                    contentType: "json",
                    data: requestData,
                    callback: function(responseData) {
                        try {
                            var getCrefRes = JSON.parse(responseData.response);
                            if (getCrefRes.status === 200) {
                                var repBannerWrapper = document.querySelector(".st_representative-banner--wrapper_JS");
                                if (!!repBannerWrapper) {
                                    var customerType = repBannerWrapper.getAttribute("data-customer-type").trim();
                                    if (customerType === "affiliate") {
                                        _this.affiliateFlow();
                                    } else {
                                        _this.retailAndGuestFlow(cref);
                                        _this.handlerRefBanner(getCrefRes.data.referralProvider);
                                    }
                                }
                            } else if (getCrefRes.status === 400) {
                                var params = new URLSearchParams(window.location.search);
                                params.delete("cref");
                                var newURL = window.location.href.replace(window.location.search, "");
                                history.replaceState(null, null, "?" + params);
                                _this.deleteCrefCartAttributes();
                            }
                        } catch (e) {}
                    }
                });
            };
            _this_1.handlerRefBanner = function(refFullName) {
                var params = new URLSearchParams(window.location.search);
                var cref = params.get("cref");
                cref = !cref ? window.shopifyCartData.attributes.cref : cref;
                console.log(params.get("cref"), window.shopifyCartData.attributes.cref);
                if (!!cref) {
                    var crefFullname = document.querySelector(".st_tasting-with-fullname_JS");
                    if (!!crefFullname) {
                        crefFullname.innerHTML = refFullName.firstName + " " + refFullName.lastName;
                    }
                    _this_1.showRef();
                } else {
                    _this_1.hideRef();
                }
            };
            _this_1.showRef = function() {
                var refWrapper = document.querySelector(".st_tasting-with-wrp_JS");
                if (!!refWrapper) {
                    if (refWrapper.classList.contains("st_hidden")) {
                        refWrapper.classList.remove("st_hidden");
                    }
                }
            };
            _this_1.hideRef = function() {
                var refWrapper = document.querySelector(".st_tasting-with-wrp_JS");
                if (!!refWrapper) {
                    if (!refWrapper.classList.contains("st_hidden")) {
                        refWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this_1.affiliateFlow = function() {
                var params = new URLSearchParams(window.location.search);
                params.delete("cref");
                var newURL = window.location.href.replace(window.location.search, "");
                history.replaceState(null, null, "?" + params);
                _this_1.deleteCrefCartAttributes();
                _this_1.notification.showNotification(notification_11.ENotificationType.error, "Error", "User is an Affiliate. Affiliates cannot use customer referral program.");
            };
            _this_1.retailAndGuestFlow = function(cref) {
                var attrinutesUpdate = {
                    attributes: {
                        cref: cref
                    }
                };
                _this_1.cart.updateCartAttributesOrNote(attrinutesUpdate, function(response) {});
                return cref;
            };
            _this_1.logoutAccount = function() {
                var _this = _this_1;
                var logoutBtn = document.querySelector(".st_account-logout_JS");
                if (!!logoutBtn) {
                    logoutBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.deleteCrefCartAttributes();
                    });
                }
            };
            _this_1.deleteCrefCartAttributes = function() {
                _this_1.cookies.clearCookie("cref");
                var attrinutesUpdate = {
                    attributes: {
                        cref: ""
                    }
                };
                _this_1.cart.updateCartAttributesOrNote(attrinutesUpdate, function(response) {});
            };
            _this_1.notification = notification;
            _this_1.cart = cart;
            _this_1.cookies = cookies;
            return _this_1;
        }
        return StCustomerReferral;
    }(st_module_62.StModule);
    exports.StCustomerReferral = StCustomerReferral;
});

define("extension/shopify-app/st-modules/customizable-label/label-loading", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_63) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StLabelLoading = void 0;
    var StLabelLoading = function(_super) {
        __extends(StLabelLoading, _super);
        function StLabelLoading(objectFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "LabelLoading";
            _this_1.init = function() {};
            _this_1.checkLabel = function(callback, callbackParams) {
                if (callback === void 0) {
                    callback = function() {};
                }
                if (callbackParams === void 0) {
                    callbackParams = [];
                }
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var _this = _this_1;
                if (!!urlParams.labelToken) {
                    setTimeout(function() {
                        _this.addPersonalizedItemNew(urlParams.variantId, urlParams.quantityId, urlParams.labelToken);
                    }, 3e3);
                } else {
                    callback.apply(void 0, callbackParams);
                }
            };
            _this_1.addPersonalizedItem = function(variantId, quantity, token) {
                var imageLink = "https://personalizedwine.wineshopathome.com/wp-content/uploads/wineshop-labels/" + token + ".jpeg";
                var data = {
                    items: [ {
                        quantity: Number(quantity),
                        id: Number(variantId),
                        properties: {
                            _personalizeLabelToken: token,
                            _personalizeLabelImg: imageLink
                        }
                    } ]
                };
                _this_1.ajax.send({
                    endpoint: "/cart/add.js",
                    method: "POST",
                    contentType: "json",
                    data: data,
                    callback: function(res) {
                        window.location.href = "" + window.location.origin + "/cart";
                    }
                });
            };
            _this_1.addPersonalizedItemNew = function(variantId, quantity, token) {
                var imageLink = "https://personalizedwine.wineshopathome.com/wp-content/uploads/wineshop-labels/" + token + ".jpeg";
                var item = {
                    quantity: Number(quantity),
                    id: Number(variantId),
                    attributes: [ {
                        key: "_personalizeLabelToken",
                        value: token
                    }, {
                        key: "_personalizeLabelImg",
                        value: imageLink
                    } ],
                    merchandiseId: Number(variantId)
                };
                console.log(item);
                _this_1.addItemWhenReady(item);
            };
            _this_1.addItemWhenReady = function(item) {
                var _this = _this_1;
                if (!!window.Shopify && !!window.Shopify.StorefrontCart && !!window.Shopify.StorefrontCart.addItem) {
                    window.Shopify.StorefrontCart.addItem(item, {
                        onSettled: function() {
                            setTimeout(function() {
                                window.location.href = "" + window.location.origin + "/cart";
                            }, 2e3);
                        }
                    });
                } else {
                    setTimeout(function() {
                        _this.addItemWhenReady(item);
                    }, 200);
                }
            };
            _this_1.objectFormatting = objectFormatting;
            return _this_1;
        }
        return StLabelLoading;
    }(st_module_63.StModule);
    exports.StLabelLoading = StLabelLoading;
});

define("extension/shopify-app/st-modules/webalias/webalias-extended", [ "require", "exports", "core/shopify-app/st-modules/webalias/webalias", "_features.config" ], function(require, exports, webalias_1, _features_config_15) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebaliasExtended = void 0;
    var StWebaliasExtended = function(_super) {
        __extends(StWebaliasExtended, _super);
        function StWebaliasExtended(classConfig, browserHistory, objectFormatting, cookies, customerType, generalMethods, injectRepresentativeInfo, cartComponent, searchSponsorGuard, accountPersonalSite, customerReferral, labelLoading) {
            var _this = _super.call(this, classConfig, browserHistory, objectFormatting, cookies, customerType, generalMethods, injectRepresentativeInfo, cartComponent, searchSponsorGuard, accountPersonalSite) || this;
            _this.className = "WebAlias";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.labelLoading.checkLabel(_this.initWebAliasSequence);
                });
            };
            _this.initWebAliasSequence = function() {
                _this.initWebAliasFlow();
                _this.initSponsorCheck();
            };
            _this.initWebAliasFlow = function() {
                _this.redirectOldRepUrls();
                if (_this.isCustomerRepresentative) {
                    return _this.affiliateAliasFlow(_this.getRepSiteInfo, _this.handleRepresentativeInfoResponse);
                }
                if (_this.isCustomerRetail) {
                    return _this.retailCustomerAliasFlow(_this.getRepSiteInfo, _this.handleRetailSponsorInfoResponse);
                }
                if (_this.isCustomerGuest) {
                    return _this.guestCustomerAliasFlow(_this.getRepSiteInfo, _this.handleGuestSponsorInfoResponse);
                }
            };
            _this.redirectOldRepUrls = function() {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                if (urlParams.rep) {
                    urlParams.ref = urlParams.rep;
                    delete urlParams.rep;
                    var urlArrayByID = window.location.href.split("#");
                    var urlArrayByQuery = urlArrayByID[0].split("?");
                    var newSearchString = _this.objectFormatting.convertObjectToQueryString(urlParams);
                    var URL_1 = urlArrayByQuery[0] + newSearchString + (urlArrayByID.length > 1 ? "#" + urlArrayByID[1] : "");
                    window.history.replaceState(null, "", URL_1);
                }
            };
            _this.affiliateAliasFlow = function(getRepSiteMethod, handleRepSiteResponseMethod) {
                var customerIdFromMetafields = _this.customerIdFromMetafields;
                if (!customerIdFromMetafields) {
                    getRepSiteMethod(_features_config_15.defaultWebAlias, handleRepSiteResponseMethod);
                }
                getRepSiteMethod(_this.customerIdFromMetafields, handleRepSiteResponseMethod);
            };
            _this.guestCustomerAliasFlow = function(getRepSiteMethod, handleRepSiteResponseMethod) {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentUrlAlias = urlParams[_features_config_15.aliasQueryParam];
                var cookieAlias = _this.cookies.getCookie("webAlias");
                if (currentUrlAlias) {
                    if (currentUrlAlias === _features_config_15.defaultWebAlias && !!cookieAlias && cookieAlias !== currentUrlAlias) {
                        return getRepSiteMethod(cookieAlias, handleRepSiteResponseMethod);
                    }
                    return getRepSiteMethod(currentUrlAlias, handleRepSiteResponseMethod);
                } else if (!!cookieAlias) {
                    return getRepSiteMethod(cookieAlias, handleRepSiteResponseMethod);
                } else {
                    return getRepSiteMethod(_features_config_15.defaultWebAlias, handleRepSiteResponseMethod);
                }
            };
            _this.retailCustomerAliasFlow = function(getRepSiteMethod, handleRepSiteResponseMethod) {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentUrlAlias = urlParams[_features_config_15.aliasQueryParam];
                var cookieAlias = _this.cookies.getCookie("webAlias");
                var sponsorIfFromMetafield = _this.representativeIdFromMetafields;
                if (_features_config_15.lockedRepresentativeSite) {
                    return getRepSiteMethod(sponsorIfFromMetafield, handleRepSiteResponseMethod);
                } else {
                    if (!!currentUrlAlias && currentUrlAlias != _features_config_15.defaultWebAlias) {
                        return getRepSiteMethod(currentUrlAlias, handleRepSiteResponseMethod);
                    } else if (!currentUrlAlias && (!cookieAlias || cookieAlias == _features_config_15.defaultWebAlias) && !!sponsorIfFromMetafield) {
                        return getRepSiteMethod(sponsorIfFromMetafield, handleRepSiteResponseMethod);
                    } else if (!!cookieAlias) {
                        return getRepSiteMethod(cookieAlias, handleRepSiteResponseMethod);
                    } else {
                        return getRepSiteMethod(_features_config_15.defaultWebAlias, handleRepSiteResponseMethod);
                    }
                }
            };
            _this.handleRepresentativeInfoResponse = function(response) {
                var data = response.data, status = response.status;
                if (status !== 200) {
                    return _this.getRepSiteInfo(_features_config_15.defaultWebAlias, _this.handleRepresentativeInfoResponse);
                } else {
                    return _this.updateCurrentRepInfo(data);
                }
            };
            _this.getRepSiteInfo = function(customerIdOrAlias, handleResponseMethod) {
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: true
                }, handleResponseMethod);
            };
            _this.getRepresentativesOwnInfo = function(customerIdOrAlias) {
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: true
                }, _this.handleRepresentativeInfoResponse);
            };
            _this.getRetailSponsorInfo = function(customerIdOrAlias) {
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: true
                }, _this.handleRetailSponsorInfoResponse);
            };
            _this.getGuestSponsorInfo = function(customerIdOrAlias) {
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: true
                }, _this.handleGuestSponsorInfoResponse);
            };
            _this.handleGuestSponsorInfoResponse = function(response) {
                var data = response.data, status = response.status;
                var webAlias = data.webAlias, repId = data.repId;
                var cookieRepSite = _this.cookies.getCookie("webAlias");
                if (status == 400) {
                    if (!!cookieRepSite && cookieRepSite !== webAlias) {
                        return _this.getRepSiteInfo(cookieRepSite, _this.handleGuestSponsorInfoResponse);
                    } else {
                        return _this.getRepSiteInfo(_features_config_15.defaultWebAlias, _this.handleGuestSponsorInfoResponse);
                    }
                } else if (status != 200) {
                    return _this.getRepSiteInfo(_features_config_15.defaultWebAlias, _this.handleGuestSponsorInfoResponse);
                }
                if (webAlias === _features_config_15.defaultWebAlias && !!cookieRepSite && cookieRepSite != webAlias) {
                    return _this.getRepSiteInfo(cookieRepSite, _this.handleGuestSponsorInfoResponse);
                } else {
                    return _this.updateCurrentRepInfo(data);
                }
            };
            _this.handleRetailSponsorInfoResponse = function(response) {
                var data = response.data, status = response.status;
                var webAlias = data.webAlias, repId = data.repId;
                var cookieRepSite = _this.cookies.getCookie("webAlias");
                var metafieldsSponsorId = _this.representativeIdFromMetafields;
                var defaultSponsorId = window.defaultSponsorId;
                if (status == 400) {
                    var sponsor = void 0;
                    if (!cookieRepSite && webAlias == metafieldsSponsorId) {
                        return _this.getRepSiteInfo(_features_config_15.defaultWebAlias, _this.handleRetailSponsorInfoResponse);
                    }
                    if (!cookieRepSite || webAlias == cookieRepSite) {
                        _this.cookies.clearCookie("webAlias");
                        sponsor = metafieldsSponsorId;
                    } else {
                        sponsor = cookieRepSite;
                    }
                    return _this.getRepSiteInfo(sponsor, _this.handleRetailSponsorInfoResponse);
                } else if (status != 200) {
                    return _this.getRepSiteInfo(_features_config_15.defaultWebAlias, _this.handleRetailSponsorInfoResponse);
                }
                if (!webAlias && webAlias === "") {
                    data = __assign(__assign({}, data), {
                        webAlias: repId
                    });
                }
                if (webAlias === _features_config_15.defaultWebAlias) {
                    if (!!cookieRepSite && cookieRepSite != _features_config_15.defaultWebAlias) {
                        return _this.getRepSiteInfo(cookieRepSite, _this.handleRetailSponsorInfoResponse);
                    }
                    return metafieldsSponsorId == defaultSponsorId || !metafieldsSponsorId || _features_config_15.defaultWebAlias === webAlias ? _this.updateCurrentRepInfo(data) : _this.getRepSiteInfo(metafieldsSponsorId, _this.handleRetailSponsorInfoResponse);
                } else {
                    return _this.updateCurrentRepInfo(data);
                }
            };
            _this.getRepresentativeInfo = function(webAliasRequest, handleResponse) {
                if (typeof webAliasRequest.customerIdOrAlias == "undefined") {
                    return;
                }
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["webalias"]["repSite"],
                        method: "post",
                        contentType: "json",
                        data: webAliasRequest,
                        callback: function(response) {
                            var responseObject = __assign({}, JSON.parse(response.response));
                            try {
                                if (responseObject.status === 404) {
                                    var errorMessage = document.querySelectorAll(_this.classConfig.selectorErrorMessage);
                                    if (!!errorMessage) {
                                        errorMessage.forEach(function(messageSpan) {
                                            messageSpan.innerHTML = responseObject.message;
                                        });
                                    }
                                } else {
                                    handleResponse(responseObject);
                                }
                            } catch (error) {
                                _this.nonExistentRepresentativeFlow();
                                console.log("Response Error ------\x3e" + error);
                            }
                        }
                    });
                } catch (error) {
                    console.log("Request Error ------\x3e" + error);
                }
            };
            _this.nonExistentRepresentativeFlow = function() {
                return _this.getRepSiteInfo(_features_config_15.defaultWebAlias, _this.handleRepresentativeInfoResponse);
            };
            _this.getSponsorInformation = function() {
                var repIdMetafield = window.customerInfoMetafields.representativeId;
                var webAliasRequestedData = {
                    customerIdOrAlias: repIdMetafield,
                    isOwnInfo: true
                };
                _this.getRepresentativeInfo(webAliasRequestedData, _this.handleSponsorInfoResponse);
            };
            _this.handleSponsorInfoResponse = function(response) {
                if (response.status === 200) {
                    var sponsorInfo = response.data;
                    _this.injectRepresentativeInfo.injectSponsorInfoToField(sponsorInfo.firstName, sponsorInfo.lastName);
                    _this.accountPersonalSite.createLinkWithRef(sponsorInfo.webAlias);
                    _this.accountPersonalSite.includePromoCode(sponsorInfo.webAlias);
                } else {
                    _this.injectRepresentativeInfo.injectSponsorInfoToField("", "");
                }
            };
            _this.updateCurrentRepInfo = function(repInfo) {
                var webAlias = repInfo.webAlias, repId = repInfo.repId;
                if (!_this.isDataEqualToStored(repInfo)) {
                    _this.setRepresentativeCookies(repInfo);
                }
                if (!_this.isAliasEqualToUrlAlias(webAlias)) {
                    _this.setNewAliasInUrl(webAlias);
                }
                _this.cartComponent.updateCartItemsProperies(webAlias);
                _this.searchSponsorGuard.toggleCantGoUnderCorporateSite(webAlias === _features_config_15.defaultWebAlias);
                _this.injectRepresentativeInfo.injectToFields(repInfo);
            };
            _this.isAliasEqualToStored = function(alias) {
                return alias === _this.cookies.getCookie("webAlias");
            };
            _this.isDataEqualToStored = function(repInfo) {
                return repInfo.webAlias === _this.cookies.getCookie("webAlias") && repInfo.firstName === _this.cookies.getCookie("firstName") && repInfo.lastName === _this.cookies.getCookie("lastName");
            };
            _this.isAliasEqualToUrlAlias = function(alias) {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_15.aliasQueryParam];
                return currentAlias === alias;
            };
            _this.setNewAliasInUrl = function(alias) {
                var _a;
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var newUrlParams = __assign(__assign({}, urlParams), (_a = {}, _a[_features_config_15.aliasQueryParam] = alias, 
                _a));
                var newURL = window.location.href.replace(window.location.search, "");
                _this.browserHistory.pushHistory(newURL, newUrlParams);
            };
            _this.setRepresentativeCookies = function(repInfo) {
                _this.cookies.setCookies(_this.cookieNameWebAlias, repInfo.webAlias);
                _this.cookies.setCookies(_this.cookieNameRepId, repInfo.repId);
                _this.cookies.setCookies(_this.cookieNameFirstName, repInfo.firstName);
                _this.cookies.setCookies(_this.cookieNameLastName, repInfo.lastName);
                if (_features_config_15.additionalRepInfo) {
                    _this.cookies.setCookies(_this.cookieNameImageUrl, repInfo.imageUrl);
                }
            };
            _this.initSponsorCheck = function() {
                var shopifyCustomerId = _this.shopifyCustomerId;
                if (_this.isTimeForSponsorCheck() && shopifyCustomerId && shopifyCustomerId !== 0) {
                    _this.updateCustomerSponsor(shopifyCustomerId);
                }
            };
            _this.updateCustomerSponsor = function(shopifyCustomerId) {
                var updateSponsorData = {
                    shopifyCustomerId: shopifyCustomerId
                };
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["customer"]["updateSponsor"],
                        method: "post",
                        contentType: "json",
                        data: updateSponsorData
                    });
                } catch (error) {
                    console.log("Request Error ------\x3e " + error);
                }
            };
            _this.isTimeForSponsorCheck = function() {
                var timestamp = Date.now();
                var lastCheck = _this.customerSponsorLastCheck;
                var timeThreshold = _features_config_15.sponsorGenealogyTimeout ? _features_config_15.sponsorGenealogyTimeout : 9e5;
                return timestamp - lastCheck > timeThreshold;
            };
            _this.customerReferral = customerReferral;
            _this.labelLoading = labelLoading;
            return _this;
        }
        Object.defineProperty(StWebaliasExtended.prototype, "customerIdFromMetafields", {
            get: function() {
                return window.customerInfoMetafields.customerId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebaliasExtended.prototype, "representativeIdFromMetafields", {
            get: function() {
                return window.customerInfoMetafields.representativeId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebaliasExtended.prototype, "shopifyCustomerId", {
            get: function() {
                return window.customerShopifyId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebaliasExtended.prototype, "customerSponsorLastCheck", {
            get: function() {
                return window.customerSponsorLastCheck;
            },
            enumerable: false,
            configurable: true
        });
        return StWebaliasExtended;
    }(webalias_1.StWebAlias);
    exports.StWebaliasExtended = StWebaliasExtended;
});

define("extension/shopify-app/st-modules/account/blocks/testing/tasting", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_64, _features_config_16) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StTasting = void 0;
    var StTasting = function(_super) {
        __extends(StTasting, _super);
        function StTasting(cartComponent, generalMethods, themeCart, sponsorService) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Tasting";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.checkElement();
                    _this_1.toggleEvent();
                    _this_1.copyRefToClipboard();
                    _this_1.createCrefLink();
                    _this_1.themeCart.bindDrawerEvent(_this_1.selectRewardOption);
                    _this_1.themeCart.bindDrawerEvent(_this_1.handleReferralRewards);
                });
            };
            _this_1.checkElement = function() {
                var customerIdWrps = document.querySelectorAll(".wine_tasting-wrapper_JS");
                if (customerIdWrps.length < 1) {
                    setTimeout(function() {
                        _this_1.fireDOMLoadedCallbacks();
                    }, 500);
                } else {
                    customerIdWrps.forEach(function(el) {
                        if (!!el) {
                            _this_1.checkRefRewards();
                        }
                    });
                }
            };
            _this_1.fireDOMLoadedCallbacks = function() {
                _this_1.checkElement();
            };
            _this_1.checkRefRewards = function() {
                var _this = _this_1;
                var customerIdWrps = document.querySelectorAll(".wine_tasting-wrapper_JS");
                if (!!customerIdWrps) {
                    customerIdWrps.forEach(function(customerIdWrp) {
                        if (!!customerIdWrp) {
                            var customerId = customerIdWrp.getAttribute("data-customer-id");
                            _this.toggleNumberOfRewards();
                            _this.getTastingRewards();
                        }
                    });
                }
            };
            _this_1.showWrap = function() {
                var wrappers = document.querySelectorAll(".wine_tasting-content-wrapper_JS");
                if (!!wrappers) {
                    wrappers.forEach(function(wrp) {
                        wrp.classList.remove("st_hidden");
                    });
                }
            };
            _this_1.hideWrap = function() {
                var wrappers = document.querySelectorAll(".wine_tasting-content-wrapper_JS");
                if (!!wrappers) {
                    wrappers.forEach(function(wrp) {
                        wrp.classList.add("st_hidden");
                    });
                }
            };
            _this_1.getTastingRewards = function() {
                var shopifyId = window.customerShopifyId;
                var _this = _this_1;
                var getTastingRewardsRequest = {
                    customerId: Number(shopifyId)
                };
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["customer"]["getReferralRewards"],
                    method: "post",
                    contentType: "json",
                    data: getTastingRewardsRequest,
                    callback: function(responseData) {
                        try {
                            var getTastingRewardsRes = JSON.parse(responseData.response);
                            if (getTastingRewardsRes.status === 200) {
                                var rewards = getTastingRewardsRes.data.rewards;
                                if (rewards.length > 0) {
                                    _this.showWrap();
                                } else {
                                    _this.hideWrap();
                                }
                                var numberOfRewards_1 = 0;
                                rewards.forEach(function(rew) {
                                    if (rew.availableForUsage === true) {
                                        numberOfRewards_1++;
                                    }
                                });
                                var allRewards = numberOfRewards_1;
                                _this.generateRewardsPicker(allRewards, shopifyId);
                                _this.generateTastingRewardsTable(rewards);
                                _this.customerRewardsTableTitle(rewards);
                            }
                        } catch (e) {}
                    }
                });
            };
            _this_1.validateTastingRewards = function(allRewards, customerId) {
                var _this = _this_1;
                _this_1.hideErrorMessageForTastingRewards();
                var validateTastingRewardsRequest = {
                    numberOfRewards: Number(allRewards),
                    customerId: Number(customerId)
                };
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["customer"]["validateReferralRewards"],
                    method: "post",
                    contentType: "json",
                    data: validateTastingRewardsRequest,
                    callback: function(responseData) {
                        try {
                            var validateTastingRewardsRes = JSON.parse(responseData.response);
                            if (validateTastingRewardsRes.data.isValid === false) {
                                _this.showErrorMessageForTastingRewards(validateTastingRewardsRes.data.message);
                            }
                        } catch (error) {
                            console.error(error);
                        }
                    }
                });
            };
            _this_1.showErrorMessageForTastingRewards = function(responseMessage) {
                var errorMessageWrapper = document.querySelector(".wine_tasting-error-message_JS");
                if (errorMessageWrapper) {
                    errorMessageWrapper.classList.remove("st_hidden");
                    errorMessageWrapper.innerHTML = responseMessage;
                }
            };
            _this_1.hideErrorMessageForTastingRewards = function() {
                var errorMessageWrapper = document.querySelector(".wine_tasting-error-message_JS");
                if (errorMessageWrapper) {
                    errorMessageWrapper.classList.add("st_hidden");
                }
            };
            _this_1.generateRewardsPicker = function(num, customerId) {
                var mainWrps = document.querySelectorAll(".wine_tasting-rewardsPickerWrp_JS");
                mainWrps.forEach(function(mainWrp) {
                    if (num > 0) {
                        var wrp = document.createElement("div");
                        wrp.classList.add("wine_tasting-rewards-picker-wrp");
                        wrp.classList.add("wine_tasting-rewards-picker-wrp_JS");
                        wrp.style.display = "none";
                        var selectName = document.createElement("div");
                        selectName.classList.add("wine_tasting-rewardsText_JS");
                        selectName.classList.add("wine_tasting-rewards-text");
                        selectName.innerText = "Select number of rewards to redeem:";
                        var selectElement = document.createElement("select");
                        selectElement.classList.add("wine_select-tasting-reward_JS");
                        selectElement.classList.add("wine_select-tasting-reward-select");
                        selectName.style.display = "none";
                        selectElement.style.display = "none";
                        for (var z = 0; z <= num; z++) {
                            var option = document.createElement("option");
                            option.value = "" + z;
                            option.text = "" + z;
                            selectElement.appendChild(option);
                        }
                        wrp.appendChild(selectName);
                        wrp.appendChild(selectElement);
                        mainWrp.appendChild(wrp);
                    }
                });
                _this_1.selectRewardOption();
            };
            _this_1.selectRewardOption = function() {
                var customerId = window.customerShopifyId;
                var _this = _this_1;
                var selectsReward = document.querySelectorAll(".wine_select-tasting-reward_JS");
                if (!!selectsReward) {
                    selectsReward.forEach(function(select) {
                        if (select instanceof HTMLSelectElement) {
                            var getOptionsCollection = select.options;
                            var getSelectedOption_1 = getOptionsCollection[select.selectedIndex];
                            _this.hideErrorMessageForTastingRewards();
                            var validateTastingRewardsRequest = {
                                numberOfRewards: Number(getSelectedOption_1.value),
                                customerId: Number(customerId)
                            };
                            _this.ajax.send({
                                endpoint: _this.endpoint["customer"]["validateReferralRewards"],
                                method: "post",
                                contentType: "json",
                                data: validateTastingRewardsRequest,
                                callback: function(responseData) {
                                    try {
                                        var validateTastingRewardsRes = JSON.parse(responseData.response);
                                        if (validateTastingRewardsRes.data.isValid === false) {
                                            _this.showErrorMessageForTastingRewards(validateTastingRewardsRes.data.message);
                                        } else {
                                            var numberOfDiscounts = {
                                                attributes: {
                                                    wineDiscount: getSelectedOption_1.value
                                                }
                                            };
                                            _this.cartComponent.updateCartAttributesOrNote(numberOfDiscounts, function(res) {});
                                        }
                                    } catch (error) {
                                        console.error(error);
                                    }
                                }
                            });
                        }
                        select.addEventListener("change", function() {
                            if (select instanceof HTMLSelectElement) {
                                var getOptionsCollection = select.options;
                                var getSelectedOption_2 = getOptionsCollection[select.selectedIndex];
                                _this.hideErrorMessageForTastingRewards();
                                var validateTastingRewardsRequest = {
                                    numberOfRewards: Number(getSelectedOption_2.value),
                                    customerId: Number(customerId)
                                };
                                _this.ajax.send({
                                    endpoint: _this.endpoint["customer"]["validateReferralRewards"],
                                    method: "post",
                                    contentType: "json",
                                    data: validateTastingRewardsRequest,
                                    callback: function(responseData) {
                                        try {
                                            var validateTastingRewardsRes = JSON.parse(responseData.response);
                                            if (validateTastingRewardsRes.data.isValid === false) {
                                                _this.showErrorMessageForTastingRewards(validateTastingRewardsRes.data.message);
                                            } else {
                                                var numberOfDiscounts = {
                                                    attributes: {
                                                        wineDiscount: getSelectedOption_2.value
                                                    }
                                                };
                                                _this.cartComponent.updateCartAttributesOrNote(numberOfDiscounts, function(res) {});
                                            }
                                        } catch (error) {
                                            console.error(error);
                                        }
                                    }
                                });
                            }
                        });
                    });
                }
            };
            _this_1.toggleEvent = function() {
                var _this = _this_1;
                var body = document.querySelector("body");
                if (!body.classList.contains("wine_referral_cart_setup")) {
                    body.classList.add("wine_referral_cart_setup");
                    document.addEventListener("change", function(e) {
                        if (_this.isShareCartButtonClicked(e)) {
                            _this.toggleNumberOfRewards();
                        }
                    });
                }
            };
            _this_1.selectShareCartButton = function(current) {
                if (current) {
                    if (current.classList.contains("wine_toggle-rewards_JS")) {
                        return current;
                    } else {
                        return _this_1.generalMethods.getClosestByClass(current, "wine_toggle-rewards_JS");
                    }
                } else {
                    return document.querySelector(".wine_share-cart--generate-url-button_JS");
                }
            };
            _this_1.isShareCartButtonClicked = function(e) {
                return !!_this_1.selectShareCartButton(e.target);
            };
            _this_1.toggleNumberOfRewards = function() {
                var _this = _this_1;
                var toggle = document.querySelector(".wine_toggle-rewards_JS");
                if (!!toggle) {
                    var toggleReward_1 = toggle.checked;
                    _this.toggleRewards(toggleReward_1);
                    toggle.addEventListener("change", function(e) {
                        e.preventDefault();
                        toggleReward_1 = toggle.checked;
                        _this.toggleRewards(toggleReward_1);
                    });
                }
            };
            _this_1.toggleRewards = function(toggleReward) {
                var selectsReward = document.querySelector(".wine_select-tasting-reward_JS");
                var textReward = document.querySelector(".wine_tasting-rewardsText_JS");
                var wrp = document.querySelector(".wine_tasting-rewards-picker-wrp_JS");
                if (toggleReward === false) {
                    if (!!selectsReward && !!textReward) {
                        selectsReward.style.display = "none";
                        textReward.style.display = "none";
                        wrp.style.display = "none";
                    }
                }
                if (toggleReward === true) {
                    if (!!selectsReward && !!textReward) {
                        selectsReward.style.display = "block";
                        textReward.style.display = "block";
                        wrp.style.display = "flex";
                    }
                }
            };
            _this_1.generateTastingRewardsTable = function(rewards) {
                var _this = _this_1;
                var mainRewardTableWrp = document.querySelector(".wine_tasting-rewards-table-render_JS");
                if (!!mainRewardTableWrp) {
                    mainRewardTableWrp.innerHTML = "";
                    var table = document.createElement("table");
                    table.classList.add("wine_rewards-table");
                    table.setAttribute("id", "TASTING_REWARDS");
                    mainRewardTableWrp.appendChild(table);
                    var thead = document.createElement("thead");
                    var trHead = document.createElement("tr");
                    trHead.classList.add("wine_rewards-table-head-row");
                    var thCreationDate = document.createElement("th");
                    thCreationDate.innerHTML = "Creation Date";
                    var thExpirationDate = document.createElement("th");
                    thExpirationDate.innerHTML = "Expiration Date";
                    var thAvailable = document.createElement("th");
                    thAvailable.innerHTML = "Available";
                    trHead.appendChild(thCreationDate);
                    trHead.appendChild(thExpirationDate);
                    trHead.appendChild(thAvailable);
                    thead.appendChild(trHead);
                    table.appendChild(thead);
                    var tbody_1 = document.createElement("tbody");
                    rewards.forEach(function(rew) {
                        var trBody = document.createElement("tr");
                        trBody.classList.add("wine_rewards-table-row");
                        var thCreationDateValue = document.createElement("th");
                        thCreationDateValue.innerHTML = _this.dateFormat(rew.creationDate);
                        var thExpirationDateValue = document.createElement("th");
                        thExpirationDateValue.innerHTML = _this.dateFormat(rew.expirationDate);
                        var thAvailableValue = document.createElement("th");
                        thAvailableValue.innerHTML = rew.availableForUsage;
                        trBody.appendChild(thCreationDateValue);
                        trBody.appendChild(thExpirationDateValue);
                        trBody.appendChild(thAvailableValue);
                        tbody_1.appendChild(trBody);
                    });
                    table.appendChild(tbody_1);
                }
            };
            _this_1.dateFormat = function(dateInput) {
                var date = new Date(dateInput);
                var formatedDate = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
                return formatedDate;
            };
            _this_1.createCrefLink = function() {
                var _a;
                var input = document.querySelector(".wine_account-referral-link_JS");
                if (!!input) {
                    var cref = input.getAttribute("data-cref");
                    var customerType = (_a = window.customerInfoMetafields) === null || _a === void 0 ? void 0 : _a.customerType;
                    var sponsorRef = window.sponsorRef;
                    if (customerType === _features_config_16.ECustomerType.representative) {
                        sponsorRef = localStorage.getItem("webAlias");
                    }
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_16.aliasQueryParam + "=" + sponsorRef + "&" + "cref=" + cref;
                }
            };
            _this_1.copyRefToClipboard = function() {
                var copyRepSiteButtonAll = document.querySelectorAll(".wine_account-referral-link-copy-btn_JS");
                if (!!copyRepSiteButtonAll) {
                    copyRepSiteButtonAll.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            var copyText = document.querySelectorAll(".wine_account-referral-link_JS");
                            if (!!copyText) {
                                copyText.forEach(function(input) {
                                    if (!!input) {
                                        input.select();
                                        navigator.clipboard.writeText(input.value);
                                        input.style.backgroundColor = "rgb(217, 218, 220)";
                                        input.style.transition = "0.2s";
                                        setTimeout(function() {
                                            input.style.backgroundColor = "rgb(249, 249, 249)";
                                        }, 1e3);
                                    }
                                });
                            }
                        });
                    });
                }
            };
            _this_1.customerRewardsTableTitle = function(rewards) {
                var title = document.querySelector(".wine_tasting-rewards-table-title_JS");
                var table = document.querySelector(".wine_tasting-rewards-table-render_JS");
                if (!!title) {
                    if (rewards.length === 0) {
                        title.classList.add("st_hidden");
                        table.classList.add("st_hidden");
                    } else {
                        title.classList.remove("st_hidden");
                        table.classList.remove("st_hidden");
                    }
                }
            };
            _this_1.handleReferralRewards = function() {
                var referralRewardsPrimaryWrapper = document.querySelector(".wine_tasting-content-wrapper_JS");
                if (referralRewardsPrimaryWrapper) {
                    var referralRewardsWrapper_1 = referralRewardsPrimaryWrapper.querySelector(".wine_referral-content--wrapper_JS");
                    var noWineItemsInCart = referralRewardsPrimaryWrapper.querySelector(".wine_no-wine-in-cart");
                    if (noWineItemsInCart) {
                        noWineItemsInCart.remove();
                    }
                    var cartLineItems_1 = [];
                    try {
                        _this_1.ajax.send({
                            endpoint: _this_1.cartComponent.shopifyCartApiEndpoints["get-cart"],
                            method: "GET",
                            contentType: "json",
                            callback: function(res) {
                                try {
                                    var cartObj = JSON.parse(res.response);
                                    var errorMessage = document.createElement("div");
                                    for (var i = 0; i < cartObj.items.length; i++) {
                                        var isInReferralCollection = cartObj.items[i].properties._isInReferralSpendCollection;
                                        cartLineItems_1.push(isInReferralCollection);
                                        var checkItemsInCart = function(arr) {
                                            return arr.every(function(v) {
                                                return v === "false";
                                            });
                                        };
                                        if (checkItemsInCart(cartLineItems_1)) {
                                            referralRewardsWrapper_1.classList.add("st_hidden");
                                            errorMessage.classList.add("wine_no-wine-in-cart");
                                            errorMessage.innerHTML = "You have no Wine Items in Cart.";
                                            errorMessage.style.color = "red";
                                            referralRewardsPrimaryWrapper.appendChild(errorMessage);
                                        } else {
                                            referralRewardsWrapper_1.classList.remove("st_hidden");
                                            errorMessage.remove();
                                        }
                                    }
                                } catch (err) {
                                    console.log("Cart Api Error: ", err);
                                }
                            }
                        });
                    } catch (err) {
                        console.log("Get Cart ---\x3e Error:", err);
                    }
                }
            };
            _this_1.cartComponent = cartComponent;
            _this_1.generalMethods = generalMethods;
            _this_1.themeCart = themeCart;
            _this_1.sponsorService = sponsorService;
            return _this_1;
        }
        return StTasting;
    }(st_module_64.StModule);
    exports.StTasting = StTasting;
});

define("core/shopify-app/st-modules/account-login/account-login-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_65) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountLoginClassConfig = void 0;
    var StAccountLoginClassConfig = function(_super) {
        __extends(StAccountLoginClassConfig, _super);
        function StAccountLoginClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountClassConfig";
            _this.classNamePasswordVisibilityButton = "st_toggle-password-visibility-button_JS";
            _this.selectorPasswordVisibilityButton = "." + _this.classNamePasswordVisibilityButton;
            _this.classLoginPasswordInput = "st_login-password-input_JS";
            _this.selectorLoginPasswordInput = "." + _this.classLoginPasswordInput;
            _this.classLoginPasswordFormControl = "st_login-password-form-control_JS";
            _this.selectorLoginPasswordFormControl = "." + _this.classLoginPasswordFormControl;
            return _this;
        }
        return StAccountLoginClassConfig;
    }(st_module_65.StModule);
    exports.StAccountLoginClassConfig = StAccountLoginClassConfig;
});

define("extension/shopify-app/st-modules/account/blocks/wine-cellar/wine-cellar", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_66, notification_12) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWineCellar = void 0;
    var StWineCellar = function(_super) {
        __extends(StWineCellar, _super);
        function StWineCellar(notification, buttonActions) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StWineCellar";
            _this_1.init = function() {
                var _this = _this_1;
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.handleWineCellarClick();
                });
            };
            _this_1.handleWineCellarClick = function() {
                var _this = _this_1;
                var wineCellarButtons = document.querySelectorAll(".wine_account-wine-cellar_JS");
                wineCellarButtons.forEach(function(wineCellarButton) {
                    wineCellarButton.addEventListener("click", function() {
                        _this.buttonActions.prevent(wineCellarButton);
                        _this.tokenizeWineCellarLink(window.customerShopifyId, function(redirectURL) {
                            window.location.href = redirectURL;
                            _this.buttonActions.allow(wineCellarButton);
                        }, [], function(status, message, wineCellarButton) {
                            _this.buttonActions.allow(wineCellarButton);
                            _this.notification.showNotification(notification_12.ENotificationType.error, "An Error Occurred", message);
                        }, [ wineCellarButton ]);
                    });
                });
            };
            _this_1.tokenizeWineCellarLink = function(customerShopifyId, callback, callbackParams, errorCallback, errorCallbackParams) {
                if (callback === void 0) {
                    callback = function(redirectURL) {};
                }
                if (callbackParams === void 0) {
                    callbackParams = [];
                }
                if (errorCallback === void 0) {
                    errorCallback = function(status, message) {};
                }
                if (errorCallbackParams === void 0) {
                    errorCallbackParams = [];
                }
                var _this = _this_1;
                _this.ajax.send({
                    endpoint: _this.endpoint["customer"]["generateSSOForWineCellar"],
                    method: "post",
                    contentType: "json",
                    data: {
                        shopifyCustomerId: customerShopifyId
                    },
                    callback: function(response) {
                        try {
                            var wineCellarResponse = JSON.parse(response.response);
                            if (wineCellarResponse.status === 200) {
                                callback.apply(void 0, __spreadArray([ wineCellarResponse.data.redirectUrl ], callbackParams, false));
                            } else {
                                errorCallback.apply(void 0, __spreadArray([ wineCellarResponse.status, wineCellarResponse.message ], errorCallbackParams, false));
                            }
                        } catch (error) {
                            errorCallback.apply(void 0, __spreadArray([ 500, error.message ], errorCallbackParams, false));
                        }
                    }
                });
            };
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            return _this_1;
        }
        return StWineCellar;
    }(st_module_66.StModule);
    exports.StWineCellar = StWineCellar;
});

define("extension/shopify-app/st-modules/account/blocks/manage-subscriptions/manage-subscriptions", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_67) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StManageSubscriptions = void 0;
    var StManageSubscriptions = function(_super) {
        __extends(StManageSubscriptions, _super);
        function StManageSubscriptions(notification, buttonActions) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StManageSubscriptions";
            _this_1.init = function() {
                var _this = _this_1;
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.handleManageSubscriptions();
                });
            };
            _this_1.handleManageSubscriptions = function() {
                var _this = _this_1;
                var manageSubscriptionLink = document.querySelector(".wine_account-manage-subscriptions_JS");
                var subscriptionError = document.querySelector(".wine_account-subscription-error_JS");
                var manageSubscriptionsBody = document.querySelector(".wine_active-subscriptions-body_JS");
                console.log("ALO BREEEEEEEEEEEEEE" + manageSubscriptionLink);
                if (manageSubscriptionLink) {
                    var customerShopifyId = window.customerShopifyId;
                    var manageSubscriptionData = {
                        customerId: customerShopifyId
                    };
                    _this.ajax.send({
                        endpoint: _this.endpoint["customer"]["getAwtomicCustomerPortalLink"],
                        method: "post",
                        contentType: "json",
                        data: manageSubscriptionData,
                        callback: function(response) {
                            try {
                                var manageSubscriptionsResponse = JSON.parse(response.response);
                                if (manageSubscriptionsResponse.status === 200) {
                                    subscriptionError.classList.add("st_hidden");
                                    var urlToRedirect = "/apps/winehub";
                                    manageSubscriptionLink.href = urlToRedirect;
                                } else {
                                    subscriptionError.classList.remove("st_hidden");
                                    manageSubscriptionsBody.classList.add("st_hidden");
                                }
                            } catch (error) {
                                subscriptionError.classList.remove("st_hidden");
                                manageSubscriptionsBody.classList.add("st_hidden");
                                console.error(error);
                            }
                        }
                    });
                }
            };
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            return _this_1;
        }
        return StManageSubscriptions;
    }(st_module_67.StModule);
    exports.StManageSubscriptions = StManageSubscriptions;
});

define("extension/shopify-app/st-modules/account/blocks/samplers/account-samplers-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_68) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountSamplersClassConfig = void 0;
    var StAccountSamplersClassConfig = function(_super) {
        __extends(StAccountSamplersClassConfig, _super);
        function StAccountSamplersClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountClassConfig";
            _this.classNameWineSamplersPageWrapper = "wine_samplers-add-new-sampler-tab_JS";
            _this.selectorWineSamplersPageWrapper = "." + _this.classNameWineSamplersPageWrapper;
            _this.classNameWineSamplersAdditionalItems = "wine_samplers-add-additional-items_JS";
            _this.selectorWineSamplersAdditionalItems = "." + _this.classNameWineSamplersAdditionalItems;
            _this.classNameAdditionalItemsWrapper = "wine_samplers-add-additional-items-primary--wrapper_JS";
            _this.selectorAdditionalItemsWrapper = "." + _this.classNameAdditionalItemsWrapper;
            _this.classNameAdditionalItemsOverlay = "wine_samplers-add-additional-items-overlay_JS";
            _this.selectorAdditionalItemsOverlay = "." + _this.classNameAdditionalItemsOverlay;
            _this.classNameAdditionalItemsSingleItemWrapper = "wine_samplers-single-item--wrapper_JS";
            _this.selectorAdditionalItemsSingleItemWrapper = "." + _this.classNameAdditionalItemsSingleItemWrapper;
            _this.classNameAdditionalItemsInnerWrapper = "wine_samplers-add-additional-items-inner--wrapper_JS";
            _this.selectorAdditionalItemsInnerWrapper = "." + _this.classNameAdditionalItemsInnerWrapper;
            _this.classNameAddedItemsWrapper = "wine_samplers-added-items--wrapper_JS";
            _this.selectorAddedItemsWrapper = "." + _this.classNameAddedItemsWrapper;
            _this.classNameAdditionalItemsInput = "wine_sampler-quantity-input_JS";
            _this.selectorAdditionalItemsInput = "." + _this.classNameAdditionalItemsInput;
            _this.classNameAddedItemWrapper = "wine_added-item--wrapper_JS";
            _this.selectorAddedItemWrapper = "." + _this.classNameAddedItemWrapper;
            _this.classNameStoredSelectedItems = "wine_store-selected-additional-items_JS";
            _this.selectorStoredSelectedItems = "." + _this.classNameStoredSelectedItems;
            _this.classNameClosePopup = "wine_sampler-close-popup_JS";
            _this.selectorClosePopup = "." + _this.classNameClosePopup;
            _this.classNameSaveChanges = "wine_sampler-save-items_JS";
            _this.selectorSaveChanges = "." + _this.classNameSaveChanges;
            _this.classNameQuantityPicker = "wine_samplers-quantity-picker_JS";
            _this.selectorQuantityPicker = "." + _this.classNameQuantityPicker;
            _this.classNameIncrementButton = "wine_sampler-increment-button_JS";
            _this.selectorIncrementButton = "." + _this.classNameIncrementButton;
            _this.classNameDecrementButton = "wine_sampler-decrement-button_JS";
            _this.selectorDecrementButton = "." + _this.classNameDecrementButton;
            _this.classNameDatePicker = "wine_shipping-date-picker-input_JS";
            _this.selectorDatePicker = "." + _this.classNameDatePicker;
            return _this;
        }
        return StAccountSamplersClassConfig;
    }(st_module_68.StModule);
    exports.StAccountSamplersClassConfig = StAccountSamplersClassConfig;
});

define("extension/shopify-app/st-modules/account/blocks/samplers/account-samplers", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency", "_features.config" ], function(require, exports, st_module_69, currency_2, _features_config_17) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountSamplers = void 0;
    var StAccountSamplers = function(_super) {
        __extends(StAccountSamplers, _super);
        function StAccountSamplers(classConfig, generalMethods, buttonActions, currency) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountSamplers";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.handleOpenSamplerAdditionalItemPopup();
                    _this_1.handleClosePopupClick();
                    _this_1.getAffiliateData();
                    _this_1.handleSaveItemsClick();
                    _this_1.handleQuantityPickerSetup();
                    _this_1.handleButtonStateIfLimitIsReached();
                });
            };
            _this_1.handleOpenSamplerAdditionalItemPopup = function() {
                var _this = _this_1;
                var additionalItemButtons = document.querySelectorAll(_this_1.classConfig.selectorWineSamplersAdditionalItems);
                additionalItemButtons.forEach(function(button) {
                    button.addEventListener("click", function() {
                        var addAdditionalItemWrapper = document.querySelector(_this.classConfig.selectorAdditionalItemsWrapper);
                        var addAdditionalItemOverlay = document.querySelector(_this.classConfig.selectorAdditionalItemsOverlay);
                        _this.openAdditionalItemsPopup(addAdditionalItemWrapper, addAdditionalItemOverlay);
                        _this.disableDocumentScroll();
                    });
                });
            };
            _this_1.handleClosePopupClick = function() {
                var _this = _this_1;
                var closePopupEl = document.querySelectorAll(_this_1.classConfig.selectorClosePopup);
                closePopupEl.forEach(function(el) {
                    el.addEventListener("click", function() {
                        _this.closePopupHandle();
                        _this.enableDocumentScroll();
                    });
                });
            };
            _this_1.handleSaveItemsClick = function() {
                var _this = _this_1;
                var addedItemsWrapper = document.querySelector(_this.classConfig.selectorAddedItemsWrapper);
                var saveChangesButton = document.querySelectorAll(_this_1.classConfig.selectorSaveChanges);
                saveChangesButton.forEach(function(button) {
                    button.addEventListener("click", function() {
                        addedItemsWrapper.replaceChildren();
                        _this.buttonActions.prevent(this);
                        var addedItems = _this.isItemSelected();
                        addedItems.forEach(function(item) {
                            var imageEl = document.querySelector('[data-sampler-image-holder="'.concat(item.productId, '"]'));
                            var titleEl = document.querySelector('[data-sampler-title-holder="'.concat(item.productId, '"]'));
                            var priceEl = document.querySelector('[data-sampler-price-holder="'.concat(item.productId, '"]'));
                            var imageUrl = imageEl ? imageEl.src : "";
                            var title = titleEl ? titleEl.innerHTML : "";
                            var priceRaw = priceEl ? parseInt(priceEl.getAttribute("data-sampler-price-row")) : 0;
                            var priceMultipliedByQuantity = priceRaw * item.quantity;
                            var fixedPrice = (priceMultipliedByQuantity / 100).toFixed(2);
                            var finalPrice = _this.currency.applyFormat(parseFloat(fixedPrice), currency_2.ECurrencyFormatType.withCurrency);
                            var printAdditionalSampleItem = {
                                productId: item.productId.toString(),
                                image: imageUrl,
                                title: title,
                                quantity: item.quantity.toString(),
                                price: finalPrice
                            };
                            if (addedItemsWrapper) {
                                var newItems = _this.generateSamplerItems(printAdditionalSampleItem);
                                addedItemsWrapper.appendChild(newItems);
                                addedItemsWrapper.classList.remove("st_hidden");
                            }
                        });
                        _this.buttonActions.allow(this);
                        _this.enableDocumentScroll();
                        _this.closePopupHandle();
                    });
                });
            };
            _this_1.isItemSelected = function() {
                var additionalItems = [];
                var quantityInputs = document.querySelectorAll(_this_1.classConfig.selectorAdditionalItemsInput);
                quantityInputs.forEach(function(input) {
                    var currentValue = parseFloat(input.value);
                    if (currentValue > 0) {
                        var closestWrapper = _this_1.generalMethods.getClosestByClass(input, _this_1.classConfig.classNameAdditionalItemsSingleItemWrapper);
                        var productId = closestWrapper.getAttribute("data-product-id");
                        additionalItems.push({
                            productId: parseFloat(productId),
                            quantity: currentValue
                        });
                        var setChosenItems = document.querySelector(_this_1.classConfig.selectorStoredSelectedItems);
                        setChosenItems.value = JSON.stringify(additionalItems);
                        setChosenItems.setAttribute("value", setChosenItems.value);
                    }
                });
                return additionalItems;
            };
            _this_1.generateSamplerItems = function(productInfo) {
                var wrap = document.createElement("div");
                wrap.classList.add("wine_added-item--wrapper", "wine_added-item--wrapper_JS");
                wrap.setAttribute("data-sampler-id", productInfo.productId);
                var imageTitleWrapper = document.createElement("div");
                imageTitleWrapper.classList.add("wine_added-item-row");
                var imageWrapper = document.createElement("div");
                var image = document.createElement("img");
                image.src = productInfo.image;
                image.alt = productInfo.title;
                var titleWrapper = document.createElement("div");
                titleWrapper.classList.add("wine_added-item-inner-row");
                var titlePlaceholder = document.createElement("div");
                titlePlaceholder.innerHTML = "Title:";
                titlePlaceholder.classList.add("wine_bold");
                var title = document.createElement("div");
                title.innerHTML = productInfo.title;
                var quantityPriceWrapper = document.createElement("div");
                quantityPriceWrapper.classList.add("wine_added-item-row");
                var quantityWrapper = document.createElement("div");
                quantityWrapper.classList.add("wine_added-item-inner-row");
                var quantityPlaceholder = document.createElement("div");
                quantityPlaceholder.innerHTML = "Quantity:";
                quantityPlaceholder.classList.add("wine_bold");
                var quantity = document.createElement("div");
                quantity.innerHTML = productInfo.quantity;
                var priceWrapper = document.createElement("div");
                priceWrapper.classList.add("wine_added-item-inner-row");
                var pricePlaceholder = document.createElement("div");
                pricePlaceholder.innerHTML = "Price:";
                pricePlaceholder.classList.add("wine_bold");
                var price = document.createElement("div");
                price.innerHTML = productInfo.price;
                var deleteButton = document.createElement("button");
                deleteButton.setAttribute("type", "button");
                deleteButton.classList.add("wine_added-item-delete-button");
                var svgIcon = _this_1.createDeleteIcon();
                _this_1.deleteAddedItemClickHandle(deleteButton);
                imageTitleWrapper.appendChild(imageWrapper);
                imageTitleWrapper.appendChild(titleWrapper);
                imageWrapper.appendChild(image);
                titleWrapper.appendChild(titlePlaceholder);
                titleWrapper.appendChild(title);
                quantityPriceWrapper.appendChild(quantityWrapper);
                quantityPriceWrapper.appendChild(priceWrapper);
                quantityWrapper.appendChild(quantityPlaceholder);
                quantityWrapper.appendChild(quantity);
                priceWrapper.appendChild(pricePlaceholder);
                priceWrapper.appendChild(price);
                deleteButton.appendChild(svgIcon);
                wrap.appendChild(imageTitleWrapper);
                wrap.appendChild(quantityPriceWrapper);
                wrap.appendChild(deleteButton);
                return wrap;
            };
            _this_1.deleteAddedItemClickHandle = function(button) {
                var _this = _this_1;
                button.addEventListener("click", function() {
                    var closestPageWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameWineSamplersPageWrapper);
                    var closestItemWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameAddedItemWrapper);
                    var additionalItemsInputStorage = closestPageWrapper.querySelector(_this.classConfig.selectorStoredSelectedItems);
                    var deletedItemId = parseFloat(closestItemWrapper.getAttribute("data-sampler-id"));
                    var originalItemsArray = JSON.parse(additionalItemsInputStorage.value);
                    var deletedItem = originalItemsArray.find(function(el) {
                        return el.productId === deletedItemId;
                    });
                    var foundIndex = originalItemsArray.indexOf(deletedItem);
                    if (foundIndex != -1) {
                        originalItemsArray.splice(foundIndex, 1);
                        additionalItemsInputStorage.value = JSON.stringify(originalItemsArray);
                    }
                    closestItemWrapper.remove();
                    _this.removedAllAddedItems();
                });
            };
            _this_1.removedAllAddedItems = function() {
                var addedItemsWrapper = document.querySelector(_this_1.classConfig.selectorAddedItemsWrapper);
                if (addedItemsWrapper.children.length === 0) {
                    addedItemsWrapper.classList.add("st_hidden");
                }
            };
            _this_1.createDeleteIcon = function() {
                var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                var pathCircle = document.createElementNS("http://www.w3.org/2000/svg", "path");
                svg.setAttribute("width", "24");
                svg.setAttribute("height", "24");
                svg.setAttribute("viewBox", "0 -960 960 960");
                pathCircle.setAttribute("d", "M292.309-140.001q-29.827 0-51.067-21.241-21.241-21.24-21.241-51.067V-720h-10q-12.75 0-21.375-8.629-8.625-8.628-8.625-21.384 0-12.755 8.625-21.37 8.625-8.616 21.375-8.616H360q0-14.692 10.346-25.038t25.038-10.346h169.232q14.692 0 25.038 10.346T600-779.999h149.999q12.75 0 21.375 8.629t8.625 21.384q0 12.756-8.625 21.371Q762.749-720 749.999-720h-10v507.691q0 29.827-21.241 51.067-21.24 21.241-51.067 21.241H292.309ZM680-720H280v507.691q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462h375.382q5.385 0 8.847-3.462 3.462-3.462 3.462-8.847V-720ZM406.168-280q12.755 0 21.37-8.625 8.616-8.625 8.616-21.374v-300.002q0-12.749-8.629-21.374Q418.896-640 406.141-640q-12.756 0-21.371 8.625-8.615 8.625-8.615 21.374v300.002q0 12.749 8.629 21.374Q393.412-280 406.168-280Zm147.691 0q12.756 0 21.371-8.625 8.615-8.625 8.615-21.374v-300.002q0-12.749-8.629-21.374Q566.588-640 553.832-640q-12.755 0-21.37 8.625-8.616 8.625-8.616 21.374v300.002q0 12.749 8.629 21.374Q541.104-280 553.859-280ZM280-720v520-520Z");
                pathCircle.setAttribute("fill", "currentColor");
                svg.append(pathCircle);
                return svg;
            };
            _this_1.handleQuantityPickerSetup = function() {
                _this_1.handleIncrementClick();
                _this_1.handleDecrementClick();
                _this_1.handleQuantityChange();
            };
            _this_1.handleIncrementClick = function() {
                var _this = _this_1;
                var incrementButtons = document.querySelectorAll(_this_1.classConfig.selectorIncrementButton);
                incrementButtons.forEach(function(button) {
                    button.addEventListener("click", function() {
                        var closestWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameQuantityPicker);
                        var quantityInput = closestWrapper.querySelector(_this.classConfig.selectorAdditionalItemsInput);
                        var parsedValue = parseFloat(quantityInput.value);
                        var finalValue = (parsedValue + 1).toString();
                        if (finalValue <= _features_config_17.samplerAdditionalItemQuantityLimit) {
                            quantityInput.value = finalValue;
                            quantityInput.setAttribute("value", finalValue);
                        }
                        _this.handleButtonStateIfLimitIsReached();
                    });
                });
            };
            _this_1.handleDecrementClick = function() {
                var _this = _this_1;
                var decrementButtons = document.querySelectorAll(_this_1.classConfig.selectorDecrementButton);
                decrementButtons.forEach(function(button) {
                    button.addEventListener("click", function() {
                        var closestWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameQuantityPicker);
                        var quantityInput = closestWrapper.querySelector(_this.classConfig.selectorAdditionalItemsInput);
                        var parsedValue = parseFloat(quantityInput.value);
                        var finalValue = (parsedValue - 1).toString();
                        if (finalValue < "0") {
                            quantityInput.value = "0";
                            quantityInput.setAttribute("value", "0");
                        } else {
                            _this.enableIncrementButtons();
                            quantityInput.value = finalValue;
                            quantityInput.setAttribute("value", finalValue);
                        }
                    });
                });
            };
            _this_1.handleQuantityChange = function() {
                var _this = _this_1;
                var quantityInputs = document.querySelectorAll(_this_1.classConfig.selectorAdditionalItemsInput);
                quantityInputs.forEach(function(input) {
                    input.addEventListener("input", function() {
                        _this.changeInputQuantity(this);
                    });
                    input.addEventListener("change", function() {
                        _this.changeInputQuantity(this);
                    });
                    input.addEventListener("paste", function() {
                        _this.changeInputQuantity(this);
                    });
                });
            };
            _this_1.changeInputQuantity = function(input) {
                var regexValue = _this_1.onlyNumberRegex(input);
                if (regexValue) {
                    var parsedValue = parseInt(regexValue);
                    var quantityLimit = parseInt(_features_config_17.samplerAdditionalItemQuantityLimit);
                    if (parsedValue > quantityLimit) {
                        input.value = "0";
                        input.setAttribute("value", "0");
                    } else if (isNaN(parsedValue) || regexValue === "") {
                        input.value = "0";
                        input.setAttribute("value", "0");
                    } else {
                        input.value = parsedValue.toString();
                        input.setAttribute("value", parsedValue.toString());
                    }
                    _this_1.handleButtonStateIfLimitIsReached(input);
                }
            };
            _this_1.handleButtonStateIfLimitIsReached = function(input) {
                var totalSumOfAllInputs = _this_1.calculateIsLimitReached();
                if (totalSumOfAllInputs != null && totalSumOfAllInputs.toString() === _features_config_17.samplerAdditionalItemQuantityLimit) {
                    _this_1.disabledIncrementButtons();
                } else if (totalSumOfAllInputs != null && totalSumOfAllInputs.toString() > _features_config_17.samplerAdditionalItemQuantityLimit) {
                    input.value = "0";
                    input.setAttribute("value", "0");
                    _this_1.enableIncrementButtons();
                } else {
                    _this_1.enableIncrementButtons();
                }
            };
            _this_1.onlyNumberRegex = function(inputField) {
                var inputValue = inputField.value.replace(/[^\d+$]+/, "");
                return inputValue === "" ? "0" : inputValue;
            };
            _this_1.calculateIsLimitReached = function() {
                var productsWrapper = document.querySelector(_this_1.classConfig.selectorAdditionalItemsInnerWrapper);
                if (productsWrapper) {
                    var quantityInputs = productsWrapper.querySelectorAll(_this_1.classConfig.selectorAdditionalItemsInput);
                    var totalSumOfAllInputs_1 = 0;
                    var numArray_1 = [];
                    quantityInputs.forEach(function(input) {
                        numArray_1.push(parseFloat(input.value));
                    });
                    numArray_1.forEach(function(el) {
                        return totalSumOfAllInputs_1 += el;
                    });
                    return totalSumOfAllInputs_1;
                } else {
                    return null;
                }
            };
            _this_1.disabledIncrementButtons = function() {
                var quantityButtons = document.querySelectorAll(_this_1.classConfig.selectorIncrementButton);
                quantityButtons.forEach(function(button) {
                    button.disabled = true;
                });
            };
            _this_1.enableIncrementButtons = function() {
                var quantityButtons = document.querySelectorAll(_this_1.classConfig.selectorIncrementButton);
                quantityButtons.forEach(function(button) {
                    button.disabled = false;
                });
            };
            _this_1.closePopupHandle = function() {
                var addAdditionalItemWrapper = document.querySelector(_this_1.classConfig.selectorAdditionalItemsWrapper);
                var addAdditionalItemOverlay = document.querySelector(_this_1.classConfig.selectorAdditionalItemsOverlay);
                _this_1.closeAdditionalItemsPopup(addAdditionalItemWrapper, addAdditionalItemOverlay);
            };
            _this_1.disableDocumentScroll = function() {
                document.body.style.overflow = "hidden";
            };
            _this_1.enableDocumentScroll = function() {
                document.body.style.overflow = "visible";
            };
            _this_1.openAdditionalItemsPopup = function(wrapper, overlay) {
                wrapper.classList.remove("st_hidden");
                overlay.classList.remove("st_hidden");
            };
            _this_1.closeAdditionalItemsPopup = function(wrapper, overlay) {
                wrapper.classList.add("st_hidden");
                overlay.classList.add("st_hidden");
            };
            _this_1.getAffiliateData = function() {
                var _this = _this_1;
                var params = new URLSearchParams(document.location.search);
                var refCode = params.get("ref");
                var affiliateData = {
                    referralCode: refCode
                };
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["customer"]["contactAffiliate"],
                    method: "POST",
                    data: affiliateData,
                    callback: function(res) {
                        var searchCustomer = res.response !== "" || res.response !== null ? JSON.parse(res.response) : res;
                        if ((searchCustomer === null || searchCustomer === void 0 ? void 0 : searchCustomer.status) == 200) {
                            if (searchCustomer.data.phone) {
                                _this.showPhoneTitle();
                                _this.getOperatingSystem(searchCustomer.data.phone);
                            } else {
                                _this.linkIosHide();
                                _this.linkAndroidHide();
                            }
                            if (searchCustomer.data.email) {
                                _this.showEmailTitle();
                                _this.emailLink(searchCustomer.data.email);
                                var emailLink = document.querySelector(".wine_account-samplers-email-anchor_JS");
                                if (!!emailLink) {
                                    emailLink.style.display = "block";
                                }
                            } else {
                                var emailLink = document.querySelector(".wine_account-samplers-email-anchor_JS");
                                if (!!emailLink) {
                                    emailLink.style.display = "none";
                                }
                            }
                        } else {}
                    }
                });
            };
            _this_1.showPhoneTitle = function() {
                var phoneTitle = document.querySelector(".wine_account-samplers-phone-title_JS");
                if (!!phoneTitle) {
                    phoneTitle.style.display = "block";
                }
            };
            _this_1.showEmailTitle = function() {
                var phoneTitle = document.querySelector(".wine_account-samplers-email-title_JS");
                if (!!phoneTitle) {
                    phoneTitle.style.display = "block";
                }
            };
            _this_1.getOperatingSystem = function(phone) {
                var _this = _this_1;
                var userAgent = navigator.userAgent || navigator.vendor || window.opera;
                if (/windows phone/i.test(userAgent)) {
                    _this.smsAndroidLink(phone);
                    _this.linkIosHide();
                    return "Windows Phone";
                }
                if (/windows/i.test(userAgent)) {
                    _this.smsAndroidLink(phone);
                    _this.linkIosHide();
                    return "Windows";
                }
                if (/android/i.test(userAgent)) {
                    _this.smsAndroidLink(phone);
                    _this.linkIosHide();
                    return "Android";
                }
                if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    _this.smsIOSLink(phone);
                    _this.linkAndroidHide();
                    return "iOS";
                }
                if (/mac/i.test(userAgent)) {
                    _this.smsIOSLink(phone);
                    _this.linkAndroidHide();
                    return "Mac";
                }
                if (/linux/i.test(userAgent)) {
                    _this.smsAndroidLink(phone);
                    _this.linkIosHide();
                    return "Linux";
                }
                return "unknown";
            };
            _this_1.linkIosHide = function() {
                var iosLink = document.querySelector(".wine_account-samplers-phone-anchor-ios_JS");
                if (!!iosLink) {
                    iosLink.style.display = "none";
                }
            };
            _this_1.linkAndroidHide = function() {
                var androidLink = document.querySelector(".wine_account-samplers-phone-anchor-android_JS");
                if (!!androidLink) {
                    androidLink.style.display = "none";
                }
            };
            _this_1.smsAndroidLink = function(phone) {
                var bannerWrapper = document.querySelector(".wine_account-samplers-account-main-wrapper_JS");
                if (!!bannerWrapper) {
                    var name_1 = bannerWrapper.getAttribute("data-customer-name");
                    var shop = bannerWrapper.getAttribute("data-shop");
                    var nameEncoded = encodeURIComponent(name_1);
                    var shopEncoded = encodeURIComponent(shop);
                    var androidLink = document.querySelector(".wine_account-samplers-phone-anchor-android_JS");
                    if (!!androidLink) {
                        androidLink.style.display = "flex";
                        androidLink.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="22.292" height="21.751" viewBox="0 0 22.292 21.751">\n' + '  <g id="Group_5903" data-name="Group 5903" transform="translate(0 0)">\n' + '    <path id="sms_FILL0_wght300_GRAD0_opsz24" d="M106.454-850.161a1,1,0,0,0,.734-.3,1,1,0,0,0,.3-.734,1,1,0,0,0-.3-.734,1,1,0,0,0-.734-.3,1,1,0,0,0-.734.3,1,1,0,0,0-.3.734,1,1,0,0,0,.3.734A1,1,0,0,0,106.454-850.161Zm4.693,0a1,1,0,0,0,.734-.3,1,1,0,0,0,.3-.734,1,1,0,0,0-.3-.734,1,1,0,0,0-.734-.3,1,1,0,0,0-.734.3,1,1,0,0,0-.3.734,1,1,0,0,0,.3.734A1,1,0,0,0,111.147-850.161Zm4.693,0a1,1,0,0,0,.734-.3,1,1,0,0,0,.3-.734,1,1,0,0,0-.3-.734,1,1,0,0,0-.734-.3,1,1,0,0,0-.734.3,1,1,0,0,0-.3.734,1,1,0,0,0,.3.734A1,1,0,0,0,115.84-850.161ZM100-838.248v-19.63a2.048,2.048,0,0,1,.616-1.505,2.047,2.047,0,0,1,1.5-.616h18.051a2.047,2.047,0,0,1,1.5.616,2.048,2.048,0,0,1,.616,1.505v13.357a2.047,2.047,0,0,1-.616,1.505,2.047,2.047,0,0,1-1.5.616h-16.02Zm3.4-5.912h16.769a.345.345,0,0,0,.248-.113.345.345,0,0,0,.113-.248v-13.357a.345.345,0,0,0-.113-.248.345.345,0,0,0-.248-.113H102.122a.345.345,0,0,0-.248.113.345.345,0,0,0-.113.248v15.343Zm-1.643,0v0Z" transform="translate(-100.001 859.999)" fill="#9a9b9c"/>\n' + "  </g>\n" + "</svg>";
                        androidLink.href = "sms:".concat(phone, "?body=Hey! ").concat(nameEncoded, " has prepared a cart for you at ").concat(shopEncoded, "? Check out your cart! ") + " .";
                    }
                }
            };
            _this_1.smsIOSLink = function(phone) {
                var bannerWrapper = document.querySelector(".wine_account-samplers-account-main-wrapper_JS");
                if (!!bannerWrapper) {
                    var name_2 = bannerWrapper.getAttribute("data-customer-name");
                    var shop = bannerWrapper.getAttribute("data-shop");
                    var nameEncoded = encodeURIComponent(name_2);
                    var shopEncoded = encodeURIComponent(shop);
                    var iosLink = document.querySelector(".wine_account-samplers-phone-anchor-ios_JS");
                    if (!!iosLink) {
                        iosLink.style.display = "flex";
                        iosLink.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="22.292" height="21.751" viewBox="0 0 22.292 21.751">\n' + '  <g id="Group_5903" data-name="Group 5903" transform="translate(0 0)">\n' + '    <path id="sms_FILL0_wght300_GRAD0_opsz24" d="M106.454-850.161a1,1,0,0,0,.734-.3,1,1,0,0,0,.3-.734,1,1,0,0,0-.3-.734,1,1,0,0,0-.734-.3,1,1,0,0,0-.734.3,1,1,0,0,0-.3.734,1,1,0,0,0,.3.734A1,1,0,0,0,106.454-850.161Zm4.693,0a1,1,0,0,0,.734-.3,1,1,0,0,0,.3-.734,1,1,0,0,0-.3-.734,1,1,0,0,0-.734-.3,1,1,0,0,0-.734.3,1,1,0,0,0-.3.734,1,1,0,0,0,.3.734A1,1,0,0,0,111.147-850.161Zm4.693,0a1,1,0,0,0,.734-.3,1,1,0,0,0,.3-.734,1,1,0,0,0-.3-.734,1,1,0,0,0-.734-.3,1,1,0,0,0-.734.3,1,1,0,0,0-.3.734,1,1,0,0,0,.3.734A1,1,0,0,0,115.84-850.161ZM100-838.248v-19.63a2.048,2.048,0,0,1,.616-1.505,2.047,2.047,0,0,1,1.5-.616h18.051a2.047,2.047,0,0,1,1.5.616,2.048,2.048,0,0,1,.616,1.505v13.357a2.047,2.047,0,0,1-.616,1.505,2.047,2.047,0,0,1-1.5.616h-16.02Zm3.4-5.912h16.769a.345.345,0,0,0,.248-.113.345.345,0,0,0,.113-.248v-13.357a.345.345,0,0,0-.113-.248.345.345,0,0,0-.248-.113H102.122a.345.345,0,0,0-.248.113.345.345,0,0,0-.113.248v15.343Zm-1.643,0v0Z" transform="translate(-100.001 859.999)" fill="#9a9b9c"/>\n' + "  </g>\n" + "</svg>";
                        iosLink.href = "sms:".concat(phone, "&body=Hey! ").concat(nameEncoded, " has prepared a cart for you at ").concat(shopEncoded, "? Check out your cart! ") + " .";
                    }
                }
            };
            _this_1.emailLink = function(email) {
                var bannerWrapper = document.querySelector(".wine_account-samplers-account-main-wrapper_JS");
                if (!!bannerWrapper) {
                    var name_3 = bannerWrapper.getAttribute("data-customer-name");
                    var shop = bannerWrapper.getAttribute("data-shop");
                    var nameEncoded = encodeURIComponent(name_3);
                    var shopEncoded = encodeURIComponent(shop);
                    var emailLink = document.querySelector(".wine_account-samplers-email-anchor_JS");
                    if (!!emailLink) {
                        emailLink.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="22.292" height="17.599" viewBox="0 0 22.292 17.599">\n' + '  <g id="Group_5904" data-name="Group 5904" transform="translate(0 0)">\n' + '    <path id="mail_FILL0_wght300_GRAD0_opsz24_1_" data-name="mail_FILL0_wght300_GRAD0_opsz24 (1)" d="M102.122-762.4a2.047,2.047,0,0,1-1.5-.616,2.047,2.047,0,0,1-.616-1.505v-13.357a2.047,2.047,0,0,1,.616-1.5,2.047,2.047,0,0,1,1.5-.616h18.051a2.047,2.047,0,0,1,1.5.616,2.047,2.047,0,0,1,.616,1.5v13.357a2.047,2.047,0,0,1-.616,1.505,2.047,2.047,0,0,1-1.5.616Zm9.025-8.145-9.386-6v12.026a.351.351,0,0,0,.1.26.352.352,0,0,0,.26.1h18.051a.352.352,0,0,0,.259-.1.351.351,0,0,0,.1-.26v-12.026Zm0-1.828,9.206-5.866H101.941Zm-9.386-4.174v12.026a.351.351,0,0,0,.1.26.352.352,0,0,0,.26.1h-.361v-12.387Z" transform="translate(-100.001 779.999)" fill="#9a9b9c"/>\n' + "  </g>\n" + "</svg>";
                        emailLink.href = "mailto:".concat(email, "?subject=Hey!  &body=Check out your cart!");
                    }
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.buttonActions = buttonActions;
            _this_1.currency = currency;
            return _this_1;
        }
        return StAccountSamplers;
    }(st_module_69.StModule);
    exports.StAccountSamplers = StAccountSamplers;
});

define("extension/shopify-app/st-modules/account/blocks/share-cart/render-share-cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_70) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountRenderShareCart = void 0;
    var StAccountRenderShareCart = function(_super) {
        __extends(StAccountRenderShareCart, _super);
        function StAccountRenderShareCart(generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "RenderShareCart";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {});
            };
            _this_1.showDeleteLinkConfirmationBanner = function() {
                var deleteBanner = document.querySelector(".wine_shared-cart-delete-confirmation-banner-full-screen-wrapper_JS");
                if (!!deleteBanner) {
                    deleteBanner.classList.remove("st_hidden");
                    _this_1.scrollOnTop();
                }
            };
            _this_1.hideDeleteLinkConfirmationBanner = function() {
                var deleteBanner = document.querySelector(".wine_shared-cart-delete-confirmation-banner-full-screen-wrapper_JS");
                if (!!deleteBanner) {
                    deleteBanner.classList.add("st_hidden");
                }
            };
            _this_1.hideSharedCartBanner = function() {
                var bannerWrapper = document.querySelector(".wine_shared-cart-link-banner-full-screen-wrapper_JS");
                if (!!bannerWrapper) {
                    bannerWrapper.classList.add("st_hidden");
                    _this_1.deleteShareCartItemsTable();
                }
            };
            _this_1.deleteShareCartItemsTable = function() {
                var tableContainer = document.querySelector(".wine_shared-cart-link-banner-cart-items-table-wrapper_JS");
                if (!!tableContainer) {
                    tableContainer.innerHTML = "";
                }
            };
            _this_1.showSharedCartBanner = function(btn) {
                var bannerWrapper = document.querySelector(".wine_shared-cart-link-banner-full-screen-wrapper_JS");
                if (!!bannerWrapper) {
                    bannerWrapper.classList.remove("st_hidden");
                    var deleteButton = document.querySelector(".wine_shared-cart-link-banner-delete-btn_JS");
                    var rowNumber = btn.getAttribute("data-row-number");
                    deleteButton.setAttribute("data-row-number", rowNumber);
                    _this_1.scrollOnTop();
                }
            };
            _this_1.closeSharedCartBanner = function() {
                var _this = _this_1;
                var closeButton = document.querySelector(".wine_shared-cart-link-banner-close-btn_JS");
                if (!!closeButton) {
                    closeButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.hideSharedCartBanner();
                    });
                }
            };
            _this_1.scrollOnTop = function() {
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            };
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountRenderShareCart;
    }(st_module_70.StModule);
    exports.StAccountRenderShareCart = StAccountRenderShareCart;
});

define("extension/shopify-app/st-modules/account/blocks/share-cart/generators-share-cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_71) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountGeneratorsShareCart = void 0;
    var StAccountGeneratorsShareCart = function(_super) {
        __extends(StAccountGeneratorsShareCart, _super);
        function StAccountGeneratorsShareCart(generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "GeneratorsShareCart";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {});
            };
            _this.createTableHeader = function(table) {
                var tableHeader = document.createElement("thead");
                var tableRow = document.createElement("tr");
                var tableHeaderId = document.createElement("th");
                tableHeaderId.innerHTML = "ID";
                tableRow.appendChild(tableHeaderId);
                var tableHeaderItemsNumber = document.createElement("th");
                tableHeaderItemsNumber.innerHTML = "Number of items";
                tableRow.appendChild(tableHeaderItemsNumber);
                var tableHeaderCreationDate = document.createElement("th");
                tableHeaderCreationDate.innerHTML = "Date Created";
                tableRow.appendChild(tableHeaderCreationDate);
                var tableHeaderLinkUsed = document.createElement("th");
                tableHeaderLinkUsed.innerHTML = "Orders Created";
                tableRow.appendChild(tableHeaderLinkUsed);
                var tableHeaderTokenExpire = document.createElement("th");
                tableHeaderTokenExpire.innerHTML = "Expiry Date";
                tableRow.appendChild(tableHeaderTokenExpire);
                var tableHeaderSubtotal = document.createElement("th");
                tableHeaderSubtotal.classList.add("wine_shared-cart-links-table-th-subtotal");
                tableHeaderSubtotal.innerHTML = "Subtotal";
                tableRow.appendChild(tableHeaderSubtotal);
                var tableHeaderEmptyOne = document.createElement("th");
                tableRow.appendChild(tableHeaderEmptyOne);
                var tableHeaderEmptyTwo = document.createElement("th");
                tableRow.appendChild(tableHeaderEmptyTwo);
                tableHeader.appendChild(tableRow);
                table.appendChild(tableHeader);
            };
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StAccountGeneratorsShareCart;
    }(st_module_71.StModule);
    exports.StAccountGeneratorsShareCart = StAccountGeneratorsShareCart;
});

define("extension/shopify-app/st-modules/account/blocks/share-cart/share-cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_72, notification_13) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountShareCart = void 0;
    var StAccountShareCart = function(_super) {
        __extends(StAccountShareCart, _super);
        function StAccountShareCart(generalMethods, notification, render, generators) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountShareCart";
            _this_1.init = function() {
                var _this = _this_1;
                _this_1.subscribeDOMLoaded(function() {
                    _this.render.closeSharedCartBanner();
                    _this.closeDeleteConfirmationBanner();
                    _this.generateSharedLinkTable();
                    _this.cancelDeleteShareCartLink();
                });
            };
            _this_1.generateSharedLinkTable = function() {
                var _this = _this_1;
                _this_1.deleteSharedCartLinksTable();
                var accountPageWrapper = document.querySelector(".wine_share-cart-table-links-main-wrapper_JS");
                if (!!accountPageWrapper) {
                    var customerId = accountPageWrapper.getAttribute("data-customer-id");
                    var generateShareCartLinksData = {
                        customerId: parseInt(customerId)
                    };
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["cart"]["getShareCarts"],
                        method: "POST",
                        contentType: "json",
                        data: generateShareCartLinksData,
                        callback: function(res, req) {
                            var response = res ? JSON.parse(res.response) : "";
                            var dataSharedLinks = response.data.shareCarts;
                            if (response.status == 200) {
                                var loader = document.querySelector(".wine_shared-cart-links-loader_JS");
                                if (!!loader) {
                                    loader.classList.add("st_hidden");
                                }
                                var tableContainer = document.querySelector(".wine_shared-cart-links-table-wrapper_JS");
                                tableContainer.innerHTML = "";
                                if (tableContainer) {
                                    if (dataSharedLinks.length == 0) {
                                        tableContainer.innerHTML = "You don't have shared carts.";
                                    } else {
                                        var tableContainerInner = document.createElement("div");
                                        tableContainerInner.classList.add("wine_shared-cart-links-table-wrapper-inner");
                                        var table = document.createElement("table");
                                        var tBody = document.createElement("tbody");
                                        table.classList.add("wine_shared-cart-links-table_JS");
                                        table.classList.add("wine_shared-cart-links-table");
                                        tableContainerInner.appendChild(table);
                                        tableContainer.appendChild(tableContainerInner);
                                        _this.generators.createTableHeader(table);
                                        for (var i = 0; i < dataSharedLinks.length; i++) {
                                            var rowNumber = i;
                                            _this.createTableRow(table, tBody, i + 1, dataSharedLinks[i].numberOfItems, dataSharedLinks[i].creationDate, dataSharedLinks[i].numberOfOrdersCreated, dataSharedLinks[i].expirationDate, dataSharedLinks[i].numberOfOrdersCreated, dataSharedLinks[i].subtotal, dataSharedLinks[i].shareCartUrl, rowNumber, dataSharedLinks[i].cartToken);
                                        }
                                        _this.clickSharedLinkId();
                                    }
                                }
                            } else {
                                var loader = document.querySelector(".wine_shared-cart-links-loader_JS");
                                if (!!loader) {
                                    loader.classList.add("st_hidden");
                                }
                            }
                        }
                    });
                }
            };
            _this_1.createTableRow = function(table, tBody, id, numberOfItems, creationDate, linkUsed, tokenExpirationDate, linkAccess, subtotal, shareCartLink, rowNumber, token) {
                var tableRow = document.createElement("tr");
                tableRow.classList.add("wine_shared-cart-links-table-row_JS");
                tableRow.setAttribute("data-row-number", rowNumber);
                var tableId = document.createElement("td");
                tableRow.appendChild(tableId);
                var idBtn = document.createElement("button");
                idBtn.classList.add("wine_shared-cart-links-id-button");
                idBtn.classList.add("wine_shared-cart-links-id-button_JS");
                idBtn.setAttribute("data-row-number", rowNumber);
                idBtn.setAttribute("data-cart-id", id);
                idBtn.setAttribute("data-cart-token", token);
                idBtn.setAttribute("data-cart-creation-date", creationDate);
                idBtn.setAttribute("data-cart-number-of-items", numberOfItems);
                idBtn.setAttribute("data-cart-token-expiration-date", tokenExpirationDate);
                idBtn.setAttribute("data-cart-linkUsed", linkUsed);
                idBtn.setAttribute("data-cart-subtotal", subtotal);
                idBtn.setAttribute("data-cart-link", shareCartLink);
                idBtn.innerHTML = "#" + id;
                var loader = document.createElement("div");
                loader.classList.add("wine_shared-cart-loader-table");
                loader.classList.add("wine_shared-cart-loader-table_JS");
                loader.classList.add("st_hidden");
                tableId.appendChild(idBtn);
                idBtn.appendChild(loader);
                var tableItemsNumber = document.createElement("td");
                tableItemsNumber.innerHTML = numberOfItems;
                tableRow.appendChild(tableItemsNumber);
                var tableCreationDate = document.createElement("td");
                var creationDateFormated = _this_1.parseDateTime(creationDate);
                tableCreationDate.innerHTML = creationDateFormated;
                tableRow.appendChild(tableCreationDate);
                var tableLinkUsed = document.createElement("td");
                tableLinkUsed.innerHTML = linkUsed;
                tableRow.appendChild(tableLinkUsed);
                var tableTokenExpire = document.createElement("td");
                var expireDateFormated = _this_1.parseDateTime(tokenExpirationDate);
                tableTokenExpire.innerHTML = expireDateFormated;
                tableRow.appendChild(tableTokenExpire);
                var tableSubtotal = document.createElement("td");
                tableSubtotal.classList.add("wine_shared-cart-links-table-td-subtotal");
                tableSubtotal.innerHTML = !!subtotal && subtotal !== "" ? "$" + Number(subtotal).toFixed(2) : "";
                tableRow.appendChild(tableSubtotal);
                var tableCopy = document.createElement("td");
                var copyInput = document.createElement("input");
                copyInput.setAttribute("type", "hidden");
                copyInput.classList.add("wine_shared-cart-links-table-share-link-input_JS");
                copyInput.value = window.location.host + "/" + shareCartLink;
                tableCopy.appendChild(copyInput);
                var copyBtn = document.createElement("button");
                copyBtn.classList.add("wine_shared-cart-links-table-copy-link");
                copyBtn.classList.add("wine_shared-cart-links-table-copy-link_JS");
                copyBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="18.824" viewBox="0 0 16 18.824">\n' + '                            <path id="content_copy_FILL0_wght400_GRAD0_opsz24_1_" data-name="content_copy_FILL0_wght400_GRAD0_opsz24 (1)" d="M125.647-864.941a1.813,1.813,0,0,1-1.329-.553,1.813,1.813,0,0,1-.553-1.329v-11.294a1.813,1.813,0,0,1,.553-1.329,1.813,1.813,0,0,1,1.329-.553h8.471a1.813,1.813,0,0,1,1.329.553,1.813,1.813,0,0,1,.553,1.329v11.294a1.812,1.812,0,0,1-.553,1.329,1.813,1.813,0,0,1-1.329.553Zm0-1.882h8.471v-11.294h-8.471Zm-3.765,5.647a1.813,1.813,0,0,1-1.329-.553,1.813,1.813,0,0,1-.553-1.329v-13.176h1.882v13.176h10.353v1.882Zm3.765-5.647v0Z" transform="translate(-120 880)" />\n' + "                        </svg>";
                copyBtn.setAttribute("data-row-number", rowNumber);
                tableCopy.appendChild(copyBtn);
                tableRow.appendChild(tableCopy);
                var tableDelete = document.createElement("td");
                var deleteButton = document.createElement("button");
                deleteButton.classList.add("wine_shared-cart-links-table-delete-link");
                deleteButton.classList.add("wine_shared-cart-links-table-delete-link_JS");
                deleteButton.innerHTML = ' <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18">\n' + '                            <path id="delete_FILL0_wght400_GRAD0_opsz24" d="M163-822a1.926,1.926,0,0,1-1.413-.588A1.926,1.926,0,0,1,161-824v-13h-1v-2h5v-1h6v1h5v2h-1v13a1.926,1.926,0,0,1-.587,1.412A1.926,1.926,0,0,1,173-822Zm10-15H163v13h10Zm-8,11h2v-9h-2Zm4,0h2v-9h-2Zm-6-11v0Z" transform="translate(-160 840)" />\n' + "                        </svg>";
                deleteButton.setAttribute("data-row-number", rowNumber);
                deleteButton.setAttribute("data-cart-id", id);
                deleteButton.setAttribute("data-cart-token", token);
                tableDelete.appendChild(deleteButton);
                tableRow.appendChild(tableDelete);
                tBody.appendChild(tableRow);
                table.appendChild(tBody);
                _this_1.deleteRow(deleteButton);
                _this_1.copyLink();
            };
            _this_1.expiredDateValidation = function(expiretionDate) {
                var date1 = new Date();
                var date2 = new Date(expiretionDate);
                var isValid = false;
                if (date1 < date2) {
                    isValid = true;
                } else if (date1 > date2) {
                    isValid = false;
                } else {
                    if (date1.getTime() <= date2.getTime()) {
                        isValid = true;
                    } else {
                        isValid = false;
                    }
                }
                return isValid;
            };
            _this_1.deleteSharedCartLinksTable = function() {
                var tableContainer = document.querySelector(".wine_shared-cart-links-table-wrapper_JS");
                if (!!tableContainer) {
                    tableContainer.innerHTML = "";
                }
            };
            _this_1.parseDateTime = function(date) {
                var dateType = new Date(date);
                var formatedDate = dateType.getMonth() + 1 + "/" + dateType.getDate() + "/" + dateType.getFullYear() + " ";
                return formatedDate;
            };
            _this_1.deleteRow = function(deleteButton) {
                var _this = _this_1;
                deleteButton.addEventListener("click", function(e) {
                    e.preventDefault();
                    _this.render.showDeleteLinkConfirmationBanner();
                    var num = deleteButton.getAttribute("data-row-number");
                    _this.collectDataInConfirmationBanner(num, deleteButton);
                });
            };
            _this_1.clickSharedLinkId = function() {
                var _this = _this_1;
                var sharedCartIdBtns = document.querySelectorAll(".wine_shared-cart-links-id-button_JS");
                if (!!sharedCartIdBtns) {
                    sharedCartIdBtns.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            var cartId = btn.getAttribute("data-cart-id");
                            var wrapper = document.querySelector(".wine_shared-cart-links-section-wrapper_JS");
                            var cartToken = btn.getAttribute("data-cart-token");
                            var loader = btn.querySelector(".wine_shared-cart-loader-table_JS");
                            if (!!loader) {
                                loader.classList.remove("st_hidden");
                            }
                            var loadingPage = document.querySelector(".wine_loading-page_JS");
                            if (!!loadingPage) {
                                loadingPage.classList.remove("st_hidden");
                            }
                            _this.getCartLinkInfo(this, cartId, cartToken);
                        });
                    });
                }
            };
            _this_1.getCartLinkInfo = function(btn, cartId, cartToken) {
                var _this = _this_1;
                var cartID = Number(cartId);
                var getCartLinkInfoData = {
                    cartToken: cartToken
                };
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["cart"]["getShareCartDetails"],
                    method: "POST",
                    contentType: "json",
                    data: getCartLinkInfoData,
                    callback: function(res, req) {
                        var response = res ? JSON.parse(res.response) : "";
                        if (response.status == 200) {
                            _this.generateSharedCartItemsTable(cartId, btn, response.data);
                            _this.render.showSharedCartBanner(btn);
                            var loader = btn.querySelector(".wine_shared-cart-loader-table_JS");
                            if (!!loader) {
                                loader.classList.add("st_hidden");
                            }
                            var loadingPage = document.querySelector(".wine_loading-page_JS");
                            if (!!loadingPage) {
                                loadingPage.classList.add("st_hidden");
                            }
                        } else {
                            _this.notification.showNotification(notification_13.ENotificationType.error, "Server Error", response.message);
                            var loader = btn.querySelector(".wine_shared-cart-loader-table_JS");
                            if (!!loader) {
                                loader.classList.add("st_hidden");
                            }
                            var loadingPage = document.querySelector(".wine_loading-page_JS");
                            if (!!loadingPage) {
                                loadingPage.classList.add("st_hidden");
                            }
                        }
                    }
                });
            };
            _this_1.copyLink = function() {
                var _this = _this_1;
                var copyLinkButtons = document.querySelectorAll(".wine_shared-cart-links-table-copy-link_JS");
                if (!!copyLinkButtons) {
                    copyLinkButtons.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            var num = btn.getAttribute("data-row-number");
                            var rows = document.querySelectorAll(".wine_shared-cart-links-table-row_JS");
                            if (!!rows) {
                                rows.forEach(function(row) {
                                    var rowNum = row.getAttribute("data-row-number");
                                    if (num === rowNum) {
                                        var input = row.querySelector(".wine_shared-cart-links-table-share-link-input_JS");
                                        if (!!input) {
                                            input.select();
                                            navigator.clipboard.writeText(input.value);
                                            _this.notification.showNotification(notification_13.ENotificationType.success, "Copy Link", "Copied Shared Cart Link to the clipboard!", 5e3, false);
                                        }
                                    }
                                });
                            }
                        });
                    });
                }
            };
            _this_1.deleteCartLinks = function(deleteCartLinkData, row, btnTable) {
                var _this = _this_1;
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["cart"]["deleteShareCart"],
                    method: "POST",
                    contentType: "json",
                    data: deleteCartLinkData,
                    callback: function(res, req) {
                        var response = res ? JSON.parse(res.response) : "";
                        if (response.status == 200) {
                            row.remove();
                            _this.generateSharedLinkTable();
                        } else {}
                        _this.render.hideSharedCartBanner();
                        _this.render.hideDeleteLinkConfirmationBanner();
                        btnTable.removeAttribute("disable");
                        btnTable.style.opacity = "1";
                    }
                });
            };
            _this_1.generateSharedCartItemsTable = function(cartId, btn, dataSharedCart) {
                var _this = _this_1;
                if (!!btn) {
                    var creationDate = btn.getAttribute("data-cart-creation-date");
                    var numberOfItems = btn.getAttribute("data-cart-number-of-items");
                    var tokenExpirationDate = btn.getAttribute("data-cart-token-expiration-date");
                    var linkUsed = btn.getAttribute("data-cart-linkUsed");
                    var subtotal = btn.getAttribute("data-cart-subtotal");
                    var shareCartLink = btn.getAttribute("data-cart-link");
                    var token = btn.getAttribute("data-cart-token");
                    _this.printDataIntoShareLinkBanner(cartId, creationDate, numberOfItems, linkUsed, tokenExpirationDate, subtotal, shareCartLink, token);
                    _this_1.copySharedCartLinkBanner(shareCartLink);
                }
                _this.parseDateTime(dataSharedCart.creationDate);
                var tableContainer = document.querySelector(".wine_shared-cart-link-banner-cart-items-table-wrapper_JS");
                if (tableContainer) {
                    var tableContainerInner = document.createElement("div");
                    tableContainerInner.classList.add("wine_shared-cart-links-table-wrapper-inner");
                    var table = document.createElement("table");
                    table.classList.add("wine_shared-cart-link-banner-cart-items-table_JS");
                    table.classList.add("wine_shared-cart-link-banner-cart-items-table");
                    tableContainerInner.appendChild(table);
                    tableContainer.appendChild(tableContainerInner);
                    _this_1.createSharedCartItemsTableHeader(table);
                    var items = dataSharedCart.items;
                    for (var i = 0; i < items.length; i++) {
                        var total = Number(items[i].price) * Number(items[i].quantity);
                        _this.createSharedCartItemsTableRows(table, items[i].image, items[i].productName, items[i].productVariantName, items[i].quantity, total);
                    }
                }
                _this_1.deleteSharedCartLink();
            };
            _this_1.createSharedCartItemsTableHeader = function(table) {
                var tableRow = document.createElement("tr");
                tableRow.classList.add("wine_shared-cart-link-banner-cart-items-table-header");
                var tableHeaderItem = document.createElement("th");
                tableHeaderItem.classList.add("wine_shared-cart-link-banner-cart-items-table-title-item");
                tableHeaderItem.innerHTML = "Item";
                tableRow.appendChild(tableHeaderItem);
                var tableHeaderVariant = document.createElement("th");
                tableHeaderVariant.classList.add("wine_shared-cart-link-banner-cart-items-table-title");
                tableHeaderVariant.classList.add("wine_shared-cart-link-banner-cart-items-table-title-variant");
                tableHeaderVariant.innerHTML = "Variant";
                tableRow.appendChild(tableHeaderVariant);
                var tableHeaderQuantity = document.createElement("th");
                tableHeaderQuantity.classList.add("wine_shared-cart-link-banner-cart-items-table-title");
                tableHeaderQuantity.classList.add("wine_shared-cart-link-banner-cart-items-table-title-quantity");
                tableHeaderQuantity.innerHTML = "Quantity";
                tableRow.appendChild(tableHeaderQuantity);
                var tableHeaderTotal = document.createElement("th");
                tableHeaderTotal.classList.add("wine_shared-cart-link-banner-cart-items-table-title");
                tableHeaderTotal.classList.add("wine_shared-cart-link-banner-cart-items-table-title-total");
                tableHeaderTotal.innerHTML = "Total";
                tableRow.appendChild(tableHeaderTotal);
                table.appendChild(tableRow);
            };
            _this_1.createSharedCartItemsTableRows = function(table, imageSrc, productName, variant, quantity, total) {
                var tableRow = document.createElement("tr");
                tableRow.classList.add("wine_shared-cart-link-banner-cart-items-table-item-row");
                var tableDataImgAndName = document.createElement("td");
                var imageAndNameWrap = document.createElement("div");
                imageAndNameWrap.classList.add("wine_shared-cart-link-banner-cart-items-table-item-img-wrap");
                tableDataImgAndName.appendChild(imageAndNameWrap);
                var imgWrp = document.createElement("div");
                imgWrp.classList.add("wine_shared-cart-link-banner-item-img-wrap");
                imageAndNameWrap.appendChild(imgWrp);
                var img = document.createElement("img");
                img.classList.add("wine_shared-cart-link-banner-cart-items-table-img");
                img.classList.add("photoswipe__image");
                img.classList.add("lazyautosizes");
                img.classList.add("lazyloaded");
                img.setAttribute("src", imageSrc);
                imgWrp.appendChild(img);
                var productNameWrp = document.createElement("div");
                productNameWrp.classList.add("wine_shared-cart-link-banner-cart-items-table-value-name");
                productNameWrp.innerHTML = productName;
                imageAndNameWrap.appendChild(productNameWrp);
                tableRow.appendChild(tableDataImgAndName);
                var itemVatiant = document.createElement("td");
                itemVatiant.classList.add("wine_shared-cart-link-banner-cart-items-table-value");
                itemVatiant.classList.add("wine_shared-cart-link-banner-cart-items-table-value-variant");
                itemVatiant.innerHTML = variant;
                tableRow.appendChild(itemVatiant);
                var itemQuantity = document.createElement("td");
                itemQuantity.classList.add("wine_shared-cart-link-banner-cart-items-table-value");
                itemQuantity.classList.add("wine_shared-cart-link-banner-cart-items-table-value-quantity");
                itemQuantity.innerHTML = quantity;
                tableRow.appendChild(itemQuantity);
                var itemTotal = document.createElement("td");
                itemTotal.classList.add("wine_shared-cart-link-banner-cart-items-table-value-subtotal");
                itemTotal.classList.add("wine_shared-cart-link-banner-cart-items-table-value-subtotal-total");
                itemTotal.innerHTML = !!total && total !== "" ? "$" + total.toFixed(2) : "";
                tableRow.appendChild(itemTotal);
                table.appendChild(tableRow);
            };
            _this_1.printDataIntoShareLinkBanner = function(linkId, creationDate, numberOfItems, linkUsed, tokenExpirationDate, subtotal, sharedCartLink, token) {
                var shareLinkId = document.querySelector(".wine_shared-cart-link-banner-title_JS");
                if (!!shareLinkId) {
                    shareLinkId.innerHTML = "#" + linkId;
                }
                var deleteButton = document.querySelector(".wine_shared-cart-link-banner-delete-btn_JS");
                if (!!deleteButton) {
                    deleteButton.setAttribute("data-cart-id", linkId);
                    deleteButton.setAttribute("data-cart-token", token);
                }
                var creationDateEl = document.querySelector(".wine_sc-banner-creation-date_JS");
                if (!!creationDateEl) {
                    var creationDateFormated = _this_1.parseDateTime(creationDate);
                    creationDateEl.innerHTML = creationDateFormated;
                }
                var numberOfItemsEl = document.querySelector(".wine_sc-banner-number-of-items_JS");
                if (!!numberOfItemsEl) {
                    numberOfItemsEl.innerHTML = numberOfItems;
                }
                var tokenExpirationDateEL = document.querySelector(".wine_sc-banner-token-expire_JS");
                if (!!tokenExpirationDateEL) {
                    var expireDateFormated = _this_1.parseDateTime(tokenExpirationDate);
                    tokenExpirationDateEL.innerHTML = expireDateFormated;
                }
                var linkAccessEL = document.querySelector(".wine_sc-banner-token-link-access_JS");
                if (!!linkAccessEL) {
                    linkAccessEL.innerHTML = linkUsed;
                }
                var subtotalEL = document.querySelector(".wine_sc-banner-token-subtotal_JS");
                if (!!subtotalEL) {
                    subtotalEL.innerHTML = !!subtotal && subtotal !== "" ? "$" + subtotal : "";
                }
                var inputEl = document.querySelector(".wine_shared-cart-link-banner-copy-link-input_JS");
                if (!!inputEl) {
                    inputEl.value = window.location.host + "/" + sharedCartLink;
                }
            };
            _this_1.copySharedCartLinkBanner = function(shareCartLink) {
                var _this = _this_1;
                var input = document.querySelector(".wine_shared-cart-link-banner-copy-link-input_JS");
                var buttonEl = document.querySelector(".wine_shared-cart-link-banner-copy-link-btn_JS");
                if (!!buttonEl) {
                    buttonEl.addEventListener("click", function(e) {
                        e.preventDefault();
                        input.select();
                        navigator.clipboard.writeText(input.value);
                        _this.notification.showNotification(notification_13.ENotificationType.success, "Share Cart", "Link copied to clipboard!", 5e3, false);
                    });
                }
            };
            _this_1.deleteSharedCartLink = function() {
                var _this = _this_1;
                var deleteButton = document.querySelector(".wine_shared-cart-link-banner-delete-btn_JS");
                if (!!deleteButton) {
                    deleteButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.render.showDeleteLinkConfirmationBanner();
                        _this.render.hideSharedCartBanner();
                        var cancelButton = document.querySelector(".wine_shared-cart-delete-conf-banner-cancel-btn_JS");
                        if (!!cancelButton) {
                            cancelButton.setAttribute("data-from-table", "false");
                        }
                        var num = deleteButton.getAttribute("data-row-number");
                        _this.collectDataInConfirmationBanner(num, deleteButton);
                    });
                }
            };
            _this_1.closeDeleteConfirmationBanner = function() {
                var _this = _this_1;
                var closeButton = document.querySelector(".wine_shared-cart-delete-confirmation-banner-close-btn_JS");
                if (!!closeButton) {
                    closeButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.render.hideDeleteLinkConfirmationBanner();
                    });
                }
            };
            _this_1.cancelDeleteShareCartLink = function() {
                var _this = _this_1;
                var cancelButton = document.querySelector(".wine_shared-cart-delete-conf-banner-cancel-btn_JS");
                if (!!cancelButton) {
                    cancelButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.render.hideDeleteLinkConfirmationBanner();
                    });
                }
            };
            _this_1.collectDataInConfirmationBanner = function(clickedBtnRowNumber, btn) {
                var _this = _this_1;
                var deleteButton = document.querySelector(".wine_shared-cart-delete-conf-banner-delete-btn_JS");
                if (!!deleteButton) {
                    deleteButton.addEventListener("click", function() {
                        var token = btn.getAttribute("data-cart-token");
                        var arrayOfIds = [];
                        var deleteCartLinkData = {
                            cartToken: token
                        };
                        var rows = document.querySelectorAll(".wine_shared-cart-links-table-row_JS");
                        if (!!rows) {
                            rows.forEach(function(row) {
                                var rowNum = row.getAttribute("data-row-number");
                                if (clickedBtnRowNumber === rowNum) {
                                    var cartId = btn.getAttribute("data-cart-id");
                                    btn.setAttribute("disable", "true");
                                    btn.style.opacity = "0.5";
                                    var id = Number(cartId);
                                    arrayOfIds.push(id);
                                    _this.deleteCartLinks(deleteCartLinkData, row, btn);
                                }
                            });
                        }
                    });
                }
            };
            _this_1.generalMethods = generalMethods;
            _this_1.notification = notification;
            _this_1.render = render;
            _this_1.generators = generators;
            return _this_1;
        }
        return StAccountShareCart;
    }(st_module_72.StModule);
    exports.StAccountShareCart = StAccountShareCart;
});

define("extension/shopify-app/st-modules/account/blocks/samplers/samplers", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, st_module_73, notification_14, _features_config_18) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSamplers = void 0;
    var StSamplers = function(_super) {
        __extends(StSamplers, _super);
        function StSamplers(generalMethods, notifications, buttonActions, accountSamplers, cart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Samplers";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setDefaultState();
                    _this_1.selectSamplerItem();
                    _this_1.generateSampler();
                    _this_1.sampleTitle();
                    _this_1.getAllSamples();
                    _this_1.openNewSamplerTab();
                    _this_1.openAllSamplersTab();
                    _this_1.closeButton();
                    _this_1.closeOverlay();
                    _this_1.deleteSamplerClick();
                    _this_1.getSamplerLinks();
                    _this_1.clickOnCancelConfirmationBanner();
                    _this_1.clickOnCloseConfirmationBanner();
                    _this_1.clickOnDeleteOnBanner();
                    _this_1.goToSamplerFromDashboard();
                    _this_1.setupReferralEmail();
                    var accountButtons = document.querySelectorAll(".st_account-button_JS");
                    accountButtons.forEach(function(button) {
                        var sampleLink = button.innerText === "Samplers";
                        var closestWrapper = _this_1.generalMethods.getClosestByClass(button, "st_account-nav--holder-single_JS");
                        if (closestWrapper.classList.contains("current") && sampleLink) {
                            _this_1.fetchSamplerLinks();
                        }
                    });
                });
            };
            _this_1.renderSamplerDate = function() {
                var sampleShippingSateSelectors = document.querySelectorAll(".wine_sample-shipping-date_JS");
                sampleShippingSateSelectors.forEach(function(element) {
                    var _a, _b;
                    if ((_a = window.shopifyCartData.attributes) === null || _a === void 0 ? void 0 : _a.chosenDate) {
                        element.innerHTML = (_b = window.shopifyCartData.attributes) === null || _b === void 0 ? void 0 : _b.chosenDate;
                    }
                });
            };
            _this_1.setDefaultState = function() {
                var sampleItems = document.querySelectorAll(".wine_radio-button-input_JS");
                sampleItems.forEach(function(item) {
                    item.setAttribute("checked", "false");
                    sampleItems[0].setAttribute("checked", "true");
                });
            };
            _this_1.selectSamplerItem = function() {
                var _this = _this_1;
                var sampleItems = document.querySelectorAll(".wine_radio-button-input_JS");
                sampleItems.forEach(function(item) {
                    item.addEventListener("click", function() {
                        var samplersWrapper = _this.generalMethods.getClosestByClass(this, "wine_samplers-add-new-sampler-tab_JS");
                        samplersWrapper.querySelector('[checked="true"]').setAttribute("checked", "false");
                        this.setAttribute("checked", "true");
                    });
                });
            };
            _this_1.sampleTitle = function() {
                var sampleTitleInputs = document.querySelectorAll(".wine_sample-input_JS");
                sampleTitleInputs.forEach(function(titleInput) {
                    titleInput.setAttribute("value", "");
                    titleInput.addEventListener("input", function() {
                        this.setAttribute("value", this.value);
                    });
                });
            };
            _this_1.setupReferralEmail = function() {
                var _this = _this_1;
                var referralEmail = document.querySelector(".wine_sample-referralEmail-input_JS");
                if (referralEmail) {
                    referralEmail.addEventListener("input", function(e) {
                        console.log("referralEmail-e.target", e.target);
                        referralEmail.classList.remove("wine_invalid-email");
                        var generateLinkButtons = document.querySelectorAll(".wine_generate-sampler-button_JS");
                        generateLinkButtons.forEach(function(button) {
                            button.classList.remove("st_account-page--button_disabled");
                        });
                    });
                }
            };
            _this_1.generateSampler = function() {
                var _this = _this_1;
                var generateLinkButtons = document.querySelectorAll(".wine_generate-sampler-button_JS");
                generateLinkButtons.forEach(function(button) {
                    button.addEventListener("click", function() {
                        var closestWrapper = _this.generalMethods.getClosestByClass(this, "wine_samplers-page--wrapper_JS");
                        var shopifyId = window.customerShopifyId;
                        var webAlias = window.shopifyCartData.attributes.sponsorWebAlias;
                        var selectedSampleItem = closestWrapper.querySelector('.wine_radio-button-input_JS[checked="true"]');
                        var selectedSampleId = _this.generalMethods.getClosestByClass(selectedSampleItem, "wine_samplers-product--wrapper_JS").getAttribute("productId");
                        var sampleTitle = closestWrapper.querySelector(".wine_sample-input_JS");
                        var referralEmail = closestWrapper.querySelector(".wine_sample-referralEmail-input_JS");
                        var samplersLoadingPageHandle = window.stAppConfig.options.samplersLoadingPageHandle;
                        var additionalItemsInput = closestWrapper.querySelector(".wine_store-selected-additional-items_JS");
                        var dateInput = closestWrapper.querySelector(".wine_shipping-date-picker-input_JS");
                        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        if (referralEmail.value !== "" && !emailRegex.test(referralEmail.value)) {
                            referralEmail.classList.add("wine_invalid-email");
                            button.classList.add("st_account-page--button_disabled");
                            return;
                        }
                        var selectedItems = JSON.parse(additionalItemsInput.value);
                        var dateInputValue = dateInput.value;
                        var requestData = {
                            chosenSamplerKitId: parseFloat(selectedSampleId),
                            affiliateShopifyId: shopifyId,
                            webAlias: webAlias.toString(),
                            note: sampleTitle.value,
                            referralEmail: referralEmail.value === "" ? undefined : referralEmail.value,
                            additionalItems: selectedItems,
                            chosenDate: dateInputValue
                        };
                        _this.buttonActions.prevent(button);
                        _this.ajax.send({
                            endpoint: _this.endpoint["sampler"]["generateLink"],
                            method: "post",
                            data: requestData,
                            callback: function(response) {
                                try {
                                    var submitResponse_1 = JSON.parse(response.response);
                                    if (submitResponse_1.status === 200) {
                                        _this.buttonActions.allow(button);
                                        var requestData_1 = {
                                            shopifyCustomerId: shopifyId
                                        };
                                        _this.cart.updateCartAttributesOrNote({
                                            attributes: {
                                                billingDate: ""
                                            }
                                        }, function(response) {});
                                        _this.ajax.send({
                                            endpoint: _this.endpoint["sampler"]["getLinks"],
                                            method: "post",
                                            data: requestData_1,
                                            callback: function(response) {
                                                try {
                                                    if (response.status === 200) {
                                                        var subResponse = JSON.parse(response.response);
                                                        _this.printSamplers(subResponse.data.samplerLinks);
                                                        var generatedLink = document.querySelector(".wine_generated-link--wrapper_JS");
                                                        var generatedInput = generatedLink === null || generatedLink === void 0 ? void 0 : generatedLink.querySelector(".wine_generated-input-link_JS");
                                                        var samplerElements = _this.samplersDOMTraverse(button);
                                                        _this.samplersOpenAllSamplers(samplerElements.viewAllSamplersTab, samplerElements.createNewSamplerTab);
                                                        generatedLink === null || generatedLink === void 0 ? void 0 : generatedLink.classList.remove("st_hidden");
                                                        if (!!generatedInput) {
                                                            generatedInput.value = window.location.host + "/pages/" + samplersLoadingPageHandle + submitResponse_1.data.samplerUrl;
                                                            generatedInput.setAttribute("value", window.location.host + "/pages/" + samplersLoadingPageHandle + submitResponse_1.data.samplerUrl);
                                                            _this.copyCode();
                                                        }
                                                    }
                                                } catch (error) {
                                                    _this.buttonActions.allow(button);
                                                    console.error(error);
                                                    _this.notifications.showNotification(notification_14.ENotificationType.error, "Server Error", error);
                                                }
                                            }
                                        });
                                    } else {
                                        _this.buttonActions.allow(button);
                                        _this.notifications.showNotification(notification_14.ENotificationType.error, "An Error Occurred", submitResponse_1.message);
                                    }
                                } catch (error) {
                                    _this.buttonActions.allow(button);
                                    console.error(error);
                                    _this.notifications.showNotification(notification_14.ENotificationType.error, "Server Error", error);
                                }
                            }
                        });
                    });
                });
            };
            _this_1.getSamplerLinks = function() {
                var shopifyId = window.customerShopifyId;
                var requestData = {
                    shopifyCustomerId: shopifyId
                };
                var samplersLoadingPageHandle = window.stAppConfig.options.samplersLoadingPageHandle;
                var _this = _this_1;
                _this.ajax.send({
                    endpoint: _this.endpoint["sampler"]["getLinks"],
                    method: "post",
                    data: requestData,
                    callback: function(response) {
                        try {
                            if (response.status === 200) {
                                var subResponse = JSON.parse(response.response);
                                _this.printSamplers(subResponse.data.samplerLinks);
                                var generatedLink = document.querySelector(".wine_generated-link--wrapper_JS");
                                var generatedInput = generatedLink === null || generatedLink === void 0 ? void 0 : generatedLink.querySelector(".wine_generated-input-link_JS");
                                if (!!generatedInput) {
                                    generatedInput.value = window.location.host + "/pages/" + samplersLoadingPageHandle + subResponse.data.samplerUrl;
                                    generatedInput.setAttribute("value", window.location.host + "/pages/" + samplersLoadingPageHandle + subResponse.data.samplerUrl);
                                }
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notifications.showNotification(notification_14.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.copyCode = function() {
                var copyCodeBtn = document.querySelector(".wine_copy-link-button_JS");
                if (!!copyCodeBtn) {
                    copyCodeBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var input = document.querySelector(".wine_generated-input-link_JS");
                        if (!!input) {
                            input.select();
                            input.setSelectionRange(0, 99999);
                            navigator.clipboard.writeText(input.value);
                            input.style.backgroundColor = "rgb(217, 218, 220)";
                            input.style.transition = "0.2s";
                            setTimeout(function() {
                                input.style.backgroundColor = "rgb(249, 249, 249)";
                            }, 1e3);
                        }
                    });
                }
            };
            _this_1.samplersDOMTraverse = function(el) {
                var pageWrapper = _this_1.generalMethods.getClosestByClass(el, "wine_samplers-page--wrapper_JS");
                var createNewSamplerTab = pageWrapper === null || pageWrapper === void 0 ? void 0 : pageWrapper.querySelector(".wine_samplers-add-new-sampler-tab_JS");
                var viewAllSamplersTab = pageWrapper === null || pageWrapper === void 0 ? void 0 : pageWrapper.querySelector(".wine_samplers-list-of-all-samplers-tab_JS");
                return {
                    createNewSamplerTab: createNewSamplerTab,
                    viewAllSamplersTab: viewAllSamplersTab
                };
            };
            _this_1.samplersOpenAllSamplers = function(allSamplersTab, newSamplerTab) {
                allSamplersTab.classList.remove("st_hidden");
                newSamplerTab.classList.add("st_hidden");
            };
            _this_1.samplersOpenNewSampler = function(allSamplersTab, newSamplerTab) {
                allSamplersTab.classList.add("st_hidden");
                newSamplerTab.classList.remove("st_hidden");
            };
            _this_1.openNewSamplerTab = function() {
                var _this = _this_1;
                var newSamplerButtons = document.querySelectorAll(".wine_make_new-sampler-button_JS");
                newSamplerButtons === null || newSamplerButtons === void 0 ? void 0 : newSamplerButtons.forEach(function(button) {
                    button.addEventListener("click", function() {
                        var samplerElements = _this.samplersDOMTraverse(this);
                        _this.resetBillingDatePicker();
                        _this.samplersOpenNewSampler(samplerElements.viewAllSamplersTab, samplerElements.createNewSamplerTab);
                    });
                });
            };
            _this_1.openAllSamplersTab = function() {
                var _this = _this_1;
                var samplerButtons = document.querySelectorAll(".wine_new-sampler-button_JS");
                samplerButtons === null || samplerButtons === void 0 ? void 0 : samplerButtons.forEach(function(button) {
                    button.addEventListener("click", function() {
                        var samplerElements = _this.samplersDOMTraverse(this);
                        _this.samplersOpenAllSamplers(samplerElements.viewAllSamplersTab, samplerElements.createNewSamplerTab);
                    });
                });
            };
            _this_1.resetBillingDatePicker = function() {
                var billingDatePicker = document.querySelector(".wine_shipping-date-picker-input_JS");
                if (billingDatePicker) {
                    billingDatePicker.value = billingDatePicker.min;
                    billingDatePicker.setAttribute("value", billingDatePicker.min);
                }
            };
            _this_1.getAllSamples = function() {
                var _this = _this_1;
                var accountButtons = document.querySelectorAll(".st_account-button_JS");
                accountButtons === null || accountButtons === void 0 ? void 0 : accountButtons.forEach(function(button) {
                    button.addEventListener("click", function() {
                        var closestWrapper = _this.generalMethods.getClosestByClass(button, "st_account-nav--holder-single_JS");
                        if (closestWrapper.classList.contains("samplers-added")) {
                            return;
                        }
                        if (button.innerText === "Samplers") {
                            closestWrapper.classList.add("samplers-added");
                            _this.fetchSamplerLinks();
                        }
                    });
                });
            };
            _this_1.fetchSamplerLinks = function() {
                var _this = _this_1;
                var shopifyId = window.customerShopifyId;
                var requestData = {
                    shopifyCustomerId: shopifyId
                };
                _this.ajax.send({
                    endpoint: _this.endpoint["sampler"]["getLinks"],
                    method: "post",
                    data: requestData,
                    callback: function(response) {
                        try {
                            var submitResponse = JSON.parse(response.response);
                            if (submitResponse.status === 200) {
                                _this.printSamplers(submitResponse.data.samplerLinks);
                                _this.showTableWrapper();
                            } else {
                                _this.notifications.showNotification(notification_14.ENotificationType.error, "An Error Occurred", submitResponse.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notifications.showNotification(notification_14.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.printSamplers = function(samplerLinks) {
                var _this = _this_1;
                if (samplerLinks.length === 0) {
                    _this_1.noSamplers();
                    return;
                }
                var wineOuterWrapper = document.querySelector(".wine_table-outer--wrapper_JS");
                wineOuterWrapper.style.border = "1px solid #ececec";
                var wineTableWrapper = wineOuterWrapper.querySelector(".wine_sample-table--wrapper_JS");
                var loader = wineOuterWrapper.querySelector(".st_loader");
                loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
                wineTableWrapper.classList.remove("st_hidden");
                var sampleWrapper = wineOuterWrapper.querySelector(".wine_list-items_JS");
                sampleWrapper.textContent = "";
                for (var i = 0; i < samplerLinks.length; i++) {
                    var sampleRow = document.createElement("tr");
                    sampleRow.classList.add("wine_sampler-row", "wine_sampler-row_JS");
                    sampleRow.setAttribute("data-numb", (i + 1).toString());
                    var sampleTitle = document.createElement("th");
                    sampleTitle.innerHTML = samplerLinks[i].note !== "null" ? samplerLinks[i].note : "";
                    var sampleUrl = document.createElement("th");
                    var sampleLink = document.createElement("span");
                    sampleLink.classList.add("wine_sampler-link", "wine_sampler-link_JS");
                    var sampleLinkValue = window.location.protocol + "//" + window.location.host + "/" + samplerLinks[i].link;
                    sampleLink.setAttribute("data-link", sampleLinkValue);
                    sampleLink.innerHTML = sampleLinkValue;
                    sampleUrl.appendChild(sampleLink);
                    var sampleDate = document.createElement("th");
                    var d = new Date(samplerLinks[i].creation_date);
                    sampleDate.innerHTML = "".concat(d.getUTCMonth() + 1, "/").concat(d.getUTCDate(), "/").concat(d.getUTCFullYear());
                    var sampleStatus = document.createElement("th");
                    sampleStatus.innerHTML = samplerLinks[i].valid === 1 ? "active" : "";
                    var buttonCell = document.createElement("th");
                    var sampleDeleteButton = document.createElement("button");
                    sampleDeleteButton.innerHTML = ' <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18">\n' + '                            <path id="delete_FILL0_wght400_GRAD0_opsz24" d="M163-822a1.926,1.926,0,0,1-1.413-.588A1.926,1.926,0,0,1,161-824v-13h-1v-2h5v-1h6v1h5v2h-1v13a1.926,1.926,0,0,1-.587,1.412A1.926,1.926,0,0,1,173-822Zm10-15H163v13h10Zm-8,11h2v-9h-2Zm4,0h2v-9h-2Zm-6-11v0Z" transform="translate(-160 840)" />\n' + "                        </svg>";
                    sampleDeleteButton.setAttribute("type", "button");
                    sampleDeleteButton.setAttribute("data-link", window.location.host + "/" + samplerLinks[i].link);
                    sampleDeleteButton.setAttribute("data-numb", i.toString());
                    sampleDeleteButton.classList.add("wine_delete-sampler_JS");
                    var copyButtonTH = document.createElement("th");
                    var copyButton = document.createElement("button");
                    copyButton.setAttribute("type", "button");
                    copyButton.classList.add("wine_sampler-copy-link", "wine_sampler-copy-link_JS");
                    copyButton.innerHTML = '<svg id="content_copy_FILL0_wght400_GRAD0_opsz48" xmlns="http://www.w3.org/2000/svg" width="13.6" height="16" viewBox="0 0 13.6 16">\n' + '  <path id="content_copy_FILL0_wght400_GRAD0_opsz48-2" data-name="content_copy_FILL0_wght400_GRAD0_opsz48" d="M121.2-865a1.151,1.151,0,0,1-.84-.36,1.151,1.151,0,0,1-.36-.84v-12.06h1.2v12.06h9.48v1.2Zm2.4-2.4a1.151,1.151,0,0,1-.84-.36,1.151,1.151,0,0,1-.36-.84v-11.2a1.152,1.152,0,0,1,.36-.84,1.151,1.151,0,0,1,.84-.36h8.8a1.151,1.151,0,0,1,.84.36,1.152,1.152,0,0,1,.36.84v11.2a1.151,1.151,0,0,1-.36.84,1.151,1.151,0,0,1-.84.36Zm0-1.2h8.8v-11.2h-8.8Zm0,0v0Z" transform="translate(-120 881)" fill="#b8b6b6"/>\n' + "</svg>";
                    _this_1.copyWineCellarLink(copyButton);
                    copyButtonTH.appendChild(copyButton);
                    sampleRow.appendChild(sampleTitle);
                    sampleRow.appendChild(sampleUrl);
                    sampleRow.appendChild(sampleDate);
                    sampleRow.appendChild(sampleStatus);
                    sampleRow.appendChild(buttonCell);
                    sampleRow.appendChild(copyButtonTH);
                    buttonCell.appendChild(sampleDeleteButton);
                    var checkForMessage = wineOuterWrapper.querySelector(".wine_sampler-message");
                    if (checkForMessage) {
                        checkForMessage.remove();
                    }
                    sampleWrapper.appendChild(sampleRow);
                }
                _this.deleteSamplerClick();
            };
            _this_1.deleteSamplerClick = function() {
                var _this = _this_1;
                var samplerBtns = document.querySelectorAll(".wine_delete-sampler_JS");
                samplerBtns.forEach(function(btn) {
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var btnNumb = btn.getAttribute("data-numb");
                        var btnLink = btn.getAttribute("data-link");
                        _this.showDeleteConfirmationBanner();
                        var deleteButtonIbBanner = document.querySelector(".wine_sampler-delete-conf-banner-delete-btn_JS");
                        if (!!deleteButtonIbBanner) {
                            deleteButtonIbBanner.setAttribute("data-sampler-link", btnLink);
                        }
                    });
                });
            };
            _this_1.copyWineCellarLink = function(button) {
                var _this = _this_1;
                button.addEventListener("click", function() {
                    return __awaiter(this, void 0, void 0, function() {
                        var closestRowWrapper, sampleLinkEl, sampleLinkData, copyMessage, error_1;
                        return __generator(this, function(_a) {
                            switch (_a.label) {
                              case 0:
                                closestRowWrapper = _this.generalMethods.getClosestByClass(this, "wine_sampler-row_JS");
                                sampleLinkEl = closestRowWrapper.querySelector(".wine_sampler-link_JS");
                                sampleLinkData = sampleLinkEl.getAttribute("data-link");
                                copyMessage = document.createElement("div");
                                copyMessage.classList.add("wine_sampler-copy-message");
                                button.appendChild(copyMessage);
                                _a.label = 1;

                              case 1:
                                _a.trys.push([ 1, 3, , 4 ]);
                                return [ 4, navigator.clipboard.writeText(sampleLinkData) ];

                              case 2:
                                _a.sent();
                                copyMessage.innerHTML = "Copied!";
                                setTimeout(function() {
                                    copyMessage.remove();
                                }, 1e3);
                                return [ 3, 4 ];

                              case 3:
                                error_1 = _a.sent();
                                copyMessage.innerHTML = "Unable to copy!";
                                setTimeout(function() {
                                    copyMessage.remove();
                                }, 1e3);
                                console.error("Failed to copy:", error_1);
                                return [ 3, 4 ];

                              case 4:
                                return [ 2 ];
                            }
                        });
                    });
                });
            };
            _this_1.clickOnDeleteOnBanner = function() {
                var _this = _this_1;
                var deleteBtn = document.querySelector(".wine_sampler-delete-conf-banner-delete-btn_JS");
                if (!!deleteBtn) {
                    deleteBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var btnLink = deleteBtn.getAttribute("data-sampler-link");
                        var queryString = btnLink;
                        var urlParams = new URLSearchParams(queryString);
                        var sampler = urlParams.get("sampler");
                        _this.deleteSampler(sampler);
                    });
                }
            };
            _this_1.showDeleteConfirmationBanner = function() {
                window.scrollTo(0, 0);
                var bannerWrapper = document.querySelector(".wine_sampler-delete-confirmation-banner-full-screen-wrapper_JS");
                if (!!bannerWrapper) {
                    bannerWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.clickOnCloseConfirmationBanner = function() {
                var _this = _this_1;
                var closeBtn = document.querySelector(".wine_sampler-delete-confirmation-banner-close-btn_JS");
                if (!!closeBtn) {
                    closeBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.hideDeleteConfirmationBanner();
                    });
                }
            };
            _this_1.clickOnCancelConfirmationBanner = function() {
                var _this = _this_1;
                var cancelBtn = document.querySelector(".wine_sampler-delete-conf-banner-cancel-btn_JS");
                if (!!cancelBtn) {
                    cancelBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.hideDeleteConfirmationBanner();
                    });
                }
            };
            _this_1.hideDeleteConfirmationBanner = function() {
                var bannerWrapper = document.querySelector(".wine_sampler-delete-confirmation-banner-full-screen-wrapper_JS");
                if (!!bannerWrapper) {
                    bannerWrapper.classList.add("st_hidden");
                }
            };
            _this_1.deleteSampler = function(sampler) {
                var _this = _this_1;
                var requestData = {
                    sampleToken: sampler
                };
                _this.ajax.send({
                    endpoint: _this.endpoint["sampler"]["deleteSampleLink"],
                    method: "post",
                    data: requestData,
                    callback: function(response) {
                        try {
                            var submitResponse = JSON.parse(response.response);
                            if (submitResponse.status === 200) {
                                _this.hideTableWrapper();
                                if (submitResponse.data.success === true) {
                                    _this.hideDeleteConfirmationBanner();
                                    var tbodyEl = document.querySelector(".wine_list-items_JS");
                                    tbodyEl.innerHTML = "";
                                    _this.notifications.showNotification(notification_14.ENotificationType.success, "Success", submitResponse.message);
                                    _this.fetchSamplerLinks();
                                } else {
                                    _this.showTableWrapper();
                                    _this.notifications.showNotification(notification_14.ENotificationType.error, "An Error Occurred", submitResponse.message);
                                }
                            } else {
                                _this.notifications.showNotification(notification_14.ENotificationType.error, "An Error Occurred", submitResponse.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notifications.showNotification(notification_14.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.hideTableWrapper = function() {
                var wrp = document.querySelector(".wine_table-outer--wrapper_JS");
                if (wrp) {
                    wrp.classList.add("st_hidden");
                }
            };
            _this_1.showTableWrapper = function() {
                var wrp = document.querySelector(".wine_table-outer--wrapper_JS");
                if (wrp) {
                    wrp.classList.remove("st_hidden");
                }
            };
            _this_1.noSamplers = function() {
                var wineSamplersWrapper = document.querySelector(".wine_samplers-page--wrapper_JS");
                if (!!wineSamplersWrapper) {
                    var tableOuterWrapper = wineSamplersWrapper.querySelector(".wine_table-outer--wrapper_JS");
                    var tableWrapper = wineSamplersWrapper.querySelector(".wine_sample-table--wrapper_JS");
                    tableWrapper.classList.add("st_hidden");
                    var loader = wineSamplersWrapper.querySelector(".st_loader");
                    loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
                    var checkForMessage = tableOuterWrapper.querySelector(".wine_sampler-message");
                    if (checkForMessage) {
                        return;
                    }
                    var message = document.createElement("p");
                    message.innerHTML = "You don't have any active sampler links.";
                    message.classList.add("wine_sampler-message");
                    tableOuterWrapper.appendChild(message);
                }
            };
            _this_1.createSampleLinkContent = function(submitResponse) {
                var samplersWrapper = document.querySelector(".wine_samplers-page--wrapper_JS");
                var createPopup = document.createElement("div");
                var samplersLoadingPageHandle = window.stAppConfig.options.samplersLoadingPageHandle;
                createPopup.classList.add("wine_generated-link-popup--wrapper");
                var title = document.createElement("h2");
                title.innerHTML = "Generated link";
                var labelTitle = document.createElement("label");
                labelTitle.setAttribute("for", "sampleGeneratedLink");
                labelTitle.classList.add("wine_font-size-20", "wine_color-70", "wine_mb-14", "wine_block", "wine-w-full");
                labelTitle.innerHTML = "Sampler";
                var inputWrapper = document.createElement("div");
                var input = document.createElement("input");
                input.setAttribute("type", "text");
                input.setAttribute("id", "sampleGeneratedLink");
                input.classList.add("wine_sample-input");
                input.setAttribute("value", "/pages/" + samplersLoadingPageHandle + submitResponse.data.samplerUrl);
                input.value = "/pages/" + samplersLoadingPageHandle + submitResponse.data.samplerUrl;
                inputWrapper.appendChild(input);
                createPopup.appendChild(title);
                createPopup.appendChild(labelTitle);
                createPopup.appendChild(inputWrapper);
                samplersWrapper.appendChild(createPopup);
            };
            _this_1.goToSamplerFromDashboard = function() {
                var samplerButtons = document.querySelectorAll(".wine_request-a-sampler-button_JS");
                samplerButtons.forEach(function(sampler) {
                    var sponsorWebAlias = window.shopifyCartData.attributes.sponsorWebAlias;
                    if ("href" in sampler) {
                        var redirectUrl = window.location.protocol + "//" + window.location.hostname + "/pages/host-a-tasting-form" + "?".concat(_features_config_18.aliasQueryParam, "=") + sponsorWebAlias;
                        sampler.href = redirectUrl;
                    }
                });
            };
            _this_1.closeButton = function() {
                var _this = _this_1;
                var closeButton = document.querySelectorAll(".wine_custom-close-button_JS");
                if (!!closeButton) {
                    closeButton.forEach(function(button) {
                        button.addEventListener("click", function() {
                            var generateLinkWrapper = _this.generalMethods.getClosestByClass(this, "wine_generated-link--wrapper_JS");
                            generateLinkWrapper.classList.add("st_hidden");
                        });
                    });
                }
            };
            _this_1.closeOverlay = function() {
                var _this = _this_1;
                var closeOverlay = document.querySelector(".wine_generated-link--overlay_JS");
                if (!!closeOverlay) {
                    closeOverlay.addEventListener("click", function() {
                        var samplerWrapper = _this.generalMethods.getClosestByClass(this, "wine_samplers-page--wrapper_JS");
                        var generateLinkWrapper = samplerWrapper.querySelector(".wine_generated-link--wrapper_JS");
                        generateLinkWrapper.classList.add("st_hidden");
                    });
                }
            };
            _this_1.generalMethods = generalMethods;
            _this_1.notifications = notifications;
            _this_1.buttonActions = buttonActions;
            _this_1.accountSamplers = accountSamplers;
            _this_1.cart = cart;
            return _this_1;
        }
        return StSamplers;
    }(st_module_73.StModule);
    exports.StSamplers = StSamplers;
});

define("extension/connector-app/_shared/models/sampler/sampler.validate.link.request", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/connector-app/_shared/models/sampler/sampler.validate.link.response", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/shopify-app/st-modules/account/blocks/samplers/samplers-order", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_74, notification_15) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSamplersOrder = void 0;
    var StSamplersOrder = function(_super) {
        __extends(StSamplersOrder, _super);
        function StSamplersOrder(generalMethods, notifications, buttonActions, cart, themeCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "SamplersOrder";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.checkIfSamplerExistInURL();
                    _this_1.renderSamplerDate();
                    _this_1.themeCart.bindDrawerEvent(_this_1.renderSamplerDate);
                });
            };
            _this_1.renderSamplerDate = function() {
                var sampleShippingSateSelectors = document.querySelectorAll(".wine_sampler-shipping-date--wrapper_JS .wine_sampler-shipping-date_JS");
                if (sampleShippingSateSelectors.length === 0) {
                    return;
                }
                sampleShippingSateSelectors.forEach(function(element) {
                    var _a, _b;
                    if ((_a = window.shopifyCartData.attributes) === null || _a === void 0 ? void 0 : _a.samplerDate) {
                        element.textContent = (_b = window.shopifyCartData.attributes) === null || _b === void 0 ? void 0 : _b.samplerDate;
                    }
                });
            };
            _this_1.checkIfSamplerExistInURL = function() {
                var _a;
                console.log("CHECK SAMPLER VALID 1: " + "");
                var urlParams = new URLSearchParams(window.location.search);
                console.log("CHECK SAMPLER VALID 2: " + urlParams);
                var sampler = urlParams.get("sampler");
                var cameFromCheckout = sessionStorage.getItem("cameFromCheckout");
                console.log("CHECK SAMPLER VALID 3: " + sampler);
                if (sampler) {
                    var cref_1 = urlParams.get("cref");
                    var customerType = (_a = window.customerInfoMetafields) === null || _a === void 0 ? void 0 : _a.customerType;
                    if (customerType === "affiliate") {
                        window.location.href = "/account";
                    } else {
                        console.log("CHECK SAMPLER VALID 4");
                        localStorage.setItem("samplerKey", sampler);
                        var attributes = window.shopifyCartData.attributes;
                        attributes.sampler = sampler;
                        _this_1.clearCart(_this_1.validateLink, [ sampler, function(chosenDate) {
                            console.log("CHECK SAMPLER VALID 5");
                            _this_1.updateAttributes([ {
                                sampler: sampler,
                                samplerDate: chosenDate,
                                cref: cref_1
                            } ], function() {
                                if (cameFromCheckout) {
                                    console.log("CHECK SAMPLER VALID 6.1");
                                    window.location.href = "/cart";
                                } else {
                                    console.log("CHECK SAMPLER VALID 6.2");
                                    sessionStorage.setItem("cameFromCheckout", "true");
                                    window.location.href = "/checkout";
                                }
                            });
                        } ]);
                    }
                }
            };
            _this_1.formatDate = function(dateString) {
                var _a = dateString.split("-"), year = _a[0], month = _a[1], day = _a[2];
                return "".concat(month, "/").concat(day, "/").concat(year);
            };
            _this_1.updateAttributes = function(attributes, cb, params) {
                if (cb === void 0) {
                    cb = function() {};
                }
                if (params === void 0) {
                    params = [];
                }
                var sampler = attributes[0].sampler;
                var dateFormatted = _this_1.formatDate(attributes[0].samplerDate);
                var newAttributes = {
                    attributes: {
                        sampler: sampler,
                        samplerDate: dateFormatted
                    }
                };
                _this_1.cart.updateCartAttributesOrNote(newAttributes, function(response) {
                    cb.apply(void 0, params);
                });
            };
            _this_1.validateLink = function(sampler, cb, params) {
                if (params === void 0) {
                    params = [];
                }
                var _this = _this_1;
                var validateSamplerRequest = {
                    sampleToken: sampler
                };
                _this.ajax.send({
                    endpoint: _this.endpoint["sampler"]["validateLink"],
                    method: "post",
                    data: validateSamplerRequest,
                    callback: function(response) {
                        try {
                            var submitResponse = JSON.parse(response.response);
                            if (submitResponse.status === 200) {
                                var samplerValidateResponse = submitResponse.data;
                                if (samplerValidateResponse.isValid) {
                                    var chosenDate = samplerValidateResponse.chosenDate;
                                    _this.addItemsToCart(samplerValidateResponse, cb, __spreadArray([ chosenDate ], params, true));
                                } else {
                                    window.location.href = "/";
                                }
                            } else {
                                _this.notifications.showNotification(notification_15.ENotificationType.error, "An Error Occurred", submitResponse.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notifications.showNotification(notification_15.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.clearCart = function(cb, params) {
                if (cb === void 0) {
                    cb = function() {};
                }
                if (params === void 0) {
                    params = [];
                }
                _this_1.cart.clearCart(function(response) {
                    cb.apply(void 0, params);
                });
            };
            _this_1.addItemsToCart = function(samplerValidateResponse, cb, params) {
                if (params === void 0) {
                    params = [];
                }
                var itemsToAdd = [];
                var mainItem = {
                    id: samplerValidateResponse.chosenItemId,
                    quantity: 1
                };
                itemsToAdd.push(mainItem);
                if (samplerValidateResponse.additionalItems && samplerValidateResponse.additionalItems.length > 0) {
                    samplerValidateResponse.additionalItems.forEach(function(item) {
                        var additionalItem = {
                            id: item.variantId,
                            quantity: item.quantity
                        };
                        itemsToAdd.push(additionalItem);
                    });
                }
                _this_1.addItems(itemsToAdd, cb, params);
            };
            _this_1.addItems = function(items, cb, params) {
                if (params === void 0) {
                    params = [];
                }
                var _this = _this_1;
                _this.cart.addCart(items, function(response) {
                    cb.apply(void 0, params);
                });
            };
            _this_1.generalMethods = generalMethods;
            _this_1.notifications = notifications;
            _this_1.buttonActions = buttonActions;
            _this_1.themeCart = themeCart;
            _this_1.cart = cart;
            return _this_1;
        }
        return StSamplersOrder;
    }(st_module_74.StModule);
    exports.StSamplersOrder = StSamplersOrder;
});

define("extension/connector-app/_shared/models/auth/jwt.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/shopify-app/st-modules/_general-methods/jwt", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_75) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StJWT = void 0;
    var StJWT = function(_super) {
        __extends(StJWT, _super);
        function StJWT(objectFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "JWT";
            _this_1.shouldUseJWT = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                console.log("has token ", urlParams.has_token === "1");
                return urlParams.has_token === "1";
            };
            _this_1.createJwt = function(url, callbackFunction, customerEmail, callbackParams) {
                if (callbackFunction === void 0) {
                    callbackFunction = function(token, url) {};
                }
                if (callbackParams === void 0) {
                    callbackParams = [];
                }
                var customerId = window.customerShopifyId;
                var payload = {};
                if (!customerId) {
                    payload.customerEmail = customerEmail;
                } else {
                    payload.customerId = customerId;
                }
                var _this = _this_1;
                _this.ajax.send({
                    endpoint: _this_1.endpoint["auth"]["generateJwt"],
                    method: "POST",
                    contentType: "json",
                    data: payload,
                    callback: function(res) {
                        var token = JSON.parse(res.response).data.token;
                        if (token == "undefined") return;
                        callbackFunction.apply(void 0, __spreadArray([ token, url ], callbackParams, false));
                    }
                });
            };
            _this_1.redirect = function(token, urlEncoded) {
                var _a;
                var url = decodeURIComponent(urlEncoded);
                console.log("DABEEEEEE ", url);
                var urlSplit = url.split("?");
                var urlHashSplit = (_a = urlSplit[1]) === null || _a === void 0 ? void 0 : _a.split("#");
                var mainUrl = urlSplit[0];
                var queryParams = urlHashSplit ? urlHashSplit[0] : "";
                var urlHash = !!urlHashSplit ? urlHashSplit[1] : "";
                var urlParams;
                if (urlSplit.length > 1) {
                    urlParams = _this_1.objectFormatting.convertQueryStringToObject("?" + queryParams);
                } else {
                    urlParams = {};
                }
                urlParams.JWT = token;
                var urlQueryWithToken = _this_1.objectFormatting.convertObjectToQueryString(urlParams);
                window.location.href = mainUrl + urlQueryWithToken + "#" + urlHash;
            };
            _this_1.objectFormatting = objectFormatting;
            return _this_1;
        }
        return StJWT;
    }(st_module_75.StModule);
    exports.StJWT = StJWT;
});

define("extension/shopify-app/st-modules/enrollment-loading-page/enrolment-check", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_76) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentLoginCheck = void 0;
    var StEnrollmentLoginCheck = function(_super) {
        __extends(StEnrollmentLoginCheck, _super);
        function StEnrollmentLoginCheck(objectFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentLoginCheck";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.clickOnEnrollmentButton();
                    _this_1.checkIfCustomerIsLoggedIn();
                });
            };
            _this_1.redirectToGoaffPro = function() {
                var newHref = "https://wineshop.goaffpro.com/create-account";
                var params = new URLSearchParams(window.location.search);
                var email = window.customerEmail;
                var sponsorRef = window.sponsorRef;
                params.set("email", email);
                params.set("ref", sponsorRef);
                window.location.href = newHref + "?".concat(params);
            };
            _this_1.clickOnEnrollmentButton = function() {
                var enrollmentButtons = document.querySelectorAll(".wine_account-wine-club-affiliate-button_JS");
                if (!!enrollmentButtons) {
                    enrollmentButtons.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            window.location.href = window.location.protocol + "//" + window.location.hostname + "/pages/enrollment-check";
                        });
                    });
                }
            };
            _this_1.checkIfCustomerIsLoggedIn = function() {
                var _this = _this_1;
                var urlToString = window.location.href.toString();
                if (urlToString.includes("/pages/enrollment-check")) {
                    if (window.customerShopifyId == 0) {
                        _this_1.redirectToLogin();
                    } else {
                        _this_1.redirectToGoaffPro();
                    }
                }
            };
            _this_1.enrollmentLoginCheck = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                if (urlParams) {
                    var hasFlag = false;
                    if (urlParams.logged == "false") {
                        hasFlag = true;
                    }
                    return hasFlag;
                }
            };
            _this_1.showLoginContent = function() {
                var wineContentWrp = document.querySelector(".wine_enrollment-login-paragraph_JS");
                if (!!wineContentWrp) {
                    wineContentWrp.classList.remove("st_hidden");
                }
            };
            _this_1.hideLoginContent = function() {
                var wineContentWrp = document.querySelector(".wine_enrollment-login-paragraph_JS");
                if (!!wineContentWrp) {
                    wineContentWrp.classList.add("st_hidden");
                }
            };
            _this_1.objectFormatting = objectFormatting;
            return _this_1;
        }
        StEnrollmentLoginCheck.prototype.redirectToLogin = function() {
            var urlParamsComplete = this.objectFormatting.convertQueryStringToObject(window.location.search);
            urlParamsComplete.logged = "false";
            var urlParamsQuery = this.objectFormatting.convertObjectToQueryString(urlParamsComplete);
            window.location.href = window.location.protocol + "//" + window.location.hostname + "/account/login" + urlParamsQuery;
        };
        return StEnrollmentLoginCheck;
    }(st_module_76.StModule);
    exports.StEnrollmentLoginCheck = StEnrollmentLoginCheck;
});

define("extension/shopify-app/st-modules/account-register/account-register", [ "require", "exports", "core/shopify-app/st-modules/account-register/account-register", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, account_register_1, notification_16, _features_config_19) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountRegisterExtended = void 0;
    var StAccountRegisterExtended = function(_super) {
        __extends(StAccountRegisterExtended, _super);
        function StAccountRegisterExtended(form, notification, buttonActions, classConfig, generalMethods, JWT, objectFormatting, enrollmentCheck, wineCellar, customerType) {
            var _this_1 = _super.call(this, form, notification, buttonActions, classConfig, generalMethods) || this;
            _this_1.className = "AccountRegister";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.onSubmit();
                });
            };
            _this_1.checkLoginPage = function() {
                var urlToString = window.location.href.toString();
                if (urlToString.includes("account/register")) {
                    if (_this_1.enrollmentCheck.enrollmentLoginCheck()) {
                        _this_1.enrollmentCheck.showLoginContent();
                    }
                }
            };
            _this_1.onSubmit = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorAccountRegisterForm);
                if (!!form) {
                    var createAccountButton_1 = form.querySelector(".wine_create-sign-in-account-btn_JS");
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.buttonActions.prevent(createAccountButton_1);
                        _this.validateAccountCreation(this, e, createAccountButton_1);
                    });
                }
            };
            _this_1.validateAccountCreation = function(form, submitEvent, createAccountButton) {
                var _this = _this_1;
                if (form.classList.contains(_this_1.classConfig.classAccountRegisterFormPreventDefault)) {
                    submitEvent.preventDefault();
                    var formData = _this.form.collectFormData(form);
                    var hiddenAlsInput = form.querySelector(_this_1.classConfig.selectorRepresentativeAlias);
                    if (!(hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) || !_features_config_19.canGoUnderCorporateSite && (hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) === _features_config_19.defaultWebAlias) {
                        _this.notification.showNotification(notification_16.ENotificationType.error, "Validation Error", "Web alias not entered or invalid");
                        _this.revertSubmitButtonToDefault();
                        _this_1.buttonActions.allow(createAccountButton);
                    } else {
                        var payload_2 = {
                            email: formData["customer[email]"],
                            firstName: formData["customer[first_name]"],
                            lastName: formData["customer[last_name]"],
                            password: formData["customer[password]"],
                            sponsorsWebAlias: formData["customer[note][sponsorWebAlias]"],
                            dateOfBirth: formData["customer[dateOfBirth]"]
                        };
                        var passwordInputElement = document.querySelector('input[name="customer[password]"]');
                        var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                        if (passwordInputElement.value.length > 40) {
                            _this.notification.showNotification(notification_16.ENotificationType.error, "Validation Error", "Password cannot contain more than 40 characters!");
                            _this.revertSubmitButtonToDefault();
                            _this_1.buttonActions.allow(createAccountButton);
                        } else if (passwordInputElement.value === (repeatPasswordInputElement === null || repeatPasswordInputElement === void 0 ? void 0 : repeatPasswordInputElement.value) || !repeatPasswordInputElement) {
                            _this.ajax.send({
                                endpoint: _this.endpoint["enrollment"]["validate-data"],
                                method: "post",
                                contentType: "json",
                                data: payload_2,
                                callback: function(response) {
                                    try {
                                        var validationResponse = JSON.parse(response.response);
                                        var validationErrors = _this.prepareErrorArray(validationResponse.data);
                                        if (validationErrors.length !== 0) {
                                            _this.notification.showNotification(notification_16.ENotificationType.error, "Validation Error", validationErrors);
                                            _this.revertSubmitButtonToDefault();
                                            _this.buttonActions.allow(createAccountButton);
                                        } else {
                                            _this.registerCustomer(payload_2);
                                        }
                                    } catch (error) {
                                        console.error(error);
                                        _this.notification.showNotification(notification_16.ENotificationType.error, "Server Error", error);
                                        _this.revertSubmitButtonToDefault();
                                        _this.buttonActions.allow(createAccountButton);
                                    }
                                }
                            });
                        } else {
                            _this.notification.showNotification(notification_16.ENotificationType.error, "Validation Error", "Passwords not matching!");
                            _this.revertSubmitButtonToDefault();
                            _this_1.buttonActions.allow(createAccountButton);
                        }
                    }
                } else {
                    form.classList.add(_this.classConfig.classAccountRegisterFormPreventDefault);
                }
            };
            _this_1.loginCustomer = function(formData) {
                var _this = _this_1;
                var loginPayload = {};
                loginPayload.form_type = "customer_login";
                loginPayload["customer[email]"] = formData.email;
                loginPayload["customer[password]"] = formData.password;
                _this.ajax.send({
                    endpoint: window.location.protocol + "//" + window.location.hostname + "/account/login",
                    method: "post",
                    contentType: "form",
                    data: loginPayload,
                    callback: function(response) {
                        try {
                            if (response.status == 200) {
                                var redirectUrlResponse = response.responseURL.toString();
                                if (redirectUrlResponse.includes("/account/login")) {
                                    window.location.reload();
                                    _this.revertSubmitButtonToDefault();
                                    _this.notification.showNotification(notification_16.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                                } else {
                                    if (_this.JWT.shouldUseJWT()) {
                                        var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                                        _this.JWT.createJwt(urlParams.return_url, _this.JWT.redirect, loginPayload["customer[email]"]);
                                    } else if (_this.enrollmentCheck.enrollmentLoginCheck()) {
                                        window.location.href = "/pages/enrollment-check";
                                        _this.enrollmentCheck.hideLoginContent();
                                    } else {
                                        window.location.assign(_this.addWebAliasToRedirectURL(redirectUrlResponse));
                                    }
                                }
                            } else {
                                window.location.reload();
                                _this.revertSubmitButtonToDefault();
                                _this.notification.showNotification(notification_16.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.revertSubmitButtonToDefault();
                            _this.notification.showNotification(notification_16.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.redirectToWineCellar = function(errorCallback, errorCallbackParams) {
                if (errorCallback === void 0) {
                    errorCallback = function() {};
                }
                if (errorCallbackParams === void 0) {
                    errorCallbackParams = [];
                }
                var _this = _this_1;
                _this.wineCellar.tokenizeWineCellarLink(window.customerShopifyId, function(redirectURL) {
                    window.location.assign(redirectURL);
                }, [], errorCallback, errorCallbackParams);
            };
            _this_1.form = form;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.JWT = JWT;
            _this_1.objectFormatting = objectFormatting;
            _this_1.enrollmentCheck = enrollmentCheck;
            _this_1.wineCellar = wineCellar;
            _this_1.customerType = customerType;
            return _this_1;
        }
        StAccountRegisterExtended.prototype.addWebAliasToRedirectURL = function(redirectUrlResponse) {
            var redirectURLArrayByID = redirectUrlResponse.split("#");
            var redirectURLArrayByQuery = redirectURLArrayByID[0].split("?");
            var urlParams = {};
            if (redirectURLArrayByQuery.length > 1) {
                urlParams = this.objectFormatting.convertQueryStringToObject("?" + redirectURLArrayByQuery[1]);
            }
            var currentURLParams = this.objectFormatting.convertQueryStringToObject(window.location.search);
            urlParams[_features_config_19.aliasQueryParam] = currentURLParams[_features_config_19.aliasQueryParam];
            var newSearchString = this.objectFormatting.convertObjectToQueryString(urlParams);
            return redirectURLArrayByQuery[0] + newSearchString + (redirectURLArrayByID.length > 1 ? "#" + redirectURLArrayByID[1] : "");
        };
        return StAccountRegisterExtended;
    }(account_register_1.StAccountRegister);
    exports.StAccountRegisterExtended = StAccountRegisterExtended;
});

define("extension/shopify-app/st-modules/webalias/inject-representative-info", [ "require", "exports", "_features.config", "core/shopify-app/st-modules/webalias/inject-representative-info" ], function(require, exports, _features_config_20, inject_representative_info_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInjectRepresentativeInfoExtended = void 0;
    var StInjectRepresentativeInfoExtended = function(_super) {
        __extends(StInjectRepresentativeInfoExtended, _super);
        function StInjectRepresentativeInfoExtended(classConfig, sponsorService) {
            var _this = _super.call(this, classConfig) || this;
            _this.className = "InjectRepresentativeInfo";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.injectMyWineConsultant();
                });
            };
            _this.injectToFields = function(repInfo) {
                var repId = repInfo.repId, webAlias = repInfo.webAlias, firstName = repInfo.firstName, lastName = repInfo.lastName, imageUrl = repInfo.imageUrl;
                if (!!repId) {
                    _this.appendIdToField(repInfo.repId);
                }
                if (!!webAlias) {
                    _this.appendAlsToField(webAlias);
                    _this.appendRepSiteUrlToField(webAlias);
                    _this.injectSponsorInfoToField(firstName, lastName);
                }
                if (!!firstName || !!lastName) {
                    _this.appendRepFullNameToField(firstName, lastName, webAlias);
                    _this.injectSponsorInfoToField(firstName, lastName);
                }
                if (!!imageUrl && _features_config_20.additionalRepInfo) {
                    _this.appendRepBioToField(imageUrl);
                }
            };
            _this.injectSponsorInfoToField = function(firstName, lastName) {
                var repNameSelector = document.querySelector(_this.classConfig.selectorBusinessContentRepName);
                if (!!repNameSelector) {
                    if (firstName !== "" || lastName !== "") {
                        repNameSelector.innerHTML = firstName + " " + lastName;
                    } else {
                        repNameSelector.innerHTML = "no name";
                    }
                }
                var personalInformationRep = document.querySelector(_this.classConfig.selectorPersonalInfoRepFullName);
                if (!!personalInformationRep) {
                    if (firstName || lastName) {
                        personalInformationRep.innerHTML = firstName + " " + lastName;
                    } else {
                        personalInformationRep.innerHTML = "no name";
                    }
                }
            };
            _this.appendIdToField = function(id) {
                var repAliasFields = document.querySelectorAll(_this.classConfig.selectorRepId);
                if (repAliasFields.length > 0) {
                    _this.appendValueToFields(repAliasFields, id);
                }
            };
            _this.appendAlsToField = function(alias) {
                var repAliasFields = document.querySelectorAll(_this.classConfig.selectorRepAlias);
                if (repAliasFields.length > 0) {
                    _this.appendValueToFields(repAliasFields, alias);
                }
            };
            _this.appendRepSiteUrlToField = function(alias) {
                var repSiteFields = document.querySelectorAll(_this.classConfig.selectorRepSite);
                var repSite = window.location.origin + "/?" + _features_config_20.aliasQueryParam + "=" + alias;
                if (repSiteFields.length > 0) {
                    _this.appendValueToFields(repSiteFields, repSite);
                }
            };
            _this.appendRepFullNameToField = function(repFirstName, repLastName, webAlias) {
                var repFullNameFields = document.querySelectorAll(_this.classConfig.selectorRepFullName);
                var fullName = _this.getFullName(repFirstName, repLastName, webAlias);
                if (repFullNameFields.length > 0) {
                    _this.appendValueToFields(repFullNameFields, fullName);
                }
            };
            _this.appendRepBioToField = function(imageUrl) {
                var repImages = document.querySelectorAll(_this.classConfig.selectorRepBio);
                var imageString = 'BIO: <img class="" style="width: 50px; height: auto;" alt="representatve image" src="' + imageUrl + '">';
                if (repImages.length > 0) {
                    repImages.forEach(function(field) {
                        return field.innerHTML = imageString;
                    });
                }
            };
            _this.getFullName = function(repFirstName, repLastName, webAlias) {
                var fullName = "";
                if (!!repFirstName) {
                    fullName = repFirstName;
                    if (!!repLastName) {
                        fullName += " " + repLastName;
                    }
                }
                if (webAlias === _features_config_20.defaultWebAlias) {
                    fullName = _features_config_20.corporationName;
                }
                return fullName;
            };
            _this.appendValueToFields = function(fields, value) {
                fields.forEach(function(field) {
                    if (field.tagName.toLowerCase() === "input") {
                        field.value = value;
                    } else if (field.tagName.toLowerCase() === "a") {
                        field.setAttribute("href", value);
                    } else {
                        field.innerHTML = value;
                    }
                });
            };
            _this.injectMyWineConsultant = function() {
                var sponsorDiv = document.querySelector(".wine_account-business-sponsor-id_JS");
                var sponsorDivMetafield = document.querySelector(".wine_account-business-rep-id-metafield_JS");
                var personalInfoSponsorInput = document.querySelector(".wine_personal-info-representative-info-fullname_JS");
                if (!!sponsorDiv) {
                    var sponsorId_1 = sponsorDivMetafield.getAttribute("date-sponsorId").trim();
                    _this.sponsorService.getSponsorInfo(sponsorId_1.toString(), function(request) {
                        try {
                            if (request.status === 200) {
                                var requestInfo = JSON.parse(request.response);
                                if (requestInfo.data === undefined || requestInfo.data === null) {
                                    sponsorDiv.innerHTML = sponsorId_1;
                                    if (!!personalInfoSponsorInput) {
                                        personalInfoSponsorInput.value = sponsorId_1;
                                    }
                                } else {
                                    if (requestInfo.data.sponsors[0].firstName !== "" && requestInfo.data.sponsors[0].lastName !== "") {
                                        var nameAndSurname = requestInfo.data.sponsors[0].firstName + " " + requestInfo.data.sponsors[0].lastName;
                                        sponsorDiv.innerHTML = nameAndSurname;
                                        if (!!personalInfoSponsorInput) {
                                            personalInfoSponsorInput.value = nameAndSurname;
                                        }
                                    } else {
                                        var wa = requestInfo.data.sponsors[0].webAlias;
                                        sponsorDiv.innerHTML = wa;
                                        if (!!personalInfoSponsorInput) {
                                            personalInfoSponsorInput.value = wa;
                                        }
                                    }
                                }
                            }
                            var representativeSiteLinkInput = document.querySelectorAll(".st_representative-site-link_JS");
                            if (!!representativeSiteLinkInput) {
                                representativeSiteLinkInput.forEach(function(input) {
                                    var als = localStorage.getItem("webAlias");
                                    input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_20.aliasQueryParam + "=" + als;
                                });
                            }
                        } catch (error) {
                            console.log(error);
                        }
                    });
                }
            };
            _this.classConfig = classConfig;
            _this.sponsorService = sponsorService;
            return _this;
        }
        return StInjectRepresentativeInfoExtended;
    }(inject_representative_info_1.StInjectRepresentativeInfo);
    exports.StInjectRepresentativeInfoExtended = StInjectRepresentativeInfoExtended;
});

define("extension/shopify-app/st-modules/search-sponsor/search-sponsor", [ "require", "exports", "core/shopify-app/st-modules/search-sponsor/search-sponsor", "_features.config" ], function(require, exports, search_sponsor_1, _features_config_21) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorExtended = void 0;
    var SponsorRequestType;
    (function(SponsorRequestType) {
        SponsorRequestType[SponsorRequestType["GET_BY_ID_OR_ALIAS"] = 0] = "GET_BY_ID_OR_ALIAS";
        SponsorRequestType[SponsorRequestType["GET_BY_PERSONAL_INFORMATION"] = 1] = "GET_BY_PERSONAL_INFORMATION";
    })(SponsorRequestType || (SponsorRequestType = {}));
    var StSearchSponsorExtended = function(_super) {
        __extends(StSearchSponsorExtended, _super);
        function StSearchSponsorExtended(generalMethods, objectFormatting, browserHistory, classConfig, cookies, cart, sponsorService, themeCart, webAlias) {
            var _this_1 = _super.call(this, generalMethods, objectFormatting, browserHistory, classConfig, cookies, cart, sponsorService) || this;
            _this_1.className = "SearchSponsor";
            _this_1.endpointString = [ "getSponsorInfo", "getSponsorByPersonalInfo" ];
            _this_1.MIN_CHAR_SEARCH_REQUIREMENT = 2;
            _this_1.REQUEST_DELAY = 1e3;
            _this_1.inputValue = "";
            _this_1.cookieNameWebAlias = "webAlias";
            _this_1.cookieNameRepId = "repId";
            _this_1.cookieNameFirstName = "firstName";
            _this_1.cookieNameLastName = "lastName";
            _this_1.retryWebAliasFetch = true;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.initSearchBoxFunctionality();
                    _this_1.initRadioButtons();
                    _this_1.windowClick();
                    _this_1.triggerVisibilityOfSection();
                    _this_1.cart.subscribeRenderCart(function(callback) {
                        _this_1.changeCartEvents();
                    });
                });
            };
            _this_1.loaderOn = function(triggerBtn) {
                var label = _this_1.generalMethods.getClosestByTag(triggerBtn, "label");
                if (!!label && !label.classList.contains("st_loader-active")) {
                    label.classList.add("st_loader-active");
                }
            };
            _this_1.loaderOff = function(triggerBtn) {
                var label = _this_1.generalMethods.getClosestByTag(triggerBtn, "label");
                if (!!label && label.classList.contains("st_loader-active")) {
                    label.classList.remove("st_loader-active");
                }
            };
            _this_1.changeCartEvents = function() {
                _this_1.initSearchBoxFunctionality();
                _this_1.initRadioButtons();
                _this_1.triggerVisibilityOfSection();
                _this_1.windowClick();
            };
            _this_1.setRepCookies = function(repInfo) {
                _this_1.cookies.setCookies(_this_1.cookieNameWebAlias, repInfo.webAlias);
                _this_1.cookies.setCookies(_this_1.cookieNameRepId, repInfo.repId);
                _this_1.cookies.setCookies(_this_1.cookieNameFirstName, repInfo.firstName);
                _this_1.cookies.setCookies(_this_1.cookieNameLastName, repInfo.lastName);
            };
            _this_1.injectRepInfo = function() {
                _this_1.webAlias.injectRepInfoFromCookie();
            };
            _this_1.triggerVisibilityOfSection = function() {
                var _this = _this_1;
                var customerType = window.customerInfoMetafields.customerType;
                if (customerType == _features_config_21.ECustomerType.retail && _features_config_21.lockedRepresentativeSite || customerType == _features_config_21.ECustomerType.representative) {
                    var searchSponsorWrappers = document.querySelectorAll(_this_1.classConfig.selectorSearchSponsorWrapperPage);
                    searchSponsorWrappers.forEach(function(searchSponsorWrapper) {
                        var searchSponsorWrapperLink = searchSponsorWrapper.querySelector(_this_1.classConfig.selectorChangeSponsorWrapperLink);
                        searchSponsorWrapperLink === null || searchSponsorWrapperLink === void 0 ? void 0 : searchSponsorWrapperLink.classList.add("st_hidden");
                    });
                } else {
                    var body = document.querySelector("body");
                    if (!body.classList.contains("wine_change-sponsor-setup")) {
                        body.classList.add("wine_change-sponsor-setup");
                        document.addEventListener("click", function(e) {
                            var searchSponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                            searchSponsorWrappers.forEach(function(searchSponsorWrapper) {
                                if (_this.isChangeSponsorButtonClicked(e)) {
                                    _this.defaultVisibility(searchSponsorWrapper);
                                    _this.showSearchInput(searchSponsorWrapper);
                                    _this.hideSearchResults(searchSponsorWrapper);
                                    _this.nonSponsors(searchSponsorWrapper);
                                }
                            });
                        });
                    }
                }
            };
            _this_1.isChangeSponsorButtonClicked = function(e) {
                return !!_this_1.selectChangeSponsorButton(e.target);
            };
            _this_1.selectChangeSponsorButton = function(current) {
                if (current) {
                    if (current.classList.contains(_this_1.classConfig.classNameChangeSponsorWrapper)) {
                        return current;
                    } else {
                        return _this_1.generalMethods.getClosestByClass(current, _this_1.classConfig.classNameChangeSponsorWrapper);
                    }
                } else {
                    return document.querySelector(_this_1.classConfig.selectorChangeSponsorWrapper);
                }
            };
            _this_1.nonSponsors = function(searchSponsorWrapper) {
                var triggerForDefaultSponsorInput = searchSponsorWrapper.querySelector(_this_1.classConfig.selectorNonSponsor);
                triggerForDefaultSponsorInput === null || triggerForDefaultSponsorInput === void 0 ? void 0 : triggerForDefaultSponsorInput.addEventListener("click", function() {
                    _this_1.defaultVisibility(searchSponsorWrapper);
                });
            };
            _this_1.updateUrl = function(newAlias) {
                var _a;
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_21.aliasQueryParam];
                if (currentAlias !== newAlias) {
                    urlParams = __assign(__assign({}, urlParams), (_a = {}, _a[_features_config_21.aliasQueryParam] = newAlias, 
                    _a));
                    var newURL = window.location.href.replace(window.location.search, "");
                    _this_1.cart.updateCartItemsProperies(newAlias);
                    _this_1.browserHistory.pushHistory(newURL, urlParams);
                }
            };
            _this_1.windowClick = function() {
                document.addEventListener("click", function(e) {
                    var searchSponsorsResult = document.querySelector(_this_1.classConfig.selectorChooseSponsor);
                    if (!!searchSponsorsResult) {
                        if (!_this_1.generalMethods.getClosestByClass(e.target, "st_search-input-and-result")) {
                            var sponsorWrappers = document.querySelectorAll(_this_1.classConfig.selectorSearchSponsorWrapperPage);
                            sponsorWrappers === null || sponsorWrappers === void 0 ? void 0 : sponsorWrappers.forEach(function(sponsorWrapper) {
                                _this_1.clearSponsorSuggestions(sponsorWrapper);
                            });
                        }
                    }
                });
            };
            _this_1.defaultVisibility = function(searchSponsorWrapper) {
                if (!!searchSponsorWrapper) {
                    _this_1.hideSearchInput(searchSponsorWrapper);
                    _this_1.showSearchResults(searchSponsorWrapper);
                }
            };
            _this_1.setSponsorWebAliasToForm = function(alias) {
                if (_features_config_21.canGoUnderCorporateSite || !_features_config_21.canGoUnderCorporateSite && alias !== _features_config_21.defaultWebAlias) {
                    var sponsorWebAliasFields = document.querySelectorAll(_this_1.classConfig.selectorRepresentativeAlias);
                    sponsorWebAliasFields === null || sponsorWebAliasFields === void 0 ? void 0 : sponsorWebAliasFields.forEach(function(field) {
                        _this_1.appendValueToField(field, alias);
                    });
                }
            };
            _this_1.getSponsorInfo = function(sponsorIdOrAlias) {
                if (_this_1.lastSponsorInfo && (_this_1.lastSponsorInfo.webAlias === sponsorIdOrAlias || _this_1.lastSponsorInfo.repId === sponsorIdOrAlias)) {
                    _this_1.injectSponsorInfo(_this_1.lastSponsorInfo);
                    return;
                }
                _this_1.loadersOnForSponsorInfo();
                _this_1.sponsorService.getSponsorInfo(sponsorIdOrAlias, function(request) {
                    var _a;
                    try {
                        if (request.status === 200) {
                            var sponsorInfoResponse = JSON.parse(request.response);
                            var sponsorsInformation = (_a = sponsorInfoResponse.data) === null || _a === void 0 ? void 0 : _a.sponsors;
                            var sponsorInformation = sponsorsInformation ? sponsorsInformation[0] : null;
                            if (!sponsorInformation.webAlias && sponsorInformation.webAlias === "") {
                                sponsorInformation.webAlias = sponsorInformation.repId;
                            }
                            _this_1.lastSponsorInfo = sponsorInformation;
                            _this_1.injectSponsorInfo(sponsorInformation);
                            _this_1.setRepCookies(sponsorInformation);
                        } else {
                            if (_this_1.retryWebAliasFetch) {
                                _this_1.retryWebAliasFetch = false;
                                _this_1.getSponsorInfo(_features_config_21.defaultWebAlias);
                            }
                        }
                    } catch (error) {
                        console.log(error);
                        _this_1.getSponsorInfo(_features_config_21.defaultWebAlias);
                    }
                });
            };
            _this_1.loadersOnForSponsorInfo = function() {
                var sponsorsData = document.querySelectorAll(_this_1.classConfig.selectorSponsorData);
                var svg = '<svg width="15" height="15" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#222" class="st_loader">\n                        <g fill="none" fill-rule="evenodd">\n                            <g transform="translate(1 1)" stroke-width="2">\n                                <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>\n                                <path d="M36 18c0-9.94-8.06-18-18-18">\n                                    <animateTransform\n                                            attributeName="transform"\n                                            type="rotate"\n                                            from="0 18 18"\n                                            to="360 18 18"\n                                            dur="1s"\n                                            repeatCount="indefinite"/>\n                                </path>\n                            </g>\n                        </g>\n                    </svg>';
                sponsorsData === null || sponsorsData === void 0 ? void 0 : sponsorsData.forEach(function(sponsorData) {
                    sponsorData.innerHTML = svg;
                });
            };
            _this_1.injectSponsorInfo = function(sponsorInformation) {
                var sponsorIdFields = document.querySelectorAll(_this_1.classConfig.selectorSponsorId);
                var sponsorAliasFields = document.querySelectorAll(_this_1.classConfig.selectorSponsorAlias);
                var sponsorFullNameFields = document.querySelectorAll(_this_1.classConfig.selectorSponsorFullName);
                var sponsorInitialsFields = document.querySelectorAll(_this_1.classConfig.selectorSponsorInitials);
                var sponsorAddressFields = document.querySelectorAll(_this_1.classConfig.selectorSponsorAddress);
                _this_1.injectTextIntoFields(sponsorIdFields, sponsorInformation.repId);
                _this_1.injectTextIntoFields(sponsorAliasFields, sponsorInformation.webAlias);
                _this_1.injectTextIntoFields(sponsorFullNameFields, "".concat(sponsorInformation.firstName, " ").concat(sponsorInformation.lastName));
                _this_1.injectTextIntoFields(sponsorInitialsFields, "".concat(sponsorInformation.firstName.charAt(0)).concat(sponsorInformation.lastName.charAt(0)));
                var address = sponsorInformation.address.state && sponsorInformation.address.state !== "" ? sponsorInformation.address.state + ", " + sponsorInformation.address.city : sponsorInformation.address.city;
                _this_1.injectTextIntoFields(sponsorAddressFields, address);
            };
            _this_1.searchSponsors = function(searchWrapper) {
                var input = searchWrapper.querySelector(_this_1.classConfig.selectorSearchSponsor);
                if (!!input) {
                    input.addEventListener("keyup", function(e) {
                        _this_1.getSponsors(input);
                    });
                    input.addEventListener("input", function(e) {
                        _this_1.getSponsors(input);
                    });
                    input.addEventListener("paste", function(e) {
                        _this_1.getSponsors(input);
                    });
                }
            };
            _this_1.getSponsors = function(input) {
                var value = input.value;
                if (_this_1.inputValue === value) return;
                if (value.length < _this_1.MIN_CHAR_SEARCH_REQUIREMENT) {
                    var searchSponsorInputWrapper = _this_1.generalMethods.getClosestByClass(input, _this_1.classConfig.classNameSearchInput);
                    _this_1.clearSponsorSuggestions(searchSponsorInputWrapper);
                    _this_1.enableRadioButtons(input);
                    return;
                }
                _this_1.inputValue = value;
                var requestType = _this_1.getCurrentRoute(input);
                _this_1.loaderOn(input);
                _this_1.disableRadioButtons(input);
                if (requestType === SponsorRequestType.GET_BY_ID_OR_ALIAS) {
                    _this_1.subscribeToTimeout(input, function() {
                        _this_1.sponsorService.getSponsorInfo(value, function(request) {
                            return _this_1.handleGetSponsorsResponse(request, input);
                        });
                    });
                }
                if (requestType === SponsorRequestType.GET_BY_PERSONAL_INFORMATION) {
                    _this_1.subscribeToTimeout(input, function() {
                        _this_1.sponsorService.getSponsorByPersonalInfo(value, function(request) {
                            return _this_1.handleGetSponsorsResponse(request, input);
                        });
                    });
                }
            };
            _this_1.getCurrentRoute = function(input) {
                var route;
                var sponsorWrapper = _this_1.generalMethods.getClosestByClass(input, _this_1.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this_1.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton, index) {
                    if (radioButton.classList.contains("st_checked")) {
                        route = index;
                    }
                });
                return route;
            };
            _this_1.enableRadioButtons = function(input) {
                var sponsorWrapper = _this_1.generalMethods.getClosestByClass(input, _this_1.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this_1.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                    radioButton.removeAttribute("disabled");
                });
            };
            _this_1.disableRadioButtons = function(input) {
                var sponsorWrapper = _this_1.generalMethods.getClosestByClass(input, _this_1.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this_1.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                    radioButton.setAttribute("disabled", "disabled");
                });
            };
            _this_1.initRadioButtons = function() {
                var radioButtonsWrappers = document.querySelectorAll(_this_1.classConfig.selectorSearchInput);
                radioButtonsWrappers === null || radioButtonsWrappers === void 0 ? void 0 : radioButtonsWrappers.forEach(function(radioButtonsWrapper) {
                    var radioButtons = radioButtonsWrapper.querySelectorAll(_this_1.classConfig.selectorSearchSponsorBy);
                    radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(input) {
                        input.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this_1.handleRadioButtonStatusChange(radioButtons, radioButtonsWrapper);
                            _this_1.clearSearchSponsorInputValueAndSuggestions(input);
                        });
                    });
                });
            };
            _this_1.setChecked = function(element) {
                if (!element.classList.contains("st_checked")) {
                    element.classList.add("st_checked");
                }
                element.setAttribute("checked", "checked");
            };
            _this_1.removeChecked = function(element) {
                if (element.classList.contains("st_checked")) {
                    element.classList.remove("st_checked");
                }
                element.removeAttribute("checked");
            };
            _this_1.renderPlaceholderText = function(radioButton, wrapper) {
                var label = _this_1.generalMethods.getClosestByTag(radioButton, "label");
                var text = label.querySelector(_this_1.classConfig.selectorRadioText).textContent;
                var placeholder = wrapper.querySelector(".st_search-input .st_placeholder-text");
                placeholder.innerHTML = text;
            };
            _this_1.clearSearchSponsorInputValueAndSuggestions = function(input) {
                var searchSponsorWrapper = _this_1.generalMethods.getClosestByClass(input, _this_1.classConfig.classNameSearchInput);
                if (!!searchSponsorWrapper) {
                    _this_1.clearSearchSponsorInputValue(searchSponsorWrapper);
                    _this_1.clearSponsorSuggestions(searchSponsorWrapper);
                }
            };
            _this_1.clearSearchSponsorInputValue = function(searchSponsorWrapper) {
                var searchSponsorInput = searchSponsorWrapper.querySelector(_this_1.classConfig.selectorSearchSponsor);
                if (!!searchSponsorInput) {
                    searchSponsorInput.value = "";
                    searchSponsorInput.replaceChildren();
                }
            };
            _this_1.clearSponsorSuggestions = function(searchSponsorWrapper) {
                var searchSponsorResult = searchSponsorWrapper.querySelector(_this_1.classConfig.selectorFoundSponsor);
                searchSponsorResult === null || searchSponsorResult === void 0 ? void 0 : searchSponsorResult.replaceChildren();
            };
            _this_1.renderSuggestionsWrapper = function(sponsorsList, input) {
                var sponsorsInputWrapper = _this_1.generalMethods.getClosestByClass(input, _this_1.classConfig.classNameSearchInput);
                if (!!sponsorsInputWrapper) {
                    var sponsorsWrapper_2 = sponsorsInputWrapper.querySelector(_this_1.classConfig.selectorFoundSponsor);
                    if (!!sponsorsWrapper_2) {
                        sponsorsWrapper_2.classList.remove("st_hidden");
                        sponsorsWrapper_2.replaceChildren();
                        sponsorsList === null || sponsorsList === void 0 ? void 0 : sponsorsList.forEach(function(sponsor) {
                            var sponsorJson = JSON.stringify(sponsor);
                            var buttonWithSponsorInfo = _this_1.createDOMElement("button", "st_search-sponsor-button--result st_choose-sponsor_JS", sponsorsWrapper_2);
                            buttonWithSponsorInfo.setAttribute("type", "button");
                            buttonWithSponsorInfo.setAttribute("data-sponsor-info", sponsorJson);
                            var leftPart = _this_1.createDOMElement("span", "st_result-left-part", buttonWithSponsorInfo);
                            var credentialsSection = _this_1.createDOMElement("span", "st_account-sponsor-credentials-section", leftPart);
                            var sponsorResultName = _this_1.createDOMElement("span", "st_result-name", leftPart);
                            var initialsSection = _this_1.createDOMElement("span", "st_account-sponsor-initials", credentialsSection);
                            var initialsJSSection = _this_1.createDOMElement("span", "st_sponsor-initials_JS", initialsSection);
                            initialsJSSection.innerHTML = "".concat(sponsor.firstName.charAt(0)).concat(sponsor.lastName.charAt(0));
                            var colWrapper = _this_1.createDOMElement("span", "st_span-full-width", sponsorResultName);
                            var fullName = _this_1.createDOMElement("span", "st_sponsor-fullname_JS", colWrapper);
                            fullName.innerHTML = sponsor.firstName + " " + sponsor.lastName;
                            var sponsorIdWrapper = _this_1.createDOMElement("span", "st_sponsor-id", colWrapper);
                            var sponsorIdNumber = _this_1.createDOMElement("span", "st_sponsor-id_JS", sponsorIdWrapper);
                            sponsorIdNumber.innerHTML = " (ID: " + sponsor.repId + ")";
                            var aliasWrapper = _this_1.createDOMElement("span", "st_sponsor-alias", sponsorResultName);
                            var aliasWrapperData = _this_1.createDOMElement("span", "st_sponsor-alias_JS", aliasWrapper);
                            aliasWrapperData.innerHTML = sponsor.webAlias;
                        });
                    }
                    _this_1.chooseSponsor(sponsorsInputWrapper);
                }
            };
            _this_1.createDOMElement = function(element, classNames, parentElement) {
                var newElement = document.createElement(element);
                newElement.className = classNames;
                parentElement.appendChild(newElement);
                return newElement;
            };
            _this_1.chooseSponsor = function(sponsorsInputWrapper) {
                var sponsorButtons = sponsorsInputWrapper.querySelectorAll(_this_1.classConfig.selectorChooseSponsor);
                sponsorButtons === null || sponsorButtons === void 0 ? void 0 : sponsorButtons.forEach(function(sponsor) {
                    sponsor.addEventListener("click", function(e) {
                        e.preventDefault();
                        var newSponsorJson = sponsor.getAttribute("data-sponsor-info");
                        var newSponsor = JSON.parse(newSponsorJson);
                        var sponsorWrappers = document.querySelectorAll(_this_1.classConfig.selectorSearchSponsorWrapperPage);
                        sponsorWrappers === null || sponsorWrappers === void 0 ? void 0 : sponsorWrappers.forEach(function(sponsorWrapper) {
                            _this_1.defaultVisibility(sponsorWrapper);
                        });
                        _this_1.updateUrl(newSponsor.webAlias);
                        _this_1.clearSearchSponsorInputValueAndSuggestions(e.target);
                        _this_1.injectSponsorInfo(newSponsor);
                        _this_1.setRepCookies(newSponsor);
                        _this_1.setSponsorWebAliasToForm(newSponsor.webAlias);
                        _this_1.setNewSponsorInfoToHeader(newSponsor.firstName, newSponsor.lastName, newSponsor.webAlias);
                        window.dispatchEvent(new Event("sponsorChange"));
                    });
                });
            };
            _this_1.setNewSponsorInfoToHeader = function(repFirstName, repLastName, webAlias) {
                var repFullNameFields = document.querySelectorAll(_this_1.classConfig.selectorRepresentativeFullName);
                var fullName = _this_1.getFullName(repFirstName, repLastName, webAlias);
                repFullNameFields === null || repFullNameFields === void 0 ? void 0 : repFullNameFields.forEach(function(field) {
                    _this_1.appendValueToField(field, fullName);
                });
            };
            _this_1.appendValueToField = function(field, value) {
                if (field.tagName.toLowerCase() === "input") {
                    field.value = value;
                } else {
                    field.innerHTML = value;
                }
            };
            _this_1.hideSuggestionsWrapper = function(input) {
                var sponsorsInputWrapper = _this_1.generalMethods.getClosestByClass(input, _this_1.classConfig.classNameSearchInput);
                var sponsorsWrapper = sponsorsInputWrapper === null || sponsorsInputWrapper === void 0 ? void 0 : sponsorsInputWrapper.querySelector(_this_1.classConfig.selectorFoundSponsor);
                sponsorsWrapper === null || sponsorsWrapper === void 0 ? void 0 : sponsorsWrapper.replaceChildren();
                sponsorsWrapper === null || sponsorsWrapper === void 0 ? void 0 : sponsorsWrapper.classList.add("st_hidden");
            };
            _this_1.generalMethods = generalMethods;
            _this_1.objectFormatting = objectFormatting;
            _this_1.browserHistory = browserHistory;
            _this_1.classConfig = classConfig;
            _this_1.cookies = cookies;
            _this_1.cart = cart;
            _this_1.sponsorService = sponsorService;
            _this_1.themeCart = themeCart;
            _this_1.webAlias = webAlias;
            return _this_1;
        }
        StSearchSponsorExtended.prototype.hideSearchResults = function(searchWrapper) {
            var searchResult = searchWrapper.querySelector(this.classConfig.selectorSearchResult);
            if (!(searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.contains("st_hidden"))) {
                searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.add("st_hidden");
            }
        };
        StSearchSponsorExtended.prototype.showSearchResults = function(searchWrapper) {
            var searchResult = searchWrapper.querySelector(this.classConfig.selectorSearchResult);
            if (searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.contains("st_hidden")) {
                searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.remove("st_hidden");
            }
        };
        StSearchSponsorExtended.prototype.hideSearchInput = function(searchWrapper) {
            var searchInput = searchWrapper.querySelector(this.classConfig.selectorSearchInput);
            if (!(searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.contains("st_hidden"))) {
                searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.add("st_hidden");
            }
        };
        StSearchSponsorExtended.prototype.showSearchInput = function(searchWrapper) {
            var searchInput = searchWrapper.querySelector(this.classConfig.selectorSearchInput);
            if (searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.contains("st_hidden")) {
                searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.remove("st_hidden");
            }
        };
        StSearchSponsorExtended.prototype.initSearchBoxFunctionality = function() {
            var _this_1 = this;
            var searchWrappers = document.querySelectorAll(this.classConfig.selectorSearchSponsorWrapperPage);
            if (searchWrappers.length > 0) {
                searchWrappers.forEach(function(wrapper) {
                    if (!wrapper.classList.contains("st_search-sponsor-init_JS")) {
                        wrapper.classList.add("st_search-sponsor-init_JS");
                        var customerID = window.customerInfoMetafields.customerId;
                        var sponsorRepID = window.customerInfoMetafields.representativeId;
                        var customerType = window.customerInfoMetafields.customerType;
                        var repSite = void 0;
                        if (!!customerID && _features_config_21.lockedRepresentativeSite && customerType !== _features_config_21.ECustomerType.noType) {
                            repSite = customerType === _features_config_21.ECustomerType.representative ? customerID : sponsorRepID;
                        } else {
                            var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                            var currentAlias = urlParams[_features_config_21.aliasQueryParam];
                            if (currentAlias) {
                                repSite = currentAlias;
                            } else {
                                if (!!_this_1.cookies.getCookie("webAlias")) {
                                    repSite = _this_1.cookies.getCookie("webAlias");
                                }
                            }
                        }
                        _this_1.getSponsorInfo(repSite);
                        _this_1.searchSponsors(wrapper);
                    }
                });
            }
        };
        StSearchSponsorExtended.prototype.injectTextIntoFields = function(fields, text) {
            fields === null || fields === void 0 ? void 0 : fields.forEach(function(field) {
                field.innerHTML = text;
            });
        };
        StSearchSponsorExtended.prototype.subscribeToTimeout = function(input, request) {
            var value = input.value;
            if (value.length > 1) {
                clearTimeout(this.requestTimeout);
                this.requestTimeout = setTimeout(request, this.REQUEST_DELAY);
            } else {
                var searchSponsorInputWrapper = this.generalMethods.getClosestByClass(input, this.classConfig.classNameSearchInput);
                this.clearSponsorSuggestions(searchSponsorInputWrapper);
                this.enableRadioButtons(input);
            }
        };
        StSearchSponsorExtended.prototype.handleGetSponsorsResponse = function(request, input) {
            var res = JSON.parse(request.response);
            if (res.status === 200) {
                var sponsorsList = res.data.sponsors;
                if (sponsorsList.length > 0) {
                    this.loaderOff(input);
                    this.enableRadioButtons(input);
                    this.renderSuggestionsWrapper(sponsorsList, input);
                } else {
                    this.loaderOff(input);
                    this.enableRadioButtons(input);
                    this.hideSuggestionsWrapper(input);
                }
            } else {
                this.loaderOff(input);
                this.enableRadioButtons(input);
                this.hideSuggestionsWrapper(input);
            }
        };
        StSearchSponsorExtended.prototype.handleRadioButtonStatusChange = function(radioButtons, radioButtonsWrapper) {
            var _this_1 = this;
            radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                if (!!radioButton.checked) {
                    _this_1.setChecked(radioButton);
                    _this_1.renderPlaceholderText(radioButton, radioButtonsWrapper);
                } else {
                    _this_1.removeChecked(radioButton);
                }
            });
        };
        StSearchSponsorExtended.prototype.getFullName = function(repFirstName, repLastName, webAlias) {
            var fullName = !!repLastName ? repFirstName : "";
            fullName = !!repLastName ? fullName.concat(" ".concat(repLastName)) : fullName;
            if (webAlias === _features_config_21.defaultWebAlias) fullName = _features_config_21.corporationName;
            return fullName;
        };
        return StSearchSponsorExtended;
    }(search_sponsor_1.StSearchSponsor);
    exports.StSearchSponsorExtended = StSearchSponsorExtended;
});

define("extension/shopify-app/st-modules/samplers/remove-samplers-mode", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_77, notification_17) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StRemoveSamplers = void 0;
    var StRemoveSamplers = function(_super) {
        __extends(StRemoveSamplers, _super);
        function StRemoveSamplers(generalMethods, notifications, buttonActions, cart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "RemoveSamplers";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.removeSamplerCartEvent();
                    _this_1.goToSamplerOrder();
                });
            };
            _this_1.goToSamplerOrder = function() {
                var samplerButtons = document.querySelectorAll(".wine_sample-order_JS");
                samplerButtons.forEach(function(btn) {
                    btn.addEventListener("click", function() {
                        window.location.assign(window.location.protocol + "//" + window.location.host + "/cart");
                    });
                });
            };
            _this_1.removeSamplerCartEvent = function() {
                var _this = _this_1;
                var body = document.querySelector("body");
                if (!body.classList.contains("wine_remove_sampler_setup")) {
                    body.classList.add("wine_remove_sampler_setup");
                    document.addEventListener("click", function(e) {
                        if (_this.isRemoveSamplerButtonClicked(e)) {
                            e.preventDefault();
                            _this.clickOnRemoveSamplersMode();
                        }
                    });
                }
            };
            _this_1.selectRemoveSamplerButton = function(current) {
                if (current) {
                    if (current.classList.contains("wine_remove-samplers-mode_JS")) {
                        return current;
                    } else {
                        return _this_1.generalMethods.getClosestByClass(current, "wine_remove-samplers-mode_JS");
                    }
                } else {
                    return document.querySelector(".wl_share-cart--generate-url-button_JS");
                }
            };
            _this_1.isRemoveSamplerButtonClicked = function(e) {
                return !!_this_1.selectRemoveSamplerButton(e.target);
            };
            _this_1.clickOnRemoveSamplersMode = function() {
                var _this = _this_1;
                var buttons = document.querySelectorAll(".wine_remove-samplers-mode_JS");
                buttons.forEach(function(button) {
                    _this.buttonActions.prevent(button);
                });
                _this.cart.updateCartAttributesOrNote({
                    attributes: {
                        sampler: "",
                        billingDate: "",
                        samplerDate: ""
                    }
                }, function(cartRes) {
                    _this.cart.clearCart(function() {
                        _this.hideSampleModBanner();
                        window.location.assign(window.location.protocol + "//" + window.location.hostname);
                        buttons.forEach(function(button) {
                            _this.buttonActions.allow(button);
                        });
                    });
                });
            };
            _this_1.hideSampleModBanner = function() {
                var sampleModBanner = document.querySelector(".wine_sampler-mode-banner");
                sampleModBanner.classList.add("st_hidden");
            };
            _this_1.removeItemFormCart = function(sampler) {
                var _this = _this_1;
                var validateSamplerRequest = {
                    sampleToken: sampler
                };
                _this.ajax.send({
                    endpoint: _this.endpoint["sampler"]["validateLink"],
                    method: "post",
                    data: validateSamplerRequest,
                    callback: function(response) {
                        try {
                            var submitResponse = JSON.parse(response.response);
                            if (submitResponse.status === 200) {
                                if (submitResponse.data.isValid) {
                                    localStorage.removeItem("sampler");
                                    var sampleID = parseInt(submitResponse.data.chosenItemId);
                                    var newObj = {};
                                    newObj["".concat(sampleID)] = 0;
                                    _this.cart.updateCart({
                                        updates: newObj
                                    }, function(r) {
                                        var attributes = window.shopifyCartData.attributes;
                                        attributes.sampler.delete;
                                    });
                                } else {
                                    _this.notifications.showNotification(notification_17.ENotificationType.error, "Sampler link isn't valid or doesn't exist.");
                                }
                            } else {
                                _this.notifications.showNotification(notification_17.ENotificationType.error, "An Error Occurred", submitResponse.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notifications.showNotification(notification_17.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.generalMethods = generalMethods;
            _this_1.notifications = notifications;
            _this_1.buttonActions = buttonActions;
            _this_1.cart = cart;
            return _this_1;
        }
        return StRemoveSamplers;
    }(st_module_77.StModule);
    exports.StRemoveSamplers = StRemoveSamplers;
});

define("extension/shopify-app/st-modules/samplers/additional-items/samplers-additional-item", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_78) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSamplersAdditionalItem = void 0;
    var ESamplerAdditionalButtons;
    (function(ESamplerAdditionalButtons) {
        ESamplerAdditionalButtons["remove"] = "remove";
        ESamplerAdditionalButtons["add"] = "add";
    })(ESamplerAdditionalButtons || (ESamplerAdditionalButtons = {}));
    var StSamplersAdditionalItem = function(_super) {
        __extends(StSamplersAdditionalItem, _super);
        function StSamplersAdditionalItem(generalMethods, notifications, buttonActions, stCart, themeCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "SamplersAdditionalItem";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.checkCartItem();
                    _this_1.themeCart.bindDrawerEvent(_this_1.checkCartItem);
                });
            };
            _this_1.checkCartItem = function() {
                var hasSample = window.shopifyCartData.attributes.sampler;
                if (hasSample) {
                    var samplerItemArr_1 = [];
                    var additionalItemArr_1 = [];
                    _this_1.stCart.getCart(function(response) {
                        var itemsInCart = response.items;
                        itemsInCart.forEach(function(item) {
                            if (item.properties._bundleHandle) {
                                additionalItemArr_1.push({
                                    id: Number(item.variant_id),
                                    quantity: Number(item.quantity)
                                });
                            } else {
                                samplerItemArr_1.push({
                                    id: item.variant_id,
                                    quantity: item.quantity
                                });
                            }
                        });
                        _this_1.prepareAdditionalFor(additionalItemArr_1);
                    });
                }
            };
            _this_1.prepareAdditionalFor = function(additionalItemArr) {
                var updates = {};
                for (var i = 0; i < additionalItemArr.length; i++) {
                    additionalItemArr[i].quantity = 0;
                    var itemId = parseInt(String(additionalItemArr[i].id), 10);
                    updates[itemId] = 0;
                }
                var updatesStructure = {
                    updates: updates
                };
                _this_1.clickOnAdditionalItem(updatesStructure);
            };
            _this_1.clickOnAdditionalItem = function(updates) {
                var _this = _this_1;
                var additionalItemsWrapper = document.querySelectorAll(".wine_additional-items-btns_JS");
                additionalItemsWrapper.forEach(function(wrapper) {
                    var addAdditionalItemAnchor = wrapper.querySelector(".wine_add-additional-item-button_JS");
                    var removeAdditionalItemsButton = wrapper.querySelector(".wine_remove-additional-item-button_JS");
                    var activeButton = Object.keys(updates.updates).length > 0 ? ESamplerAdditionalButtons.remove : ESamplerAdditionalButtons.add;
                    _this.switchButtons(activeButton);
                    if (!addAdditionalItemAnchor.classList.contains("st-sampler-event-bind")) {
                        addAdditionalItemAnchor.classList.add("st-sampler-event-bind");
                        addAdditionalItemAnchor.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.addOrRemoveAdditionalItems(updates, addAdditionalItemAnchor);
                        });
                    }
                    if (!removeAdditionalItemsButton.classList.contains("st-sampler-event-bind")) {
                        removeAdditionalItemsButton.classList.add("st-sampler-event-bind");
                        removeAdditionalItemsButton.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.addOrRemoveAdditionalItems(updates, removeAdditionalItemsButton);
                        });
                    }
                });
            };
            _this_1.addOrRemoveAdditionalItems = function(updates, button) {
                var _a;
                var redirectUrl = "https://" + location.host + ((_a = window.additionalProducts) === null || _a === void 0 ? void 0 : _a.href);
                if (!redirectUrl) {
                    console.error("Redirect URL is not defined");
                    return;
                }
                var responseHandle = function(response) {
                    var _this = _this_1;
                    var additionalItemsWrapper = document.querySelectorAll(".wine_additional-items-btns_JS");
                    additionalItemsWrapper.forEach(function(wrapper) {
                        var activeButton = Object.keys(updates.updates).length > 0 ? ESamplerAdditionalButtons.remove : ESamplerAdditionalButtons.add;
                        _this.switchButtons(activeButton);
                        if (button.classList.contains("wine_remove-additional-item-button_JS")) {
                            window.location.reload();
                        }
                    });
                };
                if (updates && Object.keys(updates.updates).length > 0) {
                    _this_1.buttonActions.prevent(button);
                    _this_1.stCart.updateCart(updates, responseHandle);
                } else {
                    window.location.href = redirectUrl;
                }
            };
            _this_1.switchButtons = function(activeButton) {
                var additionalItemsWrapper = document.querySelectorAll(".wine_additional-items-btns_JS");
                additionalItemsWrapper.forEach(function(wrapper) {
                    var addAdditionalItemAnchor = wrapper.querySelector(".wine_add-additional-item-button_JS");
                    var removeAdditionalItemsButton = wrapper.querySelector(".wine_remove-additional-item-button_JS");
                    if (activeButton == ESamplerAdditionalButtons.remove) {
                        addAdditionalItemAnchor.classList.add("st_hidden");
                        removeAdditionalItemsButton.classList.remove("st_hidden");
                    } else {
                        addAdditionalItemAnchor.classList.remove("st_hidden");
                        removeAdditionalItemsButton.classList.add("st_hidden");
                    }
                });
            };
            _this_1.generalMethods = generalMethods;
            _this_1.notifications = notifications;
            _this_1.buttonActions = buttonActions;
            _this_1.stCart = stCart;
            _this_1.themeCart = themeCart;
            return _this_1;
        }
        return StSamplersAdditionalItem;
    }(st_module_78.StModule);
    exports.StSamplersAdditionalItem = StSamplersAdditionalItem;
});

define("extension/shopify-app/st-modules/samplers/edit-sempler/edit-sampler", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_79) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEditSampler = void 0;
    var StEditSampler = function(_super) {
        __extends(StEditSampler, _super);
        function StEditSampler(generalMethods, notifications, buttonActions, cart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EditSampler";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var _this = _this_1;
                    _this.clickOnCloseSampler();
                    _this.choseNewSampler();
                    _this.clickOnSave();
                    _this.clickOnCancel();
                    _this.editSamplerEvent();
                });
            };
            _this_1.editSamplerEvent = function() {
                var _this = _this_1;
                var body = document.querySelector("body");
                if (!body.classList.contains("wine_edit_sampler_setup")) {
                    body.classList.add("wine_edit_sampler_setup");
                    document.addEventListener("click", function(e) {
                        if (_this.isEditSamplerButtonClicked(e)) {
                            _this.showSamplerBanner();
                        }
                    });
                }
            };
            _this_1.selectEditSamplerButton = function(current) {
                if (current) {
                    if (current.classList.contains("wine_cart-edit-sampler-btn_JS")) {
                        return current;
                    } else {
                        return _this_1.generalMethods.getClosestByClass(current, "wine_cart-edit-sampler-btn_JS");
                    }
                } else {
                    return document.querySelector(".wine_cart-edit-sampler-btn_JS");
                }
            };
            _this_1.isEditSamplerButtonClicked = function(e) {
                return !!_this_1.selectEditSamplerButton(e.target);
            };
            _this_1.clickOnCloseSampler = function() {
                var _this = _this_1;
                var closeEditSamplerBanner = document.querySelector(".wine_samplers-edit-sampler-close-btn_JS");
                if (!!closeEditSamplerBanner) {
                    closeEditSamplerBanner.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.hideSamplerBanner();
                    });
                }
            };
            _this_1.choseNewSampler = function() {
                var _this = _this_1;
                var checkboxes = document.querySelectorAll(".wine_chosen-sample_JS");
                var saveButton = document.querySelector(".wine_samplers-edit-sampler-button-save_JS");
                _this_1.buttonActions.disable(saveButton);
                if (!!checkboxes) {
                    checkboxes.forEach(function(checkbox) {
                        var cartData = window.shopifyCartData;
                        cartData.items.forEach(function(item) {
                            var isSample = item.properties.sampler;
                            if (isSample) {
                                var sellingPlan = item.selling_plan_allocation.selling_plan.id;
                                checkbox.setAttribute("data-selling-plan", sellingPlan);
                            }
                        });
                        _this.addInfoToSaveButton(checkbox);
                        checkbox.addEventListener("change", function() {
                            _this.addInfoToSaveButton(this);
                        });
                    });
                }
            };
            _this_1.addInfoToSaveButton = function(checkbox) {
                if (checkbox.checked) {
                    var variantId = checkbox.getAttribute("data-variant-id");
                    var sellingPlan = checkbox.getAttribute("data-selling-plan");
                    var saveButton = document.querySelector(".wine_samplers-edit-sampler-button-save_JS");
                    if (!!saveButton) {
                        saveButton.setAttribute("data-variant-id", variantId);
                        saveButton.setAttribute("data-selling-plan", sellingPlan);
                        _this_1.buttonActions.enable(saveButton);
                    }
                }
            };
            _this_1.clickOnSave = function() {
                var _this = _this_1;
                var saveButton = document.querySelector(".wine_samplers-edit-sampler-button-save_JS");
                if (!!saveButton) {
                    saveButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.buttonActions.prevent(this);
                        var variantId = this.getAttribute("data-variant-id");
                        var sellingPlan = this.getAttribute("data-selling-plan");
                        var haveSample = window.shopifyCartData.attributes.sampler;
                        if (haveSample) {
                            _this.cart.getCart(function(response) {
                                var itemsInCart = response.items;
                                itemsInCart.forEach(function(item) {
                                    if (!item.properties._bundleHandle) {
                                        if (Number(item.variant_id) === Number(variantId)) {
                                            _this.buttonActions.allow(saveButton);
                                            _this.hideSamplerBanner();
                                        } else {
                                            _this.changeSampler(item.variant_id, parseInt(variantId), !!sellingPlan ? parseInt(sellingPlan) : 0);
                                        }
                                    } else {
                                        _this.buttonActions.allow(saveButton);
                                    }
                                });
                            });
                        } else {
                            console.log("Sampler not found in attributes - doing nothing");
                        }
                    });
                }
            };
            _this_1.prepareSamplerForDelete = function(samplerItemArrDelete, samplerItemArrAdd) {
                var updates = {};
                for (var i = 0; i < samplerItemArrDelete.length; i++) {
                    samplerItemArrDelete[i].quantity = 0;
                    var itemId = parseInt(String(samplerItemArrDelete[i].id), 10);
                    updates[itemId] = 0;
                }
                var updatesStructure = {
                    updates: updates
                };
                if (updatesStructure) {
                    _this_1.cart.updateCart(updatesStructure, function(response) {
                        for (var i = 0; i < samplerItemArrAdd.length; i++) {
                            _this_1.cart.addCart(samplerItemArrAdd[i], function(response) {});
                        }
                    });
                }
            };
            _this_1.changeSampler = function(previousSamplerID, newSamplerID, newSamplerSellingPlan) {
                if (newSamplerSellingPlan === void 0) {
                    newSamplerSellingPlan = 0;
                }
                var updates = {};
                updates[previousSamplerID] = 0;
                _this_1.cart.updateCart({
                    updates: updates
                }, function(response) {
                    var addItem = {
                        id: newSamplerID,
                        quantity: 1,
                        properties: {
                            sampler: true
                        }
                    };
                    _this_1.cart.addCart(addItem, function(response) {});
                });
            };
            _this_1.clickOnCancel = function() {
                var _this = _this_1;
                var cancelBtn = document.querySelector(".wine_samplers-edit-sampler-button-cancel_JS");
                if (!!cancelBtn) {
                    cancelBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.hideSamplerBanner();
                    });
                }
            };
            _this_1.showSamplerBanner = function() {
                var samplerBannerWrp = document.querySelector(".wine_samplers-edit-sampler-main-wrapper_JS");
                if (!!samplerBannerWrp) {
                    samplerBannerWrp.classList.remove("st_hidden");
                }
            };
            _this_1.hideSamplerBanner = function() {
                var samplerBannerWrp = document.querySelector(".wine_samplers-edit-sampler-main-wrapper_JS");
                if (!!samplerBannerWrp) {
                    samplerBannerWrp.classList.add("st_hidden");
                }
            };
            _this_1.generalMethods = generalMethods;
            _this_1.notifications = notifications;
            _this_1.buttonActions = buttonActions;
            _this_1.cart = cart;
            return _this_1;
        }
        return StEditSampler;
    }(st_module_79.StModule);
    exports.StEditSampler = StEditSampler;
});

define("extension/shopify-app/st-modules/samplers/shipping-date-picker/shipping-date-picker", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_80, notification_18) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShippingDateSamplers = void 0;
    var StShippingDateSamplers = function(_super) {
        __extends(StShippingDateSamplers, _super);
        function StShippingDateSamplers(generalMethods, notifications, buttonActions, cart, themeCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "ShippingDateSamplers";
            _this_1.lastValidDate = "";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setFutureDate();
                    _this_1.changeDateInput();
                    _this_1.resetLastValidDate();
                    _this_1.themeCart.bindDrawerEvent(_this_1.setFutureDate, _this_1.selectedDate ? [ _this_1.selectedDate ] : []);
                });
            };
            _this_1.setFutureDate = function(setDate) {
                var inputElements = document.querySelectorAll(".wine_shipping-date-picker-input_JS");
                if (inputElements) {
                    var localDate = new Date();
                    var minimumDate_1 = new Date(localDate.getFullYear(), localDate.getMonth(), localDate.getDate() + 1);
                    var dateForInput_1 = _this_1.formatDateToYYYYMMDD(minimumDate_1);
                    var utcDate = new Date(minimumDate_1.getTime() + minimumDate_1.getTimezoneOffset() * 6e4);
                    var dateForBackend_1 = utcDate.toISOString().slice(0, 10);
                    inputElements.forEach(function(inputElement) {
                        var formattedDate;
                        if (setDate) {
                            formattedDate = setDate;
                        } else {
                            formattedDate = inputElement.value || dateForBackend_1;
                            if (inputElement.value) {
                                var savedDateSplit = formattedDate.split("-");
                                if (savedDateSplit.length === 3) {
                                    var savedDate = new Date(parseInt(savedDateSplit[0]), parseInt(savedDateSplit[1]) - 1, parseInt(savedDateSplit[2]));
                                    if (savedDate.getTime() < minimumDate_1.getTime()) {
                                        formattedDate = dateForBackend_1;
                                    }
                                }
                            }
                        }
                        inputElement.value = dateForInput_1;
                        inputElement.setAttribute("value", dateForInput_1);
                        _this_1.selectedDate = minimumDate_1.toDateString();
                        inputElement.setAttribute("min", dateForInput_1);
                        _this_1.changeDateInput(inputElement);
                        _this_1.backendValidation(formattedDate, false);
                    });
                }
            };
            _this_1.resetLastValidDate = function() {
                var newSamplerButtons = document.querySelectorAll(".wine_make_new-sampler-button_JS");
                newSamplerButtons === null || newSamplerButtons === void 0 ? void 0 : newSamplerButtons.forEach(function(button) {
                    button.addEventListener("click", function() {
                        _this_1.lastValidDate = "";
                    });
                });
            };
            _this_1.changeDateInput = function(inputElement) {
                var inputElements = document.querySelectorAll(".wine_shipping-date-picker-input_JS");
                if (!!inputElements) {
                    inputElements.forEach(function(inputElement) {
                        var _this = _this_1;
                        if (!inputElement.classList.contains("st-sampler-event-bind")) {
                            inputElement.classList.add("st-sampler-event-bind");
                            inputElement.addEventListener("change", function(e) {
                                e.preventDefault();
                                if (_this.isWeekend(this.value)) {
                                    var today = new Date();
                                    today.setDate(today.getDate() + 1);
                                    _this.lastValidDate === "" ? this.value = _this.formatDateToYYYYMMDD(today) : this.value = _this.lastValidDate;
                                    _this.notifications.showNotification(notification_18.ENotificationType.error, "An Error Occurred", window.stTranslations.samplerDateErrorMessage);
                                } else {
                                    this.setAttribute("value", this.value);
                                    _this.lastValidDate = this.value;
                                    _this.backendValidation(this.value);
                                }
                            });
                        }
                    });
                }
            };
            _this_1.isWeekend = function(dateString) {
                var split = dateString.split("-");
                var date = new Date(parseInt(split[0]), parseInt(split[1]) - 1, parseInt(split[2]));
                var day = date.getDay();
                return day === 0 || day === 6;
            };
            _this_1.backendValidation = function(date, notification) {
                if (notification === void 0) {
                    notification = true;
                }
                var _this = _this_1;
                var validateSamplerRequest = {
                    validateDate: date
                };
                _this.ajax.send({
                    endpoint: _this.endpoint["sampler"]["validateDate"],
                    method: "post",
                    data: validateSamplerRequest,
                    callback: function(response) {
                        try {
                            var submitResponse = !!response.response ? JSON.parse(response.response) : "";
                            if (submitResponse.status === 200) {
                                _this.stCart.updateCartAttributesOrNote({
                                    attributes: {
                                        billingDate: date
                                    }
                                }, function(response) {});
                                if (notification) {
                                    _this.notifications.showNotification(notification_18.ENotificationType.success, "Sampler Shipping", submitResponse.message);
                                }
                            } else {
                                if (notification) {
                                    _this.notifications.showNotification(notification_18.ENotificationType.error, "An Error Occurred", submitResponse.message);
                                }
                            }
                        } catch (error) {
                            console.error(error);
                            if (notification) {
                                _this.notifications.showNotification(notification_18.ENotificationType.error, "An Error Occurred", error);
                            }
                        }
                    }
                });
            };
            _this_1.generalMethods = generalMethods;
            _this_1.notifications = notifications;
            _this_1.buttonActions = buttonActions;
            _this_1.stCart = cart;
            _this_1.themeCart = themeCart;
            return _this_1;
        }
        StShippingDateSamplers.prototype.formatDateToYYYYMMDD = function(date) {
            var year = date.getFullYear();
            var month = String(date.getMonth() + 1).padStart(2, "0");
            var day = String(date.getDate()).padStart(2, "0");
            return "".concat(year, "-").concat(month, "-").concat(day);
        };
        return StShippingDateSamplers;
    }(st_module_80.StModule);
    exports.StShippingDateSamplers = StShippingDateSamplers;
});

define("extension/shopify-app/st-modules/account/blocks/affiliate/affiliate", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_81) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountAffiliate = void 0;
    var StAccountAffiliate = function(_super) {
        __extends(StAccountAffiliate, _super);
        function StAccountAffiliate() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "AccountAffiliate";
            _this.init = function() {};
            return _this;
        }
        return StAccountAffiliate;
    }(st_module_81.StModule);
    exports.StAccountAffiliate = StAccountAffiliate;
});

define("extension/shopify-app/st-modules/loading-page/loading-page", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_82) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StLoadingPage = void 0;
    var StLoadingPage = function(_super) {
        __extends(StLoadingPage, _super);
        function StLoadingPage(objectFormatting, JWT) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "LoadingPage";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                    if (!!urlParams.return_url) {
                        _this_1.checkIfCustomerIsLoggedIn(urlParams);
                    }
                });
            };
            _this_1.objectFormatting = objectFormatting;
            _this_1.JWT = JWT;
            return _this_1;
        }
        StLoadingPage.prototype.checkIfCustomerIsLoggedIn = function(urlParams) {
            var _this = this;
            if (window.customerShopifyId == 0) {
                this.redirectToLogin(urlParams);
            } else {
                this.JWT.createJwt(urlParams.return_url, this.JWT.redirect);
            }
        };
        StLoadingPage.prototype.redirectToLogin = function(urlParams) {
            var urlParamsComplete = urlParams;
            urlParamsComplete.has_token = 1;
            var urlParamsQuery = this.objectFormatting.convertObjectToQueryString(urlParamsComplete);
            window.location.href = window.location.protocol + "//" + window.location.hostname + "/account/login" + urlParamsQuery;
        };
        return StLoadingPage;
    }(st_module_82.StModule);
    exports.StLoadingPage = StLoadingPage;
});

define("core/shopify-app/st-modules/account-login/account-login", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_83) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountLogin = void 0;
    var StAccountLogin = function(_super) {
        __extends(StAccountLogin, _super);
        function StAccountLogin(form, notification, buttonActions, classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountLogin";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.togglePassword();
                });
            };
            _this_1.togglePassword = function() {
                var _this = _this_1;
                var formControl = document.querySelector(_this_1.classConfig.selectorLoginPasswordFormControl);
                var passwordEyeIcons = formControl.querySelectorAll(_this_1.classConfig.selectorPasswordVisibilityButton);
                passwordEyeIcons.forEach(function(icon) {
                    icon.addEventListener("click", function(e) {
                        e.preventDefault();
                        var passwordInput = formControl.querySelector(_this.classConfig.selectorLoginPasswordInput);
                        if (!!passwordInput) {
                            if (passwordInput.getAttribute("type") === "password") {
                                passwordInput.setAttribute("type", "text");
                                this.classList.add("st_password-visible");
                            } else {
                                passwordInput.setAttribute("type", "password");
                                this.classList.remove("st_password-visible");
                            }
                        }
                    });
                });
            };
            _this_1.form = form;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountLogin;
    }(st_module_83.StModule);
    exports.StAccountLogin = StAccountLogin;
});

define("extension/shopify-app/st-modules/account-login/account-login", [ "require", "exports", "core/shopify-app/st-modules/account-login/account-login" ], function(require, exports, account_login_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountLoginExtended = void 0;
    var StAccountLoginExtended = function(_super) {
        __extends(StAccountLoginExtended, _super);
        function StAccountLoginExtended(form, notification, buttonActions, classConfig, generalMethods) {
            var _this = _super.call(this, form, notification, buttonActions, classConfig, generalMethods) || this;
            _this.className = "AccountLogin";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {});
            };
            return _this;
        }
        return StAccountLoginExtended;
    }(account_login_1.StAccountLogin);
    exports.StAccountLoginExtended = StAccountLoginExtended;
});

define("extension/shopify-app/st-modules/account-login/account-login-class-config.extended", [ "require", "exports", "core/shopify-app/st-modules/account-login/account-login-class-config" ], function(require, exports, account_login_class_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountLoginClassConfigExtended = void 0;
    var StAccountLoginClassConfigExtended = function(_super) {
        __extends(StAccountLoginClassConfigExtended, _super);
        function StAccountLoginClassConfigExtended() {
            var _this = _super.call(this) || this;
            _this.className = "EnrollmentAccountClassConfig";
            _this.classLoginCustomerControl = "wine_login-sign-in-account-btn_JS";
            _this.selectorLoginCustomerControl = "." + _this.classLoginCustomerControl;
            _this.classLoginForm = "st_login-form-JWT-intercept_JS";
            _this.selectorLoginForm = "." + _this.classLoginForm;
            _this.classRegisterControl = "wine_login--create-account-btn_JS";
            _this.selectorRegisterControl = "." + _this.classRegisterControl;
            return _this;
        }
        return StAccountLoginClassConfigExtended;
    }(account_login_class_config_1.StAccountLoginClassConfig);
    exports.StAccountLoginClassConfigExtended = StAccountLoginClassConfigExtended;
});

define("extension/shopify-app/st-modules/account-login/login-redirect", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_84) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StLoginRedirect = void 0;
    var StLoginRedirect = function(_super) {
        __extends(StLoginRedirect, _super);
        function StLoginRedirect(form, notification, buttonActions, classConfig, generalMethods, objectFormatting) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "LoginRedirect";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {});
            };
            _this.form = form;
            _this.notification = notification;
            _this.buttonActions = buttonActions;
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        return StLoginRedirect;
    }(st_module_84.StModule);
    exports.StLoginRedirect = StLoginRedirect;
});

define("extension/shopify-app/st-modules/account-login/account-login-with-jwt", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, notification_19, st_module_85) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountLoginWithJWT = void 0;
    var StAccountLoginWithJWT = function(_super) {
        __extends(StAccountLoginWithJWT, _super);
        function StAccountLoginWithJWT(form, accountRegisterClassConfig, notification, JWT, objectFormatting, enrollmentCheck, wineCellar, customerType, buttonActions) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountLoginWIthJWT";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    if (_this_1.JWT.shouldUseJWT()) {
                        _this_1.interceptLogin();
                    }
                    _this_1.checkLoginPage();
                    _this_1.formBind();
                    _this_1.createAccountButtonBind();
                });
            };
            _this_1.interceptLogin = function() {
                _this_1.formBind();
                _this_1.createAccountButtonBind();
            };
            _this_1.checkLoginPage = function() {
                var urlToString = window.location.href.toString();
                if (urlToString.includes("/account/login")) {
                    if (_this_1.enrollmentCheck.enrollmentLoginCheck()) {
                        _this_1.enrollmentCheck.showLoginContent();
                        _this_1.formBind();
                        _this_1.createAccountButtonBind();
                    }
                }
            };
            _this_1.loginCustomer = function(formData, returnURL, formButton) {
                var _this = _this_1;
                var loginPayload = {};
                loginPayload.form_type = "customer_login";
                loginPayload["customer[email]"] = formData["customer[email]"];
                loginPayload["customer[password]"] = formData["customer[password]"];
                _this.ajax.send({
                    endpoint: window.location.protocol + "//" + window.location.hostname + "/account/login",
                    method: "post",
                    contentType: "form",
                    data: loginPayload,
                    callback: function(response, returnURL) {
                        try {
                            if (response.status == 200) {
                                var redirectUrlResponse = response.responseURL.toString();
                                if (redirectUrlResponse.includes("/account/login")) {
                                    _this.revertSubmitButtonToDefault();
                                    _this.buttonActions.allow(formButton);
                                    _this.notification.showNotification(notification_19.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                                } else {
                                    if (!!returnURL) {
                                        _this.JWT.createJwt(returnURL, _this.JWT.redirect, loginPayload["customer[email]"]);
                                    } else if (_this.enrollmentCheck.enrollmentLoginCheck()) {
                                        window.location.href = "/pages/enrollment-check";
                                        _this.enrollmentCheck.hideLoginContent();
                                    } else {
                                        window.location.assign("/pages/login-routing");
                                    }
                                }
                            } else {
                                window.location.reload();
                                _this.revertSubmitButtonToDefault();
                                _this.buttonActions.allow(formButton);
                                _this.notification.showNotification(notification_19.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.revertSubmitButtonToDefault();
                            _this.buttonActions.allow(formButton);
                            _this.notification.showNotification(notification_19.ENotificationType.error, "Server Error", error);
                        }
                    },
                    callbackParams: [ returnURL ]
                });
            };
            _this_1.revertSubmitButtonToDefault = function() {
                var submitBtn = document.querySelector('[type="submit"]');
                if (!!submitBtn) {
                    submitBtn.removeAttribute("aria-busy");
                }
            };
            _this_1.formBind = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorLoginForm);
                if (!!form) {
                    var formButton_1 = form.querySelector(_this_1.classConfig.selectorLoginCustomerControl);
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.buttonActions.prevent(formButton_1);
                        var formData = _this.form.collectFormData(this);
                        var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                        _this.loginCustomer(formData, !!urlParams.return_url ? urlParams.return_url : null, formButton_1);
                    });
                }
            };
            _this_1.createAccountButtonBind = function() {
                var _this = _this_1;
                var createAccountBtn = document.querySelector(_this_1.classConfig.selectorRegisterControl);
                if (!!createAccountBtn) {
                    createAccountBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var urlParamsQuery = "";
                        var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                        if (!!urlParams.return_url) {
                            urlParams.has_token = "1";
                            urlParamsQuery = _this.objectFormatting.convertObjectToQueryString(urlParams);
                        }
                        if (_this.enrollmentCheck.enrollmentLoginCheck) {
                            urlParams.loged = "false";
                            urlParamsQuery = _this.objectFormatting.convertObjectToQueryString(urlParams);
                        }
                        window.location.href = window.location.protocol + "//" + window.location.hostname + "/account/register" + urlParamsQuery;
                    });
                }
            };
            _this_1.form = form;
            _this_1.classConfig = accountRegisterClassConfig;
            _this_1.notification = notification;
            _this_1.JWT = JWT;
            _this_1.objectFormatting = objectFormatting;
            _this_1.enrollmentCheck = enrollmentCheck;
            _this_1.wineCellar = wineCellar;
            _this_1.customerType = customerType;
            _this_1.buttonActions = buttonActions;
            return _this_1;
        }
        return StAccountLoginWithJWT;
    }(st_module_85.StModule);
    exports.StAccountLoginWithJWT = StAccountLoginWithJWT;
});

define("extension/shopify-app/st-modules/account/blocks/personal-site/personal-site", [ "require", "exports", "core/shopify-app/st-modules/account/blocks/personal-site/personal-site", "_features.config" ], function(require, exports, personal_site_1, _features_config_22) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountPersonalSiteExtended = void 0;
    var StAccountPersonalSiteExtended = function(_super) {
        __extends(StAccountPersonalSiteExtended, _super);
        function StAccountPersonalSiteExtended(classConfig, generalMethods) {
            var _this = _super.call(this, classConfig, generalMethods) || this;
            _this.className = "AccountPersonalSite";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.copyRefToClipboard(_this.classConfig.selectorAccountIconCopyText, ".st_representative-site-link_JS");
                    _this.getRefCode();
                });
            };
            _this.getRefCode = function() {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_retail-personal-promo-code-link_JS");
                if (_features_config_22.shareRefCodeFunctionality) {
                    _this.copyRefToClipboard(".st_referral-link-copy-clipboard_JS", ".st_retail-personal-promo-code-link_JS");
                    _this.createLinkWithRef();
                    _this.showIncludePromoCode();
                    _this.showPersonalSiteRetailBlock();
                    if (!customersRef) {
                        _this.createLinkWithoutRef();
                    }
                } else {
                    _this.hideIncludePromoCode();
                    _this.hidePersonalSiteRetailBlock();
                    _this.createLinkWithoutRef();
                }
            };
            _this.createLinkWithRef = function() {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_retail-personal-promo-code-link_JS");
                var alias = localStorage.getItem("webAlias");
                retailInput.forEach(function(input) {
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_22.aliasQueryParam + "=" + alias;
                });
            };
            _this.createLinkWithoutRef = function() {
                var inputEl = document.querySelectorAll(".st_representative-site-link_JS");
                if (inputEl) {
                    inputEl.forEach(function(input) {
                        var als = localStorage.getItem("webAlias");
                        input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_22.aliasQueryParam + "=" + als;
                    });
                }
            };
            _this.hidePersonalSiteRetailBlock = function() {
                var personalSiteRetailBlockWrapper = document.querySelector(".st_personal-site-retail--wrapper_JS");
                if (!!personalSiteRetailBlockWrapper) {
                    personalSiteRetailBlockWrapper.classList.add("st_hidden");
                }
            };
            _this.showPersonalSiteRetailBlock = function() {
                var personalSiteRetailBlockWrapper = document.querySelector(".st_personal-site-retail--wrapper_JS");
                if (!!personalSiteRetailBlockWrapper) {
                    personalSiteRetailBlockWrapper.classList.remove("st_hidden");
                }
            };
            _this.createLinkWithRefRep = function(alias) {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_representative-site-link_JS");
                retailInput.forEach(function(input) {
                    var alias = localStorage.getItem("webAlias");
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_22.aliasQueryParam + "=" + alias;
                });
            };
            _this.createLinkWithoutRefRep = function(als) {
                var inputEl = document.querySelectorAll(".st_representative-site-link_JS");
                if (inputEl) {
                    inputEl.forEach(function(input) {
                        var alias = localStorage.getItem("webAlias");
                        input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_22.aliasQueryParam + "=" + alias;
                    });
                }
            };
            _this.hideIncludePromoCode = function() {
                var includePromoCodeWrapper = document.querySelector(".st_include-promo-code-wrapper_JS");
                if (!!includePromoCodeWrapper) {
                    includePromoCodeWrapper.classList.add("st_hidden");
                }
            };
            _this.showIncludePromoCode = function() {
                var includePromoCodeWrapper = document.querySelector(".st_include-promo-code-wrapper_JS");
                if (!!includePromoCodeWrapper) {
                    includePromoCodeWrapper.classList.remove("st_hidden");
                }
            };
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StAccountPersonalSiteExtended;
    }(personal_site_1.StAccountPersonalSite);
    exports.StAccountPersonalSiteExtended = StAccountPersonalSiteExtended;
});

define("extension/shopify-app/st-modules/account/blocks/addresses/addresses-extended", [ "require", "exports", "core/shopify-app/st-modules/account/blocks/addresses/addresses" ], function(require, exports, addresses_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountAddressesExtended = void 0;
    var StAccountAddressesExtended = function(_super) {
        __extends(StAccountAddressesExtended, _super);
        function StAccountAddressesExtended(classConfig, generalMethods) {
            var _this_1 = _super.call(this, classConfig, generalMethods) || this;
            _this_1.className = "AccountAddress";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.openAddressDropDown();
                    _this_1.setupAddressEdit();
                    _this_1.setupAddressProvinceField();
                });
            };
            _this_1.openAddressDropDown = function() {
                var _this = _this_1;
                var dropDownButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountAddressesDropdown);
                dropDownButtons.forEach(function(dropDownButton) {
                    dropDownButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.openAddressActiveState(dropDownButton);
                    });
                });
            };
            _this_1.openAddressActiveState = function(dropDownButton) {
                dropDownButton.classList.toggle("active");
            };
            _this_1.setupAddressEdit = function() {
                var _this = _this_1;
                var addressTabButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountTabButton);
                addressTabButtons.forEach(function(addressTabButton) {
                    addressTabButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.showAddressEdit(addressTabButton);
                    });
                });
                var editAddressButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountBackButton);
                editAddressButtons.forEach(function(editAddressButton) {
                    editAddressButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.hideAddressEdit(editAddressButton);
                    });
                });
            };
            _this_1.showAddressEdit = function(addressTabButton) {
                var addressWrapper = _this_1.generalMethods.getClosestByClass(addressTabButton, _this_1.classConfig.classNameAddressesWrapper);
                if (!!addressWrapper) {
                    addressWrapper.classList.add("st_hide");
                }
            };
            _this_1.hideAddressEdit = function(editAddressButton) {
                var addressWrapper = _this_1.generalMethods.getClosestByClass(editAddressButton, _this_1.classConfig.classNameAddressesWrapper);
                if (!!addressWrapper) {
                    var buttonDropdown = addressWrapper.querySelector(".st_addresses-dots--button_JS");
                    var buttonDropdownContent = addressWrapper.querySelector(".st_dropdown-address--wrapper");
                    addressWrapper.classList.remove("st_hide");
                    buttonDropdown.classList.remove("active");
                    buttonDropdownContent.classList.remove("active");
                }
            };
            _this_1.setupAddressProvinceField = function() {
                var _this = _this_1;
                var provinceSelector = document.querySelector(_this_1.classConfig.selectorProvinceSelector);
                var provinceSource = document.querySelector(_this_1.classConfig.selectorProvinceSource);
                if (!!provinceSelector && !!provinceSource) {
                    _this_1.addProvinceOptions(provinceSelector, provinceSource);
                    provinceSource.addEventListener("change", function(e) {
                        _this.addProvinceOptions(provinceSelector, provinceSource);
                    });
                }
            };
            _this_1.addProvinceOptions = function(provinceSelector, provinceSource) {
                var selectedCountry = provinceSource.value ? provinceSource.value : provinceSource.getAttribute("data-default");
                var provinceSelectedOption = provinceSource.querySelector('option[value="'.concat(selectedCountry, '"]'));
                var provinceWrapper = _this_1.generalMethods.getClosestByClass(provinceSelector, _this_1.classConfig.classNameProvinceWrapper);
                if (!!provinceWrapper) {
                    provinceWrapper.classList.remove("st_hidden");
                }
                try {
                    var provinces = JSON.parse(provinceSelectedOption.getAttribute("data-provinces"));
                    provinceSelector.replaceChildren();
                    for (var i = 0; i < provinces.length; i++) {
                        var opt = document.createElement("option");
                        opt.value = provinces[i][0];
                        opt.innerHTML = provinces[i][1];
                        opt.setAttribute("data-ind", "" + i);
                        provinceSelector.appendChild(opt);
                    }
                    var defaultProvince = provinceSelector.getAttribute("data-default");
                    var defaultProvinceEl = provinceSelector.querySelector('option[value="'.concat(defaultProvince, '"]'));
                    var provinceOptions = provinceSelector.querySelectorAll("option");
                    var selectedOption = defaultProvince ? defaultProvinceEl : provinceOptions[0];
                    if (!!selectedOption) {
                        provinceSelector.value = selectedOption.value;
                        provinceSelector.selectedIndex = parseInt(selectedOption.getAttribute("data-ind"));
                        provinceOptions.forEach(function(provinceOption) {
                            provinceOption.removeAttribute("selected");
                        });
                        selectedOption.selected = true;
                        selectedOption.setAttribute("selected", "selected");
                    }
                } catch (e) {
                    console.error(e);
                    var provinceWrapper_2 = _this_1.generalMethods.getClosestByClass(provinceSelector, _this_1.classConfig.classNameProvinceWrapper);
                    if (!!provinceWrapper_2) {
                        provinceWrapper_2.classList.add("st_hidden");
                    }
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountAddressesExtended;
    }(addresses_1.StAccountAddresses);
    exports.StAccountAddressesExtended = StAccountAddressesExtended;
});

define("extension/shopify-app/st-modules/account-login/login-routing", [ "require", "exports", "_features.config", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, _features_config_23, st_module_86) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StLoginRouting = void 0;
    var StLoginRouting = function(_super) {
        __extends(StLoginRouting, _super);
        function StLoginRouting(objectFormatting, customerType, wineCellar) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "LoginRouting";
            _this_1.classLoginRouting = "wine_login-routing_JS";
            _this_1.selectorLoginRouting = "." + _this_1.classLoginRouting;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.initLoginRouting();
                });
            };
            _this_1.initLoginRouting = function() {
                var _this = _this_1;
                var loginRoutingPage = document.querySelector(_this_1.selectorLoginRouting);
                if (!!loginRoutingPage) {
                    var customerType = _this.customerType.get();
                    if (customerType == _features_config_23.ECustomerType.representative) {
                        _this.redirectToWineCellar(function() {
                            console.error("wine cellar token failed!");
                            window.location.assign(_this.addWebAliasToRedirectURL("/account"));
                        });
                    } else {
                        window.location.assign(_this.addWebAliasToRedirectURL("/account"));
                    }
                }
            };
            _this_1.redirectToWineCellar = function(errorCallback, errorCallbackParams) {
                if (errorCallback === void 0) {
                    errorCallback = function() {};
                }
                if (errorCallbackParams === void 0) {
                    errorCallbackParams = [];
                }
                var _this = _this_1;
                _this.wineCellar.tokenizeWineCellarLink(window.customerShopifyId, function(redirectURL) {
                    window.location.assign(redirectURL);
                }, [], errorCallback, errorCallbackParams);
            };
            _this_1.objectFormatting = objectFormatting;
            _this_1.customerType = customerType;
            _this_1.wineCellar = wineCellar;
            return _this_1;
        }
        StLoginRouting.prototype.addWebAliasToRedirectURL = function(redirectUrlResponse) {
            var redirectURLArrayByID = redirectUrlResponse.split("#");
            var redirectURLArrayByQuery = redirectURLArrayByID[0].split("?");
            var urlParams = {};
            if (redirectURLArrayByQuery.length > 1) {
                urlParams = this.objectFormatting.convertQueryStringToObject("?" + redirectURLArrayByQuery[1]);
            }
            var currentURLParams = this.objectFormatting.convertQueryStringToObject(window.location.search);
            urlParams[_features_config_23.aliasQueryParam] = currentURLParams[_features_config_23.aliasQueryParam];
            var newSearchString = this.objectFormatting.convertObjectToQueryString(urlParams);
            return redirectURLArrayByQuery[0] + newSearchString + (redirectURLArrayByID.length > 1 ? "#" + redirectURLArrayByID[1] : "");
        };
        return StLoginRouting;
    }(st_module_86.StModule);
    exports.StLoginRouting = StLoginRouting;
});

define("extension/shopify-app/st-modules/account-login/account-login-reset-password", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_87) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountLoginResetPassword = void 0;
    var StAccountLoginResetPassword = function(_super) {
        __extends(StAccountLoginResetPassword, _super);
        function StAccountLoginResetPassword(form, buttonActions) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StResetPassword";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.handleForgotPasswordClick();
                    _this_1.handleCancelResetPasswordClick();
                    _this_1.handleResetPasswordFormSubmit();
                });
            };
            _this_1.handleForgotPasswordClick = function() {
                var _this = _this_1;
                var forgotPasswordButton = document.querySelector(".wine_recover-password-button_JS");
                if (forgotPasswordButton) {
                    forgotPasswordButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.openResetPassword();
                        _this.hideLoginForm();
                    });
                }
            };
            _this_1.handleCancelResetPasswordClick = function() {
                var _this = _this_1;
                var cancelButton = document.querySelector(".wine_cancel-reset-password-button_JS");
                if (cancelButton) {
                    cancelButton.addEventListener("click", function() {
                        _this.closeResetPassword();
                        _this.openLoginForm();
                    });
                }
            };
            _this_1.handleResetPasswordFormSubmit = function() {
                var _this = _this_1;
                var recoverPasswordForm = document.querySelector(".wine_recover-password-form_JS");
                if (recoverPasswordForm) {
                    var submitButton_1 = recoverPasswordForm.querySelector(".wine_recover-password-submit-button_JS");
                    recoverPasswordForm.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.buttonActions.prevent(submitButton_1);
                        _this.resetPasswordOverride(recoverPasswordForm, submitButton_1);
                        _this.removeMessage();
                    });
                }
            };
            _this_1.resetPasswordOverride = function(form, button) {
                var emailInput = form.querySelector('input[name="email"]');
                var email = emailInput.value;
                var recoverPassRequest = {};
                recoverPassRequest.form_type = "recover_customer_password";
                recoverPassRequest["email"] = email;
                recoverPassRequest["utf8"] = "✓";
                _this_1.ajax.send({
                    endpoint: window.location.protocol + "//" + window.location.hostname + "/account/recover",
                    method: "post",
                    contentType: "form",
                    data: recoverPassRequest,
                    callback: function(res) {
                        _this_1.handleRecoverPassword(form, res, button);
                    }
                });
            };
            _this_1.handleRecoverPassword = function(form, res, button) {
                var source = res.response;
                var errorSourceArr = source.split("st_recover_error");
                var errorSource = errorSourceArr.length > 1 ? errorSourceArr[1].split("</span>")[0].substring(2).trim() : "";
                var successSourceArr = source.split("st_recover_success");
                var successSource = successSourceArr.length > 1 ? successSourceArr[1].split("</span>")[0].substring(2).trim() : "";
                var result = document.createElement("div");
                result.classList.add("cr_password-recover-message");
                _this_1.showMessageHandle(result, successSource, errorSource);
                _this_1.buttonActions.allow(button);
                if (res.status === 429) {
                    _this_1.tooManyRequestsErrorMessage(result);
                }
                form.prepend(result);
            };
            _this_1.showMessageHandle = function(result, successSource, errorSource) {
                if (successSource !== "") {
                    result.innerHTML = successSource;
                    result.style.color = "green";
                    _this_1.successMessageHandle();
                    _this_1.showBackToLoginButton();
                } else {
                    result.style.color = "red";
                    result.innerHTML = errorSource;
                }
            };
            _this_1.successMessageHandle = function() {
                var recoverPasswordFormWrapper = document.querySelector(".wine_reset-password-form--wrapper_JS");
                if (recoverPasswordFormWrapper) {
                    recoverPasswordFormWrapper.classList.add("st_hidden");
                }
            };
            _this_1.showBackToLoginButton = function() {
                var recoverPasswordForm = document.querySelector(".wine_recover-password-form_JS");
                var backToLoginWrapper = document.createElement("div");
                backToLoginWrapper.classList.add("wine_reset-password-button--wrapper");
                var backToLoginButton = document.createElement("a");
                backToLoginButton.innerHTML = "Back to Login";
                backToLoginButton.href = window.location.protocol + "//" + window.location.hostname + "/account/login";
                backToLoginWrapper.appendChild(backToLoginButton);
                recoverPasswordForm.appendChild(backToLoginWrapper);
            };
            _this_1.tooManyRequestsErrorMessage = function(result) {
                var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                var pathCircle = document.createElementNS("http://www.w3.org/2000/svg", "path");
                var pathXSymbol = document.createElementNS("http://www.w3.org/2000/svg", "path");
                var errorMessage = document.createElement("span");
                svg.setAttribute("width", "18");
                svg.setAttribute("height", "18");
                svg.setAttribute("viewBox", "0 0 18 18");
                pathCircle.setAttribute("d", "M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z");
                pathCircle.setAttribute("fill", "currentColor");
                pathXSymbol.setAttribute("d", "M5.29289 6.70711L11.2929 12.7071L12.7071 11.2929L6.70711 5.29289L5.29289 6.70711ZM6.70711 12.7071L12.7071 6.70711L11.2929 5.2929L5.29289 11.2929L6.70711 12.7071Z");
                pathXSymbol.setAttribute("fill", "#fff");
                svg.classList.add("offset-icon", "icon", "icon-error");
                result.classList.add("cr_many-request");
                errorMessage.innerHTML = "Too many attempts, please try again later.";
                svg.append(pathCircle);
                svg.append(pathXSymbol);
                result.append(svg);
                result.append(errorMessage);
            };
            _this_1.removeMessage = function() {
                var message = document.querySelector(".cr_password-recover-message");
                if (!!message) {
                    message.remove();
                }
            };
            _this_1.openLoginForm = function() {
                var loginContent = document.querySelector(".wine_login-content--wrapper_JS");
                loginContent.classList.remove("st_hidden");
            };
            _this_1.openResetPassword = function() {
                var resetPasswordContent = document.querySelector(".wine_reset-password-content--wrapper_JS");
                if (resetPasswordContent) {
                    resetPasswordContent.classList.add("active");
                }
            };
            _this_1.closeResetPassword = function() {
                var resetPasswordContent = document.querySelector(".wine_reset-password-content--wrapper_JS");
                if (resetPasswordContent) {
                    resetPasswordContent.classList.remove("active");
                }
            };
            _this_1.hideLoginForm = function() {
                var loginContent = document.querySelector(".wine_login-content--wrapper_JS");
                loginContent.classList.add("st_hidden");
            };
            _this_1.form = form;
            _this_1.buttonActions = buttonActions;
            return _this_1;
        }
        return StAccountLoginResetPassword;
    }(st_module_87.StModule);
    exports.StAccountLoginResetPassword = StAccountLoginResetPassword;
});

define("extension/shopify-app/st-modules/requestBook/request-book", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_88, notification_20) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StRequestBook = void 0;
    var StRequestBook = function(_super) {
        __extends(StRequestBook, _super);
        function StRequestBook(form, cartComponent, buttonActions, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "RequestBook";
            _this_1.recursiveInitRetry = 0;
            _this_1.timeout = 200;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.interceptRequestToBook();
                });
            };
            _this_1.interceptRequestToBook = function() {
                var _this = _this_1;
                var numberOfRetries = 20;
                var requestToBookForm = document.querySelectorAll(".wine_request-to-book-form_JS");
                if (requestToBookForm && requestToBookForm.length > 0) {
                    requestToBookForm.forEach(function(form) {
                        var submitButton = form.querySelector(".wine_request-book-submit-button_JS");
                        form.addEventListener("submit", function(e) {
                            e.preventDefault();
                            _this.buttonActions.prevent(submitButton);
                            _this.validateRequestToBook(this, submitButton);
                        });
                    });
                } else {
                    setTimeout(function() {
                        if (_this.recursiveInitRetry < numberOfRetries) {
                            _this.recursiveInitRetry++;
                            _this.interceptRequestToBook();
                        }
                    }, _this_1.timeout);
                }
            };
            _this_1.validateRequestToBook = function(form, submitButton) {
                var _this = _this_1;
                var formData = _this_1.form.collectFormData(form);
                var sponsorWebAlias = window.shopifyCartData.attributes.sponsorWebAlias;
                var formRequest = {
                    address2: formData["contact[Address Line 2]"],
                    city: formData["contact[City]"],
                    date: formData["contact[Desired Date of Wine Tasting]"],
                    hearAboutUs: formData["contact[How did you hear about us?]"],
                    firstName: formData["contact[First Name]"],
                    lastName: formData["contact[Last Name]"],
                    message: formData["contact[Message]"],
                    pageLocation: formData["contact[Page Location]"],
                    phone: formData["contact[Phone]"],
                    sampler: formData["contact[Sampler that I'm interested in]"],
                    state: formData["contact[State]"],
                    streetAddress: formData["contact[Street Address]"],
                    tasting: formData["contact[Tasting type that I'm interested in]"],
                    zip: formData["contact[Zip Code]"],
                    email: formData["contact[email]"],
                    confirmEmail: formData["contact[confirm-email]"],
                    webAlias: sponsorWebAlias
                };
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["sampler"]["hostTastingForm"],
                    method: "post",
                    contentType: "json",
                    data: formRequest,
                    callback: function(response) {
                        try {
                            var validationResponse = JSON.parse(response.response);
                            console.log("validationResponse", validationResponse);
                            if (validationResponse.status === 200) {
                                _this.hideForm(form);
                                _this.showSuccessfulMessage();
                                _this.buttonActions.allow(submitButton);
                            } else {
                                _this.buttonActions.allow(submitButton);
                                _this.notification.showNotification(notification_20.ENotificationType.error, "An Error Occurred", "Some fields are invalid.");
                            }
                        } catch (error) {
                            console.error(error);
                            _this.buttonActions.allow(submitButton);
                            _this.notification.showNotification(notification_20.ENotificationType.error, "An Error Occurred", "Server Error.");
                        }
                    }
                });
            };
            _this_1.hideForm = function(formEl) {
                formEl.classList.add("st_hidden");
            };
            _this_1.showSuccessfulMessage = function() {
                var successMessageWrapper = document.querySelector(".wine_request-to-book-success-message_JS");
                if (successMessageWrapper) {
                    successMessageWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.form = form;
            _this_1.cartComponent = cartComponent;
            _this_1.buttonActions = buttonActions;
            _this_1.notification = notification;
            return _this_1;
        }
        return StRequestBook;
    }(st_module_88.StModule);
    exports.StRequestBook = StRequestBook;
});

define("extension/shopify-app/st-modules/awtomic/manage-subscriptions", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_89) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAwtomicManageSubscriptions = void 0;
    var StAwtomicManageSubscriptions = function(_super) {
        __extends(StAwtomicManageSubscriptions, _super);
        function StAwtomicManageSubscriptions() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AwtomicManageSubscriptions";
            _this_1.infinityBreak = 0;
            _this_1.infinityThreshold = 1200;
            _this_1.retryInterval = 50;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.initForbiddenCheck();
                });
            };
            _this_1.initForbiddenCheck = function() {
                var _this = _this_1;
                var lineItems = document.querySelectorAll(".bundle-table__body-row");
                if (lineItems && lineItems.length > 0) {
                    _this_1.determineDateChangeAllowed(lineItems);
                } else {
                    setTimeout(function() {
                        _this.infinityBreak++;
                        if (_this.infinityBreak < _this.infinityThreshold) {
                            _this.initForbiddenCheck();
                        }
                    }, _this.retryInterval);
                }
            };
            _this_1.determineDateChangeAllowed = function(lineItems) {
                var forbiddenVariants = window.forbiddenNextBillingDateEdit.productVariantIDs;
                if (_this_1.isForbiddenItemInCart(forbiddenVariants, lineItems)) {
                    _this_1.hideEditNextBillingDate();
                }
            };
            _this_1.isForbiddenItemInCart = function(forbiddenVariants, lineItems) {
                var hasForbidden = false;
                for (var i = 0; i < forbiddenVariants.length; i++) {
                    for (var j = 0; j < lineItems.length; j++) {
                        var selectLineItem = lineItems[j];
                        if (selectLineItem.classList.contains("pv_gid://shopify/ProductVariant/" + forbiddenVariants[i])) {
                            hasForbidden = true;
                            break;
                        }
                    }
                    if (hasForbidden) {
                        break;
                    }
                }
                return hasForbidden;
            };
            _this_1.hideEditNextBillingDate = function() {
                document.querySelector("body").classList.add("st_hide-next-billing-date");
            };
            return _this_1;
        }
        return StAwtomicManageSubscriptions;
    }(st_module_89.StModule);
    exports.StAwtomicManageSubscriptions = StAwtomicManageSubscriptions;
});

define("extension/shopify-app/st-modules/customizable-label/customizable-label", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_90) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCustomizableLabel = void 0;
    var StCustomizableLabel = function(_super) {
        __extends(StCustomizableLabel, _super);
        function StCustomizableLabel(notification, themeCart, objectFormatting, cart, cookies, buttonActions) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StCustomizableLabel";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.clickOnAddAndPersonalize();
                });
            };
            _this_1.generateUniqueToken = function() {
                return "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
                    var r = Math.random() * 16 | 0;
                    var v = c === "x" ? r : r & 3 | 8;
                    return v.toString(16);
                });
            };
            _this_1.clickOnAddAndPersonalize = function() {
                var _this = _this_1;
                var addAndPersonalizeBtn = document.querySelector(".wine_add-to-cart-and-personalize_JS");
                if (!!addAndPersonalizeBtn) {
                    var prodId_1 = addAndPersonalizeBtn.getAttribute("data-sku");
                    var prodVariantId_1 = addAndPersonalizeBtn.getAttribute("data-variant-id");
                    var quantityInput = document.querySelector(".wine_quantity-change_JS");
                    if (!!quantityInput) {
                        addAndPersonalizeBtn.addEventListener("click", function(e) {
                            e.preventDefault();
                            var quantityInput = document.querySelector(".wine_quantity-change_JS");
                            _this.generateButtonLink(prodId_1, prodVariantId_1, quantityInput.value);
                        });
                    }
                }
            };
            _this_1.generateButtonLink = function(productId, variantId, quantity) {
                var generatedToken = _this_1.generateUniqueToken();
                _this_1.cart.getCart(function(cartResponse) {
                    var cartToken = cartResponse.token;
                    var cleanedCartToken = cartToken.split("?key=")[0];
                    var returnUrl = encodeURIComponent("".concat(window.location.origin, "/pages/load-label?labelToken=").concat(generatedToken, "&variantId=").concat(variantId, "&quantityId=").concat(quantity));
                    var createdLink = "https://personalizedwine.wineshopathome.com?product_id=".concat(productId, "&token=").concat(generatedToken, "&return_url=").concat(returnUrl);
                    window.location.href = createdLink;
                });
            };
            _this_1.notification = notification;
            _this_1.themeCart = themeCart;
            _this_1.objectFormatting = objectFormatting;
            _this_1.cart = cart;
            _this_1.cookies = cookies;
            _this_1.buttonActions = buttonActions;
            return _this_1;
        }
        return StCustomizableLabel;
    }(st_module_90.StModule);
    exports.StCustomizableLabel = StCustomizableLabel;
});

define("_shopify.app.di.container", [ "require", "exports", "core/shopify-app/st-modules/_static/static", "core/shopify-app/st-modules/account/account", "core/shopify-app/st-modules/enrollment/enrollment", "core/shopify-app/st-modules/_general-methods/browser-history", "core/shopify-app/st-modules/_general-methods/form/cart-manipulation", "core/shopify-app/st-modules/_general-methods/cookies/cookies", "core/shopify-app/st-modules/_general-methods/form/loader", "core/shopify-app/st-modules/_general-methods/general-methods", "core/shopify-app/st-modules/_general-methods/button/button-actions", "core/shopify-app/st-modules/_general-methods/form/form", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/_general-methods/object-formatting", "core/shopify-app/st-modules/_di-container/di.container.public", "core/shopify-app/st-modules/enrollment/page-header/nav/enrollment-nav", "core/shopify-app/st-modules/enrollment/page/enrollment-submit", "core/shopify-app/st-modules/enrollment/_general/enrollment-class-config", "core/shopify-app/st-modules/_general-methods/form/fields/date-input", "core/shopify-app/st-modules/_general-methods/form/form-class-config", "core/shopify-app/st-modules/enrollment/_validation/enrollment-validation", "core/shopify-app/st-modules/enrollment/blocks/review-privacy/enrollment-section-review-privacy", "core/shopify-app/st-modules/enrollment/blocks/account-details/enrollment-section-account-details", "core/shopify-app/st-modules/enrollment/blocks/business-info/enrollment-section-business-details", "core/shopify-app/st-modules/enrollment/_validation/enrollment-validation-setup", "core/shopify-app/st-modules/account/_general/account-class-config", "core/shopify-app/st-modules/search-sponsor/sponsor-search-class-config", "core/shopify-app/st-modules/enrollment-account/enrollment-account", "core/shopify-app/st-modules/enrollment-account/enrollment-account-class-config", "core/shopify-app/st-modules/enrollment/blocks/optional-kits/enrollment-section-optional-kits", "core/shopify-app/st-modules/enrollment/blocks/required-kits/enrollment-section-required-kits", "core/shopify-app/st-modules/enrollment/_general/enrollment-store", "core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review", "core/shopify-app/st-modules/enrollment/page/enrollment-page", "core/shopify-app/st-modules/_general-methods/currency", "core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review-cart", "core/shopify-app/st-modules/_general-methods/form/formatting", "core/shopify-app/st-modules/enrollment/blocks/account-details/account-details-helpers", "core/shopify-app/st-modules/enrollment/blocks/business-info/business-details-helpers", "extension/shopify-app/st-modules/account/header/nav/account-nav-extended", "core/shopify-app/st-modules/account/header/backoffice-sso/backoffice-sso", "core/shopify-app/st-modules/account/blocks/web-alias-edit/web-alias-edit", "core/shopify-app/st-modules/account/blocks/personal-info/personal-info", "core/shopify-app/st-modules/account/blocks/order-history/order-history", "core/shopify-app/st-modules/cart/cart", "core/shopify-app/st-modules/enrollment-account/enrollment-account-repeat-password-validation", "core/shopify-app/st-modules/main/auto-apply-promo", "core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page", "core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page-class-config", "core/shopify-app/st-modules/account-register/account-register-class-config", "core/shopify-app/st-modules/search-sponsor/search-sponsor-guard", "core/shopify-app/st-modules/search-sponsor/search-sponsor-service", "core/shopify-app/st-modules/reset-password/reset-password-class-config", "core/shopify-app/st-modules/reset-password/reset-password", "core/shopify-app/st-modules/enrollment/enrollment-cleanup", "extension/shopify-app/st-modules/referral/referral", "core/shopify-app/st-modules/account/blocks/coupon-codes/coupon-codes", "extension/shopify-app/st-modules/share-cart/share-cart", "extension/shopify-app/st-modules/webalias/webalias-extended", "extension/shopify-app/st-modules/_general-methods/form/customer-type-extended", "extension/shopify-app/st-modules/webalias/webalias-class-config-extended", "extension/shopify-app/st-modules/account/blocks/testing/tasting", "extension/shopify-app/st-modules/account/blocks/wine-cellar/wine-cellar", "extension/shopify-app/st-modules/account/blocks/manage-subscriptions/manage-subscriptions", "extension/shopify-app/st-modules/account/blocks/samplers/account-samplers", "extension/shopify-app/st-modules/account/blocks/share-cart/share-cart", "extension/shopify-app/st-modules/account/blocks/share-cart/render-share-cart", "extension/shopify-app/st-modules/account/blocks/share-cart/generators-share-cart", "extension/shopify-app/st-modules/account/blocks/samplers/samplers", "extension/shopify-app/st-modules/account/blocks/samplers/samplers-order", "extension/shopify-app/st-modules/account-register/account-register", "extension/shopify-app/st-modules/webalias/inject-representative-info", "extension/shopify-app/st-modules/search-sponsor/search-sponsor", "extension/shopify-app/st-modules/samplers/remove-samplers-mode", "extension/shopify-app/st-modules/samplers/additional-items/samplers-additional-item", "extension/shopify-app/st-modules/samplers/edit-sempler/edit-sampler", "extension/shopify-app/st-modules/samplers/shipping-date-picker/shipping-date-picker", "extension/shopify-app/st-modules/tasting/tasting-ref", "extension/shopify-app/st-modules/account/blocks/affiliate/affiliate", "extension/shopify-app/st-modules/loading-page/loading-page", "extension/shopify-app/st-modules/account-login/account-login", "extension/shopify-app/st-modules/account-login/login-redirect", "extension/shopify-app/st-modules/account-login/account-login-class-config.extended", "extension/shopify-app/st-modules/_general-methods/jwt", "extension/shopify-app/st-modules/account-login/account-login-with-jwt", "extension/shopify-app/st-modules/account/blocks/personal-site/personal-site", "extension/shopify-app/st-modules/cart/theme-cart", "extension/shopify-app/st-modules/account/blocks/addresses/addresses-extended", "extension/shopify-app/st-modules/enrollment-loading-page/enrolment-check", "extension/shopify-app/st-modules/account-login/login-routing", "extension/shopify-app/st-modules/account-login/account-login-reset-password", "extension/shopify-app/st-modules/requestBook/request-book", "extension/shopify-app/st-modules/awtomic/manage-subscriptions", "extension/shopify-app/st-modules/account/blocks/samplers/account-samplers-class-config", "extension/shopify-app/st-modules/customizable-label/customizable-label", "extension/shopify-app/st-modules/customizable-label/label-loading" ], function(require, exports, static_2, account_1, enrollment_1, browser_history_1, cart_manipulation_1, cookies_1, loader_1, general_methods_1, button_actions_2, form_1, notification_21, object_formatting_1, di_container_public_1, enrollment_nav_1, enrollment_submit_1, enrollment_class_config_1, date_input_1, form_class_config_1, enrollment_validation_1, enrollment_section_review_privacy_1, enrollment_section_account_details_1, enrollment_section_business_details_1, enrollment_validation_setup_1, account_class_config_1, sponsor_search_class_config_1, enrollment_account_1, enrollment_account_class_config_1, enrollment_section_optional_kits_1, enrollment_section_required_kits_1, enrollment_store_1, enrollment_review_1, enrollment_page_1, currency_3, enrollment_review_cart_1, formatting_1, account_details_helpers_1, business_details_helpers_1, account_nav_extended_1, backoffice_sso_1, web_alias_edit_1, personal_info_1, order_history_1, cart_1, enrollment_account_repeat_password_validation_1, auto_apply_promo_1, representative_redirect_page_1, representative_redirect_page_class_config_1, account_register_class_config_1, search_sponsor_guard_1, search_sponsor_service_1, reset_password_class_config_1, reset_password_1, enrollment_cleanup_1, referral_2, coupon_codes_1, share_cart_1, webalias_extended_1, customer_type_extended_1, webalias_class_config_extended_1, tasting_1, wine_cellar_1, manage_subscriptions_1, account_samplers_1, share_cart_2, render_share_cart_1, generators_share_cart_1, samplers_1, samplers_order_1, account_register_2, inject_representative_info_2, search_sponsor_2, remove_samplers_mode_1, samplers_additional_item_1, edit_sampler_1, shipping_date_picker_1, tasting_ref_1, affiliate_1, loading_page_1, account_login_2, login_redirect_1, account_login_class_config_extended_1, jwt_1, account_login_with_jwt_1, personal_site_2, theme_cart_1, addresses_extended_1, enrolment_check_1, login_routing_1, account_login_reset_password_1, request_book_1, manage_subscriptions_2, account_samplers_class_config_1, customizable_label_1, label_loading_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAppDIConfig = void 0;
    var StAppDIConfig = function() {
        function StAppDIConfig() {
            var _this = this;
            this.className = "AppDIConfig";
            this.init = function() {};
            this.components = function() {
                _this.StStaticComponent = static_2.StStatic.Instance();
                _this.DiContainerPublicComponent = new di_container_public_1.DiContainerPublic();
                _this.StObjectFormattingComponent = new object_formatting_1.StObjectFormatting();
                _this.StBrowserHistoryComponent = new browser_history_1.StBrowserHistory(_this.StObjectFormattingComponent);
                _this.StCartManipulationComponent = new cart_manipulation_1.StCartManipulation();
                _this.StCookiesComponent = new cookies_1.StCookies();
                _this.StCustomerTypeComponent = new customer_type_extended_1.StCustomerTypeExtended();
                _this.StLoaderComponent = new loader_1.StLoader();
                _this.StButtonActionsComponent = new button_actions_2.StButtonActions();
                _this.StNotificationComponent = new notification_21.StNotification();
                _this.StFormConfigComponent = new form_class_config_1.StFormClassConfig();
                _this.StGeneralMethodsComponent = new general_methods_1.StGeneralMethods();
                _this.StCurrencyComponent = new currency_3.StCurrency();
                _this.StFormattingComponent = new formatting_1.StFormFormatting();
                _this.StAutoApplyPromoComponent = new auto_apply_promo_1.StAutoApplyPromo();
                _this.StCartComponent = new cart_1.StCart();
                _this.StJWTComponent = new jwt_1.StJWT(_this.StObjectFormattingComponent);
                _this.StThemeCartComponent = new theme_cart_1.StThemeCart();
                _this.StWineCellarComponent = new wine_cellar_1.StWineCellar(_this.StNotificationComponent, _this.StButtonActionsComponent);
                _this.StEnrollmentClassConfigComponent = new enrollment_class_config_1.StEnrollmentClassConfig();
                _this.StEnrollmentAccountClassConfigComponent = new enrollment_account_class_config_1.StEnrollmentAccountClassConfig();
                _this.StEnrollmentSectionPrivacyComponent = new enrollment_section_review_privacy_1.StEnrollmentSectionPrivacy(_this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentAccountDetailsHelpersComponent = new account_details_helpers_1.StEnrollmentAccountDetailsHelpers(_this.StFormattingComponent, _this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentBusinessDetailsHelpersComponent = new business_details_helpers_1.StEnrollmentBusinessDetailsHelpers(_this.StFormattingComponent, _this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentSectionAccountDetailsComponent = new enrollment_section_account_details_1.StEnrollmentSectionAccountDetails();
                _this.StEnrollmentSectionBusinessDetailsComponent = new enrollment_section_business_details_1.StEnrollmentSectionBusinessDetails();
                _this.StEnrollmentStoreComponent = new enrollment_store_1.StEnrollmentStore(_this.StEnrollmentClassConfigComponent, _this.StCartComponent);
                _this.StEnrollmentPageComponent = new enrollment_page_1.StEnrollmentPage(_this.StEnrollmentClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StAccountLoginClassConfig = new account_login_class_config_extended_1.StAccountLoginClassConfigExtended();
                _this.StAccountClassConfigComponent = new account_class_config_1.StAccountClassConfig();
                _this.StSearchSponsorClassConfigComponent = new sponsor_search_class_config_1.StSearchSponsorClassConfig();
                _this.StDateInputComponent = new date_input_1.StDateInput(_this.StFormConfigComponent);
                _this.StFormComponent = new form_1.StForm(_this.StFormConfigComponent, _this.StDateInputComponent);
                _this.StWebAliasClassConfigExtendedComponent = new webalias_class_config_extended_1.StWebAliasClassConfigExtended();
                _this.StManageSubscriptionsComponent = new manage_subscriptions_1.StManageSubscriptions(_this.StNotificationComponent, _this.StButtonActionsComponent);
                _this.StSearchSponsorGuardComponent = new search_sponsor_guard_1.StSearchSponsorGuard(_this.StSearchSponsorClassConfigComponent, _this.StBrowserHistoryComponent, _this.StObjectFormattingComponent, _this.StGeneralMethodsComponent, _this.StCartComponent);
                _this.StAccountPersonalSiteComponent = new personal_site_2.StAccountPersonalSiteExtended(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StSearchSponsorService = new search_sponsor_service_1.StSearchSponsorService();
                _this.StInjectRepresentativeInfoComponent = new inject_representative_info_2.StInjectRepresentativeInfoExtended(_this.StWebAliasClassConfigExtendedComponent, _this.StSearchSponsorService);
                _this.StLabelLoadingComponent = new label_loading_1.StLabelLoading(_this.StObjectFormattingComponent);
                _this.StWebAliasComponent = new webalias_extended_1.StWebaliasExtended(_this.StWebAliasClassConfigExtendedComponent, _this.StBrowserHistoryComponent, _this.StObjectFormattingComponent, _this.StCookiesComponent, _this.StCustomerTypeComponent, _this.StGeneralMethodsComponent, _this.StInjectRepresentativeInfoComponent, _this.StCartComponent, _this.StSearchSponsorGuardComponent, _this.StAccountPersonalSiteComponent, _this.StCustomerReferralComponent, _this.StLabelLoadingComponent);
                _this.StSearchSponsorComponent = new search_sponsor_2.StSearchSponsorExtended(_this.StGeneralMethodsComponent, _this.StObjectFormattingComponent, _this.StBrowserHistoryComponent, _this.StSearchSponsorClassConfigComponent, _this.StCookiesComponent, _this.StCartComponent, _this.StSearchSponsorService, _this.StThemeCartComponent, _this.StWebAliasComponent);
                _this.StEnrollmentValidationComponent = new enrollment_validation_1.StEnrollmentValidation(_this.StEnrollmentClassConfigComponent, _this.StNotificationComponent, _this.StEnrollmentPageComponent);
                _this.StEnrollmentValidationSetupComponent = new enrollment_validation_setup_1.StEnrollmentValidationSetup(_this.StEnrollmentValidationComponent, _this.StEnrollmentSectionPrivacyComponent, _this.StEnrollmentSectionAccountDetailsComponent, _this.StEnrollmentSectionBusinessDetailsComponent);
                _this.StEnrollmentReviewCartComponent = new enrollment_review_cart_1.StEnrollmentReviewCart(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StCurrencyComponent);
                _this.StEnrollmentOptionalKitsComponent = new enrollment_section_optional_kits_1.StEnrollmentOptionalKits(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StEnrollmentReviewCartComponent);
                _this.StEnrollmentRequiredKitsComponent = new enrollment_section_required_kits_1.StEnrollmentRequiredKits(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StEnrollmentReviewCartComponent);
                _this.StEnrollmentReviewComponent = new enrollment_review_1.StEnrollmentReview(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StGeneralMethodsComponent, _this.StEnrollmentPageComponent, _this.StCurrencyComponent, _this.StFormComponent, _this.StEnrollmentReviewCartComponent);
                _this.StEnrollmentActionsComponent = new enrollment_submit_1.StEnrollmentActions(_this.StEnrollmentClassConfigComponent, _this.StNotificationComponent);
                _this.StEnrollmentNavComponent = new enrollment_nav_1.StEnrollmentNav(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentActionsComponent, _this.StEnrollmentOptionalKitsComponent, _this.StEnrollmentRequiredKitsComponent, _this.StEnrollmentStoreComponent, _this.StFormComponent, _this.StButtonActionsComponent, _this.StEnrollmentValidationComponent, _this.StEnrollmentValidationSetupComponent, _this.StNotificationComponent, _this.StEnrollmentReviewComponent, _this.StEnrollmentPageComponent);
                _this.StEnrollmentComponent = new enrollment_1.StEnrollment(_this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentCleanupComponent = new enrollment_cleanup_1.StEnrollmentCleanup(_this.StCartComponent);
                _this.StEnrollmentAccountComponent = new enrollment_account_1.StEnrollmentAccount(_this.StEnrollmentAccountClassConfigComponent, _this.StButtonActionsComponent, _this.StNotificationComponent, _this.StFormComponent, _this.StGeneralMethodsComponent, _this.StEnrollmentCleanupComponent, _this.StCartComponent);
                _this.StAccountNavComponent = new account_nav_extended_1.StAccountNavExtended(_this.StAccountClassConfigComponent, _this.StObjectFormattingComponent, _this.StBrowserHistoryComponent, _this.StGeneralMethodsComponent, _this.StCartComponent, _this.StCustomerTypeComponent);
                _this.StBackofficeSSOComponent = new backoffice_sso_1.StBackofficeSSO(_this.StAccountClassConfigComponent, _this.StNotificationComponent);
                _this.StAccountWebAliasEditComponent = new web_alias_edit_1.StAccountWebAliasEdit(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StFormComponent, _this.StFormattingComponent);
                _this.StAccountAddressesComponent = new addresses_extended_1.StAccountAddressesExtended(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StAccountPersonalInfoComponent = new personal_info_1.StAccountPersonalInfo(_this.StAccountClassConfigComponent, _this.StFormComponent, _this.StFormattingComponent, _this.StButtonActionsComponent, _this.StNotificationComponent, _this.StGeneralMethodsComponent);
                _this.StAccountOrderHistoryComponent = new order_history_1.StAccountOrderHistory(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StAccountComponent = new account_1.StAccount(_this.StFormComponent);
                _this.StAccountRegisterClassConfigComponent = new account_register_class_config_1.StAccountRegisterClassConfig();
                _this.StEnrollmentLoginCheckComponent = new enrolment_check_1.StEnrollmentLoginCheck(_this.StObjectFormattingComponent);
                _this.StAccountRegisterComponent = new account_register_2.StAccountRegisterExtended(_this.StFormComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StAccountRegisterClassConfigComponent, _this.StGeneralMethodsComponent, _this.StJWTComponent, _this.StObjectFormattingComponent, _this.StEnrollmentLoginCheckComponent, _this.StWineCellarComponent, _this.StCustomerTypeComponent);
                _this.StResetPasswordClassConfigComponent = new reset_password_class_config_1.StResetPasswordClassConfig();
                _this.StResetPasswordComponent = new reset_password_1.StResetPassword(_this.StFormComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StResetPasswordClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StEnrollmentRepeatPasswordValidationComponent = new enrollment_account_repeat_password_validation_1.StEnrollmentRepeatPasswordValidation(_this.StEnrollmentAccountClassConfigComponent);
                _this.StRepresentativeRedirectClassConfigComponent = new representative_redirect_page_class_config_1.StRepresentativeRedirectClassConfig();
                _this.StRepresentativeRedirectComponent = new representative_redirect_page_1.StRepresentativeRedirectPage(_this.StRepresentativeRedirectClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StReferralComponent = new referral_2.StReferralExtension(_this.StGeneralMethodsComponent, _this.StObjectFormattingComponent, _this.StNotificationComponent);
                _this.StCouponCodesComponent = new coupon_codes_1.StCouponCodes();
                _this.StShareCartComponent = new share_cart_1.StShareCart(_this.StCartComponent, _this.StGeneralMethodsComponent, _this.StButtonActionsComponent, _this.StNotificationComponent, _this.StThemeCartComponent);
                _this.StRemoveSamplersComponent = new remove_samplers_mode_1.StRemoveSamplers(_this.StGeneralMethodsComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StCartComponent);
                _this.StAccountSamplersClassConfigComponent = new account_samplers_class_config_1.StAccountSamplersClassConfig();
                _this.StAccountSamplersComponent = new account_samplers_1.StAccountSamplers(_this.StAccountSamplersClassConfigComponent, _this.StGeneralMethodsComponent, _this.StButtonActionsComponent, _this.StCurrencyComponent);
                _this.StSamplersComponent = new samplers_1.StSamplers(_this.StGeneralMethodsComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StAccountSamplersComponent, _this.StCartComponent);
                _this.StTastingComponent = new tasting_1.StTasting(_this.StCartComponent, _this.StGeneralMethodsComponent, _this.StThemeCartComponent, _this.StSearchSponsorService);
                _this.StSamplersOrderComponent = new samplers_order_1.StSamplersOrder(_this.StGeneralMethodsComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StCartComponent, _this.StThemeCartComponent);
                _this.StAccountRenderShareCartComponent = new render_share_cart_1.StAccountRenderShareCart(_this.StGeneralMethodsComponent);
                _this.StAccountGeneratorsShareCartComponent = new generators_share_cart_1.StAccountGeneratorsShareCart(_this.StGeneralMethodsComponent);
                _this.StSamplersAdditionalItemComponent = new samplers_additional_item_1.StSamplersAdditionalItem(_this.StGeneralMethodsComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StCartComponent, _this.StThemeCartComponent);
                _this.StAccountShareCartComponent = new share_cart_2.StAccountShareCart(_this.StGeneralMethodsComponent, _this.StNotificationComponent, _this.StAccountRenderShareCartComponent, _this.StAccountGeneratorsShareCartComponent);
                _this.StCustomerReferralComponent = new tasting_ref_1.StCustomerReferral(_this.StNotificationComponent, _this.StCartComponent, _this.StCookiesComponent);
                _this.StCustomizableLabelComponent = new customizable_label_1.StCustomizableLabel(_this.StNotificationComponent, _this.StThemeCartComponent, _this.StObjectFormattingComponent, _this.StCartComponent, _this.StCookiesComponent, _this.StButtonActionsComponent);
                _this.StAccountAffiliateComponent = new affiliate_1.StAccountAffiliate();
                _this.StEditSamplerComponent = new edit_sampler_1.StEditSampler(_this.StGeneralMethodsComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StCartComponent);
                _this.StShippingDateSamplersComponent = new shipping_date_picker_1.StShippingDateSamplers(_this.StGeneralMethodsComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StCartComponent, _this.StThemeCartComponent);
                _this.StLoadingPageComponent = new loading_page_1.StLoadingPage(_this.StObjectFormattingComponent, _this.StJWTComponent);
                _this.StAccountLoginComponent = new account_login_2.StAccountLoginExtended(_this.StFormComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StAccountLoginClassConfig, _this.StGeneralMethodsComponent);
                _this.LoginRedirectComponent = new login_redirect_1.StLoginRedirect(_this.StFormComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StAccountLoginClassConfig, _this.StGeneralMethodsComponent, _this.StObjectFormattingComponent);
                _this.StAccountLoginWithJWTComponent = new account_login_with_jwt_1.StAccountLoginWithJWT(_this.StFormComponent, _this.StAccountLoginClassConfig, _this.StNotificationComponent, _this.StJWTComponent, _this.StObjectFormattingComponent, _this.StEnrollmentLoginCheckComponent, _this.StWineCellarComponent, _this.StCustomerTypeComponent, _this.StButtonActionsComponent);
                _this.StLoginRoutingComponent = new login_routing_1.StLoginRouting(_this.StObjectFormattingComponent, _this.StCustomerTypeComponent, _this.StWineCellarComponent);
                _this.StAccountLoginResetPasswordComponent = new account_login_reset_password_1.StAccountLoginResetPassword(_this.StFormComponent, _this.StButtonActionsComponent);
                _this.StRequestBookComponent = new request_book_1.StRequestBook(_this.StFormComponent, _this.StCartComponent, _this.StButtonActionsComponent, _this.StNotificationComponent);
                _this.StAwtomicManageSubscriptionsComponent = new manage_subscriptions_2.StAwtomicManageSubscriptions();
            };
            this.hierarchy = function(appName) {
                var hierarchy = [ _this.DiContainerPublicComponent, _this.StStaticComponent ];
                switch (appName) {
                  case "main":
                    hierarchy = hierarchy.concat([ _this.StAutoApplyPromoComponent, _this.StWebAliasComponent, _this.StShareCartComponent, _this.StTastingComponent, _this.StSearchSponsorGuardComponent, _this.StSearchSponsorComponent, _this.StCustomerReferralComponent, _this.StRemoveSamplersComponent, _this.StSamplersAdditionalItemComponent, _this.StEditSamplerComponent, _this.StShippingDateSamplersComponent, _this.StAccountRenderShareCartComponent, _this.LoginRedirectComponent, _this.StEnrollmentLoginCheckComponent, _this.StLoginRoutingComponent, _this.StAccountLoginResetPasswordComponent, _this.StAwtomicManageSubscriptionsComponent, _this.StSamplersOrderComponent, _this.StCustomizableLabelComponent, _this.StLabelLoadingComponent ]);
                    break;

                  case "account":
                    hierarchy = hierarchy.concat([ _this.StAccountComponent, _this.StAccountNavComponent, _this.StAccountPersonalSiteComponent, _this.StAccountAddressesComponent, _this.StAccountPersonalInfoComponent, _this.StAccountOrderHistoryComponent, _this.StCouponCodesComponent, _this.StAccountSamplersComponent, _this.StCouponCodesComponent, _this.StAccountRenderShareCartComponent, _this.StAccountGeneratorsShareCartComponent, _this.StAccountShareCartComponent, _this.StCouponCodesComponent, _this.StTastingComponent, _this.StCouponCodesComponent, _this.StSamplersComponent, _this.StAccountAffiliateComponent, _this.StWineCellarComponent, _this.StManageSubscriptionsComponent ]);
                    break;

                  case "account-register":
                    hierarchy = hierarchy.concat([ _this.StAccountRegisterComponent ]);
                    break;

                  case "account-loading":
                    hierarchy = hierarchy.concat([ _this.StLoadingPageComponent ]);
                    break;

                  case "label-loading":
                    hierarchy = hierarchy.concat([ _this.StLabelLoadingComponent ]);
                    break;

                  case "account-login":
                    hierarchy = hierarchy.concat([ _this.StAccountLoginWithJWTComponent ]);
                    break;

                  case "reset-password":
                    hierarchy = hierarchy.concat([ _this.StResetPasswordComponent ]);
                    break;

                  case "enrollment":
                    hierarchy = hierarchy.concat([]);
                    break;

                  case "enrollment-account":
                    hierarchy = hierarchy.concat([]);
                    break;

                  case "checkout":
                    hierarchy = hierarchy.concat([]);
                    break;

                  case "representative-redirect-page":
                    hierarchy = hierarchy.concat([ _this.StRepresentativeRedirectComponent, _this.StRepresentativeRedirectClassConfigComponent, _this.StGeneralMethodsComponent ]);
                    break;

                  case "enrollment-thank-you":
                    hierarchy = hierarchy.concat([]);
                    break;

                  case "tasting-sponsor":
                    hierarchy = hierarchy.concat([ _this.StSearchSponsorComponent, _this.StSearchSponsorClassConfigComponent ]);
                    break;

                  case "request-book":
                    hierarchy = hierarchy.concat([ _this.StRequestBookComponent ]);
                    break;

                  default:
                    console.error("Unrecognized app provided to st-app. App name: " + appName);
                }
                return hierarchy;
            };
            this.components();
        }
        Object.defineProperty(StAppDIConfig, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StAppDIConfig;
    }();
    exports.StAppDIConfig = StAppDIConfig;
});

define("core/shopify-app/st-modules/_di-container/di.container", [ "require", "exports", "_shopify.app.di.container", "core/shopify-app/st-modules/_di-container/di.container.setup" ], function(require, exports, _shopify_app_di_container_1, di_container_setup_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDIContainer = void 0;
    var StDIContainer = function() {
        function StDIContainer() {
            this.className = "DI";
        }
        StDIContainer.run = function(appName) {
            new di_container_setup_1.StDIContainerSetup(appName, _shopify_app_di_container_1.StAppDIConfig);
        };
        return StDIContainer;
    }();
    exports.StDIContainer = StDIContainer;
});

define("core/shopify-app/st-modules/_general-methods/init-retry", [ "require", "exports", "core/shopify-app/st-modules/_static/static" ], function(require, exports, static_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInitRetry = void 0;
    var StInitRetry = function() {
        function StInitRetry() {
            var _this_1 = this;
            this.className = "InitRetry";
            this.recursiveInitRetry = 0;
            this.timeout = 200;
            this.init = function() {};
            this.initWithCondition = function(params) {
                var _this = _this_1;
                var def = {
                    conditionGeneratorParams: [],
                    callbackParams: [],
                    noOfRetries: 6
                };
                var completeParams = __assign(__assign({}, def), params);
                var initCondition = completeParams.conditionGenerator.apply(_this, completeParams.conditionGeneratorParams);
                if (initCondition) {
                    completeParams.callback.apply(_this, completeParams.callbackParams);
                } else {
                    setTimeout(function() {
                        if (_this.recursiveInitRetry < completeParams.noOfRetries) {
                            _this.recursiveInitRetry++;
                            _this.initWithCondition(completeParams);
                        }
                    }, _this_1.timeout);
                }
            };
            this.endpoint = static_3.StStatic.Instance().obtainStaticEndpoints();
        }
        StInitRetry.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        return StInitRetry;
    }();
    exports.StInitRetry = StInitRetry;
});

define("core/shopify-app/st-modules/_general-methods/shopify-ajax", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_91) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShopifyAjax = void 0;
    var StShopifyAjax = function(_super) {
        __extends(StShopifyAjax, _super);
        function StShopifyAjax() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ShopifyAjax";
            _this.updateCartAttributes = function(attributes, callback, callbackParams) {
                if (callback === void 0) {
                    callback = function() {};
                }
                if (callbackParams === void 0) {
                    callbackParams = [];
                }
                if (!!attributes) {
                    var fnReference_1 = _this;
                    var request_2 = new XMLHttpRequest();
                    request_2.open("POST", "/cart/update.js", true);
                    request_2.withCredentials = true;
                    request_2.setRequestHeader("Content-Type", "application/json");
                    request_2.onreadystatechange = function() {
                        if (request_2.readyState === 4) {
                            try {
                                var resp = JSON.parse(request_2.response);
                                callbackParams.unshift(resp);
                                callback.apply(fnReference_1, callbackParams);
                            } catch (e) {
                                console.error(e);
                                console.error("Failed to update shopify cart attributes!");
                            }
                        }
                    };
                    request_2.send(JSON.stringify({
                        attributes: attributes
                    }));
                }
            };
            return _this;
        }
        return StShopifyAjax;
    }(st_module_91.StModule);
    exports.StShopifyAjax = StShopifyAjax;
});

define("core/shopify-app/st-modules/enrollment/enrollment-cleanup-checkout", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_92) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentCleanupCheckout = void 0;
    var StEnrollmentCleanupCheckout = function(_super) {
        __extends(StEnrollmentCleanupCheckout, _super);
        function StEnrollmentCleanupCheckout(enrollmentCleanup) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StEnrollmentCleanupCheckout";
            _this.init = function() {
                _this.enrollmentCleanup.clearCartAttributes();
            };
            _this.enrollmentCleanup = enrollmentCleanup;
            return _this;
        }
        return StEnrollmentCleanupCheckout;
    }(st_module_92.StModule);
    exports.StEnrollmentCleanupCheckout = StEnrollmentCleanupCheckout;
});

(function() {
    "use strict";
    class StApp extends HTMLElement {
        static get observedAttributes() {
            return [ "app" ];
        }
        constructor() {
            super();
        }
        attributeChangedCallback(name, oldValue, newValue) {
            if (name === "app" && oldValue !== newValue) {
                this.initApp(newValue);
            }
        }
        initApp(appName) {
            require([ "core/shopify-app/st-modules/_di-container/di.container" ], function(module) {
                module.StDIContainer.run(appName);
            });
        }
    }
    customElements.define("st-app", StApp);
})();

window.define = null;